/*eslint-disable*/
import * as React from 'react'

export const Icon = (viewBox: string, className: string, path: Array<string>) => () => (
    <svg
        className={className}
        viewBox={viewBox}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        {path.map((p: string, i: number) => (
            <path d={p} key={i} />
        ))}
    </svg>
)

export const CheckIcon: React.FunctionComponent = () => (
    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 10.7 10" xmlSpace="preserve">
        <path
            d="M10.5 1.1c-.3-.3-.7-.2-1 0L4.1 7.4 1.2 4.5c-.3-.3-.7-.3-1 0-.3.3-.3.7 0 1l3.4 3.4c.1.1.3.2.5.2v-.3.3c.2 0 .4-.1.5-.2L10.5 2c.2-.2.2-.6 0-.9z"
            fill="currentColor"
        />
    </svg>
)

export const CheckColorIcon: React.FunctionComponent = () => (
    <svg id="Group_12811" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 18 18" xmlSpace="preserve">
        <style>{'.check_color_icon{fill:#4cbf96}'}</style>
        <g id="Ellipse_691">
            <circle cx={9} cy={9} r={9} fill="#e2fff5" />
            <path
                className="check_color_icon"
                d="M9 18c-5 0-9-4-9-9s4-9 9-9 9 4 9 9-4 9-9 9zM9 .5C4.3.5.5 4.3.5 9s3.8 8.5 8.5 8.5 8.5-3.8 8.5-8.5S13.7.5 9 .5z"
            />
        </g>
        <path
            className="check_color_icon"
            d="M14.1 4.9c-.3-.3-.7-.2-1 0l-5.4 6.2-2.9-2.8c-.1-.1-.3-.2-.5-.2-.1 0-.3.1-.4.2-.3.3-.3.7 0 1l3.4 3.4c.1.1.3.2.5.2v-.2.3c.2 0 .4-.1.5-.2L14.2 6c.2-.4.2-.8-.1-1.1z"
        />
    </svg>
)

export const CrossIcon: React.FunctionComponent = () => (
    <svg id="Group_10986" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 7.5 7.5" xmlSpace="preserve">
        <style>{'.stq0{fill:currentColor}'}</style>
        <g id="Group_10984">
            <path
                id="Path_7896"
                className="stq0"
                d="M6.7 7.5c-.2 0-.4-.1-.5-.2l-6-6C-.1 1-.1.5.2.2S1-.1 1.3.2l6 6c.3.3.3.8 0 1.1-.2.1-.4.2-.6.2z"
            />
        </g>
        <g id="Group_10985">
            <path
                id="Path_7897"
                className="stq0"
                d="M.8 7.5c-.5 0-.8-.3-.8-.8 0-.2.1-.4.2-.5l6-6c.3-.3.8-.3 1.1 0s.3.8 0 1.1l-6 6c-.2.1-.4.2-.5.2z"
            />
        </g>
    </svg>
)

export const AddIcon: React.FunctionComponent = () => (
    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 12 12" xmlSpace="preserve">
        <path d="M11.2 5.2H6.8V.8C6.8.3 6.4 0 6 0s-.8.3-.8.8v4.5H.8c-.5-.1-.8.3-.8.7s.3.8.8.8h4.5v4.5c-.1.4.3.7.7.7s.8-.3.8-.8V6.8h4.5c.4 0 .7-.4.7-.8s-.3-.8-.8-.8z" />
    </svg>
)
export const DeleteIcon: React.FunctionComponent = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.46 15.53">
        {/* <title>Delete</title> */}
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <path
                    fill="currentColor"
                    d="M13.91,2.34H11V2.15A2.14,2.14,0,0,0,8.85,0H5.61A2.13,2.13,0,0,0,3.48,2a.41.41,0,0,0,0,.11v.19H.55a.56.56,0,0,0,0,1.11h1.2v9.94a2.14,2.14,0,0,0,2.14,2.14h6.68a2.14,2.14,0,0,0,2.14-2v-10h1.2a.56.56,0,0,0,0-1.11ZM4.58,2.17a.13.13,0,0,1,0-.06,1,1,0,0,1,1-1H8.85a1,1,0,0,1,1,1v.19H4.58Zm7,11.19v.07a1,1,0,0,1-1,1H3.89a1,1,0,0,1-1-1V3.45H11.6Z"
                />
                <path
                    fill="currentColor"
                    d="M4.73,12.6A.56.56,0,0,0,5.29,12v-6a.56.56,0,0,0-1.11,0v6A.56.56,0,0,0,4.73,12.6Z"
                />
                <path
                    fill="currentColor"
                    d="M7.23,12.6A.56.56,0,0,0,7.79,12v-6a.56.56,0,0,0-1.11,0v6A.56.56,0,0,0,7.23,12.6Z"
                />
                <path
                    fill="currentColor"
                    d="M9.73,12.6a.55.55,0,0,0,.55-.56v-6a.55.55,0,0,0-1.1,0v6A.55.55,0,0,0,9.73,12.6Z"
                />
            </g>
        </g>
    </svg>
)

export const GroupIcon: React.FunctionComponent = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.97 18">
        <title>Group</title>
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <path
                    fill="currentColor"
                    d="M12.08,5h1.54V6.53a.85.85,0,0,0,1.69,0V5h1.54a.84.84,0,1,0,0-1.68H15.31V1.75a.85.85,0,0,0-1.69,0V3.3H12.08a.84.84,0,1,0,0,1.68Z"
                />
                <path
                    fill="currentColor"
                    d="M6.47,1.68V6.47H1.68V1.68H6.47M7,0H1.12A1.18,1.18,0,0,0,0,1.17V7A1.18,1.18,0,0,0,1.17,8.16H7A1.17,1.17,0,0,0,8.15,7a.13.13,0,0,0,0-.06V1.17A1.18,1.18,0,0,0,7,0Z"
                />
                <path
                    fill="currentColor"
                    d="M16.29,11.53v4.79H11.5V11.53h4.79m.51-1.69H10.93A1.17,1.17,0,0,0,9.81,11v5.8A1.18,1.18,0,0,0,11,18H16.8A1.17,1.17,0,0,0,18,16.88V11A1.18,1.18,0,0,0,16.8,9.84Z"
                />
                <path
                    fill="currentColor"
                    d="M6.47,11.53v4.79H1.68V11.53H6.47M7,9.84H1.12A1.17,1.17,0,0,0,0,11v5.8A1.18,1.18,0,0,0,1.17,18H7a1.17,1.17,0,0,0,1.17-1.12.11.11,0,0,0,0-.06V11A1.18,1.18,0,0,0,7,9.84Z"
                />
            </g>
        </g>
    </svg>
)
export const UnGroupIcon: React.FunctionComponent = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.97 18">
        <title>Un Group</title>
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <path fill="currentColor" d="M10.06,4.15h4a.7.7,0,1,0,0-1.4h-4a.7.7,0,1,0,0,1.4Z" />
                <path
                    fill="currentColor"
                    d="M5.4,1.4v4h-4v-4h4M5.82,0H.93A1,1,0,0,0,0,1V5.82a1,1,0,0,0,1,1H5.82a1,1,0,0,0,1-.93V1a1,1,0,0,0-1-1Z"
                />
                <path
                    fill="currentColor"
                    d="M13.57,9.6v4h-4v-4h4M14,8.2H9.11a1,1,0,0,0-.93,1V14a1,1,0,0,0,1,1H14a1,1,0,0,0,1-.93A.09.09,0,0,0,15,14V9.18a1,1,0,0,0-1-1Z"
                />
                <path
                    fill="currentColor"
                    d="M5.4,9.6v4h-4v-4h4m.42-1.4H.93a1,1,0,0,0-.93,1V14a1,1,0,0,0,1,1H5.82a1,1,0,0,0,1-.93V9.18a1,1,0,0,0-1-1Z"
                />
            </g>
        </g>
    </svg>
)
export const EditIcon: React.FunctionComponent = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.91 13.91">
        {/* <title>Edit</title> */}
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <path
                    fill="currentColor"
                    d="M11.58,1.23l1.1,1.1L5.36,9.64,4.27,8.55l7.31-7.32m0-1.23A.81.81,0,0,0,11,.24L2.89,8.36a.26.26,0,0,0,0,.38L5.17,11a.27.27,0,0,0,.38,0L13.67,2.9a.81.81,0,0,0,0-1.15L12.16.24A.82.82,0,0,0,11.58,0Z"
                />
                <path
                    fill="currentColor"
                    d="M2.1,11.14l.67.67c-.42.2-.82.37-1.19.52.15-.37.32-.77.52-1.19M1.9,9.51a.4.4,0,0,0-.36.23A33.84,33.84,0,0,0,.08,13.12c-.19.49,0,.79.34.79a1,1,0,0,0,.37-.08,33.84,33.84,0,0,0,3.38-1.46.37.37,0,0,0,.14-.59L2.13,9.6a.32.32,0,0,0-.23-.09Z"
                />
            </g>
        </g>
    </svg>
)
export const EditIconCircle: React.FunctionComponent = () => (
    <svg id="Layer_1" x="0px" y="0px" viewBox="0 0 48 48" xmlSpace="preserve">
        <style>{'.st0e{fill:#4d4d4d}'}</style>
        <path
            className="st0e"
            d="M24 48C10.8 48 0 37.2 0 24S10.8 0 24 0s24 10.8 24 24-10.8 24-24 24zm0-46C11.9 2 2 11.9 2 24s9.9 22 22 22 22-9.9 22-22S36.1 2 24 2z"
        />
        <path
            className="st0e"
            d="M21.2 30.3c-.2 0-.4-.1-.5-.2l-3.6-3.6c-.3-.3-.3-.8 0-1.1l14.5-14.6c.1-.1.4-.2.6-.2.2 0 .4.1.5.3l3.3 3.9c.3.3.2.7 0 1L21.7 30.1c-.1.1-.3.2-.5.2zm-2.5-4.4l2.5 2.6 13.3-13.3-2.4-2.8-13.4 13.5zM12.5 35.4c-.2 0-.4-.1-.5-.2-.2-.2-.3-.5-.2-.8l2.5-6.1c.1-.2.3-.4.6-.5.3 0 .5 0 .7.2l3.6 3.9c.2.2.2.4.2.7-.1.2-.2.4-.5.5l-6.1 2.2c-.1.1-.2.1-.3.1zm2.7-5.5l-1.4 3.4 3.4-1.3-2-2.1z"
        />
    </svg>
)
export const TickIcon = () => (
    <svg x="0px" y="0px" viewBox="0 0 32 32">
        <style>{'.st0{display:none}.st1{display:inline}'}</style>
        <g id="Layer_1" className="st0">
            <g className="st1">
                <path d="M16 32C7.2 32 0 24.8 0 16S7.2 0 16 0s16 7.2 16 16-7.2 16-16 16zm0-30C8.3 2 2 8.3 2 16s6.3 14 14 14 14-6.3 14-14S23.7 2 16 2z" />
                <path
                    d="M14.1 22c-.2 0-.5-.1-.6-.2l-6.1-5.2c-.4-.4-.5-1-.1-1.4.4-.4 1-.5 1.4-.1l5.4 4.6 9.3-9.3c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-9.9 10c-.3.1-.6.2-.8.2z"
                    fill="transparent"
                />
            </g>
        </g>
        <path
            d="M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16 16-7.2 16-16S24.8 0 16 0zm8.7 11.7l-9.9 10c-.2.2-.5.3-.7.3-.2 0-.5-.1-.6-.2l-6.1-5.2c-.4-.4-.5-1-.1-1.4s1-.5 1.4-.1l5.4 4.6 9.3-9.3c.4-.4 1-.4 1.4 0 .3.3.3.9-.1 1.3z"
            fill="#494949"
            id="Layer_2"
        />
        <g id="Layer_3" className="st0">
            <path
                d="M16 32C7.2 32 0 24.8 0 16S7.2 0 16 0s16 7.2 16 16-7.2 16-16 16zm0-30C8.3 2 2 8.3 2 16s6.3 14 14 14 14-6.3 14-14S23.7 2 16 2z"
                fill="#494949"
                className=""
            />
        </g>
    </svg>
)
export const ListviewIcon: React.FunctionComponent = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 12.66">
        <defs />
        <title />
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <path className="cls-1" d="M17.16,2H4.57a.84.84,0,0,1,0-1.68H17.16a.84.84,0,0,1,0,1.68Z" />
                <path className="cls-1" d="M17.16,7.17H4.57a.84.84,0,0,1,0-1.68H17.16a.84.84,0,0,1,0,1.68Z" />
                <path className="cls-1" d="M17.16,12.38H4.57a.84.84,0,0,1,0-1.68H17.16a.84.84,0,0,1,0,1.68Z" />
                <path
                    className="cls-1"
                    d="M1.12,12.66a1.13,1.13,0,0,1-.79-1.93,1.15,1.15,0,0,1,1.58,0,1.13,1.13,0,0,1,0,1.6A1.11,1.11,0,0,1,1.12,12.66Z"
                />
                <path
                    className="cls-1"
                    d="M1.12,7.45A1.13,1.13,0,0,1,.33,5.52a1.15,1.15,0,0,1,1.58,0,1.13,1.13,0,0,1,0,1.6A1.11,1.11,0,0,1,1.12,7.45Z"
                />
                <path
                    className="cls-1"
                    d="M1.12,2.24A1.13,1.13,0,0,1,0,1.11,1.17,1.17,0,0,1,.33.31a1.16,1.16,0,0,1,1.58,0,1.17,1.17,0,0,1,.33.8,1.14,1.14,0,0,1-.33.8A1.11,1.11,0,0,1,1.12,2.24Z"
                />
            </g>
        </g>
    </svg>
)
export const HomeIcon: React.FunctionComponent = () => (
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 24 24" xmlSpace="preserve">
        <style>{'.s1t0{fill:currentColor}'}</style>
        <g id="Group_5724" transform="translate(-721 -1055.016)">
            <g id="Group_5719" transform="translate(721 1055.016)">
                <g id="Group_5717" transform="translate(2.257 10.446)">
                    <path
                        id="Path_3801"
                        className="s1t0"
                        d="M14.2 12H18V.8c0-.4.3-.8.7-.8s.8.3.8.7V12c0 .8-.7 1.5-1.5 1.5h-3.8c-.8 0-1.5-.7-1.5-1.5"
                    />
                    <path
                        id="Path_3802"
                        className="s1t0"
                        d="M15 12c0 .8-.7 1.5-1.5 1.5h-12C.7 13.5 0 12.9 0 12V.8C0 .3.3 0 .7 0s.8.3.8.8V12h12"
                    />
                </g>
                <g id="Group_5718">
                    <path
                        id="Path_3803"
                        className="s1t0"
                        d="M23.3 14.3c-.2 0-.4-.1-.6-.3L12 1.9 1.3 14c-.3.3-.8.3-1.1.1s-.3-.8-.1-1.1L11.4.2c.3-.3.8-.3 1.1 0L23.8 13c.3.3.2.8-.1 1.1-.1.1-.3.2-.4.2z"
                    />
                </g>
            </g>
            <g id="Group_5720" transform="translate(727.183 1064.933)">
                <path
                    id="Path_3804"
                    className="s1t0"
                    d="M4.3 4.9H.6c-.3 0-.6-.3-.6-.6V.6C0 .3.3 0 .6 0h3.8c.3 0 .6.3.6.6v3.8c-.1.2-.4.5-.7.5zM1.1 3.8h2.6V1.1H1.1v2.7z"
                />
            </g>
            <g id="Group_5721" transform="translate(733.927 1064.933)">
                <path
                    id="Path_3805"
                    className="s1t0"
                    d="M4.3 4.9H.6c-.3 0-.6-.3-.6-.6V.6C0 .3.3 0 .6 0h3.8c.3 0 .6.3.6.6v3.8c-.1.2-.4.5-.7.5zM1.1 3.8h2.6V1.1H1.1v2.7z"
                />
            </g>
            <g id="Group_5722" transform="translate(727.183 1070.916)">
                <path
                    id="Path_3806"
                    className="s1t0"
                    d="M4.3 4.9H.6c-.3 0-.6-.3-.6-.6V.6C0 .3.3 0 .6 0h3.8c.3 0 .6.3.6.6v3.8c-.1.2-.4.5-.7.5zM1.1 3.8h2.6V1.1H1.1v2.7z"
                />
            </g>
            <g id="Group_5723" transform="translate(733.927 1070.916)">
                <path
                    id="Path_3807"
                    className="s1t0"
                    d="M4.3 4.9H.6c-.3 0-.6-.3-.6-.6V.6C0 .3.3 0 .6 0h3.8c.3 0 .6.3.6.6v3.8c-.1.2-.4.5-.7.5zM1.1 3.8h2.6V1.1H1.1v2.7z"
                />
            </g>
        </g>
    </svg>
)

export const DialogIcon: React.FunctionComponent = () => (
    <svg data-name="Layer 1" viewBox="0 0 32 32">
        <path d="M10.6 29a.6.6 0 01-.4-.1.89.89 0 01-.5-.8v-4.6A10.29 10.29 0 0111.1 3H21a10.31 10.31 0 0110.3 10.4A10.14 10.14 0 0121 23.6h-3.8l-5.9 5.2a1.08 1.08 0 01-.7.2zm.9-6v3.2l4.7-4.1a1.42 1.42 0 01.6-.2H21a8.51 8.51 0 008.5-8.6A8.43 8.43 0 0021 4.8h-9.9a8.6 8.6 0 00-8.6 8.6 8.48 8.48 0 008.1 8.5 1.09 1.09 0 011 .9c-.1 0-.1.1-.1.2z" />
    </svg>
)
export const CanvasDialogIcon: React.FunctionComponent = () => (
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 24 24" xmlSpace="preserve">
        <style>{'.wst0{fill:currentColor}'}</style>
        <g id="reg_dialog" transform="translate(-920 -19980)">
            <g id="Group_12852" transform="translate(924.3 19984)">
                <g id="Group_8265" transform="translate(.7 3)">
                    <path
                        id="Path_4336"
                        className="wst0"
                        d="M4.5 11.9h-.2c-.1-.1-.2-.2-.2-.4V9.4C1.5 9-.3 6.7.1 4.1.4 1.7 2.4 0 4.7 0h4.5C11.9 0 14 2.1 14 4.7s-2 4.6-4.6 4.7H7.5l-2.7 2.4c-.1 0-.2.1-.3.1zm.4-2.8v1.5L7 8.7c.1-.1.2-.1.3-.1h1.9c2.1 0 3.9-1.7 3.9-3.9 0-2.1-1.7-3.9-3.8-3.9H4.7C2.5.8.8 2.6.8 4.7c0 2.1 1.6 3.8 3.7 3.9.3 0 .4.2.4.5 0-.1 0 0 0 0z"
                    />
                </g>
                <circle id="Ellipse_305" className="wst0" cx={4.9} cy={7.7} r={1} />
                <circle id="Ellipse_306" className="wst0" cx={7.9} cy={7.7} r={1} />
                <circle id="Ellipse_307" className="wst0" cx={10.9} cy={7.7} r={1} />
            </g>
        </g>
    </svg>
)

export const DialogHomeIcon: React.FunctionComponent = () => (
    <svg data-name="Layer 1" viewBox="0 0 32 32">
        <path d="M10.6 29a.6.6 0 01-.4-.1.89.89 0 01-.5-.8v-4.6A10.29 10.29 0 0111.1 3H21a10.31 10.31 0 0110.3 10.4A10.14 10.14 0 0121 23.6h-3.8l-5.9 5.2a1.08 1.08 0 01-.7.2zm.9-6v3.2l4.7-4.1a1.42 1.42 0 01.6-.2H21a8.51 8.51 0 008.5-8.6A8.43 8.43 0 0021 4.8h-9.9a8.6 8.6 0 00-8.6 8.6 8.48 8.48 0 008.1 8.5 1.09 1.09 0 011 .9c-.1 0-.1.1-.1.2z" />
    </svg>
)
export const IntentIcon: React.FunctionComponent = () => (
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 16 16" xmlSpace="preserve">
        {/* <style>{'.s1t0{fill:currentColor}'}</style> */}
        <g id="Group_12619" transform="translate(-1484.999 -2388.969)">
            <g id="Group_12613" transform="translate(1485 2388.969)">
                <path
                    id="Path_10305"
                    className="s1t0"
                    d="M8 14c-3.8 0-6.9-3.2-6.9-7S4.2.1 8 .1c3.8 0 6.9 3.1 6.9 6.9 0 3.8-3.1 7-6.9 7zM8 1.1c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6c0-3.4-2.7-6-6-6z"
                />
            </g>
            <g id="Group_12614" transform="translate(1488.01 2391.979)">
                <path
                    id="Path_10306"
                    className="s1t0"
                    d="M5 8C2.8 8 1 6.2 1 4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm0-7C3.3 1 2 2.4 2 4s1.3 3 3 3 3-1.3 3-3c0-1.6-1.4-3-3-3z"
                />
            </g>
            <g id="Group_12615" transform="translate(1491.521 2402.513)">
                <path
                    id="Path_10307"
                    className="s1t0"
                    d="M1.5 1.9c-.3 0-.5-.2-.5-.5v-1c0-.3.2-.5.5-.5s.5.2.5.5v1c0 .3-.3.5-.5.5z"
                />
            </g>
            <g id="Group_12616" transform="translate(1496.036 2401.008)">
                <path
                    id="Path_10308"
                    className="s1t0"
                    d="M3.4 3.9c-.2 0-.3-.1-.4-.2l-2-3C.9.5.9.2 1.2 0c.2-.2.5-.1.7.1l2 3c.1.3 0 .6-.2.7-.1.1-.2.1-.3.1z"
                />
            </g>
            <g id="Group_12617" transform="translate(1484.999 2401.008)">
                <path
                    id="Path_10309"
                    className="s1t0"
                    d="M1.5 3.9c-.2 0-.4-.2-.5-.5 0-.1 0-.2.1-.3l2-3c.2-.2.5-.2.7-.1.2.2.3.5.1.7l-2 3c0 .1-.2.2-.4.2z"
                />
            </g>
            <g id="Group_12618" transform="translate(1491.019 2394.989)">
                <circle id="Ellipse_811" className="s1t0" cx={2} cy={1} r={1} />
            </g>
        </g>
    </svg>
)
export const EntityIcon: React.FunctionComponent = () => (
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 16 16" xmlSpace="preserve">
        {/* <style>{'.s1t1{fill:currentColor}'}</style> */}
        <g id="Group_12432" transform="translate(-402.72 -20124)">
            <g id="Ellipse_806">
                <circle cx={5.4} cy={3.9} r={3.9} fill="none" transform="translate(405 20124)" />
                <path
                    className="s1t1"
                    d="M5.4 7.8c-2.1 0-3.9-1.7-3.9-3.9S3.2 0 5.4 0s3.9 1.7 3.9 3.9-1.8 3.9-3.9 3.9zm0-6.8c-1.6 0-3 1.3-3 2.9s1.3 2.9 2.9 2.9 2.9-1.3 2.9-2.9S7 1 5.4 1z"
                    transform="translate(405 20124)"
                />
            </g>
            <path
                className="s1t1"
                d="M407.6 20140c-.5 0-1.4-.1-2.2-.8-.8-.7-1.2-1.9-1.2-3.4-.1-1.1.3-2.7 1.3-3.5.6-.5 1.4-.7 2.3-.4.4.1.7.2.9.3 1.1.4 1.3.4 2.3.3.7-.1 1.2-.3 1.7-.5.4-.2.7-.3 1-.4.5-.1 1.3 0 2 .6.8.6 1.2 1.6 1.3 2.9.1 1.9-.2 3.2-.9 3.9-.5.5-1.2.8-2 .9-1.8 0-5.8.1-6.2.1.1-.1-.1 0-.3 0zm-.5-7.3c-.3 0-.6.1-.9.3-.6.5-1.1 1.7-1 2.8 0 1.3.2 2.2.8 2.7.8.7 1.8.5 1.8.5h.1s4.3 0 6.2-.1c.6 0 1-.2 1.4-.5.5-.6.7-1.7.7-3.2-.1-1-.4-1.8-.9-2.2-.4-.3-.9-.4-1.2-.3-.2 0-.5.2-.8.3-.5.2-1.2.5-2.1.6-1.2.1-1.5 0-2.7-.4l-.9-.3c-.2-.2-.4-.2-.5-.2z"
                id="Path_10182"
            />
        </g>
    </svg>
)

export const FlowIcon: React.FunctionComponent = () => (
    <svg data-name="Layer 1" viewBox="0 0 32 32">
        <path d="M20 28.62h-6.5c-4.78 0-5.42-3.17-5.42-6.26v-15h2.08v15c0 3.24.75 4.17 3.34 4.17H20z" />
        <path d="M9.12 14.7H19.759999999999998V16.79H9.12z" />
        <path d="M9 8a3.65 3.65 0 113.65-3.65A3.66 3.66 0 019 8zm0-5.84a2.16 2.16 0 102.16 2.16A2.16 2.16 0 009 2.16zM23 19.44a3.65 3.65 0 113.65-3.65A3.65 3.65 0 0123 19.44zm0-5.81a2.16 2.16 0 102.15 2.16A2.16 2.16 0 0023 13.63zM23 31.33a3.65 3.65 0 113.65-3.65A3.65 3.65 0 0123 31.33zm0-5.81a2.16 2.16 0 102.15 2.16A2.16 2.16 0 0023 25.52z" />
    </svg>
)
export const DialogFlowIcon: React.FunctionComponent = () => (
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 24 24" xmlSpace="preserve">
        <style>{'.swt0{fill:currentColor}'}</style>
        <g id="call_automation_" transform="translate(-874 -20139)">
            <g id="Group_8117" transform="translate(825.112 20144.637)">
                <path
                    id="Path_16"
                    className="swt0"
                    d="M62.5 11.4h-2.6c-1.9 0-2.2-1.3-2.2-2.5v-6h.8v6c0 1.3.3 1.7 1.3 1.7h2.6l.1.8z"
                />
                <path id="Rectangle_4" className="swt0" d="M58.2 5.8H62.400000000000006V6.6H58.2z" />
                <path
                    id="Path_17"
                    className="swt0"
                    d="M58.1 3.2c-.8 0-1.5-.7-1.5-1.5S57.3.2 58.1.2s1.5.7 1.5 1.5-.7 1.5-1.5 1.5zm-.7-2c-.3.3-.3.8 0 1.3.4.3.9.4 1.3-.1.4-.4.2-.9-.1-1.3-.4-.3-.7-.3-1.1-.1l-.1.2z"
                />
                <path
                    id="Path_18"
                    className="swt0"
                    d="M63.7 7.7c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5c0 1-.7 1.5-1.5 1.5zm0-2.3c-.5 0-.9.4-.9.9s.4.9.9.9.8-.3.9-.8v-.1c0-.6-.5-.9-.9-.9z"
                />
                <path
                    id="Path_19"
                    className="swt0"
                    d="M63.7 12.5c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5c0 1-.7 1.5-1.5 1.5zm0-2.4c-.5 0-.9.4-.9.9s.4.9.9.9.9-.4.9-.9c-.1-.5-.5-.9-.9-.9z"
                />
            </g>
        </g>
    </svg>
)

export const CloseIcon: React.FunctionComponent = () => (
    <svg id="Group_10986" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 7.5 7.5" xmlSpace="preserve">
        <style>{'.stq0{fill:currentColor}'}</style>
        <g id="Group_10984">
            <path
                id="Path_7896"
                className="stq0"
                d="M6.7 7.5c-.2 0-.4-.1-.5-.2l-6-6C-.1 1-.1.5.2.2S1-.1 1.3.2l6 6c.3.3.3.8 0 1.1-.2.1-.4.2-.6.2z"
            />
        </g>
        <g id="Group_10985">
            <path
                id="Path_7897"
                className="stq0"
                d="M.8 7.5c-.5 0-.8-.3-.8-.8 0-.2.1-.4.2-.5l6-6c.3-.3.8-.3 1.1 0s.3.8 0 1.1l-6 6c-.2.1-.4.2-.5.2z"
            />
        </g>
    </svg>
)

export const CloseColorIcon: React.FunctionComponent = () => (
    <svg id="Group_12810" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 18 18" xmlSpace="preserve">
        <style>{'.close_color_icon{fill:#eb6453}'}</style>
        <g id="Ellipse_691">
            <circle cx={9} cy={9} r={9} fill="#ffe5e2" />
            <path
                className="close_color_icon"
                d="M9 18c-5 0-9-4-9-9s4-9 9-9 9 4 9 9-4 9-9 9zM9 .5C4.3.5.5 4.3.5 9s3.8 8.5 8.5 8.5 8.5-3.8 8.5-8.5S13.7.5 9 .5z"
            />
        </g>
        <path className="st1" d="M12 12.8L12 12.8 12 12.8z" />
        <path
            className="close_color_icon"
            d="M10.1 9l2.5-2.5c.3-.3.3-.8 0-1.1s-.8-.3-1.1 0L9 7.9 6.5 5.5c-.3-.3-.8-.3-1.1 0s-.3.8 0 1.1L7.9 9l-2.5 2.5c-.1.1-.2.3-.2.5 0 .4.3.8.7.8.2 0 .4-.1.5-.2L9 10.1l2.5 2.5c.1.1.3.2.5.2s.4-.1.5-.2c.3-.3.3-.8 0-1.1L10.1 9z"
        />
    </svg>
)
export const CloseIconWithCircle: React.FunctionComponent = () => (
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 18.2 18.2" xmlSpace="preserve">
        <style>{'.s1t0{fill:currentColor}'}</style>
        <g id="Group_11395" transform="translate(-336.293 -708.707)">
            <g id="Group_11392" transform="translate(336.293 708.707)">
                <path
                    id="Path_10108"
                    className="s1t0"
                    d="M9.1 18.2c-5 0-9.1-4.1-9.1-9.1S4.1 0 9.1 0s9.1 4.1 9.1 9.1-4.1 9.1-9.1 9.1zm0-16.7c-4.2 0-7.6 3.4-7.6 7.6s3.4 7.6 7.6 7.6 7.6-3.4 7.6-7.6c0-4.2-3.4-7.6-7.6-7.6z"
                />
            </g>
            <g id="Group_11393" transform="translate(341.597 714.011)">
                <path
                    id="Path_10109"
                    className="s1t0"
                    d="M6.8 7.6c-.2 0-.4-.1-.5-.2L.2 1.3C-.1 1-.1.5.2.2c.3-.3.8-.3 1.1 0l6.1 6.1c.3.3.3.8 0 1.1-.2.1-.4.2-.6.2z"
                />
            </g>
            <g id="Group_11394" transform="translate(341.597 714.011)">
                <path
                    id="Path_10110"
                    className="s1t0"
                    d="M.8 7.6c-.5 0-.8-.4-.8-.8 0-.2.1-.4.2-.5L6.3.2c.3-.3.8-.3 1.1 0 .3.3.3.7 0 1L1.3 7.4c-.1.1-.3.2-.5.2z"
                />
            </g>
        </g>
    </svg>
)

export const SearchIcon: React.FunctionComponent = () => (
    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 16 16" xmlSpace="preserve">
        <path d="M10 0C6.7 0 4 2.7 4 6c0 1.4.5 2.7 1.3 3.7L.2 14.8c-.3.3-.3.7 0 .9.1.2.3.3.5.3s.3-.1.5-.2l5.1-5.1c1 .8 2.3 1.3 3.7 1.3 3.3 0 6-2.7 6-6s-2.7-6-6-6zm0 10.7c-2.6 0-4.7-2.1-4.7-4.7S7.4 1.3 10 1.3s4.7 2.1 4.7 4.7-2.1 4.7-4.7 4.7z" />
    </svg>
)

export const MoveIcon: React.FunctionComponent = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 13.46">
        <title>Move</title>
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <path d="M14.26,13.46H1.74A1.75,1.75,0,0,1,0,11.71v-10A1.74,1.74,0,0,1,1.74,0H5.66A.51.51,0,0,1,6,.13c.48.38,1.33,1.25,1.7,1.63h6.55A1.74,1.74,0,0,1,16,3.5v8.21A1.75,1.75,0,0,1,14.26,13.46ZM1.74,1.14a.6.6,0,0,0-.6.6v10a.6.6,0,0,0,.6.6H14.26a.6.6,0,0,0,.6-.6V3.5a.6.6,0,0,0-.6-.6H7.47a.59.59,0,0,1-.42-.17S6,1.66,5.45,1.14Z" />
                <path d="M11,8.19H5A.58.58,0,0,1,5,7h6a.58.58,0,0,1,0,1.15Z" />
                <path d="M11,8.18a.58.58,0,0,1-.4-.17L8.3,5.73a.57.57,0,0,1,.81-.81L11.4,7.21a.57.57,0,0,1,0,.8A.58.58,0,0,1,11,8.18Z" />
                <path d="M8.71,10.47a.58.58,0,0,1-.41-1l2.29-2.28a.56.56,0,0,1,.81,0,.57.57,0,0,1,0,.8L9.11,10.3A.58.58,0,0,1,8.71,10.47Z" />
            </g>
        </g>
    </svg>
)

export const MinusIcon: React.FunctionComponent = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.24 1.86">
        <title />
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <path d="M0,.93A.93.93,0,0,1,.93,0H15.31a.93.93,0,0,1,0,1.86H.93A.93.93,0,0,1,0,.93Z" />
            </g>
        </g>
    </svg>
)

export const RemoveIcon: React.FunctionComponent = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.98 15">
        <title />
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <path d="M10.06,4.15h4a.7.7,0,1,0,0-1.4h-4a.7.7,0,1,0,0,1.4Z" />
                <path d="M5.4,1.4v4h-4v-4h4M5.82,0H.93A1,1,0,0,0,0,1V5.82a1,1,0,0,0,1,1H5.82a1,1,0,0,0,1-.93V1a1,1,0,0,0-1-1Z" />
                <path d="M13.57,9.6v4h-4v-4h4M14,8.2H9.11a1,1,0,0,0-.93,1V14a1,1,0,0,0,1,1H14a1,1,0,0,0,1-.93A.09.09,0,0,0,15,14V9.18a1,1,0,0,0-1-1Z" />
                <path d="M5.4,9.6v4h-4v-4h4m.42-1.4H.93a1,1,0,0,0-.93,1V14a1,1,0,0,0,1,1H5.82a1,1,0,0,0,1-.93V9.18a1,1,0,0,0-1-1Z" />
            </g>
        </g>
    </svg>
)

export const SortIcon: React.FunctionComponent = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 10.79">
        <title>Sort</title>
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <path d="M15.25,0H.75A.76.76,0,0,0,0,.75a.76.76,0,0,0,.75.75h14.5A.76.76,0,0,0,16,.75.76.76,0,0,0,15.25,0Z" />
                <path d="M8,4.65H.75a.75.75,0,0,0,0,1.5H8a.75.75,0,0,0,0-1.5Z" />
                <path d="M8,9.29H.75a.75.75,0,0,0,0,1.5H8a.75.75,0,0,0,0-1.5Z" />
                <path d="M14.41,7.49l-.74.74V5.39a.75.75,0,1,0-1.5,0V8.23l-.73-.74a.75.75,0,0,0-1.06,0,.77.77,0,0,0,0,1.07l2,2a.7.7,0,0,0,.26.19h0l.14,0h.15a.74.74,0,0,0,.53-.22l2-2a.75.75,0,1,0-1.06-1.07Z" />
            </g>
        </g>
    </svg>
)

export const DateIcon: React.FunctionComponent = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.45 14">
        <title>Date</title>
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <path d="M11.82,1H10.44V.5a.5.5,0,0,0-.5-.5.5.5,0,0,0-.5.5V1H4V.5A.5.5,0,0,0,3.5,0,.5.5,0,0,0,3,.5V1H1.63A1.62,1.62,0,0,0,0,2.56v9.85A1.62,1.62,0,0,0,1.63,14H11.82a1.62,1.62,0,0,0,1.63-1.59V2.56A1.62,1.62,0,0,0,11.82,1Zm.63,11.45a.62.62,0,0,1-.63.59H1.63A.61.61,0,0,1,1,12.41V5.25H12.45Zm0-8.16H1V2.56A.62.62,0,0,1,1.63,2H3v.47a.51.51,0,0,0,.5.5.5.5,0,0,0,.5-.5V2H9.44v.47a.51.51,0,0,0,.5.5.5.5,0,0,0,.5-.5V2h1.38a.62.62,0,0,1,.63.6Z" />
                <path d="M5.55,8.78a.49.49,0,0,0,.3-.1l.7-.54v3a.5.5,0,0,0,.5.5.5.5,0,0,0,.5-.5v-4a.07.07,0,0,1,0-.05s0,0,0,0a.43.43,0,0,0,0,0l0,0,0,0,0,0v0l0,0,0,0,0,0,0,0,0,0,0,0H6.93l0,0h0l0,0,0,0h0L5.24,7.88a.5.5,0,0,0-.09.7A.51.51,0,0,0,5.55,8.78Z" />
            </g>
        </g>
    </svg>
)

export const TypeIcon: React.FunctionComponent = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 9.92">
        <title />
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <path d="M13.5,1.58h-7a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h7a.5.5,0,0,1,.5.5A.5.5,0,0,1,13.5,1.58Z" />
                <path d="M13.5,3.75h-7a.5.5,0,0,1,0-1h7a.5.5,0,0,1,0,1Z" />
                <path d="M2.83,4.33H1.5A1.5,1.5,0,0,1,0,2.83V1.5A1.5,1.5,0,0,1,1.5,0H2.83a1.5,1.5,0,0,1,1.5,1.5V2.83A1.5,1.5,0,0,1,2.83,4.33ZM1.5,1a.5.5,0,0,0-.5.5V2.83a.5.5,0,0,0,.5.5H2.83a.5.5,0,0,0,.5-.5V1.5a.5.5,0,0,0-.5-.5Z" />
                <path d="M13.5,7.17h-2a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,13.5,7.17Z" />
                <path d="M13.5,9.33h-2a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,13.5,9.33Z" />
                <rect x="6" y="5.58" width="4.33" height="4.33" rx="1.5" />
            </g>
        </g>
    </svg>
)

export const TrymeCloseIcon = () => (
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 19 19" xmlSpace="preserve">
        <style>{'.st02{fill:currentColor}'}</style>
        <g id="Group_12034" transform="translate(-846.459 -138.459)">
            <path
                className="st02"
                d="M856 157.5c-5.2 0-9.5-4.3-9.5-9.5s4.3-9.5 9.5-9.5 9.5 4.3 9.5 9.5-4.3 9.5-9.5 9.5zm0-18c-4.7 0-8.5 3.8-8.5 8.5s3.8 8.5 8.5 8.5 8.5-3.8 8.5-8.5-3.9-8.5-8.5-8.5z"
                id="Ellipse_488"
            />
            <path
                className="st02"
                d="M859 151.7c-.2 0-.4-.1-.5-.2l-6-6c-.3-.3-.3-.8 0-1.1s.8-.3 1.1 0l6 6c.3.3.3.8 0 1.1-.3.1-.4.2-.6.2z"
                id="Line_335"
            />
            <path
                className="st02"
                d="M853 151.7c-.2 0-.4-.1-.5-.2-.3-.3-.3-.8 0-1.1l6-6c.3-.3.8-.3 1.1 0s.3.8 0 1.1l-6 6c-.3.1-.4.2-.6.2z"
                id="Line_336"
            />
        </g>
    </svg>
)
export const SetValuesIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 16 16" xmlSpace="preserve">
        <path
            d="M14 3.4H2C1 3.4.2 4.2.2 5.1v9.7c0 1 .8 1.8 1.7 1.8H14c1 0 1.8-.8 1.8-1.7V5.2c0-1-.8-1.8-1.8-1.8zm.6 11.4c0 .3-.2.6-.5.6H2c-.3 0-.6-.2-.6-.5V6.4h13.2v8.4z"
            transform="translate(0 -2)"
        />
        <path
            d="M11.8 10.7c0 .5-.1 1.1-.2 1.6-.1.4-.3.9-.5 1.3h.7c.3-.5.5-1 .7-1.2.2-.5.3-1.1.3-1.7 0-.3 0-.5-.1-.8-.1-.3-.1-.5-.2-.8-.1-.2-.1-.3-.2-.5-.1-.1-.1-.2-.2-.4h-.7c.1.3.3.5.4.8 0 .6.1 1.2 0 1.7zM4.2 10.7c0 .5.1 1.1.2 1.6.1.4.3.9.5 1.3h-.7c-.3-.5-.5-1-.7-1.2-.2-.5-.3-1.1-.3-1.7 0-.3 0-.5.1-.8.1-.3.1-.5.2-.8.1-.1.2-.3.3-.4 0-.1.1-.2.2-.5h.7c-.1.3-.2.5-.3.8-.2.6-.2 1.1-.2 1.7z"
            transform="translate(0 -2)"
        />
        <path
            d="M5 1.9c0 .2-.1.4-.2.5-.2.2-.4.2-.6.2-.1 0-.2 0-.4-.1 0 0-.2 0-.2-.1-.1 0-.1.1-.2.2s-.2.3-.3.4c.1.4.2.7.2.8.1.2.1.3.2.5 0 .1.1.2.2.3.1.1.3.1.4.1.1 0 .2 0 .2-.1.1 0 .2-.1.2-.1v.4l-.6.3c-.2 0-.4.1-.5.1-.1 0-.2 0-.3-.1-.1 0-.2-.1-.3-.1-.2-.1-.3-.2-.3-.3-.1-.1-.2-.2-.2-.3 0-.1-.1-.2-.1-.3 0-.1 0-.2-.1-.3 0 .2-.1.3-.1.3 0 .1 0 .1-.1.3-.1.2-.3.4-.5.6-.2.1-.4.2-.6.2-.2 0-.3-.1-.4-.2-.1-.1-.2-.2-.2-.3 0-.2.1-.4.2-.5.2-.2.4-.3.6-.3.1 0 .2 0 .4.1.1.1.2.1.3.1l.1-.2c.1-.1.2-.1.3-.3-.1-.3-.2-.5-.3-.8l-.1-.5c0-.1-.1-.2-.2-.3-.1-.1-.3-.2-.4-.1C1 1.9.9 2 .8 2c-.1 0-.2.1-.2.1l.1-.4c.2-.1.4-.2.7-.2.2 0 .4-.1.5-.1h.3c.1 0 .2.1.3.1.1 0 .2.1.2.2 0 .2.1.3.2.4 0 .1.1.2.1.3-.1.2 0 .2 0 .3l.2-.2c.1-.1.1-.1.1-.2.1-.3.3-.5.5-.7.2-.1.4-.2.6-.2.2 0 .3.1.4.2.1 0 .2.1.2.3z"
            transform="translate(0 -2) translate(5.386 7.566)"
        />
    </svg>
)
export const TrymeIcon: React.FunctionComponent = () => (
    <svg id="Layer_1" x="0px" y="0px" viewBox="0 0 60 60" xmlSpace="preserve" className="tryme_icon_svg">
        <style>{'.st4{opacity:.75;enable-background:new}.st4,.st5{fill:#fff}'}</style>
        <path
            d="M17.3 46.6C33.9 39.1 59.7 34 52 1.2 50.3.4 48.4 0 46.3 0H19.1C14.1 12.6 5.9 18.6 0 21.4v24.9c0 3.8 1.5 7.2 4 9.7 2.8-3.2 7-6.6 13.3-9.4z"
            fill="#5b9ff7"
        />
        <path
            d="M34.6 60c5.5-5.5 13.7-11.4 25.4-14.6V13.7c0-5.5-3.3-10.3-8-12.4C59.7 34 33.9 39.1 17.3 46.6 11 49.4 6.8 52.8 4 55.9c2.5 2.5 5.9 4 9.7 4l20.9.1z"
            fill="#466af3"
        />
        <path d="M46.3 60C53.9 60 60 53.8 60 46.3v-.9C48.2 48.6 40 54.5 34.6 60h11.7z" fill="#314af2" />
        <path d="M19.1 0h-5.4C6.1 0 0 6.1 0 13.7v7.8c5.8-2.9 14.1-9 19.1-21.5z" fill="#6ce6f9" />
        <g>
            <path
                className="st4"
                d="M18.9 41c0 2.4-2 4.5-4.5 4.5-2.4 0-4.5-2-4.5-4.5V19c0-2.4 2-4.5 4.5-4.5 2.4 0 4.5 2 4.5 4.5v22zM49.7 41c0 2.4-2 4.5-4.5 4.5s-4.5-2-4.5-4.5v-8.6c0-2.4 2-4.5 4.5-4.5s4.5 2 4.5 4.5V41z"
            />
            <ellipse className="st5" cx={45.1} cy={19} rx={4.5} ry={4.5} />
            <path
                className="st5"
                d="M48.2 37.8c1.8 1.7 1.8 4.6 0 6.3-1.8 1.7-4.6 1.7-6.3 0L31.7 33.6c-1.1-1.1-2.8-1.1-3.9 0L17.6 44.1c-1.8 1.7-4.6 1.7-6.3 0-1.8-1.7-1.8-4.6 0-6.3l15.2-15.6c1.8-1.8 4.8-1.8 6.6 0l15.1 15.6z"
            />
        </g>
    </svg>
)

export const NewTrymeIcon: React.FunctionComponent = () => (
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 32 32" xmlSpace="preserve">
        <style>{'.st0,.st6{fill:#fff}.st6{opacity:.75;enable-background:new}'}</style>
        <g id="Group_12043" transform="translate(-978 -395)">
            <g id="team-member-6">
                <path
                    className="st0"
                    d="M16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16S0 24.8 0 16 7.2 0 16 0z"
                    transform="translate(978 395)"
                />
                <path
                    d="M16 32C7.2 32 0 24.8 0 16S7.2 0 16 0s16 7.2 16 16-7.2 16-16 16zm0-31C7.7 1 1 7.7 1 16s6.7 15 15 15 15-6.7 15-15S24.3 1 16 1z"
                    fill="#d8d8d8"
                    transform="translate(978 395)"
                />
            </g>
            <g id="Group_12039" transform="translate(983 400)">
                <g id="Group_9648" transform="translate(3 3)">
                    <path id="Path_4786" d="M6.1.2c-3.3.8-5.7 3.6-6 7 2.9-1.3 5.2-3.8 6-7z" fill="#6ce6f9" />
                    <path
                        id="Path_4787"
                        d="M7.9 16c1.9-2.3 4.5-3.9 7.4-4.7.5-1 .7-2.2.7-3.3 0-2.5-1.2-4.9-3.2-6.4.4 6.6-5.6 7.9-9.6 9.7-.7.3-1.3.7-1.9 1.1 1.5 2.3 4 3.6 6.6 3.6z"
                        fill="#466af3"
                    />
                    <path
                        id="Path_4788"
                        d="M12.9 1.6C11.5.6 9.8 0 8 0c-.6 0-1.3.1-1.9.2-.8 3.2-3.1 5.7-6 7-.1.2-.1.5-.1.8 0 1.6.5 3.1 1.3 4.4.6-.4 1.3-.8 1.9-1.1 4-1.8 10-3 9.7-9.7z"
                        fill="#5b9ff7"
                    />
                    <path id="Path_4789" d="M7.9 16H8c3.1 0 6-1.8 7.3-4.7-2.9.8-5.4 2.5-7.4 4.7z" fill="#314af2" />
                </g>
                <g id="Group_9649" transform="translate(6.092 7.169)">
                    <path
                        id="Path_4790"
                        className="st6"
                        d="M2.2 6.6c0 .6-.5 1.1-1.1 1.1S0 7.2 0 6.6V1.1C0 .5.5 0 1.1 0s1.1.5 1.1 1.1v5.5z"
                    />
                    <path
                        id="Path_4791"
                        className="st6"
                        d="M9.9 6.6c0 .6-.5 1.1-1.1 1.1s-1.1-.5-1.1-1.1V4.5c0-.6.5-1.1 1.1-1.1s1.1.5 1.1 1.1v2.1z"
                    />
                    <circle id="Ellipse_534" className="st0" cx={8.7} cy={1.1} r={1.1} />
                    <path
                        id="Path_4792"
                        className="st0"
                        d="M9.5 5.8c.4.5.4 1.2 0 1.6-.5.4-1.1.4-1.6 0L5.4 4.7c-.3-.3-.7-.3-1 0L1.9 7.4c-.4.4-1.1.4-1.6-.1-.4-.4-.4-1.1 0-1.5l3.8-3.9c.4-.5 1.2-.5 1.6 0l3.8 3.9z"
                    />
                </g>
            </g>
        </g>
    </svg>
)

export const SlackIcon: React.FunctionComponent = () => (
    <svg version="1.1" viewBox="0 0 270 270">
        <g>
            <g>
                <path
                    className="st0"
                    d="M99.4,151.2c0,7.1-5.8,12.9-12.9,12.9c-7.1,0-12.9-5.8-12.9-12.9c0-7.1,5.8-12.9,12.9-12.9h12.9V151.2z"
                    style={{ fill: '#E01E5A' }}
                />
                <path
                    className="st0"
                    d="M105.9,151.2c0-7.1,5.8-12.9,12.9-12.9s12.9,5.8,12.9,12.9v32.3c0,7.1-5.8,12.9-12.9,12.9
                s-12.9-5.8-12.9-12.9V151.2z"
                    style={{ fill: '#E01E5A' }}
                />
            </g>
            <g>
                <path
                    className="st1"
                    d="M118.8,99.4c-7.1,0-12.9-5.8-12.9-12.9c0-7.1,5.8-12.9,12.9-12.9s12.9,5.8,12.9,12.9v12.9H118.8z"
                    style={{ fill: '#36C5F0' }}
                />
                <path
                    className="st1"
                    d="M118.8,105.9c7.1,0,12.9,5.8,12.9,12.9s-5.8,12.9-12.9,12.9H86.5c-7.1,0-12.9-5.8-12.9-12.9
                s5.8-12.9,12.9-12.9H118.8z"
                    style={{ fill: '#36C5F0' }}
                />
            </g>
            <g>
                <path
                    className="st2"
                    d="M170.6,118.8c0-7.1,5.8-12.9,12.9-12.9c7.1,0,12.9,5.8,12.9,12.9s-5.8,12.9-12.9,12.9h-12.9V118.8z"
                    style={{ fill: '#2EB67D' }}
                />
                <path
                    className="st2"
                    d="M164.1,118.8c0,7.1-5.8,12.9-12.9,12.9c-7.1,0-12.9-5.8-12.9-12.9V86.5c0-7.1,5.8-12.9,12.9-12.9
                c7.1,0,12.9,5.8,12.9,12.9V118.8z"
                    style={{ fill: '#2EB67D' }}
                />
            </g>
            <g>
                <path
                    className="st3"
                    d="M151.2,170.6c7.1,0,12.9,5.8,12.9,12.9c0,7.1-5.8,12.9-12.9,12.9c-7.1,0-12.9-5.8-12.9-12.9v-12.9H151.2z"
                    style={{ fill: '#ECB22E' }}
                />
                <path
                    className="st3"
                    d="M151.2,164.1c-7.1,0-12.9-5.8-12.9-12.9c0-7.1,5.8-12.9,12.9-12.9h32.3c7.1,0,12.9,5.8,12.9,12.9
                c0,7.1-5.8,12.9-12.9,12.9H151.2z"
                    style={{ fill: '#ECB22E' }}
                />
            </g>
        </g>
    </svg>
)

export const TeamsIconURI = "data:image/svg+xml;base64,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"

export const SlackIconURI = "data:image/svg+xml;base64,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"

export const TeamsIcon: React.FunctionComponent = () => (
    <svg id="Layer_1" x="0px" y="0px" viewBox="0 0 64 64" xmlSpace="preserve">
        <style>{'.st01{fill:#5558af}'}</style>
        <g id="teams" transform="translate(-202 -202)">
            <circle id="Ellipse_494" className="st01" cx={234} cy={234} r={32} />
            <g id="Group_8807" transform="translate(215.2 215.4)">
                <path
                    id="Path_4391"
                    d="M31.5 14.1c.3.3.7.5 1.1.7.8.3 1.8.3 2.6 0s1.4-1 1.7-1.7c.3-.8.3-1.8 0-2.6s-1-1.4-1.7-1.7c-.8-.3-1.8-.3-2.6 0s-1.4 1-1.7 1.7c-.3.8-.3 1.8 0 2.6 0 .3.3.7.6 1zm-1 3.1v10.1h1.7c.6 0 1.1-.1 1.7-.1.6-.1 1.1-.3 1.6-.5.5-.3.9-.6 1.2-1.1.3-.5.5-1.1.5-1.7v-6.6l-6.7-.1zM25.1 13c.4 0 .9-.1 1.3-.3.8-.3 1.4-1 1.7-1.7.3-.8.3-1.8 0-2.6s-1-1.4-1.7-1.7c-.4-.2-.9-.2-1.3-.3-.4 0-.9.1-1.3.3-.3.1-.4.3-.8.5v5.1c.4.2.5.4.8.5.4.1.9.2 1.3.2zM23 29.9c.3.1.6.1.9.2.3.1.7.1 1 .1.5 0 1-.1 1.5-.1.5-.1 1-.3 1.5-.5.4-.3.8-.6 1.1-1.1.3-.5.4-1.1.4-1.7V15.1h-6.3L23 29.9zM0 33.1l21.7 3.7V0L0 3.7v29.4z"
                    fill="#fff"
                />
            </g>
            <path id="Path_4392" className="st01" d="M231.1 226.7l-10.1.6v2.3l3.7-.1v10.7l2.5.1v-11l3.7-.1.2-2.5z" />
        </g>
    </svg>
)

export const WidgetIcon: React.FunctionComponent = () => (
    <svg id="Layer_1" x="0px" y="0px" viewBox="0 0 64 64" xmlSpace="preserve">
        <style>{'.widgetIcon{fill:#fff}'}</style>
        <g id="widget" transform="translate(-11.5 -11.5)">
            <circle id="Ellipse_495" cx={43.5} cy={43.5} r={32} fill="#3789e1" />
            <g id="Group_9173" transform="translate(28.636 28.623)">
                <path
                    id="Path_4519"
                    className="widgetIcon"
                    d="M17.6 24.8h2.1v.7c0 .5.4 1 1 1 .3 0 .2 0 3.2-1.7h.5c.9 0 1.7-.8 1.7-1.7V19c0-.9-.8-1.7-1.7-1.7h-6.8c-.9 0-1.7.8-1.7 1.7v4.1c0 .9.8 1.7 1.7 1.7zm.2-5.5h6.4v3.6c-1 0-.5-.1-2.6 1 0-.5-.4-1-.9-1h-2.9v-3.6z"
                />
                <path
                    id="Path_4520"
                    className="widgetIcon"
                    d="M28.7 0H.9C.4 0 0 .4 0 .9v27.8c0 .5.4.9.9.9h27.8c.5 0 .9-.4.9-.9V.9c0-.5-.4-.9-.9-.9zm-.9 27.8H1.9V8.7h25.9v19.1zm0-21H1.9v-5h25.9v5z"
                />
                <path
                    id="Path_4521"
                    className="widgetIcon"
                    d="M14.5 5.3h10.1c.5 0 .9-.4.9-.9s-.4-.9-.9-.9H14.5c-.5 0-.9.4-.9.9s.4.9.9.9z"
                />
                <circle id="Ellipse_496" className="widgetIcon" cx={5.2} cy={4.4} r={0.9} />
                <circle id="Ellipse_497" className="widgetIcon" cx={8.2} cy={4.4} r={0.9} />
                <circle id="Ellipse_498" className="widgetIcon" cx={11.3} cy={4.4} r={0.9} />
            </g>
        </g>
    </svg>
)

export const SlackIconCC: React.FunctionComponent = () => (
    <svg id="Layer_1" x="0px" y="0px" viewBox="0 0 64 64" xmlSpace="preserve">
        <style>{'.st11{fill:#e01e5a}.st21{fill:#36c5f0}.st31{fill:#2eb67d}.st41{fill:#ecb22e}'}</style>
        <g id="slack" transform="translate(-60.1 -58.5)">
            <circle id="Ellipse_493" cx={92.1} cy={90.5} r={32} fill="#4a134a" />
            <g id="Group_8796" transform="translate(75.538 73.78)">
                <g id="Group_8792" transform="translate(0 17.145)">
                    <path
                        id="Path_4374"
                        className="st11"
                        d="M6.8 3.4c0 1.9-1.5 3.4-3.4 3.4S0 5.3 0 3.4 1.5 0 3.4 0h3.4v3.4z"
                    />
                    <path
                        id="Path_4375"
                        className="st11"
                        d="M8.6 3.4C8.6 1.5 10.1 0 12 0s3.4 1.5 3.4 3.4V12c0 1.9-1.5 3.4-3.4 3.4S8.6 13.9 8.6 12V3.4z"
                    />
                </g>
                <g id="Group_8793">
                    <path
                        id="Path_4376"
                        className="st21"
                        d="M12 6.8c-1.9 0-3.4-1.5-3.4-3.4S10.1 0 12 0s3.4 1.5 3.4 3.4v3.4H12z"
                    />
                    <path
                        id="Path_4377"
                        className="st21"
                        d="M12 8.6c1.9 0 3.4 1.5 3.4 3.4s-1.5 3.4-3.4 3.4H3.4C1.5 15.4 0 13.9 0 12s1.5-3.4 3.4-3.4H12z"
                    />
                </g>
                <g id="Group_8794" transform="translate(17.145)">
                    <path
                        id="Path_4378"
                        className="st31"
                        d="M8.6 12c0-1.9 1.5-3.4 3.4-3.4s3.4 1.5 3.4 3.4-1.5 3.4-3.4 3.4H8.6V12z"
                    />
                    <path
                        id="Path_4379"
                        className="st31"
                        d="M6.8 12c0 1.9-1.5 3.4-3.4 3.4S0 13.9 0 12V3.4C0 1.5 1.5 0 3.4 0s3.4 1.5 3.4 3.4V12z"
                    />
                </g>
                <g id="Group_8795" transform="translate(17.145 17.145)">
                    <path
                        id="Path_4380"
                        className="st41"
                        d="M3.4 8.6c1.9 0 3.4 1.5 3.4 3.4s-1.5 3.4-3.4 3.4S0 13.9 0 12V8.6h3.4z"
                    />
                    <path
                        id="Path_4381"
                        className="st41"
                        d="M3.4 6.8C1.5 6.8 0 5.3 0 3.4S1.5 0 3.4 0H12c1.9 0 3.4 1.5 3.4 3.4S13.9 6.8 12 6.8H3.4z"
                    />
                </g>
            </g>
        </g>
    </svg>
)

export const AgentSummaryIcon = () =>(
    <svg
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 30 30"
      xmlSpace="preserve"
    >
      <style>{".agentst0{fill:#526a86} .agentst2{fill:#fff} .st1{clip-path:url(#SVGID_00000139987178797033312340000016608929587387952063_)}"}</style>
      <g id="Group_14244" transform="translate(-6 -863)">
        <circle id="Imran_3" className="agentst0" cx={21} cy={878} r={15} />
        <g transform="translate(13 868)" id="Group_14245">
          <defs>
            <path id="SVGID_1_" d="M0 0H15.4V20H0z" />
          </defs>
          <clipPath id="SVGID_00000128445906948756551180000005584720719128318598_">
            <use xlinkHref="#SVGID_1_" overflow="visible" />
          </clipPath>
          <g
            id="Group_14245-2"
            clipPath="url(#SVGID_00000128445906948756551180000005584720719128318598_)"
          >
            <path
              id="Path_10541"
              className="agentst2"
              d="M13.9 10.7v-.4c-.2-1.2-1.3-2.1-2.5-2.1H4c-1.2 0-2.2.8-2.5 1.9-.1.2-.1.4-.1.7h-.3c-.5 0-1 .4-1.1.9v.6c.3 1.6.5 3.1.8 4.7.1.5.2.9.2 1.4 0 .6.6 1.1 1.2 1.1H13c.6 0 1.1-.4 1.2-1 .1-.4.1-.9.2-1.3.3-1.7.6-3.3.9-5 .1-.6-.3-1.2-.9-1.3-.1-.2-.3-.2-.5-.2M7.7 0C5.8 0 4.2 1.6 4.2 3.5S5.8 7 7.7 7s3.5-1.6 3.5-3.5S9.6 0 7.7 0m0 20H13.6c.1 0 .2-.1.2-.3 0-.1-.1-.2-.3-.2H1.9c-.2 0-.3.1-.3.3s.1.2.3.2h5.8"
            />
            <path
              id="Path_10542"
              className="agentst2"
              d="M13.9 10.7c.2 0 .4 0 .6.1.6.1 1 .7.9 1.3-.3 1.7-.6 3.3-.9 5-.1.4-.1.9-.2 1.3-.1.6-.6 1-1.2 1H2.3c-.6 0-1.2-.5-1.2-1.1 0-.5-.1-.9-.2-1.4-.3-1.6-.5-3.1-.8-4.7-.1-.2-.1-.4-.1-.6.1-.5.6-.9 1.1-.9h.3c0-.2 0-.4.1-.7.3-1.1 1.3-1.9 2.5-1.9H11.4c1.3 0 2.3.9 2.5 2.1v.5m-6.2.3H1.3h-.1c-.5 0-.8.4-.8.9 0 .2.1.5.1.7.2 1.5.5 3 .7 4.4.1.4.1.9.2 1.3s.5.7.9.7H13.1c.4 0 .7-.3.8-.7.1-.5.2-1 .2-1.5.2-1.4.5-2.8.7-4.3 0-.2.1-.5.1-.7 0-.5-.4-.9-.8-.9l-6.4.1"
            />
            <path
              id="Path_10543"
              className="agentst2"
              d="M7.7 0c1.9 0 3.5 1.6 3.5 3.5S9.6 7 7.7 7 4.2 5.4 4.2 3.5 5.8 0 7.7 0"
            />
            <path
              id="Path_10544"
              className="agentst2"
              d="M7.7 20H1.9c-.2 0-.3-.1-.3-.2s.1-.3.3-.3h11.7c.1 0 .3.1.3.2s-.2.3-.3.3H7.7"
            />
            <path
              id="Path_10545"
              className="agentst0"
              d="M7.7 11h6.5c.5 0 .9.3.9.8 0 .2-.1.5-.1.7-.2 1.4-.5 2.8-.7 4.3-.1.5-.2 1-.2 1.5-.1.4-.4.7-.8.7H2.5c-.4 0-.8-.3-.9-.7-.1-.4-.1-.9-.2-1.3-.2-1.4-.5-2.8-.7-4.3 0-.2-.1-.5-.1-.7-.1-.5.3-.9.7-.9h.1l6.3-.1m-.5 3.9c0 .3.2.5.5.5s.5-.2.5-.5-.2-.5-.5-.5-.5.2-.5.5"
            />
            <path
              id="Path_10546"
              className="agentst2"
              d="M7.2 14.9c0-.3.2-.5.5-.5s.5.2.5.5-.2.5-.5.5-.5-.2-.5-.5"
            />
          </g>
        </g>
      </g>
    </svg>
)

export const AgentSummaryIconNew = () =>(
    <svg
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 30 30"
      xmlSpace="preserve"
    >
      <style>{".agentSummaryIconNew0{fill:#526a86}.agentSummaryIconNew{fill:#fff}"}</style>
      <g id="Group_14244" transform="translate(-6 -863)">
        <circle id="Imran_3" className="st0" cx={21} cy={878} r={14.8} />
        <g transform="translate(13 868)" id="Group_14245">
          <g id="Group_14245-2">
            <path
              id="Path_10541"
              className="agentSummaryIconNew"
              d="M13.9 10.7v-.4c-.2-1.2-1.3-2.1-2.5-2.1H4c-1.2 0-2.2.8-2.5 1.9-.1.2-.1.4-.1.7h-.3c-.5 0-1 .4-1.1.9v.6c.3 1.6.5 3.1.8 4.7.1.5.2.9.2 1.4 0 .6.6 1.1 1.2 1.1H13c.6 0 1.1-.4 1.2-1 .1-.4.1-.9.2-1.3.3-1.7.6-3.3.9-5 .1-.6-.3-1.2-.9-1.3-.1-.2-.3-.2-.5-.2M7.7 0C5.8 0 4.2 1.6 4.2 3.5S5.8 7 7.7 7s3.5-1.6 3.5-3.5S9.6 0 7.7 0m0 20H13.6c.1 0 .2-.1.2-.3 0-.1-.1-.2-.3-.2H1.9c-.2 0-.3.1-.3.3s.1.2.3.2h5.8"
            />
            <path
              id="Path_10542"
              className="agentSummaryIconNew"
              d="M13.9 10.7c.2 0 .4 0 .6.1.6.1 1 .7.9 1.3-.3 1.7-.6 3.3-.9 5-.1.4-.1.9-.2 1.3-.1.6-.6 1-1.2 1H2.3c-.6 0-1.2-.5-1.2-1.1 0-.5-.1-.9-.2-1.4-.3-1.6-.5-3.1-.8-4.7-.1-.2-.1-.4-.1-.6.1-.5.6-.9 1.1-.9h.3c0-.2 0-.4.1-.7.3-1.1 1.3-1.9 2.5-1.9H11.4c1.3 0 2.3.9 2.5 2.1v.5m-6.2.3H1.2c-.5 0-.8.4-.8.9 0 .2.1.5.1.7.2 1.5.5 3 .7 4.4.1.4.1.9.2 1.3s.5.7.9.7H13.1c.4 0 .7-.3.8-.7.1-.5.2-1 .2-1.5.2-1.4.5-2.8.7-4.3 0-.2.1-.5.1-.7 0-.5-.4-.9-.8-.9l-6.4.1"
            />
            <path
              id="Path_10543"
              className="agentSummaryIconNew"
              d="M7.7 0c1.9 0 3.5 1.6 3.5 3.5S9.6 7 7.7 7 4.2 5.4 4.2 3.5 5.8 0 7.7 0"
            />
            <path
              id="Path_10544"
              className="agentSummaryIconNew"
              d="M7.7 20H1.9c-.2 0-.3-.1-.3-.2s.1-.3.3-.3h11.7c.1 0 .3.1.3.2s-.2.3-.3.3H7.7"
            />
            <path
              id="Path_10545"
              className="agentSummaryIconNew0"
              d="M7.6 11.2h6.1c.5 0 .8.3.8.8 0 .2-.1.5-.1.7-.2 1.3-.5 2.7-.7 4.1-.1.5-.2 1-.2 1.4-.1.4-.4.7-.8.7H2.5c-.4 0-.8-.3-.8-.7-.1-.4-.1-.9-.2-1.2-.2-1.3-.5-2.7-.7-4.1 0-.2-.1-.5-.1-.7-.1-.5.3-.9.7-.9h.1l6.1-.1m-.4 3.7c0 .3.2.5.5.5s.5-.2.5-.5-.2-.5-.5-.5-.5.2-.5.5"
            />
            <path
              id="Path_10546"
              className="agentSummaryIconNew"
              d="M7.2 14.9c0-.3.2-.5.5-.5s.5.2.5.5-.2.5-.5.5-.5-.2-.5-.5"
            />
          </g>
        </g>
      </g>
    </svg>
)

export const WidgetCardIcon: React.FunctionComponent = () => (
    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 24 24" xmlSpace="preserve">
        <path d="M4.1 18.6H9v1.7c0 1.2 1 2.2 2.2 2.2.8 0 .4.1 7.5-3.9h1.1c2.2 0 3.9-1.7 3.9-3.9V5.3c0-2.2-1.7-3.9-3.9-3.9H4.1C2 1.4.2 3.2.2 5.3v9.4c0 2.2 1.8 3.9 3.9 3.9zM3.6 5h16.9v9.6c-2.6 0-1.5-.3-6.9 2.7 0-1.7-1.2-2.7-2.5-2.7H3.6V5z" />
    </svg>
)

export const IntegrationIcon: React.FunctionComponent = () => (
    <svg data-name="Layer 1" viewBox="0 0 32 32">
        <path d="M8.33 31.57a7.9 7.9 0 01-5.59-13.49l5.6-5.61a7.93 7.93 0 0111.19 0 13.17 13.17 0 011.68 2 1 1 0 01-.3 1.35 1 1 0 01-1.34-.3 10.69 10.69 0 00-1.42-1.7 6 6 0 00-8.43 0l-5.61 5.64a6 6 0 000 8.43 6 6 0 008.44 0l3.73-3.81a1 1 0 011.39 1.37l-3.74 3.81a7.93 7.93 0 01-5.6 2.31z" />
        <path d="M18.07 21.84a7.88 7.88 0 01-5.6-2.31 13.17 13.17 0 01-1.68-2 1 1 0 01.3-1.35 1 1 0 011.34.3 10.69 10.69 0 001.42 1.7 6 6 0 004.22 1.75 5.91 5.91 0 004.21-1.75l5.61-5.61a6 6 0 000-8.43 6 6 0 00-8.44 0l-3.73 3.78a1 1 0 01-1.39-1.37l3.74-3.81a7.91 7.91 0 0111.19 0 7.89 7.89 0 010 11.18l-5.6 5.61a7.88 7.88 0 01-5.59 2.31z" />
    </svg>
)

export const AnalyticsIcon: React.FunctionComponent = () => (
    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 147 145.77">
        <title />
        <path d="M24,112v30.24H12.61V112H24m5-5H7.61v40.24H29V107Z" transform="translate(-1.32 -2.36)" />
        <path d="M62,82v60.24H50.66V82H62m5-5H45.66v70.24H67V77Z" transform="translate(-1.32 -2.36)" />
        <path d="M100.07,92v50.24H88.71V92h11.36m5-5H83.71v60.24h21.36V87Z" transform="translate(-1.32 -2.36)" />
        <path d="M138.12,54v88.24H126.77V54h11.35m5-5H121.77v98.24h21.35V49Z" transform="translate(-1.32 -2.36)" />
        <rect y="140.77" width="147" height="5" />
        <path
            d="M18.15,82.44A14.41,14.41,0,1,1,32.56,68,14.43,14.43,0,0,1,18.15,82.44Zm0-23.82A9.41,9.41,0,1,0,27.56,68,9.42,9.42,0,0,0,18.15,58.62Z"
            transform="translate(-1.32 -2.36)"
        />
        <path
            d="M55.11,51.54A14.41,14.41,0,1,1,69.52,37.13,14.42,14.42,0,0,1,55.11,51.54Zm0-23.82a9.41,9.41,0,1,0,9.41,9.41A9.42,9.42,0,0,0,55.11,27.72Z"
            transform="translate(-1.32 -2.36)"
        />
        <path
            d="M95.62,62.08A14.41,14.41,0,1,1,110,47.67,14.43,14.43,0,0,1,95.62,62.08Zm0-23.82A9.41,9.41,0,1,0,105,47.67,9.43,9.43,0,0,0,95.62,38.26Z"
            transform="translate(-1.32 -2.36)"
        />
        <path
            d="M132.58,31.18A14.41,14.41,0,1,1,147,16.77,14.42,14.42,0,0,1,132.58,31.18Zm0-23.82A9.41,9.41,0,1,0,142,16.77,9.42,9.42,0,0,0,132.58,7.36Z"
            transform="translate(-1.32 -2.36)"
        />
        <rect x="23.89" y="49.48" width="24.43" height="5" transform="translate(-25.82 31.39) rotate(-38.48)" />
        <rect x="72.87" y="34.21" width="5" height="17.02" transform="translate(17.47 105.96) rotate(-78.77)" />
        <rect x="101.8" y="29.62" width="24.45" height="5" transform="translate(7.3 83.82) rotate(-42.89)" />
    </svg>
)

export const LogoutIcon: React.FunctionComponent = () => (
    <svg viewBox="0 0 447.7 365.4">
        <g>
            <path
                d="M182.7,338c-0.6-1.5-0.8-2.8-0.6-3.9c0.2-1-0.5-1.9-2-2.6s-2.3-1.2-2.3-1.6c0-0.4-1.1-0.7-3.3-0.9
c-2.2-0.2-3.3-0.3-3.3-0.3h-3.7h-3.1H82.2c-12.6,0-23.3-4.5-32.3-13.4c-8.9-8.9-13.4-19.7-13.4-32.3v-201C36.5,69.7,41,58.9,50,50
c8.9-8.9,19.7-13.4,32.3-13.4h91.4c2.5,0,4.4-0.6,5.9-1.9c1.4-1.2,2.4-3.1,2.9-5.6c0.5-2.5,0.8-4.7,0.9-6.7c0.1-2,0-4.5-0.1-7.6
c-0.2-3-0.3-4.9-0.3-5.7c0-2.5-0.9-4.6-2.7-6.4c-1.8-1.8-3.9-2.7-6.4-2.7H82.2c-22.6,0-42,8-58.1,24.1C8,40.2,0,59.6,0,82.2v201
c0,22.6,8,42,24.1,58.1c16.1,16.1,35.5,24.1,58.1,24.1h91.4c2.5,0,4.4-0.6,5.9-1.9c1.4-1.2,2.4-3.1,2.9-5.6
c0.5-2.5,0.8-4.7,0.9-6.7c0.1-2,0-4.5-0.1-7.6C182.8,340.7,182.7,338.8,182.7,338"
            />
            <path
                d="M442.2,169.9L286.9,14.6c-3.6-3.6-7.9-5.4-12.8-5.4s-9.2,1.8-12.9,5.4c-3.6,3.6-5.4,7.9-5.4,12.9v82.2H127.9
c-5,0-9.2,1.8-12.8,5.4c-3.6,3.6-5.4,7.9-5.4,12.9v109.6c0,4.9,1.8,9.2,5.4,12.8c3.6,3.6,7.9,5.4,12.8,5.4h127.9V338
c0,4.9,1.8,9.2,5.4,12.8c3.6,3.6,7.9,5.4,12.9,5.4c4.9,0,9.2-1.8,12.8-5.4l155.3-155.3c3.6-3.6,5.4-7.9,5.4-12.8
C447.7,177.8,445.9,173.5,442.2,169.9"
            />
        </g>
    </svg>
)

export const RetryIcon: React.FunctionComponent = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className="svg-inline--fa fa-redo-alt fa-w-16 fa-3x">
        <path
            fill="currentColor"
            d="M256.455 8c66.269.119 126.437 26.233 170.859 68.685l35.715-35.715C478.149 25.851 504 36.559 504 57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.75c-30.864-28.899-70.801-44.907-113.23-45.273-92.398-.798-170.283 73.977-169.484 169.442C88.764 348.009 162.184 424 256 424c41.127 0 79.997-14.678 110.629-41.556 4.743-4.161 11.906-3.908 16.368.553l39.662 39.662c4.872 4.872 4.631 12.815-.482 17.433C378.202 479.813 319.926 504 256 504 119.034 504 8.001 392.967 8 256.002 7.999 119.193 119.646 7.755 256.455 8z"
        />
    </svg>
)

// Dialog Editor Canvas Page Icons

export const MoreIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4 16">
        <title>More</title>
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <path d="M0,14a2,2,0,1,1,2,2,2,2,0,0,1-2-2" />
                <path d="M0,2A2,2,0,1,1,2,4,2,2,0,0,1,0,2" />
                <path d="M0,8a2,2,0,1,1,2,2A2,2,0,0,1,0,8" />
            </g>
        </g>
    </svg>
)

export const OptionIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" version="1.1" width="48px" height="48px">
        <g id="surface1">
            <path d="M 6 22 L 42 22 L 42 26 L 6 26 Z " />
            <path d="M 6 10 L 42 10 L 42 14 L 6 14 Z " />
            <path d="M 6 34 L 42 34 L 42 38 L 6 38 Z " />
        </g>
    </svg>
)
export const DialogOptionIcon = () => (
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 24 24" xmlSpace="preserve">
        <style>{'.sst0{fill:currentColor}'}</style>
        <g id="menu_option" transform="translate(-874 -20044)">
            <g id="Group_12442" transform="translate(254.963 18739.369)">
                <g id="Group_8023" transform="translate(625 1312)">
                    <path
                        id="Path_4258"
                        className="sst0"
                        d="M11.7 1.2H.4C.2 1.2 0 .9 0 .6S.2 0 .4 0h11.3c.2 0 .4.3.4.6s-.2.6-.4.6z"
                    />
                </g>
                <g id="Group_8024" transform="translate(625 1316.026)">
                    <path
                        id="Path_4259"
                        className="sst0"
                        d="M11.7 1.2H.4C.2 1.2 0 .9 0 .6S.2 0 .4 0h11.3c.2 0 .4.3.4.6s-.2.6-.4.6z"
                    />
                </g>
                <g id="Group_8025" transform="translate(625 1320.052)">
                    <path
                        id="Path_4260"
                        className="sst0"
                        d="M11.7 1.2H.4C.2 1.2 0 .9 0 .6S.2 0 .4 0h11.3c.2 0 .4.3.4.6s-.2.6-.4.6z"
                    />
                </g>
            </g>
        </g>
    </svg>
)
export const VariableIcon = () => (
    <svg id="Capa_1" x="0px" y="0px" viewBox="0 0 26 26" xmlSpace="preserve">
        <path
            className="st0"
            d="M23 2H3C1.3 2 0 3.3 0 5v16c0 1.7 1.3 3 3 3h20c1.7 0 3-1.3 3-3V5c0-1.7-1.3-3-3-3zm1 19c0 .6-.4 1-1 1H3c-.6 0-1-.4-1-1V7h22v14z"
        />
        <path
            className="st0"
            d="M19.4 14.2c0 1-.1 1.9-.4 2.7-.1.5-.5 1.2-.9 2.1h1.2c.5-.9.9-1.6 1.1-2 .3-.8.5-1.8.5-2.8 0-.4 0-.8-.1-1.3-.1-.4-.2-.9-.4-1.3-.1-.4-.3-.6-.4-.8-.1-.1-.2-.4-.4-.7h-1.2c.3.6.5 1 .6 1.4.3.7.4 1.7.4 2.7zM6.6 14.2c0 1 .1 1.9.4 2.7.1.5.5 1.2.9 2.1H6.7c-.5-.9-.9-1.6-1.1-2-.3-.8-.5-1.8-.5-2.8 0-.4 0-.8.1-1.3.1-.4.2-.9.4-1.3.1-.4.3-.6.4-.8 0-.2.2-.4.4-.8h1.2c-.3.6-.5 1-.6 1.4-.3.8-.4 1.8-.4 2.8zM17 12.1c0 .4-.1.7-.4.9s-.5.3-.9.3c-.2 0-.4 0-.6-.1-.2-.1-.4-.1-.5-.2-.1 0-.2.2-.3.3-.1.2-.3.4-.5.6.2.7.3 1.1.4 1.4.1.3.2.6.3.8.1.2.2.4.3.5.1.1.4.2.7.2.1 0 .3 0 .4-.1.2 0 .3-.1.4-.1l-.1.6c-.4.2-.8.3-1.1.4-.3.1-.6.1-.9.1-.2 0-.4 0-.5-.1-.2 0-.3-.1-.5-.2s-.3-.2-.4-.4c-.1-.1-.2-.3-.3-.6-.1-.2-.1-.3-.1-.5s-.1-.4-.1-.5c-.2.4-.3.5-.3.6-.1.1-.1.2-.2.4-.3.5-.6.9-.9 1.1s-.6.3-.9.3c-.3 0-.5-.1-.7-.3s-.3-.3-.3-.6c0-.4.1-.7.4-.9.2-.2.5-.3.9-.3.2 0 .4 0 .6.1s.4.1.5.2l.3-.3c.1-.2.3-.3.4-.6-.1-.6-.3-1-.4-1.3l-.3-.9c-.1-.2-.2-.4-.3-.5-.1-.1-.4-.2-.7-.2-.1 0-.3 0-.4.1-.2 0-.3.1-.4.1l.1-.6c.4-.2.8-.3 1.1-.4.4-.1.6-.1.9-.1h.5c.2 0 .3.1.5.2s.3.2.4.4.2.3.3.6c.1.2.1.4.1.5 0 .2.1.3.1.5.1-.1.2-.3.3-.4s.2-.3.2-.4c.3-.5.6-.9.9-1.1.3-.2.6-.3.9-.3.3 0 .5.1.7.3.3 0 .4.2.4.5z"
        />
    </svg>
)
export const DialogVariableIcon = () => (
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 24 24" xmlSpace="preserve">
        <style>{'.sst1{fill:none;stroke:currentColor;stroke-width:.8}.sst2{fill:currentColor}'}</style>
        <g id="custom_variable" transform="translate(-874 -20233)">
            <g id="Group_12464" transform="translate(90.77 20.844)">
                <g id="Group_12462" transform="translate(789.004 20217.93)">
                    <g id="Rectangle_2100">
                        <path
                            d="M1 0h10c.6 0 1 .4 1 1v10c0 .6-.4 1-1 1H1c-.6 0-1-.4-1-1V1c0-.6.4-1 1-1z"
                            fill="none"
                            transform="translate(.227 .227)"
                        />
                        <path
                            className="sst1"
                            d="M1 .4h10c.3 0 .6.3.6.6v10c0 .3-.3.6-.6.6H1c-.3 0-.6-.3-.6-.6V1C.4.7.7.4 1 .4z"
                            transform="translate(.227 .227)"
                        />
                    </g>
                    <path id="Line_561" className="sst1" d="M0.4 2.7L12.1 2.7" />
                </g>
                <path
                    id="Path_10195"
                    className="sst2"
                    d="M798.5 20225.1c0 .5-.1.9-.2 1.4-.1.4-.3.7-.5 1.1h.6c.3-.5.5-.8.6-1 .2-.5.3-.9.3-1.4 0-.2 0-.4-.1-.7 0-.2-.1-.4-.2-.7 0-.1-.1-.3-.2-.4-.1-.1-.1-.2-.2-.4h-.6c.1.2.2.5.3.7.1.5.2.9.2 1.4z"
                />
                <path
                    id="Path_10196"
                    className="sst2"
                    d="M792 20225.1c0 .5.1.9.2 1.4.1.4.3.7.5 1.1h-.7c-.3-.5-.5-.8-.6-1-.2-.5-.3-.9-.3-1.4 0-.2 0-.4.1-.7 0-.2.1-.4.2-.7 0-.1.1-.3.2-.4 0-.1.1-.2.2-.4h.6c-.1.2-.2.5-.3.7-.1.4-.1.9-.1 1.4z"
                />
                <g id="Group_12463" transform="translate(793.201 20223.621)">
                    <path
                        id="Path_4280"
                        className="sst2"
                        d="M4 .4c0 .2-.1.4-.2.5-.1.1-.2.1-.4.1h-.3C3 .9 2.9.9 2.8.9l-.1.1-.3.3c.1.4.2.6.2.7 0 .1.1.3.2.4 0 .1.1.2.2.3 0 .1.2.1.3.1s.1 0 .2-.1c.1 0 .2-.1.2-.1l-.1.4c-.1.1-.3.1-.5.2-.1 0-.3.1-.5.1-.1 0-.2 0-.3-.1-.1 0-.2-.1-.3-.1 0-.1 0-.1-.1-.2 0-.1-.1-.2-.1-.3 0-.1-.1-.2-.1-.3s0-.2-.1-.3c0 .3-.1.3-.1.4 0 0 0 .1-.1.2-.1.2-.2.4-.4.5-.2.1-.3.2-.5.2-.1 0-.3-.1-.4-.2 0 0-.1-.2-.1-.3 0-.2.1-.4.2-.5s.3-.2.5-.2c.1 0 .2 0 .3.1s.2.1.3.1l.2-.2c.1-.1.2-.2.2-.3 0-.2-.1-.4-.2-.7L1.2.8c0-.1-.1-.2-.2-.3C1 .5.8.4.7.5.6.5.6.5.5.6.4.6.3.7.3.7L.4.4C.6.3.8.3 1 .2c.1-.2.2-.2.4-.2h.3c.1 0 .2.1.3.1 0 0 0 .1.1.2s.1.2.2.3c0 .1.1.2.1.3-.1.1-.1.1-.1.2.1 0 .1-.1.2-.2s.1-.1.1-.2c.1-.2.2-.4.4-.5s.3-.2.5-.2c.1 0 .3.1.4.2.1 0 .1.1.1.2z"
                    />
                </g>
            </g>
        </g>
    </svg>
)
export const JumpIcon = () => (
    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 8.93">
        <title>Jump</title>
        <rect x="12.91" y="1.33" width="0.66" height="2.78" rx="0.3" />
        <circle cx="13.22" cy="8.15" r="0.78" />
        <path d="M12.31,1S13.58.9,13.58,2V2.5h-.67a.71.71,0,0,0-.78-.76V1Z" transform="translate(0 -0.53)" />
        <path d="M12.31,5.42s1.27.06,1.27-1.06V3.88h-.67a.71.71,0,0,1-.78.76v.78Z" transform="translate(0 -0.53)" />
        <circle cx="0.78" cy="0.78" r="0.78" />
        <rect x="0.72" y="0.42" width="11.77" height="0.78" rx="0.35" />
        <rect x="1.39" y="4.1" width="11.1" height="0.78" rx="0.35" />
        <rect x="0.36" y="5.54" width="0.66" height="2.78" rx="0.3" transform="translate(1.39 13.33) rotate(180)" />
        <path d="M1.63,4.64S.36,4.58.36,5.7v.48H1a.71.71,0,0,1,.78-.76V4.64Z" transform="translate(0 -0.53)" />
        <rect x="1.45" y="8.32" width="11.89" height="0.78" rx="0.35" transform="translate(14.78 16.89) rotate(180)" />
        <path d="M1.63,9.1s-1.27.06-1.27-1V7.56H1a.71.71,0,0,0,.78.76V9.1Z" transform="translate(0 -0.53)" />
    </svg>
)

export const DialogJumpICon = () => (
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 24 24" xmlSpace="preserve">
        <style>{'.st0s{fill:currentColor}'}</style>
        <g id="jumpto" transform="translate(-874 -20075)">
            <g id="Group_12444" transform="translate(172.904 17903.787)">
                <g id="Group_8031" transform="translate(707 2178.293)">
                    <g id="Group_8030">
                        <g id="Group_8027" transform="translate(0 1.023)">
                            <path
                                id="Path_4261"
                                className="st0s"
                                d="M10.2.4c0 .2-.2.4-.4.4H.4C.2.8 0 .6 0 .4S.2 0 .4 0h9.4c.2 0 .4.2.4.4z"
                            />
                        </g>
                        <g id="Group_8028">
                            <path
                                id="Path_4262"
                                className="st0s"
                                d="M1.6.4c0 .1 0 .2-.1.3l-.6.7.6.6c.1.2.1.4 0 .5-.2.2-.4.2-.5 0l-.9-.8c-.1-.2-.1-.4 0-.6l.9-1c.1-.1.4-.1.5 0s.1.2.1.3z"
                            />
                        </g>
                        <g id="Group_8029" transform="translate(10.31 7.555)">
                            <path
                                id="Path_4263"
                                className="st0s"
                                d="M1.8 1.4c0 .1 0 .2-.1.3l-1 .9c-.2.1-.4.1-.5 0C0 2.4 0 2.1.1 2l.8-.6L.3.6C.2.4.2.2.3.1s.4-.1.5 0l.9 1c0 .1.1.2.1.3z"
                            />
                        </g>
                    </g>
                </g>
                <g id="Group_8032" transform="translate(716.443 2179.315)">
                    <path
                        id="Path_4264"
                        className="st0s"
                        d="M2.6 2.3c0 1.3-1 2.3-2.3 2.3-.1-.1-.3-.2-.3-.4s.1-.4.3-.4c.8 0 1.5-.7 1.5-1.5S1.1.8.3.8C.2.8 0 .6 0 .4S.2 0 .4 0c1.2 0 2.2 1 2.2 2.3z"
                    />
                </g>
                <g id="Group_8033" transform="translate(708.889 2183.093)">
                    <path
                        id="Path_4265"
                        className="st0s"
                        d="M8.3.4c0 .2-.2.4-.4.4H.4C.2.8 0 .6 0 .4S.1 0 .3 0h7.6c.2 0 .4.2.4.4z"
                    />
                </g>
                <g id="Group_8034" transform="translate(708.889 2186.87)">
                    <path
                        id="Path_4266"
                        className="st0s"
                        d="M10.2.4c0 .2-.2.4-.4.4H.4C.2.8 0 .6 0 .4S.1 0 .3 0h9.4c.3 0 .5.2.5.4z"
                    />
                </g>
                <g id="Group_8035" transform="translate(707 2183.093)">
                    <path
                        id="Path_4267"
                        className="st0s"
                        d="M2.6.4c0 .2-.2.4-.4.4C1.4.8.7 1.5.7 2.3s.7 1.5 1.5 1.5c.2 0 .4.1.4.4 0 .2-.1.4-.4.4C1 4.5 0 3.5 0 2.3 0 1 1 0 2.3 0c.2 0 .3.2.3.4z"
                    />
                </g>
            </g>
        </g>
    </svg>
)

export const ResponseIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
        <title>Response</title>
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <path d="M7,0a7,7,0,1,0,7,7A7,7,0,0,0,7,0Zm.87,8.61a8.82,8.82,0,0,1-2.39,2.16l-.37-.41A7.09,7.09,0,0,0,6.49,8.84a4.07,4.07,0,0,0,.67-1.61,1.61,1.61,0,0,1-1.31-.58A1.88,1.88,0,0,1,5.44,5.4a1.81,1.81,0,0,1,.41-1.25,1.67,1.67,0,0,1,1.31-.54,1.61,1.61,0,0,1,1.29.54A1.84,1.84,0,0,1,8.89,5.4,5.38,5.38,0,0,1,7.87,8.61Z" />
            </g>
        </g>
    </svg>
)
export const DialogResponseIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 24 24" xmlSpace="preserve">
        <path
            d="M883.2 19997.9c.6-.2 1.3-.5 1.8-.8.6-.3 1.1-.7 1.5-1.2.4-.4.7-.9 1-1.4.2-.5.4-1 .4-1.6 0-.3-.1-.6-.2-.8-.1-.2-.3-.3-.5-.4-.2 0-.3 0-.5.1-.1.1-.2.1-.4.2-.1.1-.3.2-.4.2-.2.1-.4.1-.7.1s-.6-.1-.8-.2c-.3-.1-.5-.3-.7-.5s-.4-.5-.5-.8-.2-.6-.2-1 .1-.7.2-1c.2-.3.4-.6.6-.8l.9-.6c.4-.1.8-.2 1.2-.2.5 0 1 .1 1.5.4.5.2.9.6 1.2 1 .4.4.6.9.8 1.4.2.6.3 1.2.3 1.8 0 .9-.2 1.9-.6 2.7-.4.8-.9 1.5-1.5 2.2-.6.6-1.4 1.1-2.2 1.5s-1.7.6-2.6.7l.4-1z"
            fill="currentColor"
            transform="translate(-874 -19980)"
        />
    </svg>
)

export const SlotsIcon = () => (
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4.1 7">
        <g id="outline">
            <path
                d="M3.6,6.1L3.6,6.1L3.5,5.8c0-0.1-0.1-0.1-0.1-0.1c-0.1,0-0.3-0.1-0.3-0.3C3.1,5.4,3,5.3,3,5.3H2.2V4.9l1.5-1.1
        c0.1,0,0.1-0.1,0-0.2c0,0,0,0,0,0L3.2,3.2l0.5-0.3c0.1,0,0.1-0.1,0-0.2c0,0,0,0,0,0L3.2,2.3l0.5-0.3c0.1,0,0.1-0.1,0-0.2
        c0,0,0,0,0,0L2.2,0.6V0.3c0-0.1-0.1-0.1-0.1-0.1C2,0.2,1.9,0.2,1.9,0.3v0.3L0.4,1.7c-0.1,0-0.1,0.1,0,0.2c0,0,0,0,0,0l0.5,0.3
        L0.4,2.6c-0.1,0-0.1,0.1,0,0.2c0,0,0,0,0,0l0.5,0.3L0.4,3.5c-0.1,0-0.1,0.1,0,0.2c0,0,0,0,0,0l1.5,1.1v0.4H1.2C1.1,5.3,1,5.4,1,5.4
        c0,0.1-0.1,0.3-0.3,0.3c-0.1,0-0.1,0-0.1,0.1L0.5,6.1h0c-0.2,0-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4h3.1C3.8,6.9,4,6.7,4,6.5
        S3.8,6.1,3.6,6.1z M1.9,0.9v0.8c0,0.1,0.1,0.1,0.1,0.1c0.1,0,0.1-0.1,0.1-0.1V0.9l1.2,0.9l-1.3,1l-1.3-1L1.9,0.9z M1.1,2.4L2,3.1
        c0,0,0.1,0,0.2,0L3,2.5l0.4,0.3l-1.3,1l-1.3-1L1.1,2.4L1.1,2.4z M1.1,3.3L2,4c0,0,0.1,0,0.2,0L3,3.4l0.4,0.3l-1.3,1l-1.3-1L1.1,3.3
        L1.1,3.3z M0.9,5.9c0.2,0,0.4-0.2,0.4-0.4h1.6C2.9,5.8,3,5.9,3.2,5.9l0,0.1H0.8L0.9,5.9z M3.6,6.6H0.5c-0.1,0-0.1-0.1-0.1-0.1
        s0.1-0.1,0.1-0.1h3.1c0.1,0,0.1,0.1,0.1,0.1S3.7,6.6,3.6,6.6z"
            />
        </g>
    </svg>
)
export const DialogSlotsIcon = () => (
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 24 24" xmlSpace="preserve">
        <style>{'.stp0{fill:currentColor}'}</style>
        <g id="verify_userdetails_" transform="translate(-874 -20106)">
            <g id="Group_12461" transform="translate(163.987 15713.922)">
                <g id="Group_12459" transform="translate(715.934 4399)">
                    <g id="Group_12455" transform="translate(0 6.035)">
                        <path
                            id="Path_10190"
                            className="stp0"
                            d="M9.2 4H.9C.4 4 0 3.6 0 3.1v-.7c0-.2.1-.4.3-.5L3.8 0c.2-.1.5 0 .7.3s0 .5-.2.7L1 2.7V3h8v-.3L5.8.9C5.5.8 5.5.5 5.6.3s.4-.4.7-.2L9.8 2c.2 0 .3.2.3.4v.8c0 .4-.4.8-.9.8z"
                        />
                    </g>
                    <g id="Group_12456" transform="translate(8.081)">
                        <path
                            id="Path_10191"
                            className="stp0"
                            d="M3.5 1h-3C.2 1 0 .8 0 .5S.2 0 .5 0h3c.3 0 .5.2.5.5s-.2.5-.5.5z"
                        />
                    </g>
                    <g id="Group_12457" transform="translate(8.081 1.509)">
                        <path
                            id="Path_10192"
                            className="stp0"
                            d="M3.5 1h-3C.2 1 0 .8 0 .5S.2 0 .5 0h3c.3 0 .5.2.5.5s-.2.5-.5.5z"
                        />
                    </g>
                    <g id="Group_12458" transform="translate(8.081 3.018)">
                        <path
                            id="Path_10193"
                            className="stp0"
                            d="M3.5 1h-3C.2 1 0 .8 0 .5S.2 0 .5 0h3c.3 0 .5.2.5.5s-.2.5-.5.5z"
                        />
                    </g>
                </g>
                <g id="Group_12460" transform="translate(718.449 4399.503)">
                    <path
                        id="Path_10194"
                        className="stp0"
                        d="M1.5 6.5c-.1 0-.2 0-.3-.1C.4 5.7 0 4.7 0 3.7V2C.3.8 1.3 0 2.5 0S4.7.8 5 2V3.7c0 1-.4 2-1.2 2.8-.2.1-.5.1-.7-.1s-.1-.6.1-.7c.5-.6.8-1.3.8-2V2.1C3.7 1.3 2.9.8 2 1c-.4.2-.8.6-1 1.1v1.5c0 .7.3 1.5.8 2 .2.2.3.5.1.8-.1.1-.2.1-.4.1z"
                    />
                </g>
            </g>
        </g>
    </svg>
)

export const QaIcon = () => (
    <svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44">
        {/* <ellipse className="st0" cx="21.9" cy="21.9" rx="19.7" ry="19.9"/> */}
        <path
            id="XMLID_10_"
            className="st1"
            d="M22,10.1c-3.1,0-5.6,2.5-5.6,5.6c0,0.5,0.4,1,1,1s1-0.4,1-1c0-2,1.6-3.6,3.6-3.6
       s3.6,1.6,3.6,3.6v0.4c0,1.4-0.7,2.6-1.9,3.2C22,20.1,21,21.9,21,24v0.3c0,0.5,0.4,1,1,1c0.5,0,1-0.4,1-1V24c0-1.3,0.6-2.4,1.6-2.9
       c1.9-1,3-2.9,3-5v-0.4C27.6,12.6,25.1,10.1,22,10.1z"
        />
        <path
            id="XMLID_11_"
            className="st1"
            d="M22,29.2c-0.5,0-1,0.4-1,1v2.7c0,0.5,0.4,1,1,1c0.5,0,1-0.4,1-1v-2.7C23,29.6,22.5,29.2,22,29.2
       z"
        />
    </svg>
)

export const DialogQaIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 24 24" xmlSpace="preserve">
        <path
            d="M885.7 20025.2c0-.5 0-.9.1-1.3s.2-.7.3-1.1c.1-.3.3-.6.4-.9.2-.3.3-.6.4-.9.1-.3.3-.6.3-.9.1-.4.1-.7.1-1.1 0-.3 0-.7-.1-1s-.2-.5-.4-.7-.4-.3-.6-.4c-.2-.1-.5-.1-.7-.1s-.4 0-.7.1c-.2 0-.4.1-.5.2s-.3.2-.3.4c-.1.1-.1.3-.1.4s0 .3.1.4.1.2.2.3c.1.1.1.2.2.3.1.1.1.2.1.3 0 .2-.1.4-.2.6-.1.1-.3.2-.5.2-.1 0-.3 0-.4-.1l-.3-.3c-.1-.1-.2-.3-.2-.4-.1-.2-.1-.3-.1-.5 0-.4.1-.8.3-1.2.2-.3.4-.6.7-.8.3-.2.6-.4 1-.5s.7-.1 1.1-.1c.4 0 .9.1 1.3.2s.7.3 1 .5.5.5.7.9.2.7.2 1.1-.1.8-.2 1.2c-.2.4-.4.7-.6 1-.2.3-.5.6-.8 1-.3.3-.5.6-.8 1-.2.3-.4.7-.6 1-.2.4-.2.8-.2 1.2h-.2zm.3 1c.1 0 .2 0 .4.1.1 0 .2.1.3.2s.2.2.2.3c0 .1.1.2.1.4 0 .1 0 .3-.1.4 0 .1-.1.2-.2.3-.1.1-.2.2-.3.2s-.2.1-.4.1c-.1 0-.3 0-.4-.1-.1 0-.2-.1-.3-.2s-.2-.2-.2-.3c0-.1-.1-.2-.1-.4 0-.1 0-.3.1-.4 0-.1.1-.2.2-.3.1-.1.2-.2.3-.2.1-.1.3-.1.4-.1z"
            fill="currentColor"
            transform="translate(-874 -20010)"
        />
    </svg>
)

export const QaIconWithCircle = () => (
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 12 12" xmlSpace="preserve">
        <style>{'.st00{fill:currentColor}'}</style>
        <g id="Group_10954" transform="translate(-642 -556)">
            <g id="Group_9658" transform="translate(642 556)">
                <g id="Group_9657">
                    <path
                        id="Path_4793"
                        className="st00"
                        d="M6 12c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6zM6 1C3.2 1 1 3.2 1 6s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5z"
                    />
                </g>
            </g>
            <g id="Group_9661" transform="translate(646.002 558.472)">
                <g id="Group_9659">
                    <path
                        id="Path_4794"
                        className="st00"
                        d="M2 5.5c-.3 0-.5-.2-.5-.5 0-.8.4-1.6 1.1-2.1.3-.2.4-.5.4-.8C3 1.5 2.6 1 2 1c-.5 0-1 .4-1 1 0 .3-.2.5-.5.5S0 2.3 0 2C0 .9.9 0 2 0s2 .9 2 2.1c0 .6-.3 1.3-.8 1.6-.4.3-.7.8-.7 1.3 0 .2-.2.5-.5.5z"
                    />
                </g>
                <g id="Group_9660" transform="translate(1.496 6.017)">
                    <path
                        id="Path_4795"
                        className="st00"
                        d="M.5 1s-.1 0 0 0C.1 1 0 .7 0 .4.1.2.3 0 .6 0s.4.3.4.6C1 .8.7 1 .5 1z"
                    />
                </g>
            </g>
        </g>
    </svg>
)

export const LinkIcon = () => (
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 12 12" xmlSpace="preserve">
        <style>{'.linkst0{fill:#355D8B}'}</style>
        <g id="Web_Programing" transform="translate(-313.821 -6250.191)">
            <g id="Group_12592" transform="translate(313.821 6250.191)">
                <g id="Group_12589" transform="translate(3.678)">
                    <path
                        id="Path_10288"
                        className="linkst0"
                        d="M2.9 8.5c-.8 0-1.6-.3-2.2-.9-.2-.2-.4-.5-.6-.7v-.1c-.2-.2-.1-.5.1-.7.2-.2.5-.1.7.1v.1c.1.2.3.4.5.6.4.4.9.6 1.5.6s1.1-.2 1.5-.6l2.3-2.3c.8-.8.8-2.2 0-3-.4-.4-.9-.6-1.5-.6s-1.1.2-1.5.6L2.5 2.9c-.2.2-.5.2-.7 0-.2-.2-.2-.5 0-.7L3 .9C3.6.3 4.4 0 5.2 0 6 0 6.8.3 7.4.9c1.2 1.2 1.2 3.2 0 4.4L5.1 7.6c-.6.6-1.4.9-2.2.9z"
                    />
                </g>
                <g id="Group_12590" transform="translate(3.678)">
                    <path
                        id="Path_10289"
                        className="linkst0"
                        d="M2.9 8.5c-.8 0-1.6-.3-2.2-.9-.2-.2-.4-.5-.6-.7v-.1c-.2-.2-.1-.5.1-.7.2-.2.5-.1.7.1v.1c.1.2.3.4.5.6.4.4.9.6 1.5.6s1.1-.2 1.5-.6l2.3-2.3c.8-.8.8-2.2 0-3-.4-.4-.9-.6-1.5-.6s-1.1.2-1.5.6L2.5 2.9c-.2.2-.5.2-.7 0-.2-.2-.2-.5 0-.7L3 .9C3.6.3 4.4 0 5.2 0 6 0 6.8.3 7.4.9c1.2 1.2 1.2 3.2 0 4.4L5.1 7.6c-.6.6-1.4.9-2.2.9z"
                    />
                </g>
                <g id="Group_12591" transform="translate(0 3.5)">
                    <path
                        id="Path_10290"
                        className="linkst0"
                        d="M3.1 8.5c-.8 0-1.6-.3-2.2-.9C-.3 6.4-.3 4.4.9 3.2L3.2.9C4.4-.3 6.4-.3 7.6.9c.2.2.4.5.6.7v.1c.2.2.1.5-.1.7-.3.1-.5.1-.7-.1v-.1c-.2-.2-.4-.4-.5-.6-.8-.8-2.1-.8-3 0L1.6 3.9c-.8.8-.8 2.2 0 3 .4.4.9.6 1.5.6s1.1-.2 1.5-.6l1.2-1.2c.2-.2.5-.2.7 0 .2.2.2.5 0 .7L5.3 7.6c-.6.6-1.4.9-2.2.9z"
                    />
                </g>
            </g>
        </g>
    </svg>
)

export const EmojiIcon = () => (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 1000 1000"
  >
    <path d="M500 10C229.4 10 10 229.4 10 500s219.4 487 490 490c270.2 3 485.3-188.6 490-490 4.1-270.6-219.4-490-490-490zm0 904.6C271 914.6 85.4 729 85.4 500 85.4 271 271 85.4 500 85.4 729 85.4 914.6 271 914.6 500c0 229-185.7 414.6-414.6 414.6zM236.1 367c0-41.6 33.8-75.4 75.4-75.4 41.6 0 75.4 33.8 75.4 75.4 0 41.6-33.8 75.4-75.4 75.4-41.6 0-75.4-33.8-75.4-75.4zm376.9 0c0-41.6 33.8-75.4 75.4-75.4 41.6 0 75.4 33.8 75.4 75.4 0 41.6-33.7 75.4-75.4 75.4-41.6 0-75.4-33.8-75.4-75.4zm141.2 229.4c0 7.3-2 14.2-5.4 20.1-41.3 103.8-132.2 171-248.8 171-115.1 0-205.1-67.6-247.8-169.2-3-4.5-5-9.7-6-15.3 0 0-.6-5-.5-6.6.4-22 17.7-39.8 39.5-39.8 19.9 0 36.4 14.8 39.1 34.1 27.9 69.1 96.6 121.5 175.7 121.5s148-54.4 176-123.5c3.6-18.2 19.6-32 38.8-32 21.7 0 39.4 17.8 39.4 39.7z" />
  </svg>
)

export const RunIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 10.79">
        <title>Run</title>
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <path d="M15.25,0H.75A.76.76,0,0,0,0,.75a.76.76,0,0,0,.75.75h14.5A.76.76,0,0,0,16,.75.76.76,0,0,0,15.25,0Z" />
                <path d="M8,4.65H.75a.75.75,0,0,0,0,1.5H8a.75.75,0,0,0,0-1.5Z" />
                <path d="M8,9.29H.75a.75.75,0,0,0,0,1.5H8a.75.75,0,0,0,0-1.5Z" />
                <path d="M14.41,7.49l-.74.74V5.39a.75.75,0,1,0-1.5,0V8.23l-.73-.74a.75.75,0,0,0-1.06,0,.77.77,0,0,0,0,1.07l2,2a.7.7,0,0,0,.26.19h0l.14,0h.15a.74.74,0,0,0,.53-.22l2-2a.75.75,0,1,0-1.06-1.07Z" />
            </g>
        </g>
    </svg>
)

export const AnalyticsAscendingSortIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 10.79">
        <title />
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <path d="M15.25,0H.75A.76.76,0,0,0,0,.75a.76.76,0,0,0,.75.75h14.5A.76.76,0,0,0,16,.75.76.76,0,0,0,15.25,0Z" />
                <path d="M8,4.65H.75a.75.75,0,0,0,0,1.5H8a.75.75,0,0,0,0-1.5Z" />
                <path d="M8,9.29H.75a.75.75,0,0,0,0,1.5H8a.75.75,0,0,0,0-1.5Z" />
                <path d="M14.41,7.49l-.74.74V5.39a.75.75,0,1,0-1.5,0V8.23l-.73-.74a.75.75,0,0,0-1.06,0,.77.77,0,0,0,0,1.07l2,2a.7.7,0,0,0,.26.19h0l.14,0h.15a.74.74,0,0,0,.53-.22l2-2a.75.75,0,1,0-1.06-1.07Z" />
            </g>
        </g>
    </svg>
)

export const AnalyticsDescendingSortIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 10.8">
        <title />
        <g id="Layer_2_1_">
            <g id="Layer_1-2">
                <path d="M15.3,0H0.8C0.3,0,0,0.3,0,0.8c0,0.4,0.3,0.7,0.8,0.8h14.5c0.4,0,0.7-0.3,0.8-0.8C16,0.3,15.7,0,15.3,0z" />
                <path d="M8,4.7H0.8C0.3,4.7,0,5,0,5.4s0.3,0.8,0.8,0.8H8c0.4,0,0.8-0.3,0.8-0.8S8.4,4.7,8,4.7z" />
                <path d="M8,9.3H0.8C0.3,9.3,0,9.6,0,10s0.3,0.8,0.8,0.8H8c0.4,0,0.8-0.3,0.8-0.8S8.4,9.3,8,9.3z" />
                <path
                    d="M14.4,7.9c0.3,0.3,0.8,0.3,1.1,0c0.3-0.3,0.3-0.8,0-1.1l-2-2c-0.1-0.1-0.3-0.2-0.5-0.2h-0.1h-0.1l0,0
                    c-0.1,0-0.2,0.1-0.3,0.2l-2,2c-0.3,0.3-0.3,0.8,0,1.1c0.3,0.3,0.8,0.3,1.1,0l0.7-0.7V10c0,0.4,0.3,0.8,0.8,0.8s0.8-0.3,0.8-0.8
                    V7.2L14.4,7.9L14.4,7.9z"
                />
            </g>
        </g>
    </svg>
)

export const RightArrowWithCircle = () => (
    <svg
        aria-hidden="true"
        focusable="false"
        data-prefix="fal"
        data-icon="chevron-circle-right"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        className="svg-inline--fa fa-chevron-circle-right fa-w-16 fa-2x"
    >
        <path
            fill="currentColor"
            d="M8 256c0 137 111 248 248 248s248-111 248-248S393 8 256 8 8 119 8 256zM256 40c118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216zm86.6 224.5l-115.1 115c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.7-4.7-12.3 0-17L303 256l-99.5-99.5c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0l115.1 115c4.6 4.8 4.6 12.4-.1 17.1z"
            className=""
        />
    </svg>
)

export const RightArrowForAutomationErrors = () => (
    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 7.8 12.5" xmlSpace="preserve">
        <path
            d="M11.7 1.3c0-.2-.1-.5-.2-.6-.3-.4-.9-.4-1.3-.1L6 4.6 1.9.5 1.8.4C1.6.3 1.3.2 1.1.2.8.2.6.3.4.5.3.7.2.9.2 1.2c0 .3.1.5.3.7l4.8 4.8c.2.1.4.2.7.2.3 0 .5-.1.7-.3l4.8-4.8c.1-.1.2-.3.2-.5z"
            fill="#555"
            transform="rotate(-90 6.282 5.945)"
        />
    </svg>
)

export const RightArrowWithOutCircle = () => (
    <svg className="rotate_dropdown" viewBox="0 0 240.811 240.811">
        <g>
            <path
                id="Expand_More"
                d="M220.088,57.667l-99.671,99.695L20.746,57.655c-4.752-4.752-12.439-4.752-17.191,0
            c-4.74,4.752-4.74,12.451,0,17.203l108.261,108.297l0,0l0,0c4.74,4.752,12.439,4.752,17.179,0L237.256,74.859
            c4.74-4.752,4.74-12.463,0-17.215C232.528,52.915,224.828,52.915,220.088,57.667z"
            />
        </g>
    </svg>
)

export const LeftArrowWithCircle = () => (
    <svg viewBox="0 0 512 512" className="svg-inline--fa fa-chevron-circle-left fa-w-16 fa-2x">
        <path
            fill="currentColor"
            d="M504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zM256 472c-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216zm-86.6-224.5l115.1-115c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L209 256l99.5 99.5c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.7 4.7-12.3 4.7-17 0l-115.1-115c-4.6-4.8-4.6-12.4.1-17.1z"
            className=""
        />
    </svg>
)

export const DropdownWithCircle = () => (
    <svg id="Group_9262" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 16.2 16.2" xmlSpace="preserve">
        <style>{'.st00{fill:currentColor}'}</style>
        <g id="Group_8957">
            <path
                id="Path_4530"
                className="st00"
                d="M8.1 16.2C3.6 16.2 0 12.6 0 8.1S3.6 0 8.1 0s8.1 3.6 8.1 8.1-3.6 8.1-8.1 8.1zm0-14.8a6.7 6.7 0 100 13.4 6.7 6.7 0 000-13.4z"
            />
        </g>
        <g id="Group_8958" transform="translate(4.723 6.073)">
            <path
                id="Path_4531"
                className="st00"
                d="M3.4 4c-.2 0-.4 0-.5-.2L.2 1.1C-.1.8 0 .4.2.1c.3-.1.7-.1 1 .1l2.2 2.2L5.6.2c.3-.3.7-.3 1 0s.3.7 0 1L3.8 3.8c-.1.2-.2.2-.4.2z"
            />
        </g>
    </svg>
)
export const EyeCloseIcon = () => (
    <svg
        className="pwd_open_eye"
        x="0px"
        y="0px"
        width="511.626px"
        height="511.627px"
        viewBox="0 0 511.626 511.627"
        xmlSpace="preserve"
    >
        <g>
            <g>
                <path
                    d="M361.161,291.652c15.037-21.796,22.56-45.922,22.56-72.375c0-7.422-0.76-15.417-2.286-23.984l-79.938,143.321
                                       C326.235,329.101,346.125,313.438,361.161,291.652z"
                />
                <path
                    d="M372.872,94.221c0.191-0.378,0.28-1.235,0.28-2.568c0-3.237-1.522-5.802-4.571-7.715c-0.568-0.38-2.423-1.475-5.568-3.287
                                       c-3.138-1.805-6.14-3.567-8.989-5.282c-2.854-1.713-5.989-3.472-9.422-5.28c-3.426-1.809-6.375-3.284-8.846-4.427
                                       c-2.479-1.141-4.189-1.713-5.141-1.713c-3.426,0-6.092,1.525-7.994,4.569l-15.413,27.696c-17.316-3.234-34.451-4.854-51.391-4.854
                                       c-51.201,0-98.404,12.946-141.613,38.831C70.998,156.08,34.836,191.385,5.711,236.114C1.903,242.019,0,248.586,0,255.819
                                       c0,7.231,1.903,13.801,5.711,19.698c16.748,26.073,36.592,49.396,59.528,69.949c22.936,20.561,48.011,37.018,75.229,49.396
                                       c-8.375,14.273-12.562,22.556-12.562,24.842c0,3.425,1.524,6.088,4.57,7.99c23.219,13.329,35.97,19.985,38.256,19.985
                                       c3.422,0,6.089-1.529,7.992-4.575l13.99-25.406c20.177-35.967,50.248-89.931,90.222-161.878
                                       C322.908,183.871,352.886,130.005,372.872,94.221z M158.456,362.885C108.97,340.616,68.33,304.93,36.547,255.822
                                       c28.931-44.921,65.19-78.518,108.777-100.783c-11.61,19.792-17.417,41.206-17.417,64.237c0,20.365,4.661,39.68,13.99,57.955
                                       c9.327,18.274,22.27,33.4,38.83,45.392L158.456,362.885z M265.525,155.887c-2.662,2.667-5.906,3.999-9.712,3.999
                                       c-16.368,0-30.361,5.808-41.971,17.416c-11.613,11.615-17.416,25.603-17.416,41.971c0,3.811-1.336,7.044-3.999,9.71
                                       c-2.668,2.667-5.902,3.999-9.707,3.999c-3.809,0-7.045-1.334-9.71-3.999c-2.667-2.666-3.999-5.903-3.999-9.71
                                       c0-23.79,8.52-44.206,25.553-61.242c17.034-17.034,37.447-25.553,61.241-25.553c3.806,0,7.043,1.336,9.713,3.999
                                       c2.662,2.664,3.996,5.901,3.996,9.707C269.515,149.992,268.181,153.228,265.525,155.887z"
                />
                <path
                    d="M505.916,236.114c-10.853-18.08-24.603-35.594-41.255-52.534c-16.646-16.939-34.022-31.496-52.105-43.68l-17.987,31.977
                                       c31.785,21.888,58.625,49.87,80.51,83.939c-23.024,35.782-51.723,65-86.07,87.648c-34.358,22.661-71.712,35.693-112.065,39.115
                                       l-21.129,37.688c42.257,0,82.18-9.038,119.769-27.121c37.59-18.076,70.668-43.488,99.216-76.225
                                       c13.322-15.421,23.695-29.219,31.121-41.401c3.806-6.476,5.708-13.046,5.708-19.702
                                       C511.626,249.157,509.724,242.59,505.916,236.114z"
                />
            </g>
        </g>
    </svg>
)

export const EyeOpenIcon = () => (
    <svg className="pwd_open_eye" x="0px" y="0px" viewBox="0 0 511.626 511.626" xmlSpace="preserve">
        <g>
            <path
                d="M505.918,236.117c-26.651-43.587-62.485-78.609-107.497-105.065c-45.015-26.457-92.549-39.687-142.608-39.687
                c-50.059,0-97.595,13.225-142.61,39.687C68.187,157.508,32.355,192.53,5.708,236.117C1.903,242.778,0,249.345,0,255.818
                c0,6.473,1.903,13.04,5.708,19.699c26.647,43.589,62.479,78.614,107.495,105.064c45.015,26.46,92.551,39.68,142.61,39.68
                c50.06,0,97.594-13.176,142.608-39.536c45.012-26.361,80.852-61.432,107.497-105.208c3.806-6.659,5.708-13.223,5.708-19.699
                C511.626,249.345,509.724,242.778,505.918,236.117z M194.568,158.03c17.034-17.034,37.447-25.554,61.242-25.554
                c3.805,0,7.043,1.336,9.709,3.999c2.662,2.664,4,5.901,4,9.707c0,3.809-1.338,7.044-3.994,9.704
                c-2.662,2.667-5.902,3.999-9.708,3.999c-16.368,0-30.362,5.808-41.971,17.416c-11.613,11.615-17.416,25.603-17.416,41.971
                c0,3.811-1.336,7.044-3.999,9.71c-2.667,2.668-5.901,3.999-9.707,3.999c-3.809,0-7.044-1.334-9.71-3.999
                c-2.667-2.666-3.999-5.903-3.999-9.71C169.015,195.482,177.535,175.065,194.568,158.03z M379.867,349.04
                c-38.164,23.12-79.514,34.687-124.054,34.687c-44.539,0-85.889-11.56-124.051-34.687s-69.901-54.2-95.215-93.222
                c28.931-44.921,65.19-78.518,108.777-100.783c-11.61,19.792-17.417,41.207-17.417,64.236c0,35.216,12.517,65.329,37.544,90.362
                s55.151,37.544,90.362,37.544c35.214,0,65.329-12.518,90.362-37.544s37.545-55.146,37.545-90.362
                c0-23.029-5.808-44.447-17.419-64.236c43.585,22.265,79.846,55.865,108.776,100.783C449.767,294.84,418.031,325.913,379.867,349.04
                z"
            />
        </g>
    </svg>
)

export const DownArrowCircle = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 5.75">
        <title />
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <path d="M5,5.75H5a.78.78,0,0,1-.53-.21L.22,1.29a.74.74,0,0,1,0-1,.75.75,0,0,1,1,0L5,4,8.74.22a.74.74,0,0,1,1,1L5.51,5.54A.78.78,0,0,1,5,5.75Z" />
            </g>
        </g>
    </svg>
)
export const TestAutomationIcon = () => (
    <svg version="1.1" x="0px" y="0px" viewBox="0 0 32 32">
        <path d="M6.6,8.1l0,16.1c0,2,2.2,3.3,3.9,2.3l14-8.1c1.8-1,1.8-3.5,0-4.6l-14-8.1C8.8,4.8,6.6,6,6.6,8.1z" />
    </svg>
)
export const SaveAutomation = () => (
    <svg id="Layer_1" x="0px" y="0px" viewBox="0 0 32 32">
        <path d="M15.5 23.7H3.1c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h8c.6 0 1.1.5 1.1 1.1s-.5 1.1-1.1 1.1H3.3v17.4h12V8.4c0-.6.5-1.1 1.1-1.1s1.1.5 1.1 1.1v13.3c0 1.1-.9 2-2 2z" />
        <path d="M16.4 9.5h-5.3c-.6 0-1.1-.5-1.1-1.1V3.1c0-.4.3-.8.7-1 .4-.2.9-.1 1.2.2l5.3 5.3c.3.3.4.8.2 1.2-.2.5-.6.7-1 .7zm-4.2-2.1h1.7l-1.7-1.7v1.7zM23.5 11.3H20c-.6 0-1.1-.5-1.1-1.1s.5-1.1 1.1-1.1h3.5c.6 0 1.1.5 1.1 1.1s-.5 1.1-1.1 1.1zM27.9 30.8H15.5c-1.1 0-2-.9-2-2v-2.7c0-.6.5-1.1 1.1-1.1.6 0 1.1.5 1.1 1.1v2.5h12V15.5c0-.6.5-1.1 1.1-1.1.6 0 1.1.5 1.1 1.1v13.3c0 1.1-.9 2-2 2z" />
        <path d="M28.8 16.6h-5.3c-.6 0-1.1-.5-1.1-1.1v-5.3c0-.4.3-.8.7-1 .4-.2.9-.1 1.2.2l5.3 5.3c.3.3.4.8.2 1.2-.2.4-.6.7-1 .7zm-4.2-2.1h1.7l-1.7-1.7v1.7z" />
        <g>
            <path d="M25 7.5c-.4 0-.9-.3-1-.7-.2-.6.1-1.2.7-1.4l1.9-.6-.6-1.9c-.2-.6.1-1.2.7-1.4.6-.2 1.2.1 1.4.7l1 3c.2.6-.1 1.2-.7 1.4l-3 1c-.2-.1-.3-.1-.4-.1z" />
        </g>
        <g>
            <path d="M27.9 6.5c-.2 0-.3 0-.5-.1l-5.8-2.9c-.5-.3-.7-.9-.5-1.4.3-.5.9-.7 1.4-.5l5.8 2.9c.5.3.7.9.5 1.4-.1.4-.5.6-.9.6z" />
            <path d="M19.1 4.5c-.2 0-.3 0-.5-.1-.5-.3-.7-.9-.5-1.4.8-1.6 2.8-2.3 4.4-1.5.5.3.7.9.5 1.5-.3.5-.9.7-1.4.5-.6-.3-1.3-.1-1.6.4-.2.4-.5.6-.9.6z" />
        </g>
    </svg>
)
export const DeployAutomation = () => (
    <svg x="0px" y="0px" viewBox="0 0 32 32">
        <g>
            <g>
                <path
                    d="M18,32C18,32,18,32,18,32c-0.5,0-0.9-0.3-1-0.7l-3.4-12.9L0.8,15.2C0.3,15.1,0,14.7,0,14.3c0-0.4,0.2-0.8,0.6-1l30-13.2
			C31-0.1,31.4,0,31.7,0.3C32,0.6,32.1,1,31.9,1.4l-13,30C18.8,31.8,18.4,32,18,32z M4.1,13.9l10.6,2.6c0.4,0.1,0.6,0.4,0.7,0.7
			L18.3,28l10.8-25L4.1,13.9z"
                />
            </g>
        </g>
    </svg>
)

export const UploadToMarketplace = () => (
    <svg id="Layer_1" x="0px" y="0px" viewBox="0 0 30 30" xmlSpace="preserve">
        <path d="M25.4 27.2h-20c-1.1 0-2-.9-2-2v-6c0-.6.4-1 1-1s1 .4 1 1v6h20v-6c0-.6.4-1 1-1s1 .4 1 1v6c0 1.1-.9 2-2 2z" />
        <path d="M15.4 3.2c-.6 0-1 .4-1 1v16c0 .6.4 1 1 1s1-.4 1-1v-16c0-.6-.4-1-1-1z" />
        <path d="M15.4 3.2c-.3 0-.5.1-.7.3l-5 5c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0l4.3-4.3 4.3 4.3c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4l-5-5c-.1-.2-.4-.3-.7-.3z" />
    </svg>
)

export const AddFromMarketplace = () => (
    <svg id="Layer_1" x="0px" y="0px" viewBox="0 0 30 30" xmlSpace="preserve">
        <path d="M25.4 27.2h-20c-1.1 0-2-.9-2-2v-6c0-.6.4-1 1-1s1 .4 1 1v6h20v-6c0-.6.4-1 1-1s1 .4 1 1v6c0 1.1-.9 2-2 2z" />
        <path d="M15.4 21.2c-.6 0-1-.4-1-1v-16c0-.6.4-1 1-1s1 .4 1 1v16c0 .5-.4 1-1 1z" />
        <path d="M15.4 21.2c-.3 0-.5-.1-.7-.3l-5-5c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l4.3 4.3 4.3-4.3c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-5 5c-.1.2-.4.3-.7.3z" />
    </svg>
)

export const PasswordEditIcon = () => (
    <svg height="401pt" viewBox="0 -1 401.52289 401" width="401pt" xmlns="http://www.w3.org/2000/svg">
        <path d="m370.589844 250.972656c-5.523438 0-10 4.476563-10 10v88.789063c-.019532 16.5625-13.4375 29.984375-30 30h-280.589844c-16.5625-.015625-29.980469-13.4375-30-30v-260.589844c.019531-16.558594 13.4375-29.980469 30-30h88.789062c5.523438 0 10-4.476563 10-10 0-5.519531-4.476562-10-10-10h-88.789062c-27.601562.03125-49.96875 22.398437-50 50v260.59375c.03125 27.601563 22.398438 49.96875 50 50h280.589844c27.601562-.03125 49.96875-22.398437 50-50v-88.792969c0-5.523437-4.476563-10-10-10zm0 0" />
        <path d="m376.628906 13.441406c-17.574218-17.574218-46.066406-17.574218-63.640625 0l-178.40625 178.40625c-1.222656 1.222656-2.105469 2.738282-2.566406 4.402344l-23.460937 84.699219c-.964844 3.472656.015624 7.191406 2.5625 9.742187 2.550781 2.546875 6.269531 3.527344 9.742187 2.566406l84.699219-23.464843c1.664062-.460938 3.179687-1.34375 4.402344-2.566407l178.402343-178.410156c17.546875-17.585937 17.546875-46.054687 0-63.640625zm-220.257812 184.90625 146.011718-146.015625 47.089844 47.089844-146.015625 146.015625zm-9.40625 18.875 37.621094 37.625-52.039063 14.417969zm227.257812-142.546875-10.605468 10.605469-47.09375-47.09375 10.609374-10.605469c9.761719-9.761719 25.589844-9.761719 35.351563 0l11.738281 11.734375c9.746094 9.773438 9.746094 25.589844 0 35.359375zm0 0" />
    </svg>
)

export const AccountsIcon = () => (
    <svg viewBox="0 0 512 450">
        <rect x={211} y={240} width={90} height={30} />
        <g>
            <defs>
                <rect id="SVGID_1_" width={512} height={450} />
            </defs>
            <clipPath id="SVGID_2_">
                <use xlinkHref="#SVGID_1_" style={{ overflow: 'visible' }} />
            </clipPath>
            <path
                className="st0"
                d="M415.4,270H331v15c0,8.3-6.7,15-15,15H196c-8.3,0-15-6.7-15-15v-15H96.6c-19.4,0-36.5-12.4-42.7-30.8L0,77.4
		V405c0,24.8,20.2,45,45,45h422c24.8,0,45-20.2,45-45V77.4l-53.9,161.8C451.9,257.6,434.8,270,415.4,270"
            />
            <path
                className="st0"
                d="M316,0H196c-24.8,0-45,20.2-45,45v15H25.8l56.6,169.7c2.1,6.1,7.8,10.3,14.2,10.3H181v-15c0-8.3,6.7-15,15-15
		h120c8.3,0,15,6.7,15,15v15h84.4c6.5,0,12.2-4.1,14.2-10.3L486.2,60H361V45C361,20.2,340.8,0,316,0 M181,60V45c0-8.3,6.7-15,15-15
		h120c8.3,0,15,6.7,15,15v15H181z"
            />
        </g>
    </svg>
)

export const ZohoProfileIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.11 20">
        <title>entity</title>
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <path d="M8.55,8.81A4.41,4.41,0,1,0,4.15,4.4,4.42,4.42,0,0,0,8.55,8.81Z" />
                <path d="M8.55,9.78A8.57,8.57,0,0,0,0,18.33,1.67,1.67,0,0,0,1.67,20H15.44a1.67,1.67,0,0,0,1.67-1.67A8.57,8.57,0,0,0,8.55,9.78Z" />
            </g>
        </g>
    </svg>
)

export const FlowBellIcon = () => (
    <svg x="0px" y="0px" viewBox="0 0 60 60">
        <g>
            <path
                d="M47.024,31.5v-8.994c0.043-6.857-4.568-11.405-8.53-13.216C37.359,8.771,36.189,8.371,35,8.074V7.5c0-2.757-2.243-5-5-5
                                                    s-5,2.243-5,5v0.661c-1.071,0.289-2.124,0.666-3.146,1.138C17.476,11.317,13.04,16.181,13,22.5v9
                                                    c0,6.388-2.256,11.869-6.705,16.291c-0.265,0.264-0.361,0.653-0.249,1.01s0.415,0.621,0.784,0.685l9.491,1.639
                                                    c1.768,0.305,3.396,0.555,4.945,0.761c1.745,3.42,5.172,5.615,8.916,5.615c3.745,0,7.173-2.196,8.917-5.618
                                                    c1.543-0.205,3.163-0.454,4.921-0.758l9.49-1.639c0.369-0.063,0.671-0.328,0.784-0.685c0.113-0.356,0.017-0.746-0.249-1.01
                                                    C49.387,43.16,47.024,37.679,47.024,31.5z M27,7.5c0-1.654,1.346-3,3-3s3,1.346,3,3v0.182c-1.993-0.286-4.015-0.274-6,0.047V7.5z
                                                     M30.183,55.5c-2.532,0-4.898-1.258-6.417-3.315c2.235,0.23,4.321,0.346,6.406,0.346c2.093,0,4.186-0.116,6.43-0.349
                                                    C35.082,54.241,32.715,55.5,30.183,55.5z M43.681,49.153c-1.919,0.331-3.678,0.6-5.34,0.812c-0.002,0-0.004,0-0.007,0
                                                    c-0.733,0.093-1.445,0.174-2.142,0.244c-0.006,0-0.011,0.001-0.017,0.001c-0.639,0.064-1.263,0.116-1.881,0.16
                                                    c-0.116,0.008-0.232,0.016-0.347,0.023c-0.535,0.035-1.064,0.063-1.59,0.083c-0.107,0.004-0.215,0.01-0.322,0.013
                                                    c-1.244,0.042-2.471,0.042-3.714,0.001c-0.111-0.004-0.223-0.01-0.334-0.014c-0.517-0.021-1.038-0.047-1.565-0.082
                                                    c-0.125-0.008-0.25-0.016-0.376-0.025c-0.599-0.043-1.205-0.093-1.824-0.155c-0.023-0.002-0.045-0.004-0.068-0.006
                                                    c-0.692-0.069-1.398-0.15-2.124-0.242c-0.003,0-0.006,0-0.009,0c-1.668-0.211-3.434-0.482-5.361-0.814L9,47.83
                                                    c3.983-4.554,6-10.038,6-16.33v-8.994c0.034-5.435,3.888-9.637,7.691-11.391c1.131-0.521,2.304-0.91,3.497-1.183
                                                    c0.01-0.002,0.021-0.001,0.031-0.003c2.465-0.554,5.087-0.579,7.58-0.068c0.013,0.003,0.026-0.003,0.039-0.001
                                                    c1.304,0.272,2.588,0.684,3.825,1.249c3.689,1.687,7.396,5.861,7.361,11.392v9c0,6.033,2.175,11.643,6.313,16.331L43.681,49.153z"
            />
            <path
                d="M36.417,13.838c-3.875-1.771-8.62-1.773-12.469,0.002c-2.195,1.012-5.918,3.973-5.948,8.654
                                                    c-0.003,0.552,0.441,1.002,0.994,1.006c0.002,0,0.004,0,0.006,0c0.549,0,0.997-0.443,1-0.994c0.023-3.677,3.019-6.035,4.785-6.85
                                                    c3.33-1.537,7.446-1.533,10.799,0c0.503,0.23,1.096,0.009,1.326-0.493C37.14,14.66,36.918,14.067,36.417,13.838z"
            />
            <path
                d="M4.802,22.793c-0.391-0.391-1.023-0.391-1.414,0C1.203,24.978,0,27.886,0,30.983c0,3.097,1.203,6.006,3.388,8.19
                                                    c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414C2.995,35.952,2,33.546,2,30.983
                                                    c0-2.563,0.995-4.97,2.802-6.776C5.192,23.816,5.192,23.184,4.802,22.793z"
            />
            <path
                d="M8.305,37.19c0.256,0,0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414c-2.558-2.558-2.558-6.719,0-9.276
                                                    c0.391-0.391,0.391-1.023,0-1.414s-1.023-0.391-1.414,0c-3.337,3.337-3.337,8.768,0,12.104C7.793,37.093,8.049,37.19,8.305,37.19z"
            />
            <path
                d="M56.612,22.793c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414C57.005,26.014,58,28.42,58,30.983
                                                    c0,2.563-0.995,4.969-2.802,6.776c-0.391,0.391-0.391,1.023,0,1.414c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293
                                                    C58.797,36.989,60,34.08,60,30.983C60,27.886,58.797,24.978,56.612,22.793z"
            />
            <path
                d="M50.988,24.793c-0.391,0.391-0.391,1.023,0,1.414c2.558,2.558,2.558,6.719,0,9.276c-0.391,0.391-0.391,1.023,0,1.414
                                                    c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293c3.337-3.337,3.337-8.768,0-12.104
                                                    C52.011,24.402,51.378,24.402,50.988,24.793z"
            />
        </g>
    </svg>
)

export const DownarrowWithCircle = () => (
    <svg viewBox="0 0 512 512" className="svg-inline--fa fa-chevron-circle-right fa-w-16 fa-2x">
        <path
            fill="currentColor"
            d="M8 256c0 137 111 248 248 248s248-111 248-248S393 8 256 8 8 119 8 256zM256 40c118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216zm86.6 224.5l-115.1 115c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.7-4.7-12.3 0-17L303 256l-99.5-99.5c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0l115.1 115c4.6 4.8 4.6 12.4-.1 17.1z"
            className=""
        />
    </svg>
)

export const InfoIcon = () => (
    <svg viewBox="0 0 512 512">
        <path
            fill="currentColor"
            d="M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-36 344h12V232h-12c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h48c6.627 0 12 5.373 12 12v140h12c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12h-72c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12zm36-240c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"
        />
    </svg>
)

export const SettingsIcon = () => (
    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 165.33 164.32">
            <g>
                <g>
                    <path
                        d="M145.82,66.96l-10.08-1.71c-1.05-3.39-2.4-6.66-4.05-9.78l5.94-8.31c2.52-3.54,2.13-8.37-0.96-11.43l-8.94-8.94
			c-1.68-1.68-3.9-2.61-6.27-2.61c-1.86,0-3.63,0.57-5.13,1.65l-8.34,5.94c-3.24-1.71-6.63-3.12-10.14-4.17l-1.68-9.96
			c-0.72-4.29-4.41-7.41-8.76-7.41H74.78c-4.35,0-8.04,3.12-8.76,7.41l-1.74,10.2c-3.36,1.05-6.63,2.43-9.75,4.11l-8.25-5.94
			c-1.5-1.08-3.3-1.65-5.16-1.65c-2.37,0-4.62,0.93-6.27,2.61l-8.97,8.94c-3.06,3.06-3.48,7.89-0.96,11.43l6,8.43
			c-1.65,3.15-2.97,6.42-3.99,9.81l-9.96,1.68c-4.29,0.72-7.41,4.41-7.41,8.76v12.63c0,4.35,3.12,8.04,7.41,8.76l10.2,1.74
			c1.05,3.36,2.43,6.63,4.11,9.75l-5.91,8.22c-2.52,3.54-2.13,8.37,0.96,11.43l8.94,8.94c1.68,1.68,3.9,2.61,6.27,2.61
			c1.86,0,3.63-0.57,5.13-1.65l8.43-6c3.03,1.59,6.21,2.88,9.48,3.9l1.68,10.08c0.72,4.29,4.41,7.41,8.76,7.41h12.66
			c4.35,0,8.04-3.12,8.76-7.41l1.71-10.08c3.39-1.05,6.66-2.4,9.78-4.05l8.31,5.94c1.5,1.08,3.3,1.65,5.16,1.65l0,0
			c2.37,0,4.59-0.93,6.27-2.61l8.94-8.94c3.06-3.06,3.48-7.89,0.96-11.43l-5.94-8.34c1.65-3.15,3.03-6.42,4.05-9.78l10.08-1.68
			c4.29-0.72,7.41-4.41,7.41-8.76V75.72C153.23,71.37,150.11,67.68,145.82,66.96z M145.13,88.35c0,0.39-0.27,0.72-0.66,0.78
			l-12.6,2.1c-1.59,0.27-2.85,1.44-3.24,2.97c-1.14,4.41-2.88,8.64-5.22,12.57c-0.81,1.38-0.75,3.09,0.18,4.41l7.41,10.44
			c0.21,0.3,0.18,0.75-0.09,1.02l-8.94,8.94c-0.21,0.21-0.42,0.24-0.57,0.24c-0.18,0-0.33-0.06-0.45-0.15l-10.41-7.41
			c-1.29-0.93-3.03-0.99-4.41-0.18c-3.93,2.34-8.16,4.08-12.57,5.22c-1.56,0.39-2.73,1.68-2.97,3.24l-2.13,12.6
			c-0.06,0.39-0.39,0.66-0.78,0.66H75.05c-0.39,0-0.72-0.27-0.78-0.66l-2.1-12.6c-0.27-1.59-1.44-2.85-2.97-3.24
			c-4.29-1.11-8.43-2.82-12.3-5.04c-0.63-0.36-1.35-0.54-2.04-0.54c-0.81,0-1.65,0.24-2.34,0.75l-10.5,7.47
			c-0.15,0.09-0.3,0.15-0.45,0.15c-0.12,0-0.36-0.03-0.57-0.24l-8.94-8.94c-0.27-0.27-0.3-0.69-0.09-1.02l7.38-10.35
			c0.93-1.32,0.99-3.06,0.18-4.44c-2.34-3.9-4.14-8.13-5.28-12.54c-0.42-1.53-1.68-2.7-3.24-2.97l-12.69-2.16
			c-0.39-0.06-0.66-0.39-0.66-0.78V76.02c0-0.39,0.27-0.72,0.66-0.78l12.51-2.1c1.59-0.27,2.88-1.44,3.27-3
			c1.11-4.41,2.82-8.67,5.13-12.6c0.81-1.38,0.72-3.09-0.21-4.38l-7.47-10.5c-0.21-0.3-0.18-0.75,0.09-1.02l8.94-8.94
			c0.21-0.21,0.42-0.24,0.57-0.24c0.18,0,0.33,0.06,0.45,0.15l10.35,7.38c1.32,0.93,3.06,0.99,4.44,0.18
			c3.9-2.34,8.13-4.14,12.54-5.28c1.53-0.42,2.7-1.68,2.97-3.24l2.16-12.69c0.06-0.39,0.39-0.66,0.78-0.66h12.63
			c0.39,0,0.72,0.27,0.78,0.66l2.1,12.51c0.27,1.59,1.44,2.88,3,3.27c4.53,1.14,8.85,2.91,12.87,5.28c1.38,0.81,3.09,0.75,4.41-0.18
			l10.35-7.44c0.15-0.09,0.3-0.15,0.45-0.15c0.12,0,0.36,0.03,0.57,0.24l8.94,8.94c0.27,0.27,0.3,0.69,0.09,1.02l-7.41,10.41
			c-0.93,1.29-0.99,3.03-0.18,4.41c2.34,3.93,4.08,8.16,5.22,12.57c0.39,1.56,1.68,2.73,3.24,2.97l12.6,2.13
			c0.39,0.06,0.66,0.39,0.66,0.78v12.63H145.13z"
                    />
                    <path
                        d="M81.38,51.03c-17.1,0-30.99,13.89-30.99,30.99s13.89,30.99,30.99,30.99s30.99-13.89,30.99-30.99S98.48,51.03,81.38,51.03z
			 M81.38,104.91c-12.63,0-22.89-10.26-22.89-22.89s10.26-22.89,22.89-22.89s22.89,10.26,22.89,22.89S94.01,104.91,81.38,104.91z"
                    />
                </g>
            </g>
        </svg>
)

export const InfoColorIcon = () => (
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 24 24" xmlSpace="preserve">
        <style>{'.info_color_icon{fill:#f22727}'}</style>
        <g id="Group_13749" transform="translate(-301 -13)">
            <g id="Ellipse_741">
                <circle cx={12} cy={12} r={12} fill="#fff" transform="translate(301 13)" />
                <path
                    className="info_color_icon"
                    d="M12 24C5.4 24 0 18.6 0 12S5.4 0 12 0s12 5.4 12 12-5.4 12-12 12zm0-23C5.9 1 1 5.9 1 12s4.9 11 11 11 11-4.9 11-11S18.1 1 12 1z"
                    transform="translate(301 13)"
                />
            </g>
            <g id="Group_13748" transform="translate(137.934 -154.4)">
                <g id="Group_8787" transform="translate(169.246 173.4)">
                    <g id="Group_8786">
                        <path
                            className="info_color_icon"
                            d="M11.6 9.9L6.5.4C6.4.1 6.1 0 5.8 0c-.2 0-.5.1-.6.4L.1 9.9c-.2.4-.1.8.3 1 .1.1.2.1.3.1h10.2c.4 0 .7-.3.7-.7.1-.2 0-.3 0-.4zm-5.8-.4c-.4 0-.7-.3-.7-.7s.3-.7.7-.7c.4 0 .7.3.7.7s-.3.7-.7.7zm.8-2.9c0 .4-.3.7-.7.7-.5 0-.8-.3-.8-.7V3.7c0-.4.3-.7.7-.7.4 0 .7.3.7.7v2.9z"
                            id="Path_4373"
                        />
                    </g>
                </g>
            </g>
        </g>
    </svg>
)

export const FailedIcon = () => (
    <svg viewBox="0 0 475.2 475.2">
        <g>
            <g>
                <path
                    d="M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6
                        s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7
                        s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7
                        C468.6,170.8,468.6,304.4,386.5,386.5z"
                />
                <path
                    d="M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1
                        l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4
                        c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z"
                />
            </g>
        </g>
    </svg>
)

export const SuccessIcon = () => (
    <svg viewBox="0 0 384.97 384.97">
        <g>
            <g id="Check_Circle">
                <path
                    d="M192.485,0C86.173,0,0,86.173,0,192.485S86.173,384.97,192.485,384.97c106.3,0,192.485-86.185,192.485-192.485
                        C384.97,86.173,298.785,0,192.485,0z M192.485,360.909c-93.018,0-168.424-75.406-168.424-168.424S99.467,24.061,192.485,24.061
                        s168.424,75.406,168.424,168.424S285.503,360.909,192.485,360.909z"
                />
                <path
                    d="M280.306,125.031L156.538,247.692l-51.502-50.479c-4.74-4.704-12.439-4.704-17.179,0c-4.752,4.704-4.752,12.319,0,17.011
                        l60.139,58.936c4.932,4.343,12.307,4.824,17.179,0l132.321-131.118c4.74-4.692,4.74-12.319,0-17.011
                        C292.745,120.339,285.058,120.339,280.306,125.031z"
                />
            </g>
        </g>
    </svg>
)

export const NavigationIcon = () => (
    <svg viewBox="0 0 51.636 51.636">
        <path
            d="M51.353,0.914c-0.295-0.305-0.75-0.39-1.135-0.213L0.583,23.481c-0.399,0.184-0.632,0.605-0.574,1.041
                    s0.393,0.782,0.826,0.854l22.263,3.731l2.545,21.038c0.054,0.438,0.389,0.791,0.824,0.865c0.057,0.01,0.113,0.015,0.169,0.015
                    c0.375,0,0.726-0.211,0.896-0.556l24-48.415C51.72,1.675,51.648,1.218,51.353,0.914z"
        />
    </svg>
)

export const UserIconAnalytics = () => (
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 58 58" xmlSpace="preserve">
        <style>{'.st0{fill:currentColor}'}</style>
        <g id="Group_7717" transform="translate(-423 -4549.422)">
            <ellipse id="Ellipse_238" cx={452} cy={4561.2} rx={11.8} ry={11.3} />
            <path
                id="Path_4117"
                // className="st0"
                d="M427.9 4592.4c3.2-8.9 10.7-15.3 24.1-15.3s20.8 6 24.1 15.3v1.2s-8.5 13.5-24.1 13.3-24.1-14.5-24.1-14.5z"
            />
        </g>
    </svg>
)
export const UserIconAnalyticsMenu = () => (
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 32 32" xmlSpace="preserve">
        <style>{'.st22{fill:#526a86}'}</style>
        <g id="Group_11012" transform="translate(-6 -863)">
            <g id="Imran_3">
                <circle cx={16} cy={16} r={16} fill="#fff" transform="translate(6 863)" />
                <path
                    d="M16 32C7.2 32 0 24.8 0 16S7.2 0 16 0s16 7.2 16 16-7.2 16-16 16zm0-31C7.7 1 1 7.7 1 16s6.7 15 15 15 15-6.7 15-15S24.3 1 16 1z"
                    fill="#c4c4c4"
                    transform="translate(6 863)"
                />
            </g>
            <g id="Group_11011" transform="translate(-408 -3678.422)">
                <ellipse className="st22" cx={429.8} cy={4552.6} rx={3.3} ry={3.2} id="Ellipse_238" />
                <path
                    className="st22"
                    d="M423 4561.3c.9-2.5 3-4.3 6.8-4.3s5.9 1.7 6.8 4.3v.3c-1.5 2.3-4 3.7-6.8 3.7-4.4.1-6.8-4-6.8-4z"
                    id="Path_4117"
                />
            </g>
        </g>
    </svg>
)

export const TourIcon = () => (
    <svg data-name="Layer 1" viewBox="0 0 32 32">
        <path d="M29.42 24.63H2.58a1.92 1.92 0 01-1.92-1.92V5.45a1.92 1.92 0 011.92-1.91h26.84a1.92 1.92 0 011.92 1.91v17.26a1.92 1.92 0 01-1.92 1.92zm0-1.92zM2.58 5.45v17.26h26.84V5.45zM23.67 28.46H8.33a1 1 0 110-1.91h15.34a1 1 0 110 1.91z" />
        <path d="M11.56 20.29a1 1 0 01-.53-.15 1 1 0 01-.47-.85v-10a1 1 0 01.44-.85 1 1 0 011 0l9 4.92a1 1 0 01.55.9 1 1 0 01-.55.89l-9 5.08a1 1 0 01-.44.06zm1-9.38v6.76l5.79-3.45z" />
    </svg>
)

export const BotIconAnalytics = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 16.71">
        <title>sort</title>
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <path d="M17.77,0,1.37,2.09A1.37,1.37,0,0,0,0,3.58l1.15,8.5a1.84,1.84,0,0,0,1.66,1.54l4.45.47A1.58,1.58,0,0,1,8.6,15.82v0c-.1.79.4,1.09,1.11.67l1.7-1.77a5.89,5.89,0,0,1,2.78-.84l.4,0a1.77,1.77,0,0,0,1.81-1.31L19,1.35A1.09,1.09,0,0,0,17.77,0ZM5.93,8.93A1.23,1.23,0,1,1,7.12,7.7,1.21,1.21,0,0,1,5.93,8.93Zm3.36,0a1.23,1.23,0,1,1,1.2-1.23A1.22,1.22,0,0,1,9.29,8.93Zm3.36,0a1.23,1.23,0,1,1,1.2-1.23A1.22,1.22,0,0,1,12.65,8.93Z" />
            </g>
        </g>
    </svg>
)

export const ConversationsTotal = () => (
    <svg version="1.1" viewBox="0 0 512 512">
        <g>
            <g>
                <path
                    d="M372.3,50.8H28.8C12.9,50.8,0,63.7,0,79.6v206.1c0,15.9,12.9,28.8,28.8,28.8h22.3v76.7c0,4.9,2.9,9.3,7.5,11.2
                        c1.5,0.6,3.1,0.9,4.6,0.9c3.1,0,6.2-1.2,8.5-3.5l85.3-85.3h17.1c6.7,0,12.1-5.4,12.1-12.1c0-6.7-5.4-12.1-12.1-12.1
                        c0,0-22.7,0-22.9,0c-2.8,0.2-5.6,1.3-7.7,3.5L75.3,362c0,0,0-60.4-0.1-60.7c-0.5-6.2-5.7-11-12-11H28.8c-2.6,0-4.7-2.1-4.7-4.7
                        V79.6c0-2.6,2.1-4.7,4.7-4.7h343.5c2.6,0,4.7,2.1,4.7,4.7v79.1c0,6.7,5.4,12.1,12.1,12.1s12.1-5.4,12.1-12.1V79.6
                        C401.1,63.7,388.2,50.8,372.3,50.8z"
                />
            </g>
        </g>
        <g>
            <g>
                <path
                    d="M483.2,198.5H242.8c-15.9,0-28.8,12.9-28.8,28.8v140.6c0,15.9,12.9,28.8,28.8,28.8h150.5l61,61c2.3,2.3,5.4,3.5,8.5,3.5
                        c1.6,0,3.1-0.3,4.6-0.9c4.5-1.9,7.5-6.3,7.5-11.2v-52.4h8.3c15.9,0,28.8-12.9,28.8-28.8V227.3C512,211.4,499.1,198.5,483.2,198.5z
                        M487.8,367.9c0,2.6-2.1,4.7-4.7,4.7h-20.4c-6.4,0-11.6,4.9-12,11.1c0,0.3-0.1,36.3-0.1,36.3l-43.9-43.9c0,0-0.1-0.1-0.1-0.1
                        c-0.2-0.2-0.3-0.3-0.5-0.4c-2.1-1.9-4.9-3-8-3H242.8c-2.6,0-4.7-2.1-4.7-4.7V227.3c0-2.6,2.1-4.7,4.7-4.7h240.4
                        c2.6,0,4.7,2.1,4.7,4.7V367.9z"
                />
            </g>
        </g>
        <g>
            <g>
                <path d="M363,285.5c-6.7,0-12.1,5.4-12.1,12.1s5.4,12.1,12.1,12.1c6.7,0,12.1-5.4,12.1-12.1S369.6,285.5,363,285.5z" />
            </g>
        </g>
        <g>
            <g>
                <path
                    d="M310.5,130.6H90.6c-6.7,0-12.1,5.4-12.1,12.1s5.4,12.1,12.1,12.1h219.8c6.7,0,12.1-5.4,12.1-12.1S317.1,130.6,310.5,130.6
                        z"
                />
            </g>
        </g>
        <g>
            <g>
                <path
                    d="M174.1,210.5H90.7c-6.7,0-12.1,5.4-12.1,12.1s5.4,12.1,12.1,12.1h83.4c6.7,0,12.1-5.4,12.1-12.1S180.7,210.5,174.1,210.5z
                        "
                />
            </g>
        </g>
        <g>
            <g>
                <path d="M306.8,285.5c-6.7,0-12.1,5.4-12.1,12.1s5.4,12.1,12.1,12.1c6.7,0,12.1-5.4,12.1-12.1S313.5,285.5,306.8,285.5z" />
            </g>
        </g>
        <g>
            <g>
                <path d="M419.1,285.5c-6.7,0-12.1,5.4-12.1,12.1s5.4,12.1,12.1,12.1c6.7,0,12.1-5.4,12.1-12.1S425.7,285.5,419.1,285.5z" />
            </g>
        </g>
    </svg>
)

export const ConversationsMessage = () => (
    <svg viewBox="0 0 26.1 19.5">
        <g>
            <path
                d="M20.7,14.8c-0.1,0-0.2,0-0.3-0.1l-4.6-4.3c-0.2-0.2-0.2-0.4,0-0.6c0.2-0.2,0.4-0.2,0.6,0l4.6,4.3c0.2,0.2,0.2,0.4,0,0.6
                    C21,14.8,20.8,14.8,20.7,14.8L20.7,14.8z M20.7,14.8"
            />
            <path
                d="M5.4,14.8c-0.1,0-0.2,0-0.3-0.1c-0.2-0.2-0.1-0.4,0-0.6l4.6-4.3c0.2-0.2,0.4-0.1,0.6,0c0.2,0.2,0.1,0.4,0,0.6l-4.6,4.3
                    C5.6,14.8,5.5,14.8,5.4,14.8L5.4,14.8z M5.4,14.8"
            />
            <path
                d="M23.5,18.9H2.7c-1.1,0-2-0.9-2-2V3.2c0-1.1,0.9-2,2-2h20.8c1.1,0,2,0.9,2,2v13.6C25.5,18,24.6,18.9,23.5,18.9L23.5,18.9z
                    M2.7,2C2,2,1.5,2.6,1.5,3.2v13.6c0,0.7,0.5,1.2,1.2,1.2h20.8c0.7,0,1.2-0.5,1.2-1.2V3.2c0-0.7-0.5-1.2-1.2-1.2H2.7z M2.7,2"
            />
            <path
                d="M13.1,12c-0.5,0-1.1-0.2-1.5-0.5l-10.3-9C1.2,2.4,1.1,2.2,1.3,2c0.1-0.2,0.4-0.2,0.6,0l10.3,9c0.5,0.4,1.4,0.4,1.9,0
                    L24.3,2c0.2-0.1,0.4-0.1,0.6,0c0.1,0.2,0.1,0.4,0,0.6l-10.3,8.9C14.1,11.9,13.6,12,13.1,12L13.1,12z M13.1,12"
            />
        </g>
    </svg>
)

export const HelpIcon = () => (
    <svg id="Layer_1" x="0px" y="0px" viewBox="0 0 48 48" xmlSpace="preserve">
        <style>{'.st02{fill:#4d4d4d}'}</style>
        <path
            className="st02"
            d="M24 48C10.8 48 0 37.2 0 24S10.8 0 24 0s24 10.8 24 24-10.8 24-24 24zm0-46C11.9 2 2 11.9 2 24s9.9 22 22 22 22-9.9 22-22S36.1 2 24 2z"
        />
        <path
            className="st02"
            d="M24 31c-.5 0-.9-.4-1-.9 0-.2-.3-4.2 3.9-7.6 1.5-1.2 2.1-2.4 2.1-4.3 0-2.9-2.2-5.2-5-5.2s-5 2.2-5 5c0 .6-.4 1-1 1s-1-.4-1-1c0-3.9 3.1-7 7-7s7 3.2 7 7.2c0 2.5-.9 4.2-2.8 5.8-3.3 2.7-3.2 5.8-3.2 5.9 0 .6-.4 1-1 1.1.1 0 0 0 0 0z"
        />
        <g>
            <path className="st02" d="M24 38c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm0-2z" />
        </g>
    </svg>
)

export const HelpIconMenu = () => (
    <svg x="0px" y="0px" viewBox="0 0 32 32" xmlSpace="preserve">
        <path d="M16 21.6c-1 0-1.8.8-1.8 1.8s.8 1.8 1.8 1.8 1.8-.8 1.8-1.8-.8-1.8-1.8-1.8z" />
        <path d="M16 .3C7.4.3.3 7.4.3 16s7 15.7 15.7 15.7c8.6 0 15.7-7 15.7-15.7C31.7 7.4 24.7.3 16 .3zm0 29.2c-7.5 0-13.5-6-13.5-13.5S8.5 2.5 16 2.5 29.5 8.6 29.5 16c0 3.6-1.4 7-4 9.6-2.5 2.5-5.9 3.9-9.5 3.9zM16 .6z" />
        <path d="M16 8.1c-2.8 0-5.1 2.3-5.1 5.1.1.8.8 1.4 1.6 1.3.7-.1 1.3-.6 1.3-1.3 0-1.2 1-2.2 2.2-2.2 1.2 0 2.2 1 2.2 2.2s-1 2.2-2.2 2.2c-.8 0-1.5.6-1.5 1.5v3c0 .4.2.8.4 1 .3.3.6.4 1 .4.8 0 1.5-.7 1.5-1.5V18c2.6-.9 4-3.7 3.2-6.3-.6-2.1-2.5-3.5-4.6-3.6z" />
    </svg>
)

export const SupportIcon = () => (
    <svg data-name="Layer 1" viewBox="0 0 32 32">
        <path d="M9.36 21.12a1.13 1.13 0 01-1.2-1.2v-1.2a1.13 1.13 0 011.2-1.2 1.13 1.13 0 011.2 1.2v1.2a1.13 1.13 0 01-1.2 1.2z" />
        <path d="M9.36 21.12a1.23 1.23 0 01-1.2-1.2.72.72 0 01.12-.48c.12-.12.12-.24.24-.36a1.1 1.1 0 011.32-.24c.12 0 .24.12.36.24s.24.24.24.36a.72.72 0 01.12.48 1.23 1.23 0 01-1.2 1.2z" />
        <path d="M9.36 21.12a1.23 1.23 0 01-1.2-1.2.72.72 0 01.12-.48c.12-.12.12-.24.24-.36a1.1 1.1 0 011.32-.24c.12 0 .24.12.36.24s.24.24.24.36a.72.72 0 01.12.48 1.23 1.23 0 01-1.2 1.2zM9.36 24.72a1.23 1.23 0 01-1.2-1.2.72.72 0 01.12-.52c.12-.12.12-.24.24-.36a1.16 1.16 0 011.68 0c.12.12.24.24.24.36a.72.72 0 01.12.48 1.23 1.23 0 01-1.2 1.2z" />
        <path d="M9.36 19.92a1.2 1.2 0 010-2.4 1.2 1.2 0 000-2.4 1.13 1.13 0 00-1.2 1.2A1.13 1.13 0 017 17.52a1.13 1.13 0 01-1.2-1.2 3.54 3.54 0 013.6-3.6 3.6 3.6 0 110 7.2zM17.65 21a1.09 1.09 0 01-.84-.36 1.16 1.16 0 010-1.68l5-5a1.19 1.19 0 011.68 1.68l-5 5a1.3 1.3 0 01-.84.36zM19.93 23.29a1.09 1.09 0 01-.84-.36 1.16 1.16 0 010-1.68l5-5a1.19 1.19 0 011.68 1.68l-5 5a.93.93 0 01-.84.36z" />
        <path d="M24.93 18.26a1 1 0 01-.81-.34 1.11 1.11 0 010-1.61.42.42 0 00.12-.35.42.42 0 00-.46-.46.42.42 0 00-.35.12A1.14 1.14 0 0121.82 14a2.68 2.68 0 012-.81 2.66 2.66 0 011.95.81 2.35 2.35 0 01.81 2 2.7 2.7 0 01-.81 2 1.22 1.22 0 01-.84.26zM17.06 23.73a1.09 1.09 0 01-.82-.35 1.61 1.61 0 01-.34-1l.58-2.78a1.18 1.18 0 112.31.46l-.23 1.16 1.16-.22a1.18 1.18 0 01.47 2.31l-2.9.47z" />
        <path d="M28.22 1.7H3.78A3.27 3.27 0 00.52 5v2.81a.85.85 0 000 .72V27a3.27 3.27 0 003.26 3.3h24.44a3.27 3.27 0 003.26-3.3V5a3.27 3.27 0 00-3.26-3.3zM3.78 3.5h24.44A1.47 1.47 0 0129.68 5v2.3H2.32V5a1.47 1.47 0 011.46-1.5zm24.44 25H3.78A1.47 1.47 0 012.32 27V9h27.36v18a1.47 1.47 0 01-1.46 1.5z" />
    </svg>
)

export const NotificationIcon = () => (
    <svg viewBox="0 0 512 512">
        <g>
            <g>
                <path d="M467.812,431.851l-36.629-61.056c-16.917-28.181-25.856-60.459-25.856-93.312V224c0-67.52-45.056-124.629-106.667-143.04    V42.667C298.66,19.136,279.524,0,255.993,0s-42.667,19.136-42.667,42.667V80.96C151.716,99.371,106.66,156.48,106.66,224v53.483    c0,32.853-8.939,65.109-25.835,93.291l-36.629,61.056c-1.984,3.307-2.027,7.403-0.128,10.752c1.899,3.349,5.419,5.419,9.259,5.419    H458.66c3.84,0,7.381-2.069,9.28-5.397C469.839,439.275,469.775,435.136,467.812,431.851z" />
            </g>
        </g>
        <g>
            <g>
                <path d="M188.815,469.333C200.847,494.464,226.319,512,255.993,512s55.147-17.536,67.179-42.667H188.815z" />
            </g>
        </g>
    </svg>
)

export const TrainingModuleIcon = () => (
    <svg data-name="Layer 1" viewBox="0 0 32 32">
        <circle cx={19.44} cy={11.54} r={1.03} />
        <circle cx={23} cy={11.54} r={1.03} />
        <circle cx={26.56} cy={11.54} r={1.03} />
        <path d="M26 25.11H3.9a.9.9 0 01-.9-.9V12.08A3 3 0 016 9h7a.9.9 0 010 1.8H6a1.23 1.23 0 00-1.2 1.28v11.23h20.34v-2.57a.9.9 0 111.8 0v3.47a.9.9 0 01-.94.9z" />
        <path d="M12.4 19.93a.9.9 0 01-.9-.9A1.75 1.75 0 108 19a.9.9 0 01-1.8 0 3.55 3.55 0 117.09 0 .9.9 0 01-.89.93z" />
        <path d="M9.78 17.24a2.58 2.58 0 112.49-2.58 2.54 2.54 0 01-2.49 2.58zm0-3.35a.78.78 0 10.69.77.74.74 0 00-.69-.77zM23.1 19.61h-7.75a.5.5 0 01-.5-.5v-7.74a8.25 8.25 0 118.25 8.24zm-6.53-1.72h6.53a6.52 6.52 0 10-6.53-6.52zM28.47 28.88H1.5a.84.84 0 01-.6-1.43l1.84-1.9a.49.49 0 01.7 0 .5.5 0 010 .71l-1.57 1.62h26.22l-1.61-1.63a.5.5 0 010-.71.49.49 0 01.7 0l1.88 1.89a.84.84 0 01-.6 1.44z" />
    </svg>
)

export const CognideskLogoBlack = () => (
    <svg viewBox="0 0 48 48">
        <linearGradient
            id="SVGID_1_"
            gradientUnits="userSpaceOnUse"
            x1="1.6257"
            y1="-110"
            x2="46.1697"
            y2="-110"
            gradientTransform="matrix(1 0 0 1 0 134)"
        >
            <stop offset="0" />
            <stop offset="1" />
        </linearGradient>
        <path
            className="st01"
            d="M43.3,4.9L4.9,9.7c-2,0-3.4,1.6-3.2,3.4l2.8,19.4c0.2,1.8,2,3.4,3.8,3.6l10.4,1c2,0.2,3.4,2.2,3.2,4l0,0
            c-0.2,1.8,1,2.4,2.6,1.6l4-4c1.6-1,4.6-2,6.6-2h1c2,0.2,3.8-1.2,4.2-3l6-25.8C46.5,6.1,45.3,4.7,43.3,4.9z M15.5,25.1
            c-1.6,0-2.8-1.2-2.8-2.8s1.2-2.8,2.8-2.8s2.8,1.2,2.8,2.8S17.1,25.1,15.5,25.1L15.5,25.1z M23.5,25.1c-1.6,0-2.8-1.2-2.8-2.8
            s1.2-2.8,2.8-2.8s2.8,1.2,2.8,2.8l0,0C26.3,23.9,24.9,25.1,23.5,25.1z M31.3,25.1c-1.6,0-2.8-1.2-2.8-2.8s1.2-2.8,2.8-2.8
            c1.6,0,2.8,1.2,2.8,2.8C34.1,23.9,32.9,25.1,31.3,25.1L31.3,25.1z"
        />
    </svg>
)

export const SubPanelIcons: any = {
    SummaryIcon: () => (
        <svg
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 16.3 16.3"
            xmlSpace="preserve"
        >
            <style />
            <path
                className="s1t0"
                d="M14.4.2H2C1.1.2.3 1 .3 1.9v12.5c0 .9.8 1.6 1.7 1.6h12.4c.9 0 1.6-.7 1.6-1.6V1.9C16 1 15.3.2 14.4.2zM2 1.2h12.4c.4 0 .6.3.6.6V3H1.4V1.9c-.1-.4.2-.7.6-.7zM14.4 15H2c-.4 0-.6-.3-.6-.6V4H15v10.4c0 .3-.3.6-.6.6z"
            />
            <path
                className="s1t0"
                d="M7.9 6.9H3.1c-.4 0-.7.3-.7.7v5.6c0 .4.3.7.7.7h4.8c.4 0 .7-.3.7-.7V7.6c0-.4-.3-.7-.7-.7zM7.6 13H3.3V7.9h4.3V13zM13.4 6.9h-2.5c-.4 0-.7.3-.7.7v5.6c0 .4.3.7.7.7h2.5c.4 0 .7-.3.7-.7V7.6c0-.4-.3-.7-.7-.7zm-.3 6.1h-2V7.9h2V13zM2.8 6h10.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5H2.8c-.2 0-.5.2-.5.5s.3.5.5.5z"
            />
        </svg>
    ),
    BotIcon: () => (
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 32 32">
            <g>
                <g>
                    <path
                        d="M10.6,29c-0.1,0-0.3,0-0.4-0.1c-0.3-0.1-0.5-0.5-0.5-0.8v-4.6c-5.1-0.7-9-5-9-10.3C0.7,7.6,5.3,3,11.1,3H21
               c5.7,0,10.3,4.6,10.3,10.4S26.7,23.6,21,23.6h-3.8l-5.9,5.2C11,29,10.8,29,10.6,29z M11.5,23v3.2l4.7-4.1c0.2-0.1,0.4-0.2,0.6-0.2
               H21c4.7,0,8.5-3.8,8.5-8.6S25.7,4.8,21,4.8h-9.9c-4.7,0-8.6,3.8-8.6,8.6c0,4.5,3.5,8.3,8.1,8.5c0.9,0.1,1,0.9,1,0.9
               C11.5,22.8,11.5,22.9,11.5,23z"
                    />
                </g>
                <circle cx="9.8" cy="13.3" r="2.2" />
                <circle cx="16.5" cy="13.3" r="2.2" />
                <circle cx="23.1" cy="13.3" r="2.2" />
            </g>
        </svg>
    ),
    MyUploadsIcon: () => (
        <svg x="0px" y="0px" viewBox="0 0 28.5 25.5" xmlSpace="preserve">
            <path d="M22.2 24.7h-16c-1.1 0-2-.9-2-2v-13c0-1.1.9-2 2-2h4c.6 0 1 .4 1 1s-.4 1-1 1h-4v13h16v-13h-4c-.6 0-1-.4-1-1s.4-1 1-1h4c1.1 0 2 .9 2 2v13c0 1.1-.9 2-2 2z" />
            <path d="M14.2 16.7c-.6 0-1-.4-1-1v-14c0-.6.4-1 1-1s1 .4 1 1v14c0 .6-.4 1-1 1z" />
            <path d="M17.2 5.7c-.3 0-.5-.1-.7-.3l-2.3-2.3-2.3 2.3c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4l3-3c.4-.4 1-.4 1.4 0l3 3c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3z" />
        </svg>
    ),
    All: () => (
        <svg viewBox="0 0 18 18">
            <g>
                <path d="M7,1.1v6H1v-6H7 M8,0.1H0v8h8V0.1L8,0.1z" />
            </g>
            <g>
                <path d="M17,1.1v6h-6v-6H17 M18,0.1h-8v8h8V0.1L18,0.1z" />
            </g>
            <g>
                <path d="M7,10.9v6H1v-6H7 M8,9.9H0v8h8V9.9L8,9.9z" />
            </g>
            <g>
                <path d="M17,10.9v6h-6v-6H17 M18,9.9h-8v8h8V9.9L18,9.9z" />
            </g>
        </svg>
    ),

    Active: () => (
        <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 24 24" xmlSpace="preserve">
            <style>{'.st2w1{fill:CurrentColor}'}</style>
            <g id="Group_12853" transform="translate(-642 -20045.26)">
                <g id="Rectangle_2102">
                    <path
                        d="M2 0h20c1.1 0 2 .9 2 2v20c0 1.1-.9 2-2 2H2c-1.1 0-2-.9-2-2V2C0 .9.9 0 2 0z"
                        fill="none"
                        transform="translate(642 20045.26)"
                    />
                    <path
                        className="st2w1"
                        d="M22 24H2c-1.1 0-2-.9-2-2V2C0 .9.9 0 2 0h20c1.1 0 2 .9 2 2v20c0 1.1-.9 2-2 2zM2 1.5c-.3 0-.5.2-.5.5v20c0 .3.2.5.5.5h20c.3 0 .5-.2.5-.5V2c0-.3-.2-.5-.5-.5H2z"
                        transform="translate(642 20045.26)"
                    />
                </g>
                <path
                    className="st2w1"
                    d="M652.9 20061.9c-.2 0-.3-.1-.5-.2l-4.4-3.5c-.3-.3-.4-.7-.1-1.1.3-.3.7-.4 1.1-.1l3.9 3 6.3-6.8c.3-.3.8-.3 1.1 0 .3.3.3.8 0 1.1l-6.8 7.3c-.2.2-.4.3-.6.3z"
                    id="Path_10185"
                />
            </g>
        </svg>
    ),

    Inactive: () => (
        <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 24 24" xmlSpace="preserve">
            <style>{'.stw1{fill:currentColor}'}</style>
            <g id="Group_12854" transform="translate(-642 -20085.26)">
                <g id="Rectangle_2103">
                    <path
                        d="M2 0h20c1.1 0 2 .9 2 2v20c0 1.1-.9 2-2 2H2c-1.1 0-2-.9-2-2V2C0 .9.9 0 2 0z"
                        fill="none"
                        transform="translate(642 20085.26)"
                    />
                    <path
                        className="stw1"
                        d="M22 24H2c-1.1 0-2-.9-2-2V2C0 .9.9 0 2 0h20c1.1 0 2 .9 2 2v20c0 1.1-.9 2-2 2zM2 1.5c-.3 0-.5.2-.5.5v20c0 .3.2.5.5.5h20c.3 0 .5-.2.5-.5V2c0-.3-.2-.5-.5-.5H2z"
                        transform="translate(642 20085.26)"
                    />
                </g>
                <g id="Group_12435" transform="rotate(-90 594.056 20064.095)">
                    <path
                        className="stw1"
                        d="M555.9 20128.2c0-.2.1-.4.2-.5l9.2-9.2c.3-.3.8-.3 1.1 0s.3.8 0 1.1l-9.2 9.2c-.3.3-.8.3-1.1 0-.1-.2-.2-.4-.2-.6z"
                        id="Line_572"
                    />
                    <path
                        className="stw1"
                        d="M555.9 20119c0-.2.1-.4.2-.5.3-.3.8-.3 1.1 0l9.2 9.2c.3.3.3.8 0 1.1-.3.3-.8.3-1.1 0l-9.2-9.2c-.1-.2-.2-.4-.2-.6z"
                        id="Line_573"
                    />
                </g>
            </g>
        </svg>
    ),

    Saved: () => (
        <svg viewBox="0 0 18 18">
            <g>
                <g>
                    <path d="M15,1v2v0.1H4H3v1V15H1V1H15 M16,0H0v16h4V4.1h12V3V0L16,0z" />
                </g>
                <g>
                    <path d="M17,4v13H4V4H17 M18,3H3v15h15V3L18,3z" />
                </g>
            </g>
        </svg>
    ),
    Trigger: () => (
        <svg x="0px" y="0px" viewBox="0 0 32 32" xmlSpace="preserve">
            <path d="M13 32c-.2 0-.4-.1-.6-.2-.5-.3-.6-.9-.3-1.4L22.4 15h-3.8c-.6 0-1.1-.3-1.4-.7-.4-.5-.6-1.1-.5-1.7v-.1L20 .8c.2-.5.7-.8 1.2-.7.5.2.8.7.7 1.2L18.7 13h4.7c.4 0 1.2 0 1.5.7.2.4.2.9-.2 1.5L13.8 31.5c-.2.3-.5.5-.8.5z" />
            <path d="M13 32h-.2c-.5-.1-.9-.6-.8-1.2L13.9 20H8.6c-.7 0-1.2-.3-1.5-.9-.3-.5-.2-1.2.3-1.7L20.2.4c.3-.4 1-.5 1.4-.2.4.3.5 1 .2 1.4L9.5 18H14c.9 0 1.3.3 1.6.6.3.3.5.8.4 1.3l-2 11.3c-.1.5-.5.8-1 .8z" />
        </svg>
    ),
    NoTrigger: () => (
        <svg x="0px" y="0px" viewBox="0 0 32 32" xmlSpace="preserve">
            <path d="M19 13.8c-.6 0-1 1-1.4.6-.4-.5-.6-1.1-.5-1.7v-.1L20.4.8c.2-.5.7-.8 1.2-.7.5.2.8.7.7 1.2L19 12.9c0 .1 0 .1.1.1h4.5M24.4 16.8L14.3 31.5c-.2.3-.5.4-.8.4-.2 0-.4-.1-.6-.2-.5-.3-.6-.9-.3-1.4L22 16.8" />
            <g>
                <path d="M10.9 16.8L10 18h4.5c.9 0 1.3.3 1.6.6.3.3.5.8.4 1.3l-2 11.3c-.1.5-.5.8-1 .8h-.2c-.5-.1-.9-.6-.8-1.2L14.4 20H9.1c-.7 0-1.2-.3-1.5-.9-.3-.5-.2-1.2.3-1.7l.5-.6M10 14.8L20.7.4c.3-.4 1-.5 1.4-.2.4.3.5 1 .2 1.4L13 13.8" />
            </g>
            <g>
                <path d="M28 14.8H4c-.6 0-1-.4-1-1s.4-1 1-1h24c.6 0 1 .4 1 1s-.4 1-1 1z" />
            </g>
        </svg>
    ),
    Draft: () => (
        <svg x="0px" y="0px" viewBox="0 0 32 32" xmlSpace="preserve">
            <path d="M24.7 8.9h-12c-.6 0-1-.4-1-1s.4-1 1-1h12c.6 0 1 .4 1 1 0 .5-.4 1-1 1z" />
            <circle cx={7.8} cy={7.9} r={1.2} />
            <path d="M21.7 14h-9c-.6 0-1-.4-1-1s.4-1 1-1h9c.6 0 1 .4 1 1s-.4 1-1 1z" />
            <circle cx={7.8} cy={13} r={1.2} />
            <path d="M18.7 19.1h-6c-.6 0-1-.4-1-1s.4-1 1-1h6c.6 0 1 .4 1 1s-.4 1-1 1z" />
            <circle cx={7.8} cy={18.1} r={1.2} />
            <path d="M31 32H1c-.6 0-1-.4-1-1V1c0-.6.4-1 1-1h30c.6 0 1 .4 1 1v30c0 .6-.4 1-1 1zM2 30h28V2H2v28z" />
            <path d="M17.9 24.4c-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4l5.9-5.9c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-5.9 5.9c-.2.2-.5.3-.7.3zM20.7 27.2c-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4l5.9-5.9c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-5.9 5.9c-.2.2-.5.3-.7.3z" />
            <g>
                <path d="M26.6 21.2c-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4.2-.2.3-.4.3-.7 0-.3-.1-.5-.3-.7-.4-.4-1-.4-1.4 0-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4 1.1-1.1 3.1-1.1 4.2 0 .6.6.9 1.3.9 2.1s-.3 1.5-.9 2.1c-.2.2-.4.3-.7.3z" />
            </g>
            <g>
                <path d="M17.2 27.8c-.3 0-.5-.1-.7-.3-.2-.2-.3-.6-.3-.9l.7-3.5c.1-.5.6-.9 1.2-.8.5.1.9.6.8 1.2l-.4 2 2-.4c.5-.1 1.1.2 1.2.8.1.5-.2 1.1-.8 1.2l-3.5.7h-.2z" />
            </g>
        </svg>
    ),
    Analytics: () => (
        <svg viewBox="0 0 18 18">
            <g>
                <g>
                    <path d="M3.5,12.7V17h-1v-4.3H3.5 M4.5,11.7h-3V18h3V11.7L4.5,11.7z" />
                </g>
                <g>
                    <path d="M7.5,8.3V17h-1V8.3H7.5 M8.5,7.3h-3V18h3V7.3L8.5,7.3z" />
                </g>
                <g>
                    <path d="M11.5,11v6h-1v-6H11.5 M12.5,10h-3v8h3V10L12.5,10z" />
                </g>
                <g>
                    <path d="M15.5,6.1V17h-1V6.1H15.5 M16.5,5.1h-3V18h3V5.1L16.5,5.1z" />
                </g>
                <g>
                    <path
                        d="M11,5.6c0.3,0,0.5,0.2,0.5,0.5S11.3,6.5,11,6.5s-0.5-0.2-0.5-0.5S10.7,5.6,11,5.6 M11,4.6
c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5S11.8,4.6,11,4.6L11,4.6z"
                    />
                </g>
                <g>
                    <path
                        d="M7,3.2c0.3,0,0.5,0.2,0.5,0.5S7.3,4.1,7,4.1S6.6,3.9,6.6,3.7S6.8,3.2,7,3.2 M7,2.2c-0.8,0-1.5,0.7-1.5,1.5
S6.2,5.1,7,5.1s1.5-0.7,1.5-1.5S7.9,2.2,7,2.2L7,2.2z"
                    />
                </g>
                <g>
                    <path
                        d="M3,8.1c0.3,0,0.5,0.2,0.5,0.5S3.3,9,3,9S2.6,8.8,2.6,8.5S2.8,8.1,3,8.1 M3,7.1c-0.8,0-1.5,0.7-1.5,1.5
S2.2,10,3,10s1.5-0.7,1.5-1.5S3.9,7.1,3,7.1L3,7.1z"
                    />
                </g>
                <g>
                    <path
                        d="M15,1.2c0.3,0,0.5,0.2,0.5,0.5S15.3,2.1,15,2.1s-0.5-0.2-0.5-0.5S14.8,1.2,15,1.2 M15,0.2
c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5S15.9,0.2,15,0.2L15,0.2z"
                    />
                </g>
                <line className="st1_stroke" x1="3.6" y1="7.5" x2="6.2" y2="4.1" />
                <line className="st1_stroke" x1="7.9" y1="4.1" x2="10.1" y2="5.4" />
                <line className="st1_stroke" x1="11.8" y1="5.4" x2="14.5" y2="2.4" />
                <line className="st1_stroke" x1="0" y1="17.7" x2="18" y2="17.7" />
            </g>
        </svg>
    ),

    logs: () => (
        <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 16 16" xmlSpace="preserve">
            <style>{'.s1t1{fill:currentColor}'}</style>
            <g id="Group_12430" transform="translate(-400 -20017)">
                <g id="Rectangle_2100">
                    <path
                        d="M1 0h14c.6 0 1 .4 1 1v14c0 .6-.4 1-1 1H1c-.6 0-1-.4-1-1V1c0-.6.4-1 1-1z"
                        fill="none"
                        transform="translate(400 20017)"
                    />
                    <path
                        className="s1t1"
                        d="M15 16H1c-.6 0-1-.4-1-1V1c0-.6.4-1 1-1h14c.6 0 1 .4 1 1v14c0 .6-.4 1-1 1zM1 1v14h14V1H1zm0-.5V1 .5z"
                        transform="translate(400 20017)"
                    />
                </g>
                <path className="s1t1" id="Line_561" d="M400.5 20020H415.5V20021H400.5z" />
                <path
                    className="s1t1"
                    d="M413.5 20024h-9c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h9c.3 0 .5.2.5.5s-.2.5-.5.5z"
                    id="Line_562"
                />
                <path
                    className="s1t1"
                    d="M402.5 20024h-.2c-.1 0-.1-.1-.2-.1-.1-.1-.1-.2-.1-.3v-.2c0-.1.1-.1.1-.2.1-.1.1-.1.2-.1.2-.1.4 0 .5.1.1 0 .1.1.1.2v.2c0 .1-.1.3-.2.3.1 0-.1.1-.2.1z"
                    id="Line_571"
                />
                <path
                    className="s1t1"
                    d="M413.5 20027h-9c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h9c.3 0 .5.2.5.5s-.2.5-.5.5z"
                    id="Line_564"
                />
                <path
                    className="s1t1"
                    d="M402.5 20027c-.1 0-.3-.1-.4-.2-.1-.1-.1-.2-.1-.3v-.2c0-.1.1-.1.1-.2.1 0 .1-.1.2-.1h.4c.1 0 .1.1.2.1s.1.1.1.2v.2c0 .1-.1.3-.2.3 0 0-.1.1-.2.1 0 .1 0 .1-.1.1z"
                    id="Line_569"
                />
                <path
                    className="s1t1"
                    d="M413.5 20030h-9c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h9c.3 0 .5.2.5.5s-.2.5-.5.5z"
                    id="Line_566"
                />
                <path
                    className="s1t1"
                    d="M402.5 20030h-.2c-.1 0-.1-.1-.2-.1 0 0-.1-.1-.1-.2v-.2c0-.1 0-.3.1-.4.1 0 .1-.1.2-.1h.4c.1 0 .1.1.2.1s.1.1.1.2v.4c0 .1-.1.1-.1.2-.1 0-.3.1-.4.1z"
                    id="Line_567"
                />
            </g>
        </svg>
    ),
    AgentHandoff: () => (
        <svg x="0px" y="0px" viewBox="0 0 16 16" xmlSpace="preserve">
            <path d="M15.1 8.6c-.5-.5-1.4-.6-2 0l-1.9 1.7c-.2-.5-.7-.9-1.3-.9H7.5c-.6-.6-1.4-.9-2.2-.9-.6 0-1.3.2-1.8.6-.1-.5-.6-.8-1.1-.8H.5v6.5h1.9c.6 0 1.1-.4 1.2-.9l2 .7h5.5l4-3.9c.3-.3.4-.6.4-1s-.2-.8-.4-1.1zM2.8 13.5c0 .2-.2.4-.4.4h-1V9.1h1c.2 0 .4.2.4.4v4zM14.4 10l-3.7 3.6h-5l-2.1-.7v-2.8c.4-.5 1-.8 1.7-.8.6 0 1.3.3 1.7.8l.1.2h2.8c.3 0 .5.2.5.5s-.2.5-.5.5H7.4v.9h2.5c.5 0 1-.3 1.3-.8l2.5-2.3c.2-.2.6-.2.8 0 .1.1.2.2.2.4-.1.3-.1.4-.3.5zM12.6 1.3H6.1v6.4h6.4V1.3zm-3.8.8h1v1h-1v-1zm2.9 4.7H7V2.1h1V4h2.7V2.1h1v4.7z" />
        </svg>
    ),
    DialogAgentHandoff: () => (
        <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 24 24" xmlSpace="preserve">
            <style>{'.sqt0{fill:currentColor}'}</style>
            <g id="agent_handover" transform="translate(-874 -20172)">
                <g id="Group_12448" transform="translate(649.639 19945.98)">
                    <path
                        id="Path_4328"
                        className="sqt0"
                        d="M241.9 238.8c-.4-.4-1.1-.4-1.6 0l-1.5 1.4c-.2-.4-.6-.7-1-.7h-1.9c-.8-.8-2.2-1-3.1-.3-.2-.4-.5-.6-.9-.6h-1.5v5.1h1.5c.4 0 .8-.3 1-.7l1.6.5h4.3l3.2-3.1c.4-.4.4-1.2-.1-1.6zm-9.7 3.8c0 .2-.1.3-.3.3h-.8v-3.7h.8c.2 0 .3.1.3.3v3.1zm9.2-2.7l-3 2.9h-3.9l-1.7-.6V240c.6-.7 1.7-.8 2.5-.2l.2.2.1.1h2.2c.2 0 .4.2.5.4 0 .2-.2.4-.4.5h-2v.7h2c.4 0 .8-.2 1-.6l2-1.8c.2-.2.5-.2.6 0 .1.2.1.4-.1.6z"
                    />
                    <path
                        id="Path_4329"
                        className="sqt0"
                        d="M239.9 233h-5.1v5.1h5.1V233zm-2.9.7h.8v.8h-.8v-.8zm2.2 3.7h-3.7v-3.7h.8v1.5h2.2v-1.5h.8l-.1 3.7z"
                    />
                </g>
            </g>
        </svg>
    ),

    OnPremICon: () => (
        <svg x="0px" y="0px" viewBox="0 0 32 32" xmlSpace="preserve">
            <title>OnPrem</title>
            <path d="M30.2 25.5c0-.7-.7-1.4-1.5-1.5h-.1s-.1 0-.1-.1l.1-.1c.5-.6.3-1.6-.1-2-.5-.5-1.4-.6-2.1-.1l-.1.1h-.1v-.2c-.1-.7-.8-1.3-1.5-1.3s-1.4.7-1.5 1.4v.1s0 .1-.1.1l-.1-.1c-.6-.5-1.5-.5-2 .1-.6.5-.7 1.4-.1 2.1 0 0 0 .1.1.1v.1h-.2c-.7.1-1.3.8-1.3 1.5s.7 1.4 1.5 1.5l.2.2-.2.1c-.5.6-.5 1.5.1 2 .5.5 1.4.6 2 .1l.2-.1c.1 0 .1 0 .1-.1v.2c.1.7.8 1.3 1.5 1.3.8 0 1.4-.5 1.7-1.5l.1-.2.1.1c.6.5 1.5.5 2-.1.5-.5.6-1.4.1-2.1l.1.2v-.1h.4l-.1-.2c.5-.3.9-.9.9-1.5zm-3 1l-.1.3c-.2.3-.1.7 0 1.1-.4-.1-.8-.2-1.1 0-.2.1-.7.5-1 1-.2-.4-.5-.8-.8-.9l-.9-.3c-.3-.2-.5-.2-.8 0 .1-.4.2-.8 0-1.1-.1-.2-.5-.7-1-1 .5-.2.8-.4.9-.8l.3-.5c.2-.2.2-.4.2-.5 0-.2 0-.3-.1-.5.3.1.7.1 1.1 0 .3-.1.8-.5 1.1-1 .2.5.4.8.8.9l.3.1c.3.2.7.1 1.1 0-.2.4-.2.9 0 1.2.1.3.5.8 1 1.1-.4.2-.8.4-1 .9z" />
            <path d="M25 23.8c-1 0-1.8.8-1.8 1.8s.8 1.9 1.8 1.9 1.8-.9 1.8-1.9c0-1-.8-1.8-1.8-1.8zm0 1.8v.1-.1c-.1 0 0 0 0 0zM18 29.5H4.9c-.9 0-1.6-.7-1.6-1.7v-6H18c.5 0 .8-.4.8-.8s-.4-.8-.9-.8H3.2v-8.3h23.1V18c0 .4.4.8.9.8.4 0 .8-.4.8-.8V4.2C28 2.4 26.5.8 24.7.8H4.8C3 .9 1.5 2.4 1.5 4.2v23.6c0 1.8 1.5 3.4 3.3 3.4h13.1c.4 0 .8-.4.9-.8v-.1c0-.4-.4-.8-.8-.8zm8.3-19.4H3.2V4.2c0-.9.7-1.7 1.5-1.7h19.9c.9 0 1.6.7 1.6 1.7v5.9z" />
            <path d="M8.6 4.6H6.1c-.4 0-.9.4-.9.9s.4.9.9.9h2.5c.4 0 .9-.4.9-.9s-.5-.9-.9-.9zM6.1 14c-.4 0-.9.4-.9.8s.4.9.9.9h2.5c.4 0 .9-.4.9-.9 0-.4-.5-.8-.9-.8H6.1zM6.1 23.8c-.4 0-.9.4-.9.9 0 .4.4.8.9.8h2.5c.4 0 .9-.4.9-.8s-.4-.9-.9-.9H6.1z" />
        </svg>
    ),

    HomePage: () => (
        <svg viewBox="0 0 24 24">
            <title>icon-track-home</title>
            <path
                d="M3.2,11.7v9.8c-0.1,0.5,0,1.1,0.2,1.6c0.3,0.4,0.8,0.7,1.3,0.6h14.7c0.7,0,1.2-0.6,1.2-1.3c0,0,0,0,0,0V11.7
                c0-0.4-0.4-0.8-0.8-0.8c-0.4,0-0.8,0.4-0.8,0.8v10.4h-3.6v-5.7c0-0.7,0.2-1.7-0.7-2c-0.2,0-0.4,0-0.5,0h-4c-0.6,0-1.2,0-1.5,0.5
                c-0.1,0.3-0.2,0.6-0.2,0.9v6.3H4.8V11.7c0-0.4-0.4-0.8-0.8-0.8C3.6,10.9,3.2,11.3,3.2,11.7z M10,15.8h3.8v6.3H10V15.8z M1.8,11.8
                l6.9-6.4l3.2-3l6.4,5.9l3.9,3.4c0.3,0.3,0.8,0.3,1.1,0c0.3-0.3,0.3-0.8,0-1.1c0,0,0,0,0,0l-7.1-6.4l-3.7-3.4c-0.3-0.3-0.8-0.3-1.1,0
                L4.4,7.2l-3.8,3.5C-0.1,11.3,1,12.4,1.8,11.8z"
            />
        </svg>
    ),

    settings: () => (
        <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 165.33 164.32">
            <g>
                <g>
                    <path
                        d="M145.82,66.96l-10.08-1.71c-1.05-3.39-2.4-6.66-4.05-9.78l5.94-8.31c2.52-3.54,2.13-8.37-0.96-11.43l-8.94-8.94
			c-1.68-1.68-3.9-2.61-6.27-2.61c-1.86,0-3.63,0.57-5.13,1.65l-8.34,5.94c-3.24-1.71-6.63-3.12-10.14-4.17l-1.68-9.96
			c-0.72-4.29-4.41-7.41-8.76-7.41H74.78c-4.35,0-8.04,3.12-8.76,7.41l-1.74,10.2c-3.36,1.05-6.63,2.43-9.75,4.11l-8.25-5.94
			c-1.5-1.08-3.3-1.65-5.16-1.65c-2.37,0-4.62,0.93-6.27,2.61l-8.97,8.94c-3.06,3.06-3.48,7.89-0.96,11.43l6,8.43
			c-1.65,3.15-2.97,6.42-3.99,9.81l-9.96,1.68c-4.29,0.72-7.41,4.41-7.41,8.76v12.63c0,4.35,3.12,8.04,7.41,8.76l10.2,1.74
			c1.05,3.36,2.43,6.63,4.11,9.75l-5.91,8.22c-2.52,3.54-2.13,8.37,0.96,11.43l8.94,8.94c1.68,1.68,3.9,2.61,6.27,2.61
			c1.86,0,3.63-0.57,5.13-1.65l8.43-6c3.03,1.59,6.21,2.88,9.48,3.9l1.68,10.08c0.72,4.29,4.41,7.41,8.76,7.41h12.66
			c4.35,0,8.04-3.12,8.76-7.41l1.71-10.08c3.39-1.05,6.66-2.4,9.78-4.05l8.31,5.94c1.5,1.08,3.3,1.65,5.16,1.65l0,0
			c2.37,0,4.59-0.93,6.27-2.61l8.94-8.94c3.06-3.06,3.48-7.89,0.96-11.43l-5.94-8.34c1.65-3.15,3.03-6.42,4.05-9.78l10.08-1.68
			c4.29-0.72,7.41-4.41,7.41-8.76V75.72C153.23,71.37,150.11,67.68,145.82,66.96z M145.13,88.35c0,0.39-0.27,0.72-0.66,0.78
			l-12.6,2.1c-1.59,0.27-2.85,1.44-3.24,2.97c-1.14,4.41-2.88,8.64-5.22,12.57c-0.81,1.38-0.75,3.09,0.18,4.41l7.41,10.44
			c0.21,0.3,0.18,0.75-0.09,1.02l-8.94,8.94c-0.21,0.21-0.42,0.24-0.57,0.24c-0.18,0-0.33-0.06-0.45-0.15l-10.41-7.41
			c-1.29-0.93-3.03-0.99-4.41-0.18c-3.93,2.34-8.16,4.08-12.57,5.22c-1.56,0.39-2.73,1.68-2.97,3.24l-2.13,12.6
			c-0.06,0.39-0.39,0.66-0.78,0.66H75.05c-0.39,0-0.72-0.27-0.78-0.66l-2.1-12.6c-0.27-1.59-1.44-2.85-2.97-3.24
			c-4.29-1.11-8.43-2.82-12.3-5.04c-0.63-0.36-1.35-0.54-2.04-0.54c-0.81,0-1.65,0.24-2.34,0.75l-10.5,7.47
			c-0.15,0.09-0.3,0.15-0.45,0.15c-0.12,0-0.36-0.03-0.57-0.24l-8.94-8.94c-0.27-0.27-0.3-0.69-0.09-1.02l7.38-10.35
			c0.93-1.32,0.99-3.06,0.18-4.44c-2.34-3.9-4.14-8.13-5.28-12.54c-0.42-1.53-1.68-2.7-3.24-2.97l-12.69-2.16
			c-0.39-0.06-0.66-0.39-0.66-0.78V76.02c0-0.39,0.27-0.72,0.66-0.78l12.51-2.1c1.59-0.27,2.88-1.44,3.27-3
			c1.11-4.41,2.82-8.67,5.13-12.6c0.81-1.38,0.72-3.09-0.21-4.38l-7.47-10.5c-0.21-0.3-0.18-0.75,0.09-1.02l8.94-8.94
			c0.21-0.21,0.42-0.24,0.57-0.24c0.18,0,0.33,0.06,0.45,0.15l10.35,7.38c1.32,0.93,3.06,0.99,4.44,0.18
			c3.9-2.34,8.13-4.14,12.54-5.28c1.53-0.42,2.7-1.68,2.97-3.24l2.16-12.69c0.06-0.39,0.39-0.66,0.78-0.66h12.63
			c0.39,0,0.72,0.27,0.78,0.66l2.1,12.51c0.27,1.59,1.44,2.88,3,3.27c4.53,1.14,8.85,2.91,12.87,5.28c1.38,0.81,3.09,0.75,4.41-0.18
			l10.35-7.44c0.15-0.09,0.3-0.15,0.45-0.15c0.12,0,0.36,0.03,0.57,0.24l8.94,8.94c0.27,0.27,0.3,0.69,0.09,1.02l-7.41,10.41
			c-0.93,1.29-0.99,3.03-0.18,4.41c2.34,3.93,4.08,8.16,5.22,12.57c0.39,1.56,1.68,2.73,3.24,2.97l12.6,2.13
			c0.39,0.06,0.66,0.39,0.66,0.78v12.63H145.13z"
                    />
                    <path
                        d="M81.38,51.03c-17.1,0-30.99,13.89-30.99,30.99s13.89,30.99,30.99,30.99s30.99-13.89,30.99-30.99S98.48,51.03,81.38,51.03z
			 M81.38,104.91c-12.63,0-22.89-10.26-22.89-22.89s10.26-22.89,22.89-22.89s22.89,10.26,22.89,22.89S94.01,104.91,81.38,104.91z"
                    />
                </g>
            </g>
        </svg>
    )
}

export const ManageUserIcon = () => (
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 16 16" xmlSpace="preserve">
        <style>{'.st03{fill:currentColor}'}</style>
        <g id="Group_12710" transform="translate(-864.001 -4469)">
            <g id="Group_12696" transform="translate(864.001 4471.286)">
                <g id="Group_12695">
                    <path
                        id="Path_10365"
                        className="st03"
                        d="M12.3 13.7H1.4c-.8 0-1.4-.6-1.4-1.4V1.4C0 .6.6 0 1.4 0h7.2c.3 0 .6.3.5.6 0 .3-.3.5-.5.5H1.4c-.1 0-.3.1-.3.3v10.9c0 .1.1.3.3.3h10.9c.1 0 .3-.1.3-.3V5.1c0-.3.3-.6.6-.6s.6.3.6.6v7.2c-.1.8-.7 1.4-1.5 1.4z"
                    />
                </g>
            </g>
            <g id="Group_12698" transform="translate(876.572 4469)">
                <path
                    id="Path_10367"
                    className="st03"
                    d="M.6 5.7c-.3 0-.6-.2-.6-.6V.6C0 .3.3 0 .6 0s.6.3.6.6v4.6c-.1.3-.3.5-.6.5z"
                />
            </g>
            <g id="Group_12699" transform="translate(874.287 4471.286)">
                <path
                    id="Path_10368"
                    className="st03"
                    d="M5.1 1.1H.6C.3 1.1 0 .9 0 .5 0 .3.3 0 .6 0h4.6c.3 0 .6.3.5.6 0 .3-.3.5-.6.5z"
                />
            </g>
            <g id="Group_12709" transform="translate(866.286 4473.582)">
                <g id="Group_12700" transform="translate(2.287 1.141)">
                    <path
                        id="Rectangle_2076"
                        className="st03"
                        d="M.6 0c.3 0 .6.3.6.6v2.3c0 .3-.3.6-.6.6-.3-.1-.6-.3-.6-.6V.6C0 .3.3 0 .6 0z"
                    />
                </g>
                <g id="Group_12701" transform="translate(5.714 1.141)">
                    <path
                        id="Rectangle_2077"
                        className="st03"
                        d="M.6 0c.3 0 .6.3.6.6v2.3c0 .3-.3.6-.6.6-.3-.1-.6-.3-.6-.6V.6C0 .3.3 0 .6 0z"
                    />
                </g>
                <g id="Group_12702" transform="translate(2.286)">
                    <path
                        id="Path_10369"
                        className="st03"
                        d="M.6 2.3C.3 2.3 0 2 0 1.7v-.1C.3.6 1.3 0 2.3 0c1 0 2 .6 2.3 1.6.1.3-.1.6-.4.7-.4 0-.7-.2-.8-.5-.3-.6-1.1-.8-1.8-.5-.2.1-.4.3-.5.5 0 .3-.3.5-.5.5z"
                    />
                </g>
                <g id="Group_12703" transform="translate(5.143 3.427)">
                    <path
                        id="Path_10370"
                        className="st03"
                        d="M.6 2.9c-.3 0-.6-.3-.6-.6 0-.2 0-.3.1-.4.3-.4.4-.8.4-1.3.1-.3.3-.6.6-.6s.6.2.6.5c0 .8-.2 1.5-.7 2.1-.1.2-.3.3-.4.3z"
                    />
                </g>
                <g id="Group_12704" transform="translate(2.286 3.427)">
                    <path
                        id="Path_10371"
                        className="st03"
                        d="M1.1 2.9c-.1 0-.3-.1-.4-.2C.2 2.1 0 1.3 0 .5 0 .2.3 0 .6 0s.5.3.5.6c0 .5.1.9.4 1.3.2.2.2.6-.1.8 0 .1-.1.2-.3.2z"
                    />
                </g>
                <g id="Group_12707" transform="translate(0 5.132)">
                    <g id="Group_12705" transform="translate(5.142)">
                        <path
                            id="Path_10372"
                            className="st03"
                            d="M3.4 2.9c-.1 0-.2 0-.3-.1L.3 1.1C0 .9-.1.5.1.3.2 0 .6-.1.9.1l2.9 1.7c.2.2.3.5.1.8-.1.2-.3.3-.5.3z"
                        />
                    </g>
                    <g id="Group_12706" transform="translate(0 .009)">
                        <path
                            id="Path_10373"
                            className="st03"
                            d="M.6 2.8c-.3 0-.6-.2-.6-.5 0-.2.1-.4.3-.5L3.2.1c.2-.2.6-.1.7.2.2.2.1.6-.2.8L.9 2.8H.6z"
                        />
                    </g>
                </g>
                <g id="Group_12708" transform="translate(0 6.847)">
                    <path
                        id="Path_10374"
                        className="st03"
                        d="M8 2.3H1.1C.5 2.3 0 1.8 0 1.1V.6C0 .3.3 0 .6 0s.6.3.6.6v.6H8V.6c0-.3.3-.6.6-.6s.6.3.6.6v.6c-.1.6-.6 1.1-1.2 1.1z"
                    />
                </g>
            </g>
        </g>
    </svg>
)

export const ProfileIcon = () => (
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 16 16" xmlSpace="preserve">
        <style>{'.st03{fill:currentColor}'}</style>
        <g id="Group_12694" transform="translate(-864 -4545)">
            <g id="Group_12691" transform="translate(868 4548.333)">
                <g id="Group_12690">
                    <g id="Group_12688" transform="translate(1.333)">
                        <g id="Group_12687">
                            <path
                                id="Path_10361"
                                className="st03"
                                d="M2.7 5.3C1.2 5.3 0 4.1 0 2.7S1.2 0 2.7 0c1.5 0 2.7 1.2 2.7 2.7-.1 1.4-1.3 2.6-2.7 2.6zm0-4c-.7 0-1.3.6-1.3 1.3S1.9 4 2.7 4 4 3.4 4 2.7c0-.8-.6-1.4-1.3-1.4z"
                            />
                        </g>
                    </g>
                    <g id="Group_12689" transform="translate(0 4.667)">
                        <path
                            id="Path_10362"
                            className="st03"
                            d="M7.3 4.7c-.3 0-.6-.3-.6-.7 0-1.5-1.2-2.6-2.7-2.6-1.5 0-2.6 1.2-2.7 2.6 0 .4-.3.7-.6.7S0 4.4 0 4.1V4c0-2.2 1.8-4 4-4s4 1.8 4 4c0 .4-.3.7-.7.7z"
                        />
                    </g>
                </g>
            </g>
            <g id="Group_12692" transform="translate(864 4545)">
                <path
                    id="Path_10363"
                    className="st03"
                    d="M14.7 16H1.3C.6 16 0 15.4 0 14.7V1.3C0 .6.6 0 1.3 0h13.4c.7 0 1.3.6 1.3 1.3v13.4c0 .7-.6 1.3-1.3 1.3zm0-14.7H1.4v13.3h13.3V1.3z"
                />
            </g>
            <g id="Group_12693" transform="translate(864 4556.333)">
                <path
                    id="Path_10364"
                    className="st03"
                    d="M15.3 1.3H.7C.3 1.3 0 1 0 .6 0 .3.3 0 .7 0h14.7c.3 0 .6.3.6.7 0 .3-.3.6-.7.6z"
                />
            </g>
        </g>
    </svg>
)

export const WorkspacesIcon = () => (
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 16 16" xmlSpace="preserve">
        <style>{'.st23{fill:currentColor}'}</style>
        <g id="Group_12723" transform="translate(-716 -2772)">
            <g id="Group_12716" transform="translate(716 2776)">
                <path
                    id="Path_10379"
                    className="st23"
                    d="M14 12H2c-1.1 0-2-.9-2-2V2C0 .9.9 0 2 0h12c1.1 0 2 .9 2 2v8c0 1.1-.9 2-2 2zM2 1.3c-.4 0-.7.3-.7.7v8c0 .4.3.7.7.7h12c.4 0 .7-.3.7-.7V2c0-.4-.3-.7-.7-.7H2z"
                />
            </g>
            <g id="Group_12717" transform="translate(717.333 2774)">
                <path
                    id="Path_10380"
                    className="st23"
                    d="M12.7 1.3H.7C.3 1.3 0 1 0 .6 0 .3.3 0 .7 0h12c.4 0 .7.3.6.7 0 .3-.3.6-.6.6z"
                />
            </g>
            <g id="Group_12718" transform="translate(718.667 2772)">
                <path
                    id="Path_10381"
                    className="st23"
                    d="M10 1.3H.7C.3 1.3 0 1 0 .6 0 .3.3 0 .7 0H10c.4 0 .7.3.6.7 0 .3-.3.6-.6.6z"
                />
            </g>
            <g id="Group_12719" transform="translate(718.667 2781.333)">
                <path
                    id="Path_10382"
                    className="st23"
                    d="M4.7 1.3h-4C.3 1.3 0 1 0 .6 0 .3.3 0 .7 0h4c.3 0 .6.3.6.7 0 .3-.3.6-.6.6z"
                />
            </g>
            <g id="Group_12720" transform="translate(718.667 2784)">
                <path
                    id="Path_10383"
                    className="st23"
                    d="M4.7 1.3h-4C.3 1.3 0 1 0 .6 0 .3.3 0 .7 0h4c.3 0 .6.3.6.7 0 .3-.3.6-.6.6z"
                />
            </g>
            <g id="Group_12721" transform="translate(718.667 2778.667)">
                <path
                    id="Path_10384"
                    className="st23"
                    d="M2.7 1.3h-2c-.4 0-.7-.2-.7-.6C0 .3.2 0 .6 0h2.1c.3 0 .6.3.7.6 0 .4-.3.7-.7.7z"
                />
            </g>
            <g id="Group_12722" transform="translate(726 2778)">
                <path
                    id="Path_10385"
                    className="st23"
                    d="M3.3 4H.7C.3 4 0 3.7 0 3.3V.7C0 .3.3 0 .7 0h2.7c.3 0 .6.3.6.7v2.7c0 .3-.3.6-.7.6zm-2-1.3h1.3V1.3H1.3v1.4z"
                />
            </g>
        </g>
    </svg>
)

export const ApplicationTrigger = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
        <g id="trigger" transform="translate(-166 -961)">
            <circle
                id="Ellipse_20"
                data-name="Ellipse 20"
                cx="24"
                cy="24"
                r="24"
                transform="translate(166 961)"
                fill="#4277c3"
            />
            <g id="Group_5802" data-name="Group 5802" transform="translate(179.768 968.922)">
                <g id="Group_5750" data-name="Group 5750" transform="translate(4.824 0.053)">
                    <path
                        id="Path_3816"
                        data-name="Path 3816"
                        d="M12.962,30.874a1.371,1.371,0,0,1-.579-.193.949.949,0,0,1-.289-1.351l9.937-14.857H18.365a1.688,1.688,0,0,1-1.351-.675,2.079,2.079,0,0,1-.482-1.64v-.1L19.715.775A1.048,1.048,0,0,1,20.873.1a1.048,1.048,0,0,1,.675,1.158L18.461,12.544H23c.386,0,1.158,0,1.447.675a1.378,1.378,0,0,1-.193,1.447L13.734,30.392A.984.984,0,0,1,12.962,30.874Z"
                        transform="translate(-11.931 -0.081)"
                        fill="#fff"
                    />
                </g>
                <g id="Group_5751" data-name="Group 5751" transform="translate(0 0)">
                    <path
                        id="Path_3817"
                        data-name="Path 3817"
                        d="M12.786,30.872h-.193a1,1,0,0,1-.772-1.158L13.654,19.3H8.541a1.5,1.5,0,0,1-1.447-.868,1.355,1.355,0,0,1,.289-1.64L19.732.387A1.037,1.037,0,0,1,21.083.194a1.037,1.037,0,0,1,.193,1.351L9.409,17.366h4.341a1.93,1.93,0,0,1,1.544.579A1.426,1.426,0,0,1,15.68,19.2L13.751,30.1A.939.939,0,0,1,12.786,30.872Z"
                        transform="translate(-6.931 -0.026)"
                        fill="#fff"
                    />
                </g>
            </g>
        </g>
    </svg>
)

export const FlowCanvasIcons: any = {
    StartIcon: () => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 10.6 9"
            xmlSpace="preserve"
            >
            <path
                d="M3.4 9c-.1 0-.3-.1-.3-.3V7.1C1.1 6.8-.2 5 0 3.1.3 1.3 1.8 0 3.6 0H7c2 0 3.6 1.7 3.5 3.6 0 1.9-1.6 3.5-3.5 3.5H5.7L3.6 9h-.2zm.3-2.1V8l1.6-1.4c.1 0 .1-.1.2-.1H7c1.6 0 3-1.3 3-3 0-1.6-1.3-3-3-3H3.6C2 .5.6 1.8.6 3.4c0 1.6 1.2 2.9 2.8 3 .2.1.3.3.3.5 0-.1 0-.1 0 0z"
                fill="#355d8b"
                transform="translate(-389 -724) translate(389 724)"
            />
        </svg>
    ),
    ArrowPlusIconWithBackground: () => (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
            <path
                d="M32.2,42.2c-3.2,0-5.8,2.6-5.8,5.8c0,3.2,2.6,5.8,5.8,5.8c3.2,0,5.8-2.6,5.8-5.8C38.1,44.9,35.4,42.2,32.2,42.2
	z M34.7,48.6h-2.1v2.1h-0.9v-2.1h-2.1v-0.9h2.1v-2.1h0.9v2.1h2.1V48.6z"
            />
            <g>
                <g>
                    <rect x="31.5" y="15.7" width="1" height="2.5" />
                </g>
                <g>
                    <path d="M32.5,35.6h-1v-5.4h1V35.6z M32.5,26.9h-1v-5.4h1V26.9z" />
                </g>
                <g>
                    <rect x="31.5" y="38.8" width="1" height="2.5" />
                </g>
            </g>
            <circle cx="32.1" cy="13" r="2.6" />
        </svg>
    ),
    ArrowPlusIcon: () => (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.24 16.24">
            <title>add</title>
            <g id="Layer_2" data-name="Layer 2">
                <g id="Layer_1-2" data-name="Layer 1">
                    <path d="M0,8.12a.93.93,0,0,1,.93-.93H7.19V.93a.93.93,0,0,1,1.86,0V7.19h6.26a.93.93,0,0,1,0,1.86H9.05v6.26a.93.93,0,0,1-1.86,0V9.05H.93A.93.93,0,0,1,0,8.12Z" />
                </g>
            </g>
        </svg>
    ),
    ArrowIcon: () => (
        <svg viewBox="0 0 10 40.7">
            <g>
                <g>
                    <path
                        className="st0"
                        d="M5,35.6c-0.3,0-0.5-0.2-0.5-0.5v-30c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v30C5.5,35.4,5.3,35.6,5,35.6z"
                    />
                </g>
                <circle className="st0" cx="5" cy="5.1" r="2.5" />
                <polygon className="st0" points="5,38.1 2.5,33.1 7.5,33.1 	" />
            </g>
        </svg>
    ),
    RepeatIcon: () => (
        <svg viewBox="0 0 48.7 42.7">
            <g>
                <defs>
                    <rect x="7.2" y="1.9" width="34.2" height="38.9" />
                </defs>

                <path
                    d="M30.5,2l10.8,8.3c0.1,0.1,0.2,0.2,0.2,0.3c0,0.1-0.1,0.3-0.2,0.3l-10.8,8.3c-0.1,0.1-0.2,0.1-0.3,0.1
                    c-0.1,0-0.2,0-0.3-0.1c-0.2-0.1-0.2-0.3-0.1-0.5l2.2-5.5h-23c-0.2,0-0.4-0.2-0.4-0.4V8.5C8.5,8.2,8.7,8,8.9,8h23l-2.2-5.5
                    c-0.1-0.2,0-0.4,0.1-0.5C30.1,1.9,30.3,1.9,30.5,2 M18.7,23.4c-0.1-0.1-0.2-0.1-0.3-0.1c-0.1,0-0.2,0-0.3,0.1L7.4,31.7
                    c-0.1,0.1-0.2,0.2-0.2,0.3c0,0.1,0.1,0.3,0.2,0.4l10.8,8.3c0.2,0.1,0.4,0.1,0.5,0c0.2-0.1,0.2-0.3,0.1-0.5l-2.2-5.5h23
                    c0.2,0,0.4-0.2,0.4-0.4v-4.4c0-0.2-0.2-0.4-0.4-0.4h-23l2.2-5.5C19,23.8,18.9,23.6,18.7,23.4"
                />
            </g>
        </svg>
    ),
    TriggerDescriptionIcon: () => (
        <svg viewBox="0 0 14 14">
            <g>
                <path d="M13,4v9H4V4H13 M14,3H3v11h11V3L14,3z" />
            </g>
            <g>
                <path d="M10,1v2L4,3L3,3l0,1l0,6H1V1H10 M11,0H0v11h4l0-7l7,0V0L11,0z" />
            </g>
        </svg>
    ),
    SwitchAccountIcon: () => (
        <svg viewBox="0 0 48.7 42.7">
            <g>
                <defs>
                    <rect x="7.2" y="1.9" width="34.2" height="38.9" />
                </defs>
                <path
                    d="M30.5,2l10.8,8.3c0.1,0.1,0.2,0.2,0.2,0.3c0,0.1-0.1,0.3-0.2,0.3l-10.8,8.3c-0.1,0.1-0.2,0.1-0.3,0.1
                    c-0.1,0-0.2,0-0.3-0.1c-0.2-0.1-0.2-0.3-0.1-0.5l2.2-5.5h-23c-0.2,0-0.4-0.2-0.4-0.4V8.5C8.5,8.2,8.7,8,8.9,8h23l-2.2-5.5
                    c-0.1-0.2,0-0.4,0.1-0.5C30.1,1.9,30.3,1.9,30.5,2 M18.7,23.4c-0.1-0.1-0.2-0.1-0.3-0.1c-0.1,0-0.2,0-0.3,0.1L7.4,31.7
                    c-0.1,0.1-0.2,0.2-0.2,0.3c0,0.1,0.1,0.3,0.2,0.4l10.8,8.3c0.2,0.1,0.4,0.1,0.5,0c0.2-0.1,0.2-0.3,0.1-0.5l-2.2-5.5h23
                    c0.2,0,0.4-0.2,0.4-0.4v-4.4c0-0.2-0.2-0.4-0.4-0.4h-23l2.2-5.5C19,23.8,18.9,23.6,18.7,23.4"
                />
            </g>
        </svg>
    )
}

export const NodeHoverMenuIcons: any = {
    AddIcon: () => (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 16.6">
            <g>
                <g>
                    <path d="M222.39,130.13v21.69h-80.57v-21.69H222.39 M229.39,123.13h-94.57v35.69h94.57V123.13L229.39,123.13z" />
                </g>
                <g>
                    <path d="M259.15,219.94v21.69h-80.57v-21.69H259.15 M266.15,212.94h-94.57v35.69h94.57V212.94L266.15,212.94z" />
                </g>
                <g>
                    <polyline points="148.32,201.75 148.32,158.82 155.32,158.82 155.32,206.75 		" />
                </g>
                <g>
                    <polygon points="171.58,234.29 148.32,234.29 148.32,199.23 155.32,199.23 155.32,227.29 171.58,227.29 		" />
                </g>
            </g>
        </svg>
    ),

    InfoIcon: () => (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            <g>
                <g>
                    <g>
                        <path
                            d="M256,0C114.52,0,0,114.5,0,256c0,141.48,114.5,256,256,256c141.48,0,256-114.5,256-256C512,114.52,397.5,0,256,0z
                            M256,472c-119.38,0-216-96.61-216-216c0-119.38,96.61-216,216-216c119.38,0,216,96.61,216,216C472,375.38,375.39,472,256,472z"
                        />
                    </g>
                </g>
            </g>
            <g>
                <path
                    d="M288.9,318.92c0.65,0.13,1.04,0.46,1.17,0.98c1.56,6.9,0.65,13.28-2.73,19.14c-19.79,24.61-42.25,36.91-67.38,36.91
                    c-13.15,0-16.99-13.21-11.52-39.65l17.97-84.77c0.52-1.69,0.52-3.25,0-4.69c-0.52-1.43-1.43-2.15-2.73-2.15
                    c-4.3,0-10.16,2.67-17.58,8.01l-0.78-0.39c-0.39-0.13-0.72-0.32-0.98-0.59c-0.78-0.39-1.17-0.85-1.17-1.37
                    c0-6.77,1.24-12.24,3.71-16.41c26.69-23.44,49.22-35.16,67.58-35.16c4.42,0,7.1,3.78,8.01,11.33c0.78,6.38,0.26,14.19-1.56,23.44
                    l-16.41,75c-1.43,7.55-2.22,12.83-2.34,15.82c-0.39,5.34,0.91,8.01,3.91,8.01c2.6,0,5.99-1.43,10.16-4.3
                    c3.52-2.34,7.35-5.47,11.52-9.38L288.9,318.92z M286.36,126.15c2.86,1.17,4.75,2.41,5.66,3.71c0.91,1.3,1.63,3.91,2.15,7.81
                    c0.39,3.52,0.46,5.99,0.2,7.42c-2.08,11.07-6.84,19.6-14.26,25.59c-1.04,0.91-3.12,1.83-6.25,2.73c-2.73,0.78-5.86,1.5-9.38,2.15
                    l-9.77,0.98c-3,0.13-5.08-0.06-6.25-0.59c-1.56-0.78-2.87-1.63-3.91-2.54c-1.3-1.04-2.48-2.15-3.52-3.32
                    c-2.34-3.12-3.91-7.29-4.69-12.5c-1.17-9.5,0.71-16.47,5.66-20.9c8.72-8.2,19.92-12.3,33.59-12.3
                    C279.52,124.39,283.1,124.98,286.36,126.15z"
                />
            </g>
        </svg>
    ),
    EditIcon: () => (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 401 401">
            <path
                d="M320.5,62.89c-17.55-17.55-46.01-17.55-63.56,0L108.86,218.85c-1.22,1.22-2.1,2.73-2.56,4.4L67.07,325.44
            c-0.96,3.47,0.02,7.18,2.56,9.73c2.55,2.54,6.26,3.52,9.73,2.56l100.38-41.04c1.66-0.46,3.18-1.34,4.4-2.56l148.08-155.96
            c17.52-17.56,17.52-45.99,0-63.56L320.5,62.89z M130.62,225.34l115.73-123.61l47.03,47.03L177.64,272.37L130.62,225.34z
            M121.22,244.19l37.57,37.58l-67.77,32L121.22,244.19z M318.1,124.05l-10.59,10.59l-47.03-47.03l10.6-10.59
            c9.75-9.75,25.56-9.75,35.31,0l11.72,11.72C327.83,98.5,327.83,114.29,318.1,124.05z"
            />
        </svg>
    ),
    CopyIcon: () => (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 401 401">
            <g>
                <path d="M348.4,160.37v209.77H138.63V160.37H348.4 M364.4,144.37H122.63v241.77H364.4V144.37L364.4,144.37z" />
            </g>
            <g>
                <path
                    d="M284.27,95.61v48.02l-145.72,0.73l-16.01,0.08l0.09,16.01l0.79,144.93H74.49V95.61H284.27 M300.27,79.61H58.49v241.77
                    h81.01l-0.88-161.02l161.64-0.81V79.61L300.27,79.61z"
                />
            </g>
        </svg>
    ),
    DeleteIcon: () => (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 401 401">
            <g>
                <g>
                    <g>
                        <polygon points="243.5,157.96 221.73,157.16 217.01,286.02 238.78,286.82 			" />
                        <polygon points="184.09,286.02 179.37,157.15 157.6,157.95 162.32,286.82 			" />
                        <path
                            d="M70.69,103.83v21.78h22.69l18,204.6c0.49,5.62,5.2,9.94,10.85,9.94h155.72c5.64,0,10.36-4.32,10.85-9.94l18-204.6h23.06
                            v-21.78H70.69z M267.98,318.37H132.21l-16.96-192.75h169.7L267.98,318.37z"
                        />
                    </g>
                </g>
            </g>
            <g>
                <g>
                    <path
                        d="M235.85,62.09h-71.15c-10.01,0-18.15,8.14-18.15,18.15v34.49h21.78V83.87h63.89v30.86H254V80.24
                        C254,70.23,245.86,62.09,235.85,62.09z"
                    />
                </g>
            </g>
        </svg>
    )
}

export const FlowCanvasActionMenu: any = {
    AddAction: () => (
        <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 24 24" xmlSpace="preserve">
            <style>{'.st22{fill:currentColor}'}</style>
            <g id="workflow_icon_1" transform="translate(-1112 -19979)">
                <g id="Group_12466" transform="translate(1118 19986)">
                    <g id="Group_3645" transform="translate(2.878 7.676)">
                        <g id="Path_2503">
                            <path
                                className="st22"
                                d="M.2 2.9h8.2c.1 0 .2-.1.2-.2V.2c0-.1-.1-.2-.2-.2H.2C.1 0 0 .1 0 .2v2.4c0 .2.1.3.2.3zm8-.5H.5V.5h7.7v1.9z"
                            />
                            <path
                                className="st22"
                                d="M8.4 3.1H.2c-.2 0-.5-.2-.5-.5V.2c0-.2.3-.5.5-.5h8.2c.1 0 .3.1.3.1.1.2.2.3.2.4v2.4c0 .3-.2.5-.5.5zm-7.7-1h7.2V.7H.7v1.4z"
                            />
                        </g>
                    </g>
                    <g id="Group_3646" transform="translate(0 8.875)">
                        <g id="Path_2504">
                            <path className="st22" d="M.2.5H3c.1 0 .2-.1.2-.2s0-.3-.1-.3H.2C.1 0 0 .1 0 .2s.1.3.2.3z" />
                            <path className="st22" d="M3.1.7H.2C0 .7-.3.5-.3.2S0-.2.2-.2H3c.3 0 .5.2.5.5s-.2.4-.4.4z" />
                        </g>
                    </g>
                    <g id="Group_3649">
                        <g id="Path_2507">
                            <path
                                className="st22"
                                d="M.2 2.9h8.2c.1 0 .2-.1.2-.2V.2c0-.1-.1-.2-.2-.2H.2C.1 0 0 .1 0 .2v2.4c0 .2.1.3.2.3zm8-.5H.5V.5h7.7v1.9z"
                            />
                            <path
                                className="st22"
                                d="M8.4 3.1H.2c-.2 0-.4-.2-.4-.5V.2c0-.2.2-.5.4-.5h8.2c.3 0 .5.2.5.5v2.4c0 .3-.2.5-.5.5zm-7.7-1h7.2V.7H.7v1.4z"
                            />
                        </g>
                    </g>
                    <g id="Group_3651" transform="translate(0 2.192)">
                        <g id="Path_2509">
                            <path
                                className="st22"
                                d="M.2 7.2c.1 0 .2-.1.2-.2V.2C.5.1.4 0 .2 0S0 .1 0 .2V7c0 .1.1.2.2.2z"
                            />
                            <path
                                className="st22"
                                d="M.2 7.4c-.2 0-.4-.2-.4-.4V.2c0-.2.2-.4.5-.4s.5.2.5.4V7c-.1.2-.3.4-.6.4z"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    ),
    TimerIcon: () => (
        <svg
            id="Group_13942"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 13.2 16"
            xmlSpace="preserve"
            >
            <style />
            <defs>
                <path id="SVGID_1_" d="M0 0H13.2V16H0z" />
            </defs>
            <clipPath id="SVGID_00000176754147459123049000000013465580959527655835_">
                <use xlinkHref="#SVGID_1_" overflow="visible" />
            </clipPath>
            <g
                id="Group_13941"
                clipPath="url(#SVGID_00000176754147459123049000000013465580959527655835_)"
            >
                <path
                id="Path_10524"
                d="M7.4 2.8c3.6.4 6.2 3.7 5.8 7.4S9.5 16.4 5.8 16-.4 12.2 0 8.6C.4 5.5 3 3 6.2 2.8V1.7H4.9c-.2 0-.4-.2-.4-.4V.4c0-.2.2-.4.4-.4h3.7c.2 0 .4.2.4.4v.9c0 .2-.2.4-.4.4H7.4v1.1zm-.3 5.6c.5.3.7 1 .5 1.5-.3.5-1 .7-1.5.5s-.7-1-.5-1.5c.1-.2.3-.4.5-.5V5.8c0-.3.2-.5.5-.6.3 0 .5.2.6.5l-.1 2.7zm5.4-3.6c.3-.5.2-1.2-.1-1.7-.5-.5-1.3-.6-2-.2.8.6 1.5 1.2 2.1 1.9M.7 4.8C.4 4.3.5 3.6.8 3.1c.5-.5 1.3-.6 2-.2C2 3.5 1.3 4.1.7 4.8m9.8.7c-2.2-2.2-5.7-2.2-7.8 0s-2.2 5.7 0 7.8 5.7 2.2 7.8 0c1-1 1.6-2.5 1.6-3.9.1-1.5-.5-2.9-1.6-3.9"
                fill="#305b8b"
                />
            </g>
        </svg>
    ),
    AddRepeat: () => (
        <svg viewBox="0 0 401 401">
            <g>
                <path
                    d="M264,182.73c1.9,4.13,3.06,8.23,3.51,12.5c2.45,23.36-12.53,44.34-35.46,49.53c-3.32,0.75-6.81,1.06-10.22,1.08
                    c-15.15,0.11-30.3,0.05-45.45,0.05c-0.54,0-1.09,0-1.81,0c0,5.5,0,10.94,0,16.37c-7.92-7.93-15.76-15.78-23.44-23.47
                    c7.69-7.69,15.56-15.56,23.34-23.34c0,5.08,0,10.47,0,15.98c0.56,0.04,0.99,0.1,1.42,0.1c15.35,0,30.7,0.07,46.04-0.02
                    c15.15-0.09,27.55-10.28,30.41-25.16c0.69-3.6,0.27-7.42,0.38-11.14c0.02-0.5,0.02-1.16,0.32-1.47
                    C256.6,190.1,260.21,186.52,264,182.73z"
                />
                <path
                    d="M142.46,218.11c-2.92-6.66-4.22-13.35-3.74-20.33c1.33-19.52,14.53-35.91,33.33-41.09c3.89-1.07,8.04-1.61,12.08-1.66
                    c15.3-0.19,30.6-0.08,45.9-0.08c0.59,0,1.18,0,1.88,0c0-5.53,0-10.94,0-16.21c7.84,7.86,15.69,15.73,23.41,23.48
                    c-7.61,7.61-15.48,15.48-23.34,23.34c0-5.27,0-10.67,0-16.25c-0.65,0-1.18,0-1.71,0c-15.25,0-30.5-0.02-45.75,0
                    c-15.74,0.02-28.37,10.56-31.08,26.04c-0.63,3.58-0.91,7.23,0.28,10.8c0.08,0.25-0.02,0.71-0.21,0.9
                    C149.9,210.7,146.27,214.31,142.46,218.11z"
                />
            </g>
        </svg>
    ),
    AddParallel: () => (
        <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 24 24" xmlSpace="preserve">
            <style>{'.st22{fill:currentColor}'}</style>
            <g id="workflow_icon_2" transform="translate(-1112 -20027)">
                <g id="Group_12468" transform="translate(1118 20033)">
                    <g id="Union_3">
                        <path
                            className="st22"
                            d="M3.1 11.5c-.1 0-.2-.1-.2-.2v-1H.2c-.1 0-.2-.1-.2-.2V.2C0 .1.1 0 .2 0s.2.1.2.2v1.9h2.4v-1c.1 0 .2-.1.3-.1h8.2c.1 0 .2.1.2.2v2.4c0 .1-.1.2-.2.2H3.1c-.1 0-.2-.1-.2-.2v-1H.5V6h2.4V5c0-.1.1-.2.2-.2h8.2c.1 0 .2.1.2.2v2.4c0 .1-.1.2-.2.2H3.1c-.1.1-.2 0-.2-.2v-1H.5v3.4h2.4v-1c0-.1.1-.2.2-.2h8.2c.1 0 .2.1.2.2v2.4c0 .1-.1.2-.2.2l-8.2.1zm.3-.5H11V9.1H3.4V11zm0-3.8H11V5.3H3.4v1.9zm0-3.8H11v-2H3.4v2z"
                        />
                        <path
                            className="st22"
                            d="M11.3 11.8H3.1c-.3 0-.5-.2-.5-.5v-.7H.2c-.3 0-.5-.2-.5-.5V.2c.1-.2.3-.5.5-.5.3 0 .5.2.5.5v1.7h1.9v-.7c0-.3.2-.5.5-.5h8.2c.3 0 .5.2.5.5v2.4c0 .1 0 .3-.1.3-.1.1-.2.1-.3.1H3.1c-.3 0-.5-.2-.5-.5v-.6H.7v2.9h1.9V5c0-.3.2-.5.5-.5h8.2c.3 0 .5.2.5.5v2.4c0 .1 0 .3-.1.3-.1.1-.2.1-.3.1H3.1c-.3 0-.5-.2-.5-.5v-.6H.7v2.9h1.9v-.7c0-.3.2-.5.5-.5h8.2c.3 0 .5.2.5.5v2.4c0 .2-.3.5-.5.5zm-7.7-1h7.2V9.4H3.6v1.4zm0-3.9h7.2V5.5H3.6v1.4zm0-3.8h7.2V1.7H3.6v1.4z"
                        />
                    </g>
                </g>
            </g>
        </svg>
    ),
    AddCondition: () => (
        <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 24 24" xmlSpace="preserve">
            <style>{'.st22{fill:currentColor}'}</style>
            <g id="workflow_icon_3" transform="translate(-1112 -20079)">
                <g id="Group_12470" transform="translate(1118.416 20085)">
                    <g id="Group_3654" transform="translate(5.517 2.942)">
                        <g id="Path_2510">
                            <path
                                className="st22"
                                d="M.2 3.1c-.1 0-.2-.2-.2-.3V.2C0 .1.1 0 .2 0s.2.1.2.2v2.6c.1.1 0 .3-.2.3z"
                            />
                            <path
                                className="st22"
                                d="M.2 3.3c-.1 0-.3 0-.3-.1-.1-.1-.1-.2-.1-.3V.2c0-.1 0-.3.1-.3.1-.1.2-.2.3-.2.3 0 .5.2.5.5v2.6c0 .3-.2.5-.5.5zm.1-.5z"
                            />
                        </g>
                    </g>
                    <g id="Group_3655" transform="translate(9.595 5.518)">
                        <g id="Path_2511">
                            <path
                                className="st22"
                                d="M.2 3.1c-.1 0-.2-.2-.2-.3V.2C0 .1.1 0 .2 0s.2.1.2.2v2.6c.1.1 0 .3-.2.3z"
                            />
                            <path
                                className="st22"
                                d="M.2 3.3c-.2 0-.5-.2-.5-.5V.2c.1-.2.3-.4.5-.4.3 0 .5.2.5.5v2.6c0 .2-.2.4-.5.4z"
                            />
                        </g>
                    </g>
                    <g id="Group_8183" transform="translate(1.023 5.518)">
                        <g id="Path_2511-2">
                            <path
                                className="st22"
                                d="M.2 3.1c-.1 0-.2-.2-.2-.3V.2C0 .1.1 0 .2 0s.2.1.2.2v2.6c.1.1 0 .3-.2.3z"
                            />
                            <path
                                className="st22"
                                d="M.2 3.3c-.2 0-.5-.2-.5-.5V.2c.1-.2.3-.4.5-.4.3 0 .5.2.5.5v2.6c0 .2-.2.4-.5.4z"
                            />
                        </g>
                    </g>
                    <g id="Group_3656" transform="translate(1.024 5.518)">
                        <g id="Path_2512">
                            <path
                                className="st22"
                                d="M8.7.5H.3C.2.5 0 .4 0 .3S0 0 .2 0h8.5c.2 0 .3 0 .3.2 0 .1 0 .3-.2.3h-.1z"
                            />
                            <path
                                className="st22"
                                d="M8.8.7s-.1 0 0 0H.3C.1.7-.2.6-.3.3s.1-.5.4-.6h8.6c.1 0 .2 0 .3.1.2.1.3.2.3.3s0 .3-.1.4-.1.2-.4.2c.1 0 .1 0 0 0z"
                            />
                        </g>
                    </g>
                    <g id="Group_3657" transform="translate(-.416 8.078)">
                        <g id="Path_2513">
                            <path
                                className="st22"
                                d="M3.1 3.4H.2c-.1 0-.2-.1-.2-.3V.2C0 .1.1 0 .2 0h2.9c.1 0 .2.1.2.2v2.9c.1.2 0 .3-.2.3zM.5 2.9h2.4V.5H.5v2.4z"
                            />
                            <path
                                className="st22"
                                d="M3.1 3.6H.2c-.2 0-.5-.2-.5-.5V.2c0-.2.3-.4.5-.4h2.9c.1 0 .3 0 .3.1.2.1.2.2.2.3v2.9c0 .3-.2.5-.5.5zm-2.4-1h1.9V.7H.7v1.9z"
                            />
                        </g>
                    </g>
                    <g id="Group_3658" transform="translate(4.078)">
                        <g id="Path_2514">
                            <path
                                className="st22"
                                d="M3.1 3.4H.2c-.1 0-.2-.1-.2-.3V.2C0 .1.1 0 .2 0h2.9c.1 0 .2.1.2.2v2.9c.1.2 0 .3-.2.3zM.5 2.9h2.4V.5H.5v2.4z"
                            />
                            <path
                                className="st22"
                                d="M3.1 3.6H.2c-.2 0-.5-.2-.5-.5V.2c0-.1 0-.3.1-.3.2-.1.3-.1.4-.1h2.9c.1 0 .2.1.3.1.2.1.2.2.2.3v2.9c0 .1 0 .3-.1.3-.1.2-.2.2-.4.2zm-2.4-1h1.9V.7H.7v1.9z"
                            />
                        </g>
                    </g>
                    <g id="Group_3659" transform="translate(8.156 8.156)">
                        <g id="Path_2515">
                            <path
                                className="st22"
                                d="M3.1 3.4H.2c-.1 0-.2-.1-.2-.3V.2C0 .1.1 0 .2 0h2.9c.1 0 .2.1.2.2v2.9c.1.2 0 .3-.2.3zM.5 2.9h2.4V.5H.5v2.4z"
                            />
                            <path
                                className="st22"
                                d="M.2 3.6c-.1 0-.2 0-.3-.1s-.1-.2-.1-.3v-3C-.3 0 0-.2.2-.2h2.9c.3 0 .5.2.5.5v2.9c0 .1 0 .3-.1.3s-.2.1-.4.1H.2zm.5-1h1.9V.7H.7v1.9z"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    ),
    CallAutomation: () => (
        <svg viewBox="0 0 401 401">
            <g>
                <path d="M219.5,261.5h-31c-22.91,0-26-15.17-26-30v-72h10v72c0,15.51,3.59,20,16,20h31V261.5z" />
            </g>
            <g>
                <rect x="167.5" y="194.74" width="51" height="10" />
            </g>
            <g>
                <path
                    d="M167,162.5c-9.65,0-17.5-7.85-17.5-17.5s7.85-17.5,17.5-17.5s17.5,7.85,17.5,17.5S176.65,162.5,167,162.5z M167,133.5
                    c-6.34,0-11.5,5.16-11.5,11.5s5.16,11.5,11.5,11.5s11.5-5.16,11.5-11.5S173.34,133.5,167,133.5z"
                />
            </g>
            <g>
                <path
                    d="M234,217.5c-9.65,0-17.5-7.85-17.5-17.5s7.85-17.5,17.5-17.5s17.5,7.85,17.5,17.5S243.65,217.5,234,217.5z M234,188.5
                    c-6.34,0-11.5,5.16-11.5,11.5s5.16,11.5,11.5,11.5s11.5-5.16,11.5-11.5S240.34,188.5,234,188.5z"
                />
            </g>
            <g>
                <path
                    d="M234,274.5c-9.65,0-17.5-7.85-17.5-17.5s7.85-17.5,17.5-17.5s17.5,7.85,17.5,17.5S243.65,274.5,234,274.5z M234,245.5
                    c-6.34,0-11.5,5.16-11.5,11.5s5.16,11.5,11.5,11.5s11.5-5.16,11.5-11.5S240.34,245.5,234,245.5z"
                />
            </g>
        </svg>
    ),
    ForEachIcon: () => (
        <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 32 32" xmlSpace="preserve">
            {/* <style>{'.st_tree{fill:#367af2}'}</style> */}
            <g id="Group_12705" transform="translate(-314 -407)">
                <g id="Group_11545" transform="translate(-540.47 -1539.186)">
                    <g id="Group_11552" transform="translate(863.413 1960.297)">
                        <g id="Group_11548" transform="translate(0 3.778)">
                            <g id="Group_11547">
                                <g id="Group_11546">
                                    <g id="Group_11545-2">
                                        <path
                                            id="Path_7909"
                                            className="st_tree"
                                            d="M3.1 6.3c-.1 0-.3-.1-.4-.2L.2 3.6C0 3.4 0 3 .2 2.7L2.7.2c.3-.2.7-.2.9 0 .2.2.2.6 0 .8L1.5 3.2l2.1 2.1c.2.2.2.6 0 .9-.1 0-.3.1-.5.1z"
                                        />
                                    </g>
                                </g>
                            </g>
                        </g>
                        <g id="Group_11551">
                            <g id="Group_11549" transform="translate(0 6.297)">
                                <path
                                    id="Path_7910"
                                    className="st_tree"
                                    d="M11.3 1.3H.6C.3 1.3 0 1 0 .6S.3 0 .6 0h10.7c.4 0 .7.3.7.6s-.3.7-.7.7z"
                                />
                            </g>
                            <g id="Group_11550" transform="translate(10.705)">
                                <path
                                    id="Path_7911"
                                    className="st_tree"
                                    d="M.6 7.6c-.3 0-.6-.3-.6-.7s.3-.6.6-.6c1.4 0 2.5-1.1 2.5-2.5V.6c0-.3.3-.6.7-.6s.6.3.6.6v3.1c0 2.2-1.7 3.9-3.8 3.9z"
                                />
                            </g>
                        </g>
                    </g>
                    <g id="Group_11560" transform="translate(862.414 1954)">
                        <g id="Group_11556" transform="translate(11.334)">
                            <g id="Group_11555">
                                <g id="Group_11554">
                                    <g id="Group_11553">
                                        <path
                                            id="Path_7912"
                                            className="st_tree"
                                            d="M.6 6.3C.3 6.3 0 6 0 5.7c0-.2.1-.3.2-.4l2.1-2.1L.2 1.1C0 .8 0 .4.2.2c.3-.2.6-.2.9 0l2.5 2.5c.2.2.2.6 0 .9L1.1 6.1c-.1.1-.3.2-.5.2z"
                                        />
                                    </g>
                                </g>
                            </g>
                        </g>
                        <g id="Group_11559" transform="translate(0 2.519)">
                            <g id="Group_11557" transform="translate(3.148)">
                                <path
                                    id="Path_7913"
                                    className="st_tree"
                                    d="M11.3 1.3H.6C.3 1.3 0 1 0 .6S.3 0 .6 0h10.7c.4 0 .7.3.7.6s-.3.7-.7.7z"
                                />
                            </g>
                            <g id="Group_11558">
                                <path
                                    id="Path_7914"
                                    className="st_tree"
                                    d="M.6 7.6c-.3 0-.6-.3-.6-.7V3.8C0 1.7 1.7 0 3.8 0c.3 0 .6.3.6.6s-.3.7-.6.7c-1.4 0-2.5 1.1-2.5 2.5v3.1c0 .4-.3.7-.7.7z"
                                />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    ),
    FunctionIcon: () => (
        <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 24 24" xmlSpace="preserve">
            <style>{'.st30{fill:currentColor}'}</style>
            <g id="workflow_icon_5" transform="translate(-1112 -20179)">
                <g id="Group_12473" transform="translate(1114.826 20181.301)">
                    <path
                        id="Path_4001"
                        className="st30"
                        d="M11.2 7.9c-.1-.4-.4-.7-.8-.7h-.7c.1-.4.3-1 .3-1 .1-.6.4-1.2.8-1.6.3 0 .4.7.4.8 0 .4.4.7.8.8.4 0 .7-.3.7-.7 0-.8-.5-1.6-1.3-1.9H11c-1.4 0-1.9 1.8-2.2 2.6-.1.5-.3.9-.4 1.3H6.8c-.2 0-.3.1-.4.2-.2.1-.3.3-.3.5 0 .4.3.7.7.7h1.4c-.4 2-1.1 4.4-1.2 4.8 0 .1-.1.5-.4.5-.5 0-.8-.8-.8-.8-.1-.4-.5-.7-1-.5-.4.1-.7.7-.5 1 .2 1 1.1 1.8 2.2 1.9.8 0 1.4-.7 1.6-1.6.5-1.7.9-3.5 1.2-5.3h1.2c.4-.2.7-.7.7-1z"
                    />
                    <path
                        id="Path_4002"
                        className="st30"
                        d="M14 13.1l-1.1-1.2 1.1-1.2c.1-.1.2-.3.1-.4 0-.3-.3-.5-.5-.5s-.4.1-.5.3l-.8 1.1-.7-.8c-.2-.4-.3-.6-.6-.6s-.4.3-.4.5c0 .1 0 .3.1.4l1.1 1.2-1.1 1.2c-.1.1-.2.3-.1.4 0 .3.3.5.5.5s.4-.1.5-.3l.8-1.2.8 1.2c.1.1.3.1.4.1.3 0 .5-.3.5-.5.2.1.2-.1-.1-.2z"
                    />
                </g>
            </g>
        </svg>
    ),
    ApprovalIcon: () => (
        <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 32 32" xmlSpace="preserve">
            {/* <style>{'.st_tree{fill:#367af2}'}</style> */}
            <g id="Group_13590" transform="translate(-1236 -3349)">
                <path
                    id="Path_4325"
                    className="st_tree"
                    d="M1257.2 3368.2v2.5c0 .7-.6 1.3-1.3 1.3H1247.1c-.7 0-1.3-.5-1.4-1.2v-.1-1-9.9c0-1.2.5-1.7 1.7-1.7h8.3c.7-.1 1.4.4 1.5 1.2v.8c.1 1.1-.3 2.1-1.2 2.7v-.5-2.3c0-.5-.1-.6-.6-.6h-8c-.5 0-.6.1-.6.6v10.3c0 .5.1.6.6.6h8c.3 0 .6-.1.6-.4 0-.6.2-1.1.6-1.5.2-.4.4-.6.6-.8z"
                />
                <path
                    id="Path_4326"
                    className="st_tree"
                    d="M1254.5 3366.4l3.8-4.7.3-.3c.3-.5 1-.7 1.5-.4 0 0 .1 0 .1.1.5.4.5 1 .2 1.5l-.1.1c-.9 1.1-1.8 2.3-2.7 3.4-.7.8-1.3 1.6-2 2.5-.3.5-1 .7-1.5.4-.1-.1-.3-.2-.4-.3l-1.8-2.1c-.4-.4-.4-1.1 0-1.5s1.1-.4 1.5 0c0 0 .1.1.1.2.2.2.3.4.5.6l.5.5z"
                />
            </g>
        </svg>
    ),
    AutomationNotificationIcon: () => (
        <svg
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 16 16"
        xmlSpace="preserve"
        >
      {/* <style>{".automationNotificationIcon{fill:#305b8b}"}</style> */}
      <g id="Group_13940">
        <g id="Group_12707">
          <path
            id="Path_10304"
            className="automationNotificationIcon"
            d="M14.9 13.1c-1.7-.8-1.8-4-1.8-4.1V6.7c0-2.1-1.2-3.9-3.1-4.7 0-1.1-.9-2-2-2S6 .9 6 2c-1.9.8-3.1 2.7-3.1 4.7v2.2c0 .1-.1 3.4-1.8 4.1-.2.1-.3.4-.2.6.1.2.2.3.4.3h4.3c.1.5.3.9.7 1.3.9 1 2.4 1 3.3.1l.1-.1c.3-.4.6-.8.7-1.3h4.3c.2 0 .5-.2.5-.4-.1-.2-.2-.4-.3-.4m-2.3-1.6c.2.6.4 1.1.8 1.5H2.6c.3-.5.6-1 .8-1.5h9.2zM8 .9c.5 0 .9.3 1 .8-.6-.1-1.4-.1-2 0 .1-.4.5-.8 1-.8m-4.2 8V6.7c0-2.3 1.9-4.2 4.3-4.1 2.3 0 4.1 1.9 4.1 4.1v2.2c0 .6.1 1.1.2 1.7H3.6c.1-.6.2-1.1.2-1.7M8 15.1c-.7 0-1.3-.5-1.5-1.2h2.9c-.1.7-.7 1.1-1.4 1.2"
          />
          <path
            id="Path_10305"
            className="automationNotificationIcon"
            d="M8 3.1c-1.9 0-3.5 1.6-3.5 3.5 0 .2.2.4.4.4s.4-.2.4-.4C5.4 5.2 6.6 4 8 4c.2 0 .4-.2.4-.4 0-.3-.2-.5-.4-.5"
          />
        </g>
      </g>
        </svg>
    )
}

export const ApprovalIConSidepanel = () => (
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 25.3 24.5" xmlSpace="preserve">
        <style>{'.st0w{fill:currentColor}'}</style>
        <path
            className="st0w"
            d="M18 22.2c0 .4-.3.8-.8.8h-15c-.4 0-.8-.3-.8-.8v-20c0-.4.3-.8.8-.8h15c.4 0 .8.3.8.8v9.3l1.5-1.6V2.2c0-1.2-1-2.2-2.2-2.2h-15C1 0 0 1 0 2.2v20c0 1.2 1 2.2 2.2 2.2h15c1.2 0 2.2-1 2.2-2.2V18L18 19.5v2.7z"
        />
        <path
            className="st0w"
            d="M24.8 8.2c-.3-.3-.8-.3-1.1 0L17.4 15l-3.9-3c-.3-.3-.8-.2-1.1.1-.3.3-.2.8.1 1.1l4.4 3.5c.1.1.3.2.5.2s.4-.1.6-.2l6.8-7.3c.3-.4.3-.9 0-1.2z"
        />
    </svg>
)
export const MoreIconJump = () => (
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 10 10" xmlSpace="preserve">
        <style>{'.st0{fill:#555}'}</style>
        <g id="Group_11086" transform="translate(-1650 -3324)">
            <g id="Group_11083" transform="translate(1 2)">
                <circle id="Ellipse_700" className="st0" cx={1654} cy={3323} r={1} />
            </g>
            <g id="Group_11084" transform="translate(1 6)">
                <circle id="Ellipse_700-2" className="st0" cx={1654} cy={3323} r={1} />
            </g>
            <g id="Group_11085" transform="translate(1 10)">
                <circle id="Ellipse_700-3" className="st0" cx={1654} cy={3323} r={1} />
            </g>
        </g>
    </svg>
)
export const FlowCanvasContextIcons: any = {
    NextIcon: () => (
        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 12 14" xmlSpace="preserve">
            <path d="M12 7L0 14V0l12 7z" fill="currentColor" />
        </svg>
    ),
    NumIcon: () => (
        <svg viewBox="0 0 16 16">
            <g>
                <path d="M3.08,9.99V5.85L2.09,6.21L1.83,5.34l1.7-0.68h0.66v5.33H3.08z" />
                <path
                    d="M6.04,4.96c0.19-0.12,0.4-0.22,0.64-0.29s0.49-0.11,0.78-0.11c0.53,0,0.95,0.14,1.25,0.42s0.46,0.68,0.46,1.18
                c0,0.21-0.03,0.41-0.08,0.6C9.03,6.96,8.96,7.14,8.86,7.31c-0.1,0.17-0.21,0.33-0.34,0.49S8.25,8.1,8.09,8.25
                C7.93,8.41,7.77,8.56,7.62,8.7s-0.3,0.27-0.44,0.4h2.03v0.89H5.9L5.75,9.35c0.14-0.15,0.28-0.29,0.4-0.41
                C6.26,8.82,6.38,8.7,6.48,8.59c0.11-0.11,0.21-0.22,0.31-0.32s0.2-0.22,0.31-0.34c0.12-0.13,0.23-0.27,0.35-0.4
                C7.57,7.4,7.67,7.26,7.76,7.12C7.85,6.98,7.92,6.84,7.97,6.7C8.03,6.55,8.06,6.4,8.06,6.25c0-0.25-0.07-0.45-0.22-0.59
                C7.7,5.52,7.5,5.45,7.24,5.45c-0.2,0-0.37,0.03-0.53,0.08s-0.3,0.12-0.42,0.2L6.04,4.96z"
                />
                <path
                    d="M13.99,8.54c0,0.24-0.05,0.46-0.15,0.64s-0.23,0.35-0.4,0.48c-0.17,0.13-0.37,0.24-0.6,0.31
                c-0.23,0.07-0.47,0.11-0.74,0.11c-0.25,0-0.49-0.03-0.74-0.08c-0.25-0.05-0.47-0.12-0.66-0.21l0.18-0.83
                c0.17,0.07,0.34,0.13,0.52,0.18c0.18,0.05,0.37,0.07,0.57,0.07c0.3,0,0.53-0.07,0.68-0.2c0.15-0.13,0.22-0.3,0.22-0.5
                c0-0.27-0.11-0.47-0.34-0.59c-0.22-0.12-0.51-0.18-0.86-0.18h-0.45V6.85h0.3c0.4,0,0.7-0.07,0.92-0.22
                c0.22-0.14,0.32-0.34,0.32-0.59c0-0.19-0.07-0.34-0.2-0.44c-0.13-0.1-0.32-0.16-0.56-0.16c-0.34,0-0.66,0.07-0.96,0.22l-0.19-0.79
                c0.17-0.1,0.38-0.17,0.62-0.23c0.24-0.06,0.5-0.08,0.76-0.08c0.23,0,0.44,0.03,0.64,0.09s0.37,0.14,0.52,0.26
                c0.15,0.11,0.26,0.25,0.34,0.41c0.08,0.16,0.12,0.34,0.12,0.54c0,0.3-0.08,0.57-0.25,0.8c-0.17,0.23-0.42,0.42-0.75,0.56
                c0.15,0.04,0.29,0.1,0.43,0.18s0.25,0.17,0.36,0.28c0.1,0.11,0.18,0.24,0.24,0.38C13.96,8.21,13.99,8.37,13.99,8.54z"
                />
            </g>
        </svg>
    ),
    ABCIcon: () => (
        <svg viewBox="0 0 16 16">
            <g>
                <path
                    d="M6.24,11.41H5.08l-0.38-1.12H2.51l-0.38,1.12H0.98L3,6.08h1.22L6.24,11.41z M3.61,6.98L2.81,9.4h1.6L3.61,6.98
                    z"
                />
                <path
                    d="M10.77,9.91c0,0.24-0.05,0.45-0.16,0.63c-0.11,0.18-0.26,0.34-0.45,0.47c-0.19,0.13-0.42,0.23-0.7,0.3
                    s-0.57,0.1-0.9,0.1H6.95V6.08h1.82c0.27,0,0.52,0.03,0.74,0.09c0.22,0.06,0.41,0.15,0.56,0.26c0.15,0.11,0.27,0.24,0.36,0.4
                    c0.08,0.15,0.13,0.33,0.13,0.51c0,0.34-0.1,0.61-0.29,0.82s-0.46,0.37-0.8,0.47c0.38,0.06,0.7,0.2,0.93,0.41
                    C10.65,9.25,10.77,9.55,10.77,9.91z M8.53,8.26c0.28,0,0.5-0.06,0.68-0.18c0.17-0.12,0.26-0.3,0.26-0.52
                    c0-0.21-0.07-0.37-0.22-0.47c-0.15-0.1-0.35-0.15-0.61-0.15H8.05v1.33H8.53z M9.67,9.83c0-0.24-0.1-0.42-0.3-0.54
                    C9.16,9.17,8.9,9.11,8.58,9.11H8.05v1.46h0.59c0.35,0,0.61-0.07,0.78-0.2C9.58,10.23,9.67,10.05,9.67,9.83z"
                />
                <path
                    d="M14.18,5.99c0.13,0,0.27,0.01,0.41,0.02s0.27,0.03,0.4,0.06s0.26,0.05,0.38,0.09
                    c0.12,0.03,0.23,0.08,0.32,0.12l-0.16,0.82c-0.17-0.06-0.36-0.12-0.57-0.16s-0.41-0.06-0.62-0.06c-0.61,0-1.07,0.16-1.4,0.47
                    c-0.32,0.32-0.48,0.78-0.48,1.4c0,0.62,0.16,1.08,0.48,1.4c0.32,0.32,0.79,0.47,1.4,0.47c0.2,0,0.41-0.02,0.62-0.06
                    s0.4-0.09,0.57-0.16l0.16,0.82c-0.1,0.05-0.2,0.09-0.32,0.12c-0.12,0.04-0.25,0.06-0.38,0.09s-0.27,0.04-0.4,0.05
                    c-0.14,0.01-0.27,0.02-0.41,0.02c-0.46,0-0.86-0.07-1.22-0.21c-0.35-0.14-0.65-0.33-0.89-0.58c-0.24-0.25-0.42-0.54-0.54-0.87
                    c-0.12-0.34-0.18-0.7-0.18-1.1s0.06-0.77,0.18-1.1c0.12-0.34,0.3-0.63,0.54-0.87c0.24-0.25,0.54-0.44,0.89-0.58
                    C13.32,6.06,13.73,5.99,14.18,5.99z"
                />
            </g>
        </svg>
    ),
    ThreeDotLandscape: () => (
        <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 43 16">
            <circle cx={11} cy={8} r={4} />
            <circle cx={22} cy={8} r={4} />
            <circle cx={33} cy={8} r={4} />
        </svg>
    ),
    DownFatArrow: () => (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 5.52">
            <title>down</title>
            <g id="Layer_2" data-name="Layer 2">
                <g id="Layer_1-2" data-name="Layer 1">
                    <path
                        className="cls-1"
                        d="M7.83,1.21l-3.26,4A.76.76,0,0,1,4,5.52a.78.78,0,0,1-.58-.27l-3.25-4A.76.76,0,0,1,.07.43.73.73,0,0,1,.74,0H7.26a.73.73,0,0,1,.67.42A.77.77,0,0,1,8,.74.75.75,0,0,1,7.83,1.21Z"
                    />
                </g>
            </g>
        </svg>
    ),
    CollectionVariableIcon: () => (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10">
            <g>
                <g>
                    <path d="M7.8,8.8" />
                </g>

                <g>
                    <path d="M7.8,9.3H4c-0.3,0-0.5-0.2-0.5-0.5S3.7,8.3,4,8.3h3.8c0.3,0,0.5,0.2,0.5,0.5S8,9.3,7.8,9.3z" />
                </g>

                <g>
                    <path d="M3.9,9.1H2.1C1.9,9.1,1.8,9,1.8,8.8s0.1-0.2,0.2-0.2h1.8c0.1,0,0.2,0.1,0.2,0.2S4,9.1,3.9,9.1z" />
                </g>

                <g>
                    <g>
                        <g>
                            <path d="M2,9.1C1.8,9.1,1.7,9,1.7,8.8V0.9c0-0.1,0.1-0.2,0.2-0.2s0.2,0.1,0.2,0.2v7.9C2.2,9,2.1,9.1,2,9.1z" />
                        </g>
                    </g>

                    <g>
                        <g>
                            <path d="M7.8,6.7H4c-0.3,0-0.5-0.2-0.5-0.5S3.7,5.7,4,5.7h3.8C8,5.7,8.3,6,8.3,6.2S8,6.7,7.8,6.7z" />
                        </g>
                    </g>

                    <g>
                        <g>
                            <path d="M7.8,4.2H4c-0.3,0-0.5-0.2-0.5-0.5S3.7,3.2,4,3.2h3.8c0.3,0,0.5,0.2,0.5,0.5S8,4.2,7.8,4.2z" />
                        </g>
                    </g>

                    <g>
                        <g>
                            <path d="M3.9,6.5H2.1c-0.1,0-0.2-0.1-0.2-0.2S1.9,6,2.1,6h1.8C4,6,4.1,6.1,4.1,6.2S4,6.5,3.9,6.5z" />
                        </g>
                    </g>

                    <g>
                        <g>
                            <path
                                d="M3.9,3.9H2.1c-0.1,0-0.2-0.1-0.2-0.2c0-0.1,0.1-0.2,0.2-0.2h1.8c0.1,0,0.2,0.1,0.2,0.2

					C4.1,3.8,4,3.9,3.9,3.9z"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    ),
    CollectionPickerIcon: () => (
        <svg id="Layer_1" x="0px" y="0px" viewBox="0 0 16 16" xmlSpace="preserve">
            <style>{'.st1{fill:#466382}'}</style>
            <circle cx={8} cy={8} r={8} fill="#fff" />
            <path className="st1" d="M10.8 12.3H7c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h3.8c.3 0 .5.2.5.5s-.3.5-.5.5z" />
            <path className="st1" d="M6.9 12.1H5.1c-.1 0-.2-.1-.2-.2s.1-.2.2-.2h1.8c.1 0 .2.1.2.2s-.1.2-.2.2z" />
            <path
                className="st1"
                d="M5 12.1c-.1 0-.2-.1-.2-.2v-8c0-.1.1-.2.2-.2s.2.1.2.2v7.9c0 .2-.1.3-.2.3zM10.8 9.7H7c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h3.8c.3 0 .5.2.5.5s-.3.5-.5.5zM10.8 7.2H7c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h3.8c.3 0 .5.2.5.5s-.3.5-.5.5z"
            />
            <path
                className="st1"
                d="M6.9 9.5H5.1c-.1 0-.2-.1-.2-.2s0-.3.2-.3h1.8c.1 0 .2.1.2.2s-.1.3-.2.3zM6.9 6.9H5.1c-.1 0-.2-.1-.2-.2s.1-.2.2-.2h1.8c.1 0 .2.1.2.2s-.1.2-.2.2z"
            />
        </svg>
    )
}
export const ThumbsUpIcon = () => (
    <svg className="thums_up" x="0px" y="0px" viewBox="0 0 489.37 489.37">
        <g>
            <g>
                <path
                    id="thumbs_up"
                    d="M245.2,293.72h-58.7c-2.1,0-3.9-1.8-3.9-3.9v-155.6c0-2.1,1.8-3.9,3.9-3.9h58.7
                    c2.1,0,3.9,1.8,3.9,3.9v155.6C249.1,291.92,247.3,293.72,245.2,293.72z"
                />
                <path
                    d="M458.9,345.42c1.8-4.7-0.4-9.9-5.1-11.8c-4.7-1.8-9.9,0.4-11.8,5.1c-6.9,17.5-24.1,29.3-42.9,29.3H209.4
                    c-2.3,0-4.6,0.9-6.3,2.5l-86.6,82.9v-76.4c0-2.4-1-4.7-2.7-6.4c-1.7-1.7-4-2.7-6.4-2.7H64.2c-25.4,0-46.1-20.7-46.1-46.1v-204.3
                    c0-25.4,20.7-46.1,46.1-46.1h205.5c5,0,9.1-4.1,9.1-9.1s-4.1-9.1-9.1-9.1H64.2c-35.4,0-64.2,28.8-64.2,64.2v204.4
                    c0,35.4,28.8,64.2,64.2,64.2h34.2v88.6c0,3.6,2.2,6.9,5.5,8.3c1.1,0.5,2.4,0.7,3.6,0.7c2.3,0,4.6-0.9,6.3-2.5l99.3-95.1h186.1
                    C425.3,386.12,449.3,369.72,458.9,345.42z"
                />
                <path
                    d="M488.8,158.82c2.7-16.9-4.3-34.1-17.8-43.8c-7.7-5.5-16.7-8.4-26.1-8.4h-66.3v-47.4c0-21-6.2-36.2-18.4-45.1
                    c-19.3-14.2-45.7-6.1-46.8-5.8c-3.8,1.2-6.3,4.7-6.3,8.6v54.7c0,42.1-49.1,56.5-51.1,57.1c-0.2,0.1-0.4,0.2-0.6,0.2
                    c-3-4.6-8.2-7.7-14.2-7.7h-50.8c-9.3,0-16.9,7.6-16.9,16.9v147.7c0,9.3,7.6,16.9,16.9,16.9h50.8c4.7,0,8.9-1.9,12-5
                    c8.1,8.1,19.3,13.1,31.7,13.1h133.8c30.3,0,49.6-15.9,53.1-43.6L488.8,158.82z M240,284.62h-48.3v-145.2H240V284.62z
                    M470.9,156.02l-17.1,108.6c0,0.1,0,0.2,0,0.3c-2.3,18.5-14.1,27.9-35.1,27.9H284.9c-14.8,0-26.8-12-26.8-26.8v-119.5
                    c0.9,0,1.8,0,2.7-0.3c2.6-0.7,64.4-18.6,64.4-74.6v-47.3c6.6-0.9,16.8-1.1,24.4,4.4c7.3,5.4,10.9,15.6,10.9,30.5v56.5
                    c0,5,4.1,9.1,9.1,9.1H445c5.6,0,11,1.7,15.5,5C468.4,135.52,472.5,145.82,470.9,156.02z"
                />
            </g>
        </g>
    </svg>
)
export const NewThumbsUpIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" x="0px" y="0px" viewBox="0 0 18 17.2" xmlSpace="preserve">
        <style>{'.st0{fill:currentColor}'}</style>
        <g id="Group_11944" transform="translate(-902 -527)">
            <path
                id="Path_10131"
                // className="st0"
                d="M920 537.6c0-.6-.2-1.2-.7-1.6.5-.4.7-1 .7-1.6 0-1-.8-1.9-1.8-2H913.8v-2.7c.1-1.5-1.1-2.7-2.5-2.7h-.2c-.2 0-.4.2-.4.4v3l-1.5 2.2-1.7 1.3v-1c0-.2-.2-.4-.4-.4h-4.7c-.2 0-.4.2-.4.4v11c0 .2.2.4.4.4h4.7c.2 0 .4-.2.4-.4v-.3c.3.4.7.6 1.2.7h8.6c.6 0 1.2-.2 1.6-.7.6-.7.7-1.7.2-2.5.5-.1.9-.5.9-1.1 0-.5-.2-1-.5-1.4.3-.3.5-.6.5-1zm-13.3 5.8h-3.9v-10.2h3.9v10.2zm10.6-5.4c-.2 0-.4.2-.4.4s.2.4.4.4h.8c.6 0 1.1.4 1.2 1.1v.1c0 .3-.2.4-1.2.4h-1.6c-.2 0-.4.2-.4.4s.2.4.4.4h1.6c.4 0 .6.5.6 1 0 .3-.1.7-.3.9-.3.3-.7.4-1.1.4h-8.6c-.3 0-.9-.7-1.2-1.3v-7.3l2.2-1.6.1-.1 1.6-2.3c0-.1.1-.1.1-.2V528c.9.1 1.6 1 1.6 1.9v3.1c0 .2.2.4.4.4h4.7c.6 0 1.2.5 1.2 1.1 0 .6-.5 1.2-1.1 1.2H916.9c-.2 0-.4.2-.4.4s.2.4.4.4h1.3c.6 0 1.1.4 1.2 1.1v.1c0 .3-.2.4-1.2.4l-.9-.1z"
            />
            <path
                id="Path_10132"
                // className="st0"
                d="M904.7 542.3c.4 0 .8-.3.8-.7 0-.4-.3-.8-.7-.8-.4 0-.8.3-.8.7-.1.3.2.7.7.8z"
            />
        </g>
    </svg>
)
export const NewThumbsDownIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" id="Group_11957" x="0px" y="0px" viewBox="0 0 18 17.2" xmlSpace="preserve">
        <style>{'.st0{fill:currentColor}'}</style>
        <path
            id="Path_10131"
            // className="st0"
            d="M18 6.7c0 .6-.2 1.2-.7 1.6.5.4.7 1 .7 1.6 0 1-.8 1.9-1.8 2H11.8v2.7c.1 1.5-1.1 2.7-2.5 2.7h-.2c-.2 0-.4-.2-.4-.4v-3l-1.5-2.2-1.7-1.3v1c0 .2-.2.4-.4.4H.4c-.2 0-.4-.2-.4-.4V.4C0 .2.2 0 .4 0h4.7c.2 0 .4.2.4.4v.3c.3-.4.7-.6 1.2-.7h8.6c.6 0 1.2.2 1.6.7.6.7.7 1.7.2 2.5.6.1.9.6.9 1.1 0 .5-.2 1-.5 1.4.3.2.5.5.5 1zM4.7.8H.8V11h3.9V.8zm10.6 5.5c-.2 0-.4-.2-.4-.4s.2-.4.4-.4h.7c.6 0 1.1-.4 1.2-1.1v-.1c0-.3-.2-.4-1.2-.4h-1.6c-.2 0-.4-.2-.4-.4s.2-.4.4-.4H16c.4 0 .6-.5.6-1 0-.3-.1-.7-.3-.9-.3-.3-.7-.4-1.1-.4H6.7c-.3 0-.9.7-1.2 1.3v7.3L7.7 11l.1.1 1.6 2.3c0 .1.1.1.1.2v2.7c.9-.1 1.6-1 1.6-1.9v-3.1c0-.2.2-.4.4-.4H16c.6 0 1.2-.5 1.2-1.1 0-.6-.5-1.2-1.1-1.2H14.7c-.2 0-.4-.2-.4-.4s.2-.4.4-.4H16c.6 0 1.1-.4 1.2-1.1v-.1c0-.3-.2-.4-1.2-.4l-.7.1z"
        />
        <path
            id="Path_10132"
            // className="st0"
            d="M2.7 2c.4 0 .8.3.8.7 0 .4-.3.8-.7.8-.4 0-.8-.3-.8-.7-.1-.4.2-.8.7-.8z"
        />
    </svg>
)
export const ThumbsDownIcon = () => (
    <svg className="thumbs_down" x="0px" y="0px" viewBox="0 0 489.37 489.37">
        <g>
            <path
                id="thumbs_down"
                d="M417.67,142.99h58.7c2.1,0,3.9,1.8,3.9,3.9v155.6c0,2.1-1.8,3.9-3.9,3.9h-58.7
                c-2.1,0-3.9-1.8-3.9-3.9l0-155.6C413.77,144.79,415.57,142.99,417.67,142.99z"
            />
            <path
                d="M249.1,368.02h-39.7c-2.3,0-4.6,0.9-6.3,2.5l-86.6,82.9v-76.4c0-2.4-1-4.7-2.7-6.4c-1.7-1.7-4-2.7-6.4-2.7H64.2
                c-25.4,0-46.1-20.7-46.1-46.1v-204.3c0-25.4,20.7-46.1,46.1-46.1h335.5c5,0,9.1-4.1,9.1-9.1s-4.1-9.1-9.1-9.1H64.2
                c-35.4,0-64.2,28.8-64.2,64.2v204.4c0,35.4,28.8,64.2,64.2,64.2h34.2v88.6c0,3.6,2.2,6.9,5.5,8.3c1.1,0.5,2.4,0.7,3.6,0.7
                c2.3,0,4.6-0.9,6.3-2.5l99.3-95.1h36.1c0,0,5.33-1.88,5.08-8.86C254.06,370.85,249.1,368.02,249.1,368.02z"
            />
            <path d="M399.1,71.22c18.8,0,36,11.8,42.9,29.3c1.9,4.7,7.1,6.9,11.8,5.1c4.7-1.9,6.9-7.1,5.1-11.8c-9.6-24.3-33.6-40.7-59.7-40.6" />
            <path
                d="M174.07,277.89c-2.7,16.9,4.3,34.1,17.8,43.8c7.7,5.5,16.7,8.4,26.1,8.4h66.3v47.4c0,21,6.2,36.2,18.4,45.1
                c19.3,14.2,45.7,6.1,46.8,5.8c3.8-1.2,6.3-4.7,6.3-8.6v-54.7c0-42.1,49.1-56.5,51.1-57.1c0.2-0.1,0.4-0.2,0.6-0.2
                c3,4.6,8.2,7.7,14.2,7.7h50.8c9.3,0,16.9-7.6,16.9-16.9v-147.7c0-9.3-7.6-16.9-16.9-16.9h-50.8c-4.7,0-8.9,1.9-12,5
                c-8.1-8.1-19.3-13.1-31.7-13.1h-133.8c-30.3,0-49.6,15.9-53.1,43.6L174.07,277.89z M422.87,152.09h48.3v145.2h-48.3V152.09z
                M191.97,280.69l17.1-108.6c0-0.1,0-0.2,0-0.3c2.3-18.5,14.1-27.9,35.1-27.9h133.8c14.8,0,26.8,12,26.8,26.8v119.5
                c-0.9,0-1.8,0-2.7,0.3c-2.6,0.7-64.4,18.6-64.4,74.6v47.3c-6.6,0.9-16.8,1.1-24.4-4.4c-7.3-5.4-10.9-15.6-10.9-30.5v-56.5
                c0-5-4.1-9.1-9.1-9.1h-75.4c-5.6,0-11-1.7-15.5-5C194.47,301.19,190.37,290.89,191.97,280.69z"
            />
        </g>
    </svg>
)

export const AuditLogsIcon = () => (
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 120 120">
        <path
            d="M93.8,110.8H22c-4.4,0-7.9-3.5-7.9-7.9V19.7c0-4.4,3.5-7.9,7.9-7.9h71.8c4.4,0,7.9,3.5,7.9,7.9v83.2
	C102.6,107.3,99.1,110.8,93.8,110.8L93.8,110.8z M22,17.1c-0.9,0-1.8,0.9-1.8,2.6v83.2c0,0.9,0.9,1.8,1.8,2.6h71.8
	c0.9,0,1.8-0.9,1.8-2.6V19.7c0-0.9-0.9-1.8-1.8-2.6H22z M84.2,39.8H53.5c-0.9,0-1.8-0.9-1.8-2.6c0-1.8,0.9-2.6,2.6-2.6h30.6
	c0.9,0,2.6,0.9,2.6,2.6C86.8,39,85.1,39.8,84.2,39.8L84.2,39.8z M84.2,63.5H53.5c-0.9,0-1.8-0.9-1.8-2.6c0-1.8,0.9-2.6,2.6-2.6h30.6
	c0.9,0,2.6,0.9,2.6,2.6C86.8,62.6,85.1,63.5,84.2,63.5L84.2,63.5z M84.2,87.1H53.5c-0.9,0-1.8-0.9-1.8-2.6c0-1.8,0.9-2.6,2.6-2.6
	h30.6c0.9,0,2.6,0.9,2.6,2.6C86.8,86.2,85.1,87.1,84.2,87.1L84.2,87.1z M30.8,37.2c0,3.5,2.6,6.1,6.1,6.1s6.1-2.6,6.1-6.1l0,0
	c0-3.5-2.6-6.1-6.1-6.1C33.4,31.1,30.8,33.7,30.8,37.2L30.8,37.2z M30.8,60.9c0,3.5,2.6,6.1,6.1,6.1s6.1-2.6,6.1-6.1l0,0
	c0-3.5-2.6-6.1-6.1-6.1C33.4,54.7,30.8,57.4,30.8,60.9L30.8,60.9z M30.8,84.5c0,3.5,2.6,6.1,6.1,6.1S43,88,43,84.5l0,0
	c0-3.5-2.6-6.1-6.1-6.1S30.8,81,30.8,84.5L30.8,84.5z"
        />
    </svg>
)
export const SubscriptionDetailsIcon = () => (
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 16 16" xmlSpace="preserve">
        <style>{'.st03{fill:currentColor}'}</style>
        <g id="Group_12715" transform="translate(-1736 -2394)">
            <g id="Group_12711" transform="translate(1736 2395.956)">
                <path
                    id="Path_10375"
                    className="st03"
                    d="M7 14c-3.9 0-7-3.1-7-7s3.1-7 7-7c.4 0 .7.3.6.7.1.3-.2.6-.6.6-3.1 0-5.7 2.6-5.7 5.7s2.5 5.7 5.7 5.7c1.5 0 3-.6 4-1.7.3-.3.7-.2.9 0 .2.3.2.7 0 .9-1.2 1.4-3 2.1-4.9 2.1z"
                />
            </g>
            <g id="Group_12712" transform="translate(1742.667 2394)">
                <path
                    id="Path_10376"
                    className="st03"
                    d="M6.3 15c-.2 0-.3-.1-.5-.2L.2 9.1C.1 9 0 8.8 0 8.7v-8C0 .3.3 0 .7 0c4.8 0 8.7 3.9 8.7 8.7 0 2.3-.9 4.5-2.5 6.1-.2.1-.4.2-.6.2zm-5-6.6l5 5C8.9 10.2 8.5 5.6 5.4 3c-1.1-1-2.5-1.5-4-1.7v7.1z"
                />
            </g>
            <g id="Group_12713" transform="translate(1742.667 2394)">
                <path
                    id="Path_10377"
                    className="st03"
                    d="M6.3 15c-.2 0-.3-.1-.5-.2L.2 9.1C.1 9 0 8.8 0 8.7v-8C0 .3.3 0 .7 0c4.8 0 8.7 3.9 8.7 8.7 0 2.3-.9 4.5-2.5 6.1-.2.1-.4.2-.6.2zm-5-6.6l5 5C8.9 10.2 8.5 5.6 5.4 3c-1.1-1-2.5-1.5-4-1.7v7.1z"
                />
            </g>
            <g id="Group_12714" transform="translate(1736 2402)">
                <path
                    id="Path_10378"
                    className="st03"
                    d="M7 1.3H.7C.3 1.3 0 1 0 .6 0 .3.3 0 .7 0H7c.4 0 .7.3.6.7.1.3-.2.6-.6.6z"
                />
            </g>
        </g>
    </svg>
)

export const NextIconCanvas = () => (
    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 12 14" xmlSpace="preserve">
        <path d="M12 7L0 14V0l12 7z" fill="currentColor" />
    </svg>
)

export const NextDetailICon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 12 14" xmlSpace="preserve">
        <path d="M12 7L0 14V0l12 7z" fill="currentColor" />
    </svg>
)

export const IconViewICon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 16.6 15.8" xmlSpace="preserve">
        <path
            d="M12.2 4.3H.7C.3 4.3 0 4 0 3.6V.7C0 .3.3 0 .7 0h11.5c.4 0 .8.3.8.7v2.9c0 .4-.4.7-.8.7zM1.4 2.9h10.1V1.4H1.4v1.5z"
            transform="translate(-457 -8966) translate(460.601 8977.523)"
        />
        <path
            d="M12.2 4.3H.7C.3 4.3 0 4 0 3.6V.7C0 .3.3 0 .7 0h11.5c.4 0 .8.3.8.7v2.9c0 .4-.4.7-.8.7zM1.4 2.9h10.1V1.4H1.4v1.5z"
            transform="translate(-457 -8966) translate(460.601 8971.762)"
        />
        <path
            d="M12.2 4.3H.7C.3 4.3 0 4 0 3.6V.7C0 .3.3 0 .7 0h11.5c.4 0 .8.3.8.7v2.9c0 .4-.4.7-.8.7zM1.4 2.9h10.1V1.4H1.4v1.5z"
            transform="translate(-457 -8966) translate(457 8966)"
        />
    </svg>
)

export const DetailViewICon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 17.5 16" xmlSpace="preserve">
        <path
            d="M8 8.7H.7C.3 8.7 0 8.4 0 8V.7C0 .3.3 0 .7 0H8c.4 0 .7.3.7.7V8c0 .4-.3.7-.7.7zM1.5 7.3h5.8V1.5H1.5v5.8z"
            transform="translate(-642 -6319) translate(642 6319)"
        />
        <path
            d="M6.6 1.5H.7c-.4 0-.7-.4-.7-.8S.3 0 .7 0h5.8c.5 0 .8.3.8.7s-.3.8-.7.8z"
            transform="translate(-642 -6319) translate(652.202 6319)"
        />
        <path
            d="M6.6 1.5H.7c-.4 0-.7-.4-.7-.8S.3 0 .7 0h5.8c.5 0 .8.3.8.7s-.3.8-.7.8z"
            transform="translate(-642 -6319) translate(652.202 6322.643)"
        />
        <path
            d="M6.6 1.5H.7c-.4 0-.7-.4-.7-.8S.3 0 .7 0h5.8c.5 0 .8.3.8.7s-.3.8-.7.8z"
            transform="translate(-642 -6319) translate(652.202 6326.287)"
        />
        <path
            d="M16.8 1.5H.8c-.5 0-.8-.4-.8-.8S.3 0 .7 0h16c.4 0 .7.3.7.7s-.2.8-.6.8z"
            transform="translate(-642 -6319) translate(642 6329.93)"
        />
        <path
            d="M12.4 1.5H.7c-.4 0-.7-.4-.7-.8S.3 0 .7 0h11.7c.4 0 .7.3.7.7s-.3.8-.7.8z"
            transform="translate(-642 -6319) translate(642 6333.574)"
        />
    </svg>
)

export const WorkAtivIcon = () => (
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 18 18" xmlSpace="preserve">
        <style>{'.st4{opacity:.75;enable-background:new}.st4,.st5{fill:#fff}'}</style>
        <g id="Group_9650" transform="translate(-3 -3)">
            <g id="Group_9648" transform="translate(3 3)">
                <path id="Path_4786" d="M6.9.3C3.2 1.1.5 4.3.1 8 1.9 7.3 5.2 5.4 6.9.3z" fill="#6ce6f9" />
                <path
                    id="Path_4787"
                    d="M8.9 18c2.2-2.6 5.1-4.4 8.3-5.3.5-1.1.8-2.4.8-3.7 0-2.8-1.3-5.5-3.6-7.2.4 7.4-6.3 8.9-10.8 10.9-.8.3-1.5.8-2.2 1.2C3.1 16.5 5.9 18 8.9 18z"
                    fill="#466af3"
                />
                <path
                    id="Path_4788"
                    d="M14.4 1.8C12.9.6 11 0 9 0c-.7 0-1.4.1-2.1.3C5.9 3.8 3.4 6.6.1 8c-.1.4-.1.7-.1 1 0 1.8.5 3.5 1.5 5 .7-.5 1.4-.9 2.2-1.2 4.4-2.1 11.1-3.5 10.7-11z"
                    fill="#5b9ff7"
                />
                <path id="Path_4789" d="M8.9 18H9c3.5 0 6.7-2.1 8.2-5.3-3.2.9-6.1 2.7-8.3 5.3z" fill="#314af2" />
            </g>
            <g id="Group_9649" transform="translate(6.47 7.679)">
                <path
                    id="Path_4790"
                    className="st4"
                    d="M2.5 7.4c0 .7-.5 1.3-1.2 1.3S0 8.2 0 7.5V1.2C0 .6.6 0 1.3 0 2 0 2.5.5 2.5 1.2v6.2z"
                />
                <path
                    id="Path_4791"
                    className="st4"
                    d="M11.1 7.4c0 .7-.6 1.2-1.3 1.2-.7 0-1.2-.5-1.2-1.2V5c0-.7.6-1.2 1.3-1.2.7 0 1.2.5 1.2 1.2v2.4z"
                />
                <circle id="Ellipse_534" className="st5" cx={9.8} cy={1.2} r={1.2} />
                <path
                    id="Path_4792"
                    className="st5"
                    d="M10.7 6.5c.5.5.5 1.3 0 1.8s-1.3.5-1.7 0l-2.9-3C5.8 5 5.3 5 5 5.3l-2.9 3c-.5.5-1.3.5-1.8 0S-.2 7 .3 6.6l4.2-4.4c.5-.5 1.3-.5 1.8 0l4.4 4.3z"
                />
            </g>
        </g>
    </svg>
)

export const AlphabetIcon = () => (
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 16 16">
        <g>
            <path
                d="M6.24,11.41H5.08l-0.38-1.12H2.51l-0.38,1.12H0.98L3,6.08h1.22L6.24,11.41z M3.61,6.98L2.81,9.4h1.6L3.61,6.98
                                        z"
            />
            <path d="M10.77,9.91c0,0.24-0.05,0.45-0.16,0.63c-0.11,0.18-0.26,0.34-0.45,0.47c-0.19,0.13-0.42,0.23-0.7,0.3s-0.57,0.1-0.9,0.1H6.95V6.08h1.82c0.27,0,0.52,0.03,0.74,0.09c0.22,0.06,0.41,0.15,0.56,0.26c0.15,0.11,0.27,0.24,0.36,0.4c0.08,0.15,0.13,0.33,0.13,0.51c0,0.34-0.1,0.61-0.29,0.82s-0.46,0.37-0.8,0.47c0.38,0.06,0.7,0.2,0.93,0.41C10.65,9.25,10.77,9.55,10.77,9.91z M8.53,8.26c0.28,0,0.5-0.06,0.68-0.18c0.17-0.12,0.26-0.3,0.26-0.52c0-0.21-0.07-0.37-0.22-0.47c-0.15-0.1-0.35-0.15-0.61-0.15H8.05v1.33H8.53z M9.67,9.83c0-0.24-0.1-0.42-0.3-0.54C9.16,9.17,8.9,9.11,8.58,9.11H8.05v1.46h0.59c0.35,0,0.61-0.07,0.78-0.2C9.58,10.23,9.67,10.05,9.67,9.83z" />
            <path d="M14.18,5.99c0.13,0,0.27,0.01,0.41,0.02s0.27,0.03,0.4,0.06s0.26,0.05,0.38,0.09c0.12,0.03,0.23,0.08,0.32,0.12l-0.16,0.82c-0.17-0.06-0.36-0.12-0.57-0.16s-0.41-0.06-0.62-0.06c-0.61,0-1.07,0.16-1.4,0.47c-0.32,0.32-0.48,0.78-0.48,1.4c0,0.62,0.16,1.08,0.48,1.4c0.32,0.32,0.79,0.47,1.4,0.47c0.2,0,0.41-0.02,0.62-0.06s0.4-0.09,0.57-0.16l0.16,0.82c-0.1,0.05-0.2,0.09-0.32,0.12c-0.12,0.04-0.25,0.06-0.38,0.09s-0.27,0.04-0.4,0.05c-0.14,0.01-0.27,0.02-0.41,0.02c-0.46,0-0.86-0.07-1.22-0.21c-0.35-0.14-0.65-0.33-0.89-0.58c-0.24-0.25-0.42-0.54-0.54-0.87c-0.12-0.34-0.18-0.7-0.18-1.1s0.06-0.77,0.18-1.1c0.12-0.34,0.3-0.63,0.54-0.87c0.24-0.25,0.54-0.44,0.89-0.58C13.32,6.06,13.73,5.99,14.18,5.99z" />
        </g>
    </svg>
)

export const NumberIcon = () => (
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
        <g>
            <path d="M3.08,9.99V5.85L2.09,6.21L1.83,5.34l1.7-0.68h0.66v5.33H3.08z" />
            <path d="M6.04,4.96c0.19-0.12,0.4-0.22,0.64-0.29s0.49-0.11,0.78-0.11c0.53,0,0.95,0.14,1.25,0.42s0.46,0.68,0.46,1.18c0,0.21-0.03,0.41-0.08,0.6C9.03,6.96,8.96,7.14,8.86,7.31c-0.1,0.17-0.21,0.33-0.34,0.49S8.25,8.1,8.09,8.25C7.93,8.41,7.77,8.56,7.62,8.7s-0.3,0.27-0.44,0.4h2.03v0.89H5.9L5.75,9.35c0.14-0.15,0.28-0.29,0.4-0.41C6.26,8.82,6.38,8.7,6.48,8.59c0.11-0.11,0.21-0.22,0.31-0.32s0.2-0.22,0.31-0.34c0.12-0.13,0.23-0.27,0.35-0.4C7.57,7.4,7.67,7.26,7.76,7.12C7.85,6.98,7.92,6.84,7.97,6.7C8.03,6.55,8.06,6.4,8.06,6.25c0-0.25-0.07-0.45-0.22-0.59C7.7,5.52,7.5,5.45,7.24,5.45c-0.2,0-0.37,0.03-0.53,0.08s-0.3,0.12-0.42,0.2L6.04,4.96z" />
            <path d="M13.99,8.54c0,0.24-0.05,0.46-0.15,0.64s-0.23,0.35-0.4,0.48c-0.17,0.13-0.37,0.24-0.6,0.31c-0.23,0.07-0.47,0.11-0.74,0.11c-0.25,0-0.49-0.03-0.74-0.08c-0.25-0.05-0.47-0.12-0.66-0.21l0.18-0.83c0.17,0.07,0.34,0.13,0.52,0.18c0.18,0.05,0.37,0.07,0.57,0.07c0.3,0,0.53-0.07,0.68-0.2c0.15-0.13,0.22-0.3,0.22-0.5c0-0.27-0.11-0.47-0.34-0.59c-0.22-0.12-0.51-0.18-0.86-0.18h-0.45V6.85h0.3c0.4,0,0.7-0.07,0.92-0.22c0.22-0.14,0.32-0.34,0.32-0.59c0-0.19-0.07-0.34-0.2-0.44c-0.13-0.1-0.32-0.16-0.56-0.16c-0.34,0-0.66,0.07-0.96,0.22l-0.19-0.79c0.17-0.1,0.38-0.17,0.62-0.23c0.24-0.06,0.5-0.08,0.76-0.08c0.23,0,0.44,0.03,0.64,0.09s0.37,0.14,0.52,0.26c0.15,0.11,0.26,0.25,0.34,0.41c0.08,0.16,0.12,0.34,0.12,0.54c0,0.3-0.08,0.57-0.25,0.8c-0.17,0.23-0.42,0.42-0.75,0.56c0.15,0.04,0.29,0.1,0.43,0.18s0.25,0.17,0.36,0.28c0.1,0.11,0.18,0.24,0.24,0.38C13.96,8.21,13.99,8.37,13.99,8.54z" />
        </g>
    </svg>
)

export const BooleanIcon = () => (
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
        <g>
            <path d="M6.4,5.8v1H4.7v5H3.5v-5H1.8v-1H6.4z" />
            <path d="M8.6,5.4l1.1,0.4l-2.3,6.9l-1.1-0.4L8.6,5.4z" />
            <path d="M10.7,11.8v-6h3.6v1h-2.4v1.6h2.2v1h-2.2v2.4H10.7z" />
        </g>
    </svg>
)

export const ExitIcon = (props: any) => (
    <svg version="1.1" id="Capa_1" viewBox="0 0 512 512">
        <g>
            <g>
                <path
                    d="M255.15,468.625H63.787c-11.737,0-21.262-9.526-21.262-21.262V64.638c0-11.737,9.526-21.262,21.262-21.262H255.15
c11.758,0,21.262-9.504,21.262-21.262S266.908,0.85,255.15,0.85H63.787C28.619,0.85,0,29.47,0,64.638v382.724
c0,35.168,28.619,63.787,63.787,63.787H255.15c11.758,0,21.262-9.504,21.262-21.262
C276.412,478.129,266.908,468.625,255.15,468.625z"
                />
            </g>
        </g>
        <g>
            <g>
                <path
                    d="M505.664,240.861L376.388,113.286c-8.335-8.25-21.815-8.143-30.065,0.213s-8.165,21.815,0.213,30.065l92.385,91.173
H191.362c-11.758,0-21.262,9.504-21.262,21.262c0,11.758,9.504,21.263,21.262,21.263h247.559l-92.385,91.173
c-8.377,8.25-8.441,21.709-0.213,30.065c4.167,4.21,9.653,6.336,15.139,6.336c5.401,0,10.801-2.041,14.926-6.124l129.276-127.575
c4.04-3.997,6.336-9.441,6.336-15.139C512,250.302,509.725,244.88,505.664,240.861z"
                />
            </g>
        </g>
    </svg>
)

export const DialogExitIcon = () => (
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 24 24" xmlSpace="preserve">
        <style>{'.sdt0{fill:currentColor}'}</style>
        <g id="exit" transform="translate(-874 -20263)">
            <g id="Group_12453" transform="translate(675.404 20064.232)">
                <g id="Group_8120" transform="translate(204.8 204.97)">
                    <g id="Group_8119">
                        <path
                            id="Path_4297"
                            className="sdt0"
                            d="M5.9 10.8H1.5c-.3 0-.5-.2-.5-.5V1.5c0-.3.2-.5.5-.5h4.4c.3 0 .5-.2.5-.5S6.1 0 5.9 0H1.5C.7 0 0 .7 0 1.5v8.8c0 .8.7 1.5 1.5 1.5h4.4c.3 0 .5-.2.5-.5s-.2-.5-.5-.5z"
                        />
                    </g>
                </g>
                <g id="Group_8122" transform="translate(208.719 207.419)">
                    <g id="Group_8121">
                        <path
                            id="Path_4298"
                            className="sdt0"
                            d="M7.7 3.1L4.7.2C4.6 0 4.2 0 4.1.1c-.2.2-.2.5 0 .7l2.1 2.1H.5c-.3 0-.5.3-.5.5 0 .3.2.5.5.5h5.7L4.1 6c-.2.2-.2.5 0 .7.2.2.5.2.7 0l3-2.9c.1-.2.1-.5-.1-.7z"
                        />
                    </g>
                </g>
            </g>
        </g>
    </svg>
)
export const AdaptiveIcon = () => (
    <svg version="1.1" id="Capa_1" viewBox="0 0 16 16">
        <g>
            <g>
                <g>
                    <g>
                        <g>
                            <path
                                d="M14.6,14.6H1.4c-0.5,0-0.8-0.4-0.8-0.9V2.3c0-0.5,0.4-0.9,0.8-0.9h13.2c0.5,0,0.8,0.4,0.8,0.9v11.5
						C15.4,14.2,15.1,14.6,14.6,14.6z M1.4,2.1c-0.1,0-0.2,0.1-0.2,0.2v11.5c0,0.1,0.1,0.2,0.2,0.2h13.2c0.1,0,0.2-0.1,0.2-0.2V2.3
						c0-0.1-0.1-0.2-0.2-0.2H1.4z"
                            />
                        </g>
                    </g>
                </g>
            </g>
            <g>
                <path
                    d="M6.3,8.2H2.9C2.7,8.2,2.6,8,2.6,7.8V4.4c0-0.2,0.2-0.3,0.3-0.3h3.4c0.2,0,0.3,0.2,0.3,0.3v3.4C6.6,8,6.5,8.2,6.3,8.2z
			 M3.3,7.5H6V4.8H3.3V7.5z"
                />
            </g>
            <g>
                <path d="M12.1,10.2H2.9c-0.2,0-0.3-0.2-0.3-0.3s0.2-0.3,0.3-0.3h9.1c0.2,0,0.3,0.2,0.3,0.3S12.2,10.2,12.1,10.2z" />
            </g>
            <g>
                <path d="M10,12.2H2.9c-0.2,0-0.3-0.2-0.3-0.3c0-0.2,0.2-0.3,0.3-0.3H10c0.2,0,0.3,0.2,0.3,0.3C10.4,12.1,10.2,12.2,10,12.2z" />
            </g>
            <g>
                <path d="M12.4,5.1H9C8.8,5.1,8.7,5,8.7,4.8c0-0.2,0.2-0.3,0.3-0.3h3.4c0.2,0,0.3,0.2,0.3,0.3C12.7,5,12.6,5.1,12.4,5.1z" />
            </g>
            <g>
                <path d="M12.4,7.2H9C8.8,7.2,8.7,7,8.7,6.8c0-0.2,0.2-0.3,0.3-0.3h3.4c0.2,0,0.3,0.2,0.3,0.3C12.7,7,12.6,7.2,12.4,7.2z" />
            </g>
        </g>
    </svg>
)
export const DailogAdaptiveIcon = () => (
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 24 24" xmlSpace="preserve">
        <style>{'.stw0{fill:currentColor}'}</style>
        <g id="adaptive_card">
            <path
                className="stw0"
                d="M892.1 20213.5c0-.2-.1-.4-.2-.6-.2-.2-.4-.2-.6-.2h-10.7c-.5 0-.8.4-.8.9V20222.9c0 .4.4.8.8.8h10.7c.2 0 .4-.1.6-.2.1-.2.2-.3.2-.6v-9.4c0 .1 0 .1 0 0zm-.7.1v9.3h-10.7v-9.3h10.7z"
                transform="translate(-874 -20206)"
            />
            <path
                className="stw0"
                d="M881.8 20218.5h2.8c.1 0 .2 0 .3-.1s.1-.2.1-.4v-2.8c0-.2-.2-.4-.4-.4h-2.8c-.2 0-.4.2-.4.4v2.8c.1.3.2.5.4.5zm.5-.8v-1.9h1.9v1.9h-1.9zM881.8 20220.2h7.5c.2 0 .3-.3.3-.4 0-.2-.2-.4-.4-.4h-7.4c-.2.1-.3.2-.3.3 0 .3.1.5.3.5zM881.8 20221.8h5.8c.2 0 .3-.1.4-.2 0 0 .1-.1 0-.3 0-.2-.2-.3-.4-.4h-5.8c-.2 0-.4.2-.4.4 0 .1.1.2.1.3.1.2.2.2.3.2zM886.5 20216c.1 0 .1.1.2.1H889.5c.2 0 .3-.2.3-.4s-.2-.4-.4-.4h-2.8c-.2 0-.4.2-.4.4v.1c.2 0 .3.1.3.2zM886.8 20217.7h2.8c.1 0 .2 0 .3-.1s.1-.2.1-.4-.2-.4-.4-.4h-2.8c-.2 0-.4.2-.4.4 0 .3.2.5.4.5z"
                transform="translate(-874 -20206)"
            />
        </g>
    </svg>
)

export const AttachmentIcon = () => (
    <svg x="0px" y="0px" viewBox="0 0 24 24" xmlSpace="preserve">
        <path
            d="M4.6 22.3c-1 0-2-.4-2.7-1.1-.8-.8-1.3-1.9-1.2-3 .1-1.2.6-2.3 1.7-3.3L13.8 3.4c1.1-1.1 2.5-1.6 4-1.6s2.9.6 4 1.6c2.2 2.2 2.2 5.7 0 7.9l-10 10c-.3.3-.7.3-1 0-.3-.3-.3-.7 0-1l10-10c1.6-1.6 1.6-4.3 0-5.9-.8-.8-1.8-1.2-3-1.2-1.1 0-2.2.4-3 1.2L3.3 15.8c-.8.8-1.2 1.6-1.2 2.4 0 .7.2 1.4.8 2 1.1 1.1 3 .9 4.3-.5l9.4-9.4c.3-.3.4-.6.4-.9 0-.3-.1-.7-.4-.9-.5-.5-1.3-.5-1.8 0l-8 8c-.3.3-.7.3-1 0-.3-.3-.3-.7 0-1l8-8c1.1-1.1 2.8-1.1 3.8 0 .5.5.8 1.2.8 1.9s-.3 1.4-.8 1.9l-9.4 9.4c-1 1-2.3 1.6-3.6 1.6z"
            fill="fillcolor"
        />
    </svg>
)

export const DialogAttachmentIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 24 24" xmlSpace="preserve">
        <path
            d="M2.1 10.9c-.5 0-1.1-.2-1.4-.6-.5-.4-.7-1-.7-1.6C.1 8 .4 7.4.9 7L7 .8C7.5.3 8.3 0 9.1 0s1.5.3 2.1.9c1.2 1.1 1.2 3 0 4.2l-5.3 5.3c-.2.1-.4.1-.5 0s-.1-.4 0-.5l5.3-5.3c.8-.9.8-2.3 0-3.1-.4-.4-1-.7-1.6-.6-.6-.2-1.2.1-1.6.5l-6.1 6c-.4.4-.6.8-.6 1.3 0 .4.1.8.4 1.1.7.6 1.7.5 2.2-.2v-.1l5-5c.2-.1.3-.3.3-.5s-.1-.4-.2-.5c-.3-.3-.7-.3-1 0L3.2 7.8c-.1.2-.3.2-.5 0-.1-.1-.1-.4 0-.5L7 3c.5-.6 1.4-.6 2-.1C8.9 3 9 3 9 3c.6.5.6 1.4 0 2l-5 5c-.5.6-1.2.9-1.9.9z"
            fill="currentColor"
            transform="translate(-604 -591) translate(609.264 595.753) translate(.687 1.8)"
        />
    </svg>
)

export const BulpIcon = () => (
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 512 512">
        <path
            className="tips1"
            d="M314.7,391.5c6.4-21.3,19.2-40.5,36.3-55.5c32-26.7,52.3-67.2,52.3-112c0-83.2-69.3-151.5-154.7-147.2
	C172.8,80,110.9,144,108.8,219.7c-1.1,46.9,19.2,88.5,52.3,116.3c18.1,14.9,30.9,34.1,37.3,55.5H314.7L314.7,391.5z"
        />
        <path
            className="tips2"
            d="M242.1,393.6h9.6l-42.7-158.9c1.1,0,2.1,0,3.2,0c5.3,0,10.7-2.1,14.9-6.4c2.1-2.1,4.3-3.2,7.5-3.2
	s5.3,1.1,7.5,3.2c7.5,8.5,20.3,8.5,27.7,0c2.1-2.1,4.3-3.2,7.5-3.2c2.1,0,5.3,1.1,7.5,3.2c4.3,4.3,8.5,6.4,14.9,6.4
	c1.1,0,2.1,0,3.2,0l-41.6,158.9h9.6l43.7-166.4c0-2.1,0-4.3-2.1-5.3c-2.1-1.1-4.3,0-5.3,1.1c-2.1,2.1-4.3,3.2-6.4,3.2
	c-3.2,0-5.3-1.1-8.5-3.2c-4.3-4.3-8.5-6.4-13.9-6.4s-9.6,2.1-13.9,6.4s-10.7,4.3-14.9,0c-3.2-4.3-8.5-6.4-13.9-6.4l0,0
	c-5.3,0-10.7,2.1-13.9,6.4c-2.1,2.1-5.3,3.2-8.5,3.2c-2.1,0-5.3-1.1-6.4-3.2c-1.1-1.1-3.2-2.1-5.3-1.1c-2.1,1.1-3.2,3.2-2.1,5.3
	L242.1,393.6z"
        />
        <g>
            <path className="tips3" d="M222.9,489.6c5.3,12.8,18.1,22.4,33.1,22.4c14.9,0,27.7-9.6,33.1-22.4H222.9z" />
            <path
                className="tips3"
                d="M295.5,490.7h-77.9c-10.7,0-19.2-8.5-19.2-19.2v-81.1h116.3v81.1C314.7,482.1,306.1,490.7,295.5,490.7z"
            />
        </g>
        <g>
            <path
                className="tips4"
                d="M313.6,430.9H198.4c-6.4,0-11.7-5.3-11.7-11.7l0,0c0-6.4,5.3-11.7,11.7-11.7h115.2c6.4,0,11.7,5.3,11.7,11.7
		l0,0C325.3,425.6,320,430.9,313.6,430.9z"
            />
            <path
                className="tips4"
                d="M313.6,468.3H198.4c-6.4,0-11.7-5.3-11.7-11.7l0,0c0-6.4,5.3-11.7,11.7-11.7h115.2c6.4,0,11.7,5.3,11.7,11.7
		l0,0C325.3,462.9,320,468.3,313.6,468.3z"
            />
        </g>
        <g>
            <path
                className="tips1"
                d="M256,0c-5.3,0-10.7,4.3-10.7,10.7v36.3c0,5.3,4.3,10.7,10.7,10.7s10.7-4.3,10.7-10.7V10.7
		C266.7,4.3,261.3,0,256,0z"
            />
            <path
                className="tips1"
                d="M113.1,65.1c-4.3-4.3-10.7-4.3-14.9,0s-4.3,10.7,0,14.9l25.6,25.6c4.3,4.3,10.7,4.3,14.9,0s4.3-10.7,0-14.9
		L113.1,65.1z"
            />
            <path
                className="tips1"
                d="M80,212.3H43.7c-5.3,0-10.7,4.3-10.7,10.7l0,0c0,5.3,4.3,10.7,10.7,10.7H80c5.3,0,10.7-4.3,10.7-10.7l0,0
		C90.7,217.6,85.3,212.3,80,212.3z"
            />
            <path
                className="tips1"
                d="M123.7,340.3l-25.6,25.6c-4.3,4.3-4.3,10.7,0,14.9s10.7,4.3,14.9,0l25.6-25.6c4.3-4.3,4.3-10.7,0-14.9
		S128,336,123.7,340.3z"
            />
            <path
                className="tips1"
                d="M388.3,340.3c-4.3-4.3-10.7-4.3-14.9,0s-4.3,10.7,0,14.9l25.6,25.6c4.3,4.3,10.7,4.3,14.9,0s4.3-10.7,0-14.9
		L388.3,340.3z"
            />
            <path
                className="tips1"
                d="M468.3,212.3H432c-5.3,0-10.7,4.3-10.7,10.7l0,0c0,5.3,4.3,10.7,10.7,10.7h36.3c5.3,0,10.7-4.3,10.7-10.7l0,0
		C478.9,217.6,474.7,212.3,468.3,212.3z"
            />
            <path
                className="tips1"
                d="M398.9,65.1l-25.6,25.6c-4.3,4.3-4.3,10.7,0,14.9c4.3,4.3,10.7,4.3,14.9,0L413.9,80c4.3-4.3,4.3-10.7,0-14.9
		S403.2,60.8,398.9,65.1z"
            />
        </g>
    </svg>
)

// export const DialogIcon: React.FunctionComponent = () => (
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 16.6">
//         <title>dialog</title>
//         <g id="Layer_2" data-name="Layer 2">
//             <g id="Layer_1-2" data-name="Layer 1">
//                 <path d="M13.45,0H7A7,7,0,0,0,.15,5.46a6.54,6.54,0,0,0,6.37,7.93h0v2.69a.52.52,0,0,0,.52.52.56.56,0,0,0,.31-.11l3.9-3h2.16A6.62,6.62,0,0,0,20,6.87,6.87,6.87,0,0,0,13.45,0Z" />
//             </g>
//         </g>
//     </svg>
// )

// export const ResponceIcon = () => (
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
//         <title>responce</title>
//         <g id="Layer_2" data-name="Layer 2">
//             <g id="Layer_1-2" data-name="Layer 1">
//                 <path d="M7,0a7,7,0,1,0,7,7A7,7,0,0,0,7,0Zm.87,8.61a8.82,8.82,0,0,1-2.39,2.16l-.37-.41A7.09,7.09,0,0,0,6.49,8.84a4.07,4.07,0,0,0,.67-1.61,1.61,1.61,0,0,1-1.31-.58A1.88,1.88,0,0,1,5.44,5.4a1.81,1.81,0,0,1,.41-1.25,1.67,1.67,0,0,1,1.31-.54,1.61,1.61,0,0,1,1.29.54A1.84,1.84,0,0,1,8.89,5.4,5.38,5.38,0,0,1,7.87,8.61Z" />
//             </g>
//         </g>
//     </svg>
// )
// export const OptionIcon = () => (
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" version="1.1" width="48px" height="48px">
//         <g id="surface1">
//             <path d="M 6 22 L 42 22 L 42 26 L 6 26 Z " />
//             <path d="M 6 10 L 42 10 L 42 14 L 6 14 Z " />
//             <path d="M 6 34 L 42 34 L 42 38 L 6 38 Z " />
//         </g>
//     </svg>
// )

// export const QaIcon = () => (
//     <svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44">
//         {/* <ellipse className="st0" cx="21.9" cy="21.9" rx="19.7" ry="19.9"/> */}
//         <path
//             id="XMLID_10_"
//             className="st1"
//             d="M22,10.1c-3.1,0-5.6,2.5-5.6,5.6c0,0.5,0.4,1,1,1s1-0.4,1-1c0-2,1.6-3.6,3.6-3.6
//        s3.6,1.6,3.6,3.6v0.4c0,1.4-0.7,2.6-1.9,3.2C22,20.1,21,21.9,21,24v0.3c0,0.5,0.4,1,1,1c0.5,0,1-0.4,1-1V24c0-1.3,0.6-2.4,1.6-2.9
//        c1.9-1,3-2.9,3-5v-0.4C27.6,12.6,25.1,10.1,22,10.1z"
//         />
//         <path
//             id="XMLID_11_"
//             className="st1"
//             d="M22,29.2c-0.5,0-1,0.4-1,1v2.7c0,0.5,0.4,1,1,1c0.5,0,1-0.4,1-1v-2.7C23,29.6,22.5,29.2,22,29.2
//        z"
//         />
//     </svg>
// )

// export const SlotsIcon = () => (
//     <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4.1 7">
//         <g id="outline">
//             <path
//                 d="M3.6,6.1L3.6,6.1L3.5,5.8c0-0.1-0.1-0.1-0.1-0.1c-0.1,0-0.3-0.1-0.3-0.3C3.1,5.4,3,5.3,3,5.3H2.2V4.9l1.5-1.1
//         c0.1,0,0.1-0.1,0-0.2c0,0,0,0,0,0L3.2,3.2l0.5-0.3c0.1,0,0.1-0.1,0-0.2c0,0,0,0,0,0L3.2,2.3l0.5-0.3c0.1,0,0.1-0.1,0-0.2
//         c0,0,0,0,0,0L2.2,0.6V0.3c0-0.1-0.1-0.1-0.1-0.1C2,0.2,1.9,0.2,1.9,0.3v0.3L0.4,1.7c-0.1,0-0.1,0.1,0,0.2c0,0,0,0,0,0l0.5,0.3
//         L0.4,2.6c-0.1,0-0.1,0.1,0,0.2c0,0,0,0,0,0l0.5,0.3L0.4,3.5c-0.1,0-0.1,0.1,0,0.2c0,0,0,0,0,0l1.5,1.1v0.4H1.2C1.1,5.3,1,5.4,1,5.4
//         c0,0.1-0.1,0.3-0.3,0.3c-0.1,0-0.1,0-0.1,0.1L0.5,6.1h0c-0.2,0-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4h3.1C3.8,6.9,4,6.7,4,6.5
//         S3.8,6.1,3.6,6.1z M1.9,0.9v0.8c0,0.1,0.1,0.1,0.1,0.1c0.1,0,0.1-0.1,0.1-0.1V0.9l1.2,0.9l-1.3,1l-1.3-1L1.9,0.9z M1.1,2.4L2,3.1
//         c0,0,0.1,0,0.2,0L3,2.5l0.4,0.3l-1.3,1l-1.3-1L1.1,2.4L1.1,2.4z M1.1,3.3L2,4c0,0,0.1,0,0.2,0L3,3.4l0.4,0.3l-1.3,1l-1.3-1L1.1,3.3
//         L1.1,3.3z M0.9,5.9c0.2,0,0.4-0.2,0.4-0.4h1.6C2.9,5.8,3,5.9,3.2,5.9l0,0.1H0.8L0.9,5.9z M3.6,6.6H0.5c-0.1,0-0.1-0.1-0.1-0.1
//         s0.1-0.1,0.1-0.1h3.1c0.1,0,0.1,0.1,0.1,0.1S3.7,6.6,3.6,6.6z"
//             />
//         </g>
//     </svg>
// )
// export const JumpIcon = () => (
//     <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 8.93">
//         <title>jump_to</title>
//         <rect x="12.91" y="1.33" width="0.66" height="2.78" rx="0.3" />
//         <circle cx="13.22" cy="8.15" r="0.78" />
//         <path d="M12.31,1S13.58.9,13.58,2V2.5h-.67a.71.71,0,0,0-.78-.76V1Z" transform="translate(0 -0.53)" />
//         <path d="M12.31,5.42s1.27.06,1.27-1.06V3.88h-.67a.71.71,0,0,1-.78.76v.78Z" transform="translate(0 -0.53)" />
//         <circle cx="0.78" cy="0.78" r="0.78" />
//         <rect x="0.72" y="0.42" width="11.77" height="0.78" rx="0.35" />
//         <rect x="1.39" y="4.1" width="11.1" height="0.78" rx="0.35" />
//         <rect x="0.36" y="5.54" width="0.66" height="2.78" rx="0.3" transform="translate(1.39 13.33) rotate(180)" />
//         <path d="M1.63,4.64S.36,4.58.36,5.7v.48H1a.71.71,0,0,1,.78-.76V4.64Z" transform="translate(0 -0.53)" />
//         <rect x="1.45" y="8.32" width="11.89" height="0.78" rx="0.35" transform="translate(14.78 16.89) rotate(180)" />
//         <path d="M1.63,9.1s-1.27.06-1.27-1V7.56H1a.71.71,0,0,0,.78.76V9.1Z" transform="translate(0 -0.53)" />
//     </svg>
// )
// export const FlowIcon: React.FunctionComponent = () => (
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.11 23">
//         <title>Workflow</title>
//         <g id="Layer_2" data-name="Layer 2">
//             <g id="Layer_1-2" data-name="Layer 1">
//                 <path d="M12.17,16.38a2.8,2.8,0,0,0-2.58,1.7H5.73a1.71,1.71,0,0,1-1.81-1.81V11.74a4.29,4.29,0,0,0,1.81.37H9.59a2.81,2.81,0,1,0,0-2.22H5.73A1.71,1.71,0,0,1,3.92,8.07V5.39a2.81,2.81,0,1,0-2.22,0V16.27a3.91,3.91,0,0,0,4,4H9.59a2.81,2.81,0,1,0,2.58-3.92Zm0-7A1.62,1.62,0,1,1,10.55,11,1.63,1.63,0,0,1,12.17,9.38Zm-11-6.57A1.62,1.62,0,1,1,2.81,4.43,1.61,1.61,0,0,1,1.19,2.81Zm11,18a1.62,1.62,0,1,1,1.62-1.62A1.62,1.62,0,0,1,12.17,20.81Z" />
//             </g>
//         </g>
//     </svg>
// )

// export const DeleteIcon: React.FunctionComponent = () => (
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.46 15.53">
//         <title>delete</title>
//         <g id="Layer_2" data-name="Layer 2">
//             <g id="Layer_1-2" data-name="Layer 1">
//                 <path
//                     fill="currentColor"
//                     d="M13.91,2.34H11V2.15A2.14,2.14,0,0,0,8.85,0H5.61A2.13,2.13,0,0,0,3.48,2a.41.41,0,0,0,0,.11v.19H.55a.56.56,0,0,0,0,1.11h1.2v9.94a2.14,2.14,0,0,0,2.14,2.14h6.68a2.14,2.14,0,0,0,2.14-2v-10h1.2a.56.56,0,0,0,0-1.11ZM4.58,2.17a.13.13,0,0,1,0-.06,1,1,0,0,1,1-1H8.85a1,1,0,0,1,1,1v.19H4.58Zm7,11.19v.07a1,1,0,0,1-1,1H3.89a1,1,0,0,1-1-1V3.45H11.6Z"
//                 />
//                 <path
//                     fill="currentColor"
//                     d="M4.73,12.6A.56.56,0,0,0,5.29,12v-6a.56.56,0,0,0-1.11,0v6A.56.56,0,0,0,4.73,12.6Z"
//                 />
//                 <path
//                     fill="currentColor"
//                     d="M7.23,12.6A.56.56,0,0,0,7.79,12v-6a.56.56,0,0,0-1.11,0v6A.56.56,0,0,0,7.23,12.6Z"
//                 />
//                 <path
//                     fill="currentColor"
//                     d="M9.73,12.6a.55.55,0,0,0,.55-.56v-6a.55.55,0,0,0-1.1,0v6A.55.55,0,0,0,9.73,12.6Z"
//                 />
//             </g>
//         </g>
//     </svg>
// )

// export const EditIcon: React.FunctionComponent = () => (
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.91 13.91">
//         <title>edit</title>
//         <g id="Layer_2" data-name="Layer 2">
//             <g id="Layer_1-2" data-name="Layer 1">
//                 <path
//                     fill="currentColor"
//                     d="M11.58,1.23l1.1,1.1L5.36,9.64,4.27,8.55l7.31-7.32m0-1.23A.81.81,0,0,0,11,.24L2.89,8.36a.26.26,0,0,0,0,.38L5.17,11a.27.27,0,0,0,.38,0L13.67,2.9a.81.81,0,0,0,0-1.15L12.16.24A.82.82,0,0,0,11.58,0Z"
//                 />
//                 <path
//                     fill="currentColor"
//                     d="M2.1,11.14l.67.67c-.42.2-.82.37-1.19.52.15-.37.32-.77.52-1.19M1.9,9.51a.4.4,0,0,0-.36.23A33.84,33.84,0,0,0,.08,13.12c-.19.49,0,.79.34.79a1,1,0,0,0,.37-.08,33.84,33.84,0,0,0,3.38-1.46.37.37,0,0,0,.14-.59L2.13,9.6a.32.32,0,0,0-.23-.09Z"
//                 />
//             </g>
//         </g>
//     </svg>
// )

// export const MoreIcon = () => (
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4 16">
//         <title>more</title>
//         <g id="Layer_2" data-name="Layer 2">
//             <g id="Layer_1-2" data-name="Layer 1">
//                 <path d="M0,14a2,2,0,1,1,2,2,2,2,0,0,1-2-2" />
//                 <path d="M0,2A2,2,0,1,1,2,4,2,2,0,0,1,0,2" />
//                 <path d="M0,8a2,2,0,1,1,2,2A2,2,0,0,1,0,8" />
//             </g>
//         </g>
//     </svg>
// )

// export const NextIconCanvas = () => (
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 5.52 8">
//         <title>next</title>
//         <g id="Layer_2" data-name="Layer 2">
//             <g id="Layer_1-2" data-name="Layer 1">
//                 <path
//                     className="cls-1"
//                     d="M1.21.17l4,3.26A.76.76,0,0,1,5.52,4a.78.78,0,0,1-.27.58l-4,3.25a.76.76,0,0,1-.79.1A.73.73,0,0,1,0,7.26V.74A.73.73,0,0,1,.42.07.77.77,0,0,1,.74,0,.75.75,0,0,1,1.21.17Z"
//                 />
//             </g>
//         </g>
//     </svg>
// )

// export const AddIcon: React.FunctionComponent = () => (
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.24 16.24">
//         <title>add</title>
//         <g id="Layer_2" data-name="Layer 2">
//             <g id="Layer_1-2" data-name="Layer 1">
//                 <path d="M0,8.12a.93.93,0,0,1,.93-.93H7.19V.93a.93.93,0,0,1,1.86,0V7.19h6.26a.93.93,0,0,1,0,1.86H9.05v6.26a.93.93,0,0,1-1.86,0V9.05H.93A.93.93,0,0,1,0,8.12Z" />
//             </g>
//         </g>
//     </svg>
// )

export const ConditionPopupHeaderIcon = () => (
    <svg viewBox="0 0 11 11">
        <path
            d="M5.5,0C2.5,0,0,2.5,0,5.5c0,3,2.5,5.5,5.5,5.5S11,8.5,11,5.5C11,2.5,8.5,0,5.5,0z M8,6H6v2H5V6H3V5h2V3h1v2h2V6
                z"
        />
    </svg>
)

export const ConditionRulesDeleteIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 401 401">
        <g>
            <g>
                <g>
                    <polygon points="243.5,157.96 221.73,157.16 217.01,286.02 238.78,286.82 			" />
                    <polygon points="184.09,286.02 179.37,157.15 157.6,157.95 162.32,286.82 			" />
                    <path d="M70.69,103.83v21.78h22.69l18,204.6c0.49,5.62,5.2,9.94,10.85,9.94h155.72c5.64,0,10.36-4.32,10.85-9.94l18-204.6h23.06 v-21.78H70.69z M267.98,318.37H132.21l-16.96-192.75h169.7L267.98,318.37z" />
                </g>
            </g>
        </g>
        <g>
            <g>
                <path d="M235.85,62.09h-71.15c-10.01,0-18.15,8.14-18.15,18.15v34.49h21.78V83.87h63.89v30.86H254V80.24 C254,70.23,245.86,62.09,235.85,62.09z" />
            </g>
        </g>
    </svg>
)

export const AutomationLogsHeaderIcon = () => (
    <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 424 424"
        xmlSpace="preserve"
    >
        <path
            d="M167.3,297.1c-1.6,0-3.2-0.6-4.5-1.7l-45.3-38.6c-1.6-1.3-2.5-3.3-2.5-5.3c0-2.1,0.9-4,2.5-5.3l45.3-38.6
c2.9-2.5,7.4-2.2,9.9,0.8c2.5,2.9,2.2,7.4-0.8,9.9l-39,33.2l39,33.2c2.9,2.5,3.3,6.9,0.8,9.9C171.2,296.3,169.3,297.1,167.3,297.1z"
        />
        <path
            d="M256.7,297.1c-2,0-3.9-0.8-5.3-2.5c-2.5-2.9-2.2-7.4,0.8-9.9l39-33.2l-39-33.2c-2.9-2.5-3.3-6.9-0.8-9.9
c2.5-2.9,6.9-3.3,9.9-0.8l45.3,38.6c1.6,1.3,2.5,3.3,2.5,5.3c0,2.1-0.9,4-2.5,5.3l-45.3,38.6C259.9,296.6,258.3,297.1,256.7,297.1z"
        />
        <path
            d="M196,326.1c-0.5,0-1-0.1-1.5-0.2c-3.8-0.8-6.2-4.5-5.4-8.3l28.2-134c0.8-3.8,4.5-6.2,8.3-5.4c3.8,0.8,6.2,4.5,5.4,8.3
l-28.2,134C202.1,323.8,199.2,326.1,196,326.1z"
        />
        <path
            d="M377,399.1H47c-25.9,0-47-21.1-47-47V72c0-25.9,21.1-47,47-47h330c25.9,0,47,21.1,47,47v280.1
C424,378,402.9,399.1,377,399.1z M47,39c-18.2,0-33,14.8-33,33v280.1c0,18.2,14.8,33,33,33h330c18.2,0,33-14.8,33-33V72
c0-18.2-14.8-33-33-33H47z"
        />
        <path d="M417,137.1H7c-3.9,0-7-3.1-7-7c0-3.9,3.1-7,7-7h410c3.9,0,7,3.1,7,7C424,134,420.9,137.1,417,137.1z" />
        <path
            d="M119.6,103.6c-12.2,0-22.2-9.9-22.2-22.2c0-12.2,9.9-22.2,22.2-22.2c12.2,0,22.2,9.9,22.2,22.2
C141.8,93.7,131.8,103.6,119.6,103.6z M119.6,73.3c-4.5,0-8.2,3.7-8.2,8.2c0,4.5,3.7,8.2,8.2,8.2c4.5,0,8.2-3.7,8.2-8.2
C127.8,76.9,124.1,73.3,119.6,73.3z"
        />
        <path
            d="M51.5,103.4c-12.2,0-22.2-9.9-22.2-22.2s9.9-22.2,22.2-22.2S73.7,69,73.7,81.2S63.8,103.4,51.5,103.4z M51.5,73.1
c-4.5,0-8.2,3.7-8.2,8.2c0,4.5,3.7,8.2,8.2,8.2c4.5,0,8.2-3.7,8.2-8.2C59.7,76.7,56,73.1,51.5,73.1z"
        />
        <path
            d="M187.7,103.8c-12.2,0-22.1-9.9-22.1-22.2c0-12.2,9.9-22.1,22.1-22.1c12.2,0,22.2,9.9,22.2,22.1
C209.8,93.9,199.9,103.8,187.7,103.8z M187.7,73.5c-4.5,0-8.1,3.7-8.1,8.2s3.7,8.2,8.1,8.2c4.5,0,8.2-3.7,8.2-8.2
S192.2,73.5,187.7,73.5z"
        />
    </svg>
)

export const TestWorkflowIcon = () => (
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 40 40" xmlSpace="preserve">
        <style>{'.s1t1{fill:#355d8b}'}</style>
        <g id="Group_11691" transform="translate(-446.854 -234.341)">
            <circle id="Ellipse_27" cx={466.9} cy={254.3} r={20} fill="#e0f6ff" />
            <g id="Group_11692" transform="translate(456.854 246.341)">
                <path
                    id="Path_4390"
                    className="s1t1"
                    d="M7.5 12.2c-.1 0-.1 0-.2-.1l-2-1.7c-.1-.1-.1-.3 0-.4l2-1.7c.1-.1.3-.1.4 0 .1.1.1.3 0 .4L6 10.2l1.8 1.5c.1.1.1.3 0 .4-.1.1-.2.1-.3.1z"
                />
                <path
                    id="Path_4391"
                    className="s1t1"
                    d="M11.5 12.2c-.2 0-.3-.1-.3-.3 0-.1 0-.2.1-.2l1.8-1.5-1.8-1.5c-.1-.1-.1-.3 0-.4.1-.1.3-.1.4 0l2 1.7c.1.1.1.3 0 .4l-2 1.7c0 .1-.1.1-.2.1z"
                />
                <path
                    id="Path_4392"
                    className="s1t1"
                    d="M8.8 13.5c-.2 0-.3-.2-.3-.4l1.3-6c0-.2.2-.3.4-.3s.3.2.3.4l-1.3 6c-.1.2-.2.3-.4.3z"
                />
                <path
                    id="Path_4393"
                    className="s1t1"
                    d="M16.9 16.8H2.1c-1.2 0-2.1-.9-2.1-2.1V2.1C0 .9.9 0 2.1 0h14.8c1.2 0 2.1.9 2.1 2.1v12.6c.1 1.2-.9 2.1-2.1 2.1zM2.1.6C1.3.6.6 1.3.6 2.1v12.6c0 .8.7 1.5 1.5 1.5h14.8c.8 0 1.5-.7 1.5-1.5V2.1c0-.8-.7-1.5-1.5-1.5H2.1z"
                />
                <path
                    id="Path_4394"
                    className="s1t1"
                    d="M18.7 5H.3C.1 5 0 4.9 0 4.7c0-.2.1-.3.3-.3h18.4c.2 0 .3.2.3.3 0 .2-.1.3-.3.3z"
                />
                <path
                    id="Path_4395"
                    className="s1t1"
                    d="M5.4 3.5c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.5 1-1 1zm0-1.3c-.2 0-.4.1-.4.3s.2.4.4.4.4-.2.4-.4c-.1-.2-.2-.3-.4-.3z"
                />
                <path
                    id="Path_4396"
                    className="s1t1"
                    d="M2.3 3.5c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm0-1.3c-.2 0-.3.1-.3.3s.2.4.4.4.4-.2.4-.4c-.1-.2-.3-.3-.5-.3z"
                />
                <path
                    id="Path_4397"
                    className="s1t1"
                    d="M8.4 3.5c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm0-1.3c-.2 0-.4.2-.4.4s.2.4.4.4.4-.2.4-.4c0-.3-.2-.4-.4-.4z"
                />
            </g>
        </g>
    </svg>
)

export const TriggerIcon =
    'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIzLjAuNCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkNhcGFfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiCgkgdmlld0JveD0iMCAwIDE2IDE2IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAxNiAxNjsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPgoJLnN0MHtmaWxsOiMyREI2Nzc7fQo8L3N0eWxlPgo8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMTMuODcsNi44MkwzLjQ1LDAuOEMyLjU3LDAuMywxLjQ4LDAuOTMsMS40OCwxLjkzdjEyLjAzYzAsMS4wMSwxLjA5LDEuNjQsMS45NywxLjE0bDEwLjQyLTYuMDIKCUMxNC43NCw4LjU4LDE0Ljc0LDcuMzIsMTMuODcsNi44MnoiLz4KPC9zdmc+Cg=='

export const Multiply = () => (
    <svg id="Group_10986" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 7.5 7.5" xmlSpace="preserve">
        <style>{'.stq0{fill:currentColor}'}</style>
        <g id="Group_10984">
            <path
                id="Path_7896"
                className="stq0"
                d="M6.7 7.5c-.2 0-.4-.1-.5-.2l-6-6C-.1 1-.1.5.2.2S1-.1 1.3.2l6 6c.3.3.3.8 0 1.1-.2.1-.4.2-.6.2z"
            />
        </g>
        <g id="Group_10985">
            <path
                id="Path_7897"
                className="stq0"
                d="M.8 7.5c-.5 0-.8-.3-.8-.8 0-.2.1-.4.2-.5l6-6c.3-.3.8-.3 1.1 0s.3.8 0 1.1l-6 6c-.2.1-.4.2-.5.2z"
            />
        </g>
    </svg>
)
export const Tick = () => (
    <svg viewBox="0 0 448 512" className="svg-inline--fa fa-check fa-w-14 fa-2x" version="1.1">
        <path d="M413.505 91.951L133.49 371.966l-98.995-98.995c-4.686-4.686-12.284-4.686-16.971 0L6.211 284.284c-4.686 4.686-4.686 12.284 0 16.971l118.794 118.794c4.686 4.686 12.284 4.686 16.971 0l299.813-299.813c4.686-4.686 4.686-12.284 0-16.971l-11.314-11.314c-4.686-4.686-12.284-4.686-16.97 0z" />
    </svg>
)

export const OpenBrace = () => (
    <svg viewBox="0 0 16 16">
        <path
            fill="fillcolor"
            d="M2.1 3.1c0.2 1.3 0.4 1.6 0.4 2.9 0 0.8-1.5 1.5-1.5 1.5v1c0 0 1.5 0.7 1.5 1.5 0 1.3-0.2 1.6-0.4 2.9-0.3 2.1 0.8 3.1 1.8 3.1s2.1 0 2.1 0v-2c0 0-1.8 0.2-1.8-1 0-0.9 0.2-0.9 0.4-2.9 0.1-0.9-0.5-1.6-1.1-2.1 0.6-0.5 1.2-1.1 1.1-2-0.3-2-0.4-2-0.4-2.9 0-1.2 1.8-1.1 1.8-1.1v-2c0 0-1 0-2.1 0s-2.1 1-1.8 3.1z"
        />
    </svg>
)

export const CloseBrace = () => (
    <svg viewBox="0 0 16 16">
        <path
            fill="fillcolor"
            d="M13.9 3.1c-0.2 1.3-0.4 1.6-0.4 2.9 0 0.8 1.5 1.5 1.5 1.5v1c0 0-1.5 0.7-1.5 1.5 0 1.3 0.2 1.6 0.4 2.9 0.3 2.1-0.8 3.1-1.8 3.1s-2.1 0-2.1 0v-2c0 0 1.8 0.2 1.8-1 0-0.9-0.2-0.9-0.4-2.9-0.1-0.9 0.5-1.6 1.1-2.1-0.6-0.5-1.2-1.1-1.1-2 0.2-2 0.4-2 0.4-2.9 0-1.2-1.8-1.1-1.8-1.1v-2c0 0 1 0 2.1 0s2.1 1 1.8 3.1z"
        />
    </svg>
)

export const ArrowIcon = () => (
    <svg x="0px" y="0px" viewBox="0 0 31.5 31.5">
        <path d="M21.2 5c-.4-.4-1.1-.4-1.6 0-.4.4-.4 1.1 0 1.6l8 8H1.1c-.6 0-1.1.5-1.1 1.1s.5 1.1 1.1 1.1h26.6l-8 8c-.4.4-.4 1.2 0 1.6.4.4 1.1.4 1.6 0l10-10c.4-.4.4-1.1 0-1.6L21.2 5z" />
    </svg>
)

export const MapIcon = () => (
    <svg x="0px" y="0px" viewBox="0 0 143.4 186.3" xmlSpace="preserve">
        <path d="M72.6 0v176s64-76.6 64-112c0-35.3-28.7-64-64-64z" fill="#8386e3" />
        <path d="M8.6 64c0 35.4 64 112 64 112V0c-35.4 0-64 28.7-64 64z" fill="#767dd3" />
        <path d="M48.6 56c0 13.3 10.7 24 24 24V32c-13.3 0-24 10.7-24 24z" fill="#f1f2f2" />
        <path d="M72.6 32v48c13.3 0 24-10.7 24-24s-10.8-24-24-24z" fill="#f9f9f9" />
    </svg>
)

export const MenWithArrowIcon = () => (
    <svg id="OBJECT" x="0px" y="0px" viewBox="0 0 257.5 224.4" xmlSpace="preserve">
        <style>
            {
                '.menst0{fill:#fff}.menst1st1{opacity:.45;fill:#c3bcf5}.menst1st2{fill:#6dd5b0}.menst3st3{opacity:.45;fill:#db4b86}.st7{opacity:.5}.st13{opacity:.45}.st18{fill:#c3bcf5}.st56,.st57,.st58{fill:#6560a2}.st57,.st58{opacity:.25}.st58{opacity:.45}.st59,.st60{fill:#858bcf}.st60{opacity:.45}'
            }
        </style>
        <path className="menst0" d="M132.9 11H135.6V195.1H132.9z" />
        <path className="menst1" d="M132.9 12.4H134.20000000000002V195.1H132.9z" />
        <path
            className="menst2"
            d="M61.6 52.2c24.8 11.7 49.5-11.7 74.3 0V10.4c-24.8-11.7-49.5 11.7-74.3 0 4 8.7 7.9 16.6 11.9 23.8-4 6.7-7.9 12.8-11.9 18z"
        />
        <path
            className="menst3"
            d="M115.8 49c-3.3.3-6.6.9-9.9 1.6V8.8c3.3-.7 6.6-1.3 9.9-1.6V49zM66 12.1c4.7 1.5 9.4 1.8 14.1 1.6v41.8c-4.7.3-9.4-.1-14.1-1.6V46c2.5-3.7 5-7.6 7.5-11.9-2.5-4.5-5-9.3-7.5-14.4v-7.6zM91.9 12c2-.4 3.9-.9 5.9-1.3v41.8c-2 .5-3.9.9-5.9 1.3V12z"
        />
        <path
            d="M61.6 52.2c2.4-3.1 4.7-6.5 7.1-10.2 5.9 19.6 41.3 6.5 56.6-2.1 11.7-6.6 8.8-22.4 5.9-31.3 1.5.5 3.1 1.1 4.6 1.8v41.8c-24.7-11.7-49.4 11.7-74.2 0z"
            fill="#53bc93"
        />
        <linearGradient
            id="SVGID_1_"
            gradientUnits="userSpaceOnUse"
            x1={790.7953}
            y1={171.6832}
            x2={855.7634}
            y2={171.6832}
            gradientTransform="matrix(-1 0 0 1 912.618 0)"
        >
            <stop offset={0} stopColor="#ad286b" />
            <stop offset={1} stopColor="#45296b" />
        </linearGradient>
        <path
            d="M100.5 147.8s16.6 9.6 19.8 21.7c3.2 12.1.2 20.8.2 20.8s-6 2.2-14.5-1.7c0 0 1.4-7-.7-9.6-2-2.6-13.5-9.6-17.1-15.2l-15.4 35.3s-9.7 3.8-16-1.7L69 159.6s-3.6-9.9-.3-15c3.2-5.1 31.8 3.2 31.8 3.2z"
            fill="url(#SVGID_1_)"
        />
        <linearGradient
            id="SVGID_2_"
            gradientUnits="userSpaceOnUse"
            x1={790.8042}
            y1={169.4994}
            x2={854.0726}
            y2={169.4994}
            gradientTransform="matrix(-1 0 0 1 912.618 0)"
        >
            <stop offset={0} stopColor="#ad286b" />
            <stop offset={1} stopColor="#45296b" />
        </linearGradient>
        <path
            d="M69 159.6s-3.6-9.9-.3-15c3.2-5.1 31.9 3.2 31.9 3.2s.9.5 2.4 1.5c-2.3 5.5-16.1 5.6-14.5 9 1.8 3.8 18.3 16.2 26.7 18.8 3.3 1 5.3.4 6.5-.7.8 8.4-1.1 13.9-1.1 13.9s-6 2.2-14.5-1.7c0 0 1.4-7-.7-9.6-2-2.6-13.5-9.6-17.1-15.2l-.3.6c-1.9-2.2-3.4-.6-3.4-.6s-7.7 17-9.6 23.9c-.9 3.3-.6 5.5-.1 6.8l-.6 1.4-15.7-3.9L69 159.6z"
            fill="url(#SVGID_2_)"
        />
        <g className="st7">
            <linearGradient
                id="SVGID_3_"
                gradientUnits="userSpaceOnUse"
                x1={802.0344}
                y1={180.8854}
                x2={806.9919}
                y2={180.8854}
                gradientTransform="matrix(-1 0 0 1 912.618 0)"
            >
                <stop offset={0.1541} stopColor="#889beb" />
                <stop offset={1} stopColor="#889beb" />
            </linearGradient>
            <path
                d="M110.6 182.7c.1-.1-2.3-2.1-2.3-2.1s-2.6-1.7-2.6-1.6c-.1.1 2.3 2.1 2.3 2.1s2.5 1.8 2.6 1.6z"
                fill="url(#SVGID_3_)"
            />
            <linearGradient
                id="SVGID_4_"
                gradientUnits="userSpaceOnUse"
                x1={823.9196}
                y1={161.2623}
                x2={832.5079}
                y2={161.2623}
                gradientTransform="matrix(-1 0 0 1 912.618 0)"
            >
                <stop offset={0.1541} stopColor="#889beb" />
                <stop offset={1} stopColor="#889beb" />
            </linearGradient>
            <path
                d="M80.1 158.2c-.1 0 .5 1.3 1.6 2.2.5.4 1.1.8 1.5 1.1.4.3.7.4.7.4l2.4 1.2c1.2.6 2.2 1.4 2.3 1.3.1-.1-.9-1-2.1-1.7-.6-.3-1.2-.7-1.6-.9-.4-.2-.7-.4-.7-.4s-.3-.2-.7-.4c-.4-.2-1-.6-1.5-1-1.1-.7-1.8-1.9-1.9-1.8z"
                fill="url(#SVGID_4_)"
            />
            <linearGradient
                id="SVGID_5_"
                gradientUnits="userSpaceOnUse"
                x1={841.2853}
                y1={160.3712}
                x2={843.4875}
                y2={160.3712}
                gradientTransform="matrix(-1 0 0 1 912.618 0)"
            >
                <stop offset={0.1541} stopColor="#889beb" />
                <stop offset={1} stopColor="#889beb" />
            </linearGradient>
            <path
                d="M71.3 162c0-.1-.3-.4-.6-.8s-.5-.8-.5-.8-.3-.4-.5-.8-.4-.9-.5-.9c-.1 0-.1.5.1 1.1.1.5.4 1 .4 1s.3.4.7.8c.4.3.9.5.9.4z"
                fill="url(#SVGID_5_)"
            />
            <g>
                <linearGradient
                    id="SVGID_6_"
                    gradientUnits="userSpaceOnUse"
                    x1={811.075}
                    y1={152.1316}
                    x2={822.1273}
                    y2={152.1316}
                    gradientTransform="matrix(-1 0 0 1 912.618 0)"
                >
                    <stop offset={0.1541} stopColor="#889beb" />
                    <stop offset={1} stopColor="#889beb" />
                </linearGradient>
                <path
                    d="M90.5 154.2c0 .1 1.5.2 3.1 0 1.5-.2 3-.7 3-.7s1.4-.6 2.7-1.5c1.3-.9 2.3-2 2.3-2.1-.1-.1-1.2 1-2.5 1.7-1.3.8-2.7 1.3-2.7 1.3s-1.4.6-2.9.9c-1.5.3-3 .3-3 .4z"
                    fill="url(#SVGID_6_)"
                />
            </g>
            <g>
                <linearGradient
                    id="SVGID_7_"
                    gradientUnits="userSpaceOnUse"
                    x1={826.1943}
                    y1={154.0639}
                    x2={830.9155}
                    y2={154.0639}
                    gradientTransform="matrix(-1 0 0 1 912.618 0)"
                >
                    <stop offset={0.1541} stopColor="#889beb" />
                    <stop offset={1} stopColor="#889beb" />
                </linearGradient>
                <path
                    d="M81.7 153.7c0 .1.6.3 1.1.4.6.2 1.2.3 1.2.3s.6.1 1.2.1 1.2 0 1.2-.1-.6-.2-1.2-.3l-1.2-.2s-.6-.1-1.2-.1c-.5-.1-1.1-.2-1.1-.1z"
                    fill="url(#SVGID_7_)"
                />
            </g>
        </g>
        <g className="st13">
            <linearGradient
                id="SVGID_8_"
                gradientUnits="userSpaceOnUse"
                x1={792.6992}
                y1={170.8392}
                x2={795.6309}
                y2={170.8392}
                gradientTransform="matrix(-1 0 0 1 912.618 0)"
            >
                <stop offset={0.1541} stopColor="#889beb" />
                <stop offset={1} stopColor="#889beb" />
            </linearGradient>
            <path
                d="M117 165.9c-.1 0 .6 1.2 1 2.4.5 1.2.8 2.5.8 2.5s.4 1.2.6 2.5c.2 1.3.3 2.6.4 2.6.1 0 .2-1.3 0-2.6-.1-1.3-.5-2.6-.5-2.6s-.4-1.3-1-2.5c-.5-1.3-1.2-2.4-1.3-2.3z"
                fill="url(#SVGID_8_)"
            />
            <linearGradient
                id="SVGID_9_"
                gradientUnits="userSpaceOnUse"
                x1={796.6043}
                y1={162.2132}
                x2={799.0945}
                y2={162.2132}
                gradientTransform="matrix(-1 0 0 1 912.618 0)"
            >
                <stop offset={0.1541} stopColor="#889beb" />
                <stop offset={1} stopColor="#889beb" />
            </linearGradient>
            <path
                d="M113.5 160.4c-.1 0 .2.5.5 1s.6.9.6.9.3.4.7.9c.3.4.7.9.7.8.1 0-.2-.5-.4-1-.3-.5-.5-1-.5-1s-.3-.4-.7-.9c-.4-.3-.8-.7-.9-.7z"
                fill="url(#SVGID_9_)"
            />
            <g>
                <linearGradient
                    id="SVGID_10_"
                    gradientUnits="userSpaceOnUse"
                    x1={829.3475}
                    y1={177.9742}
                    x2={834.4534}
                    y2={177.9742}
                    gradientTransform="matrix(-1 0 0 1 912.618 0)"
                >
                    <stop offset={0.1541} stopColor="#889beb" />
                    <stop offset={1} stopColor="#889beb" />
                </linearGradient>
                <path
                    d="M78.2 184.4c.1 0 .8-1.5 1.6-3.1l1.4-3.2 1.2-3.2c.6-1.6 1.1-3.3 1-3.3-.1 0-.7 1.6-1.4 3.2s-1.3 3.2-1.3 3.2l-1.2 3.2c-.8 1.5-1.4 3.1-1.3 3.2z"
                    fill="url(#SVGID_10_)"
                />
            </g>
            <g>
                <linearGradient
                    id="SVGID_11_"
                    gradientUnits="userSpaceOnUse"
                    x1={835.551}
                    y1={187.706}
                    x2={836.7198}
                    y2={187.706}
                    gradientTransform="matrix(-1 0 0 1 912.618 0)"
                >
                    <stop offset={0.1541} stopColor="#889beb" />
                    <stop offset={1} stopColor="#889beb" />
                </linearGradient>
                <path
                    d="M75.9 188.7c.1.1.8-.9.8-.9s.4-1.1.3-1.1c-.1-.1-.8.9-.8.9s-.4 1-.3 1.1z"
                    fill="url(#SVGID_11_)"
                />
            </g>
        </g>
        <path
            className="st18"
            d="M125.4 138.9s9.1 2.5 11.7-3.5c2.7-6-1.2-9.3-1.2-9.3l-3 1.4v-2.3s-8.3 1.3-11 6.5c-2.5 5.2 3.5 7.2 3.5 7.2z"
        />
        <path
            className="st1"
            d="M125.4 138.9s-6-2-3.4-7.2c2.7-5.2 11-6.5 11-6.5v2.1c-1 .6-2.8.6-3.8.8-1.9.4-5.4 5 1.1 5.4 4.7.3 6.4-3.6 6.9-5.7.8 1.6 1.4 4.1-.2 7.5-2.5 6.1-11.6 3.6-11.6 3.6z"
        />
        <g className="st7">
            <path
                className="st18"
                d="M128.4 128.3c0 .1.9 0 1.7 0 .9 0 1.7-.1 1.7-.1s.9-.1 1.7-.5c.8-.3 1.5-1 1.4-1.1 0 0-.7.5-1.5.7-.8.2-1.6.3-1.6.3s-.8.1-1.7.2c-.9.2-1.8.4-1.7.5zM126.2 134.9c.1 0 .2-.5.2-1.1 0-.5-.1-1.1-.1-1.1s-.2-.5-.5-1-.7-.8-.8-.8c-.1.1.2.5.4 1s.3.9.3.9.2.5.3 1c.1.6.1 1.1.2 1.1zM127.1 138.1c.1 0 .3-.5.4-1.1.1-.6.1-1.1.1-1.1s0-.6-.2-1.1c-.1-.6-.4-1.1-.5-1.1-.1 0 0 .6.1 1.1v2.2c.1.5.1 1 .1 1.1zM135.8 134.8c.1 0 .2-.7.6-1.4.3-.7.7-1.4.7-1.4s.3-.7.6-1.5c.2-.8.1-1.6 0-1.6s-.1.8-.4 1.5c-.3.7-.7 1.4-.7 1.4s-.3.7-.6 1.5c-.3.7-.3 1.5-.2 1.5z"
            />
        </g>
        <linearGradient
            id="SVGID_12_"
            gradientUnits="userSpaceOnUse"
            x1={786.9285}
            y1={126.114}
            x2={852.3305}
            y2={126.114}
            gradientTransform="matrix(-1 0 0 1 912.618 0)"
        >
            <stop offset={0} stopColor="#faf453" />
            <stop offset={0.6645} stopColor="#cc795a" />
            <stop offset={1} stopColor="#bb3e64" />
        </linearGradient>
        <path
            d="M99 105.9s3.4 6.4 4.8 12.5c1.4 6 2.2 11.2 2.2 11.2s10.8 4 17.1 1c0 0 3.2 3 2.4 10.6 0 0-9.8 6.6-24.3 3v4.8s-8.6 5.4-23.5 3c-14.9-2.4-17.5-8.8-17.5-8.8s3.8-39.8 10.6-43c7-3.2 28.2 5.7 28.2 5.7z"
            fill="url(#SVGID_12_)"
        />
        <linearGradient
            id="SVGID_13_"
            gradientUnits="userSpaceOnUse"
            x1={786.9282}
            y1={126.114}
            x2={852.3305}
            y2={126.114}
            gradientTransform="matrix(-1 0 0 1 912.618 0)"
        >
            <stop offset={0} stopColor="#faf453" />
            <stop offset={0.6645} stopColor="#cc795a" />
            <stop offset={1} stopColor="#bb3e64" />
        </linearGradient>
        <path
            d="M70.9 100.2c6.8-3.2 28.1 5.6 28.1 5.6s.5.9 1.1 2.2c-1.6 0-3.5.3-5.1 1.2-4 2.1-1.6 24.5 4 24.7 4.2.2 5.7-6.5 6.1-9.8.6 3.2 1 5.4 1 5.4s.6.2 1.6.5c.6 3.7 2.8 11.7 10.2 10 6.9-1.6 5.9-7.6 5.4-9.4.4.5 3.1 3.6 2.3 10.6 0 0-9.8 6.6-24.3 3v4.8s-8.6 5.4-23.5 3c-14.9-2.4-17.5-8.8-17.5-8.8s3.8-39.7 10.6-43z"
            fill="url(#SVGID_13_)"
        />
        <linearGradient
            id="SVGID_14_"
            gradientUnits="userSpaceOnUse"
            x1={790.3484}
            y1={136.5104}
            x2={791.9768}
            y2={136.5104}
            gradientTransform="matrix(-1 0 0 1 912.618 0)"
        >
            <stop offset={0} stopColor="#3f4068" />
            <stop offset={1} stopColor="#594068" />
        </linearGradient>
        <path
            d="M121.7 141c.1 0 .4-1.1.5-2.3.1-1.2 0-2.3 0-2.3s-.2-1.2-.6-2.3c-.4-1.1-.9-2.1-1-2.1-.1 0 .4 1.1.6 2.2.3 1.1.4 2.2.4 2.2s.2 1.1.2 2.2c0 1.2-.1 2.3-.1 2.4z"
            fill="url(#SVGID_14_)"
        />
        <linearGradient
            id="SVGID_15_"
            gradientUnits="userSpaceOnUse"
            x1={791.9919}
            y1={135.8136}
            x2={792.8029}
            y2={135.8136}
            gradientTransform="matrix(-1 0 0 1 912.618 0)"
        >
            <stop offset={0} stopColor="#3f4068" />
            <stop offset={1} stopColor="#594068" />
        </linearGradient>
        <path
            d="M120.4 138.4c.1 0 .2-.6.2-1.3v-1.3s-.1-.7-.3-1.3c-.2-.6-.4-1.3-.5-1.2-.1 0 0 .7.1 1.3.1.6.1 1.3.1 1.3s.1.6.2 1.3c.1.5.1 1.2.2 1.2z"
            fill="url(#SVGID_15_)"
        />
        <linearGradient
            id="SVGID_16_"
            gradientUnits="userSpaceOnUse"
            x1={806.2582}
            y1={132.2651}
            x2={806.9769}
            y2={132.2651}
            gradientTransform="matrix(-1 0 0 1 912.618 0)"
        >
            <stop offset={0} stopColor="#3f4068" />
            <stop offset={1} stopColor="#594068" />
        </linearGradient>
        <path
            d="M105.7 135.6c.1 0 .3-.8.5-1.6s.2-1.7.2-1.7 0-.8-.1-1.7c-.1-.8-.3-1.6-.3-1.6-.1 0 0 .8-.1 1.7 0 .8-.1 1.6-.1 1.6s0 .8-.1 1.6c0 .8-.1 1.6 0 1.7z"
            fill="url(#SVGID_16_)"
        />
        <linearGradient
            id="SVGID_17_"
            gradientUnits="userSpaceOnUse"
            x1={804.9127}
            y1={132.9749}
            x2={805.937}
            y2={132.9749}
            gradientTransform="matrix(-1 0 0 1 912.618 0)"
        >
            <stop offset={0} stopColor="#3f4068" />
            <stop offset={1} stopColor="#594068" />
        </linearGradient>
        <path
            d="M107.6 135.7c.1 0 .1-.7 0-1.4 0-.7-.1-1.4-.1-1.4s-.1-.7-.3-1.3c-.2-.7-.4-1.3-.5-1.3-.1 0 0 .7.1 1.4l.2 1.4s.1.7.3 1.3c.1.6.3 1.3.3 1.3z"
            fill="url(#SVGID_17_)"
        />
        <g>
            <linearGradient
                id="SVGID_18_"
                gradientUnits="userSpaceOnUse"
                x1={812.2211}
                y1={126.3195}
                x2={824.3411}
                y2={126.3195}
                gradientTransform="matrix(-1 0 0 1 912.618 0)"
            >
                <stop offset={0} stopColor="#3f4068" />
                <stop offset={1} stopColor="#594068" />
            </linearGradient>
            <path
                d="M92.4 108.6s-.1 0-.2.1-.3.2-.5.4c-.4.3-1 .9-1.6 1.8-.5.8-1 1.9-1.3 3.1-.3 1.2-.5 2.5-.5 3.8-.1 2.6.2 5.2.4 7.1.2 1.9.5 3.2.5 3.2s.2 1.3.7 3.1c.5 1.9 1.3 4.3 2.7 6.6 1.3 2.2 3.2 4.1 4.9 5.1.8.5 1.5.9 2.1 1.1.3.1.5.2.6.2.1 0 .2.1.2.1s-.3-.1-.8-.4c-.5-.2-1.2-.6-2-1.2-1.6-1.1-3.4-3-4.6-5.2-1.3-2.2-2.1-4.6-2.6-6.5-.5-1.9-.7-3.1-.7-3.1s-.2-1.3-.5-3.2c-.3-1.9-.6-4.4-.6-7 0-1.3.2-2.5.4-3.7.3-1.2.7-2.2 1.2-3 1.1-1.8 2.3-2.4 2.2-2.4z"
                fill="url(#SVGID_18_)"
            />
        </g>
        <g>
            <linearGradient
                id="SVGID_19_"
                gradientUnits="userSpaceOnUse"
                x1={812.4616}
                y1={149.1445}
                x2={824.3341}
                y2={149.1445}
                gradientTransform="matrix(-1 0 0 1 912.618 0)"
            >
                <stop offset={0} stopColor="#3f4068" />
                <stop offset={1} stopColor="#594068" />
            </linearGradient>
            <path
                d="M88.3 150.5c0 .1 1.5.2 3.1.1s3.1-.4 3.1-.4 1.5-.4 3-1c1.4-.6 2.8-1.4 2.7-1.5 0-.1-1.4.6-2.9 1.1-1.4.5-2.9.8-2.9.8s-1.5.4-3 .6c-1.6.2-3.1.2-3.1.3z"
                fill="url(#SVGID_19_)"
            />
        </g>
        <g>
            <linearGradient
                id="SVGID_20_"
                gradientUnits="userSpaceOnUse"
                x1={818.5452}
                y1={149.3743}
                x2={827.5625}
                y2={149.3743}
                gradientTransform="matrix(-1 0 0 1 912.618 0)"
            >
                <stop offset={0} stopColor="#3f4068" />
                <stop offset={1} stopColor="#594068" />
            </linearGradient>
            <path
                d="M85.1 149.4c0 .1 1.1.5 2.2.6 1.2.2 2.3.1 2.3.1s1.2-.1 2.3-.5c1.1-.3 2.2-.9 2.1-.9 0-.1-1.1.3-2.2.6-1.1.2-2.2.3-2.2.3s-1.1.1-2.3.1c-1.1-.2-2.2-.4-2.2-.3z"
                fill="url(#SVGID_20_)"
            />
        </g>
        <g className="st13">
            <linearGradient
                id="SVGID_21_"
                gradientUnits="userSpaceOnUse"
                x1={794.4963}
                y1={133.3594}
                x2={797.1304}
                y2={133.3594}
                gradientTransform="matrix(-1 0 0 1 912.618 0)"
            >
                <stop offset={0} stopColor="#3f4068" />
                <stop offset={1} stopColor="#594068" />
            </linearGradient>
            <path
                d="M115.5 133.4c0 .1.3.2.7.2.3.1.7.1.7.1s.3 0 .7-.1c.3-.1.6-.2.6-.3s-.3-.1-.7-.1h-.7s-.3 0-.6.1c-.4-.1-.7 0-.7.1z"
                fill="url(#SVGID_21_)"
            />
            <linearGradient
                id="SVGID_22_"
                gradientUnits="userSpaceOnUse"
                x1={799.0708}
                y1={132.482}
                x2={803.0941}
                y2={132.482}
                gradientTransform="matrix(-1 0 0 1 912.618 0)"
            >
                <stop offset={0} stopColor="#3f4068" />
                <stop offset={1} stopColor="#594068" />
            </linearGradient>
            <path
                d="M109.5 131.8c0 .1.4.4.9.6.5.3 1 .4 1 .4s.5.1 1.1.2c.5.1 1.1 0 1.1 0 0-.1-.5-.2-1-.4s-1-.3-1-.3-.5-.1-1-.3c-.5 0-1-.2-1.1-.2z"
                fill="url(#SVGID_22_)"
            />
            <g>
                <linearGradient
                    id="SVGID_23_"
                    gradientUnits="userSpaceOnUse"
                    x1={809.6295}
                    y1={118.3906}
                    x2={812.8251}
                    y2={118.3906}
                    gradientTransform="matrix(-1 0 0 1 912.618 0)"
                >
                    <stop offset={0} stopColor="#3f4068" />
                    <stop offset={1} stopColor="#594068" />
                </linearGradient>
                <path
                    d="M103 124.9c.1 0-.1-1.7-.3-3.4-.3-1.7-.6-3.3-.6-3.3s-.4-1.6-1-3.2c-.5-1.6-1.2-3.2-1.2-3.1-.1 0 .4 1.6.9 3.2l.8 3.2s.4 1.6.8 3.3c.2 1.7.5 3.3.6 3.3z"
                    fill="url(#SVGID_23_)"
                />
            </g>
            <g>
                <linearGradient
                    id="SVGID_24_"
                    gradientUnits="userSpaceOnUse"
                    x1={808.3777}
                    y1={128.848}
                    x2={808.9947}
                    y2={128.848}
                    gradientTransform="matrix(-1 0 0 1 912.618 0)"
                >
                    <stop offset={0} stopColor="#3f4068" />
                    <stop offset={1} stopColor="#594068" />
                </linearGradient>
                <path
                    d="M104.1 131c.2 0 .1-2.2.1-2.2s-.3-2.1-.5-2.1-.1 2.2-.1 2.2.4 2.1.5 2.1z"
                    fill="url(#SVGID_24_)"
                />
            </g>
        </g>
        <g>
            <g fill="#ffc3a9">
                <path d="M96.4 64.9s3.3 7.5 2.5 16.6c-.8 9.1-4.7 11.6-13.6 10.8-8.9-.8-11.6-8.6-11.6-8.6s16-24.9 22.7-18.8z" />
                <path
                    d="M96.4 64.9s1 2.2 1.8 5.7c-.5-.1-1-.2-1.7-.6l-1.9 1.9s1.4.9-.5 3.6c0 0 1.3 4.3-3 6.6l-.7 2.5s4.9 2.2 7.8 1.2c-1.5 5-4.7 6.7-10.5 6.6-4-4.9-6.7-11.2-8.4-16.4 5.2-6.7 13-14.9 17.1-11.1z"
                    opacity={0.45}
                />
            </g>
            <linearGradient
                id="SVGID_25_"
                gradientUnits="userSpaceOnUse"
                x1={810.7844}
                y1={62.7477}
                x2={819.2053}
                y2={62.7477}
                gradientTransform="matrix(-1 0 0 1 912.618 0)"
            >
                <stop offset={0} stopColor="#3f4068" />
                <stop offset={1} stopColor="#594068" />
            </linearGradient>
            <path
                d="M94 58.5s1-3.4 3.5-2.3c2.5 1.2.5 3.8.5 3.8s2.1-1.3 3.1 1.2c1 2.6-1 2.8-1 2.8s3.8 3.4.3 5.1c-3.6 1.8-8.7-4.9-6.4-10.6z"
                fill="url(#SVGID_25_)"
            />
            <linearGradient
                id="SVGID_26_"
                gradientUnits="userSpaceOnUse"
                x1={818.9841}
                y1={78.6034}
                x2={839.0576}
                y2={78.6034}
                gradientTransform="matrix(-1 0 0 1 912.618 0)"
            >
                <stop offset={0} stopColor="#3f4068" />
                <stop offset={1} stopColor="#594068" />
            </linearGradient>
            <path
                d="M92.4 70.9s2.7 1.9.3 4.1c0 0 1.8 4.7-3.6 6 0 0 1.2 3.2-2.9 5.6-4.2 2.4-11.1 1-12.4-2.8C72.3 80 84 65 92.4 70.9z"
                fill="url(#SVGID_26_)"
            />
            <g className="st13">
                <linearGradient
                    id="SVGID_27_"
                    gradientUnits="userSpaceOnUse"
                    x1={813.8239}
                    y1={62.5012}
                    x2={816.1072}
                    y2={62.5012}
                    gradientTransform="matrix(-1 0 0 1 912.618 0)"
                >
                    <stop offset={0} stopColor="#3f4068" />
                    <stop offset={1} stopColor="#594068" />
                </linearGradient>
                <path
                    d="M97.6 65.8s.3 0 .6-.4c.3-.3.6-.8.6-1.4 0-.6-.2-1.2-.6-1.5-.2-.2-.4-.2-.5-.3h-.1v-.1c.1-.4.2-.9.1-1.4-.1-.5-.3-1-.6-1.2-.2-.3-.5-.4-.5-.4s.6.7.7 1.7c0 .4 0 .9-.2 1.2 0 0 0 .1-.1.1 0 .1-.1.2-.1.2-.1.1-.2.3-.2.4-.1.2-.2.3-.2.4.4-.1.6-.2.7-.2h.4c.1 0 .2.1.3.2.3.2.5.6.5 1.1 0 .5-.1.9-.3 1.2-.3.3-.5.4-.5.4z"
                    fill="url(#SVGID_27_)"
                />
                <linearGradient
                    id="SVGID_28_"
                    gradientUnits="userSpaceOnUse"
                    x1={823.6951}
                    y1={80.312}
                    x2={826.332}
                    y2={80.312}
                    gradientTransform="matrix(-1 0 0 1 912.618 0)"
                >
                    <stop offset={0} stopColor="#3f4068" />
                    <stop offset={1} stopColor="#594068" />
                </linearGradient>
                <path
                    d="M86.3 81.5c0 .1.5.2 1 0s.9-.5.9-.5.4-.4.6-.9c.2-.5.1-1 .1-1-.1 0-.2.5-.4.9s-.6.7-.6.7-.3.3-.7.6c-.4 0-.9.1-.9.2z"
                    fill="url(#SVGID_28_)"
                />
                <g>
                    <linearGradient
                        id="SVGID_29_"
                        gradientUnits="userSpaceOnUse"
                        x1={827.6131}
                        y1={84.3029}
                        x2={834.4791}
                        y2={84.3029}
                        gradientTransform="matrix(-1 0 0 1 912.618 0)"
                    >
                        <stop offset={0} stopColor="#3f4068" />
                        <stop offset={1} stopColor="#594068" />
                    </linearGradient>
                    <path
                        d="M78.2 84.3s-.1.3.2.8c.2.4.9.9 1.6.8.3 0 .7-.2.9-.4l.2-.1.1.1c.2.2.4.3.5.4.1.1.2.1.2.1s.4.1.9.1c.5-.1 1.2-.4 1.5-.9.8-1.1.8-2.4.7-2.4-.1 0-.2 1.2-1 2.1-.4.4-.9.6-1.3.7-.4 0-.6-.1-.6-.1s-.1 0-.2-.1c-.1 0-.2-.1-.4-.2v-.1l-.1-.1c-.1-.1-.2-.1-.3-.1-.1 0-.2.1-.3.1l-.2.2c-.2.2-.4.3-.7.3-.5.1-1.1-.2-1.3-.5-.3-.4-.4-.7-.4-.7z"
                        fill="url(#SVGID_29_)"
                    />
                </g>
            </g>
            <linearGradient
                id="SVGID_30_"
                gradientUnits="userSpaceOnUse"
                x1={812.1647}
                y1={63.9444}
                x2={812.4573}
                y2={63.9444}
                gradientTransform="matrix(-1 0 0 1 912.618 0)"
            >
                <stop offset={0} stopColor="#3f4068" />
                <stop offset={1} stopColor="#594068" />
            </linearGradient>
            <path d="M100.3 64l-.2-.2c.1 0 .2.1.3.1 0 .1 0 .1-.1.1z" opacity={0.25} fill="url(#SVGID_30_)" />
            <linearGradient
                id="SVGID_31_"
                gradientUnits="userSpaceOnUse"
                x1={810.7838}
                y1={62.7477}
                x2={819.2053}
                y2={62.7477}
                gradientTransform="matrix(-1 0 0 1 912.618 0)"
            >
                <stop offset={0} stopColor="#3f4068" />
                <stop offset={1} stopColor="#594068" />
            </linearGradient>
            <path
                d="M97.5 56.2c.3.1.5.3.6.4-1.5 0-3.2.3-1.7 1.9 2.1 2.4.8 3.8.5 4.1.3-.2 1.1-.7 1.7.7.7 1.7-1.5 4.3 1 3.5 1.3-.5 1.4-1.2 1.2-1.9.9 1.1 2 3.2-.4 4.4-3.5 1.7-8.6-5-6.4-10.7 0-.1 1-3.5 3.5-2.4z"
                opacity={0.25}
                fill="url(#SVGID_31_)"
            />
            <linearGradient
                id="SVGID_32_"
                gradientUnits="userSpaceOnUse"
                x1={819.036}
                y1={78.6033}
                x2={839.0576}
                y2={78.6033}
                gradientTransform="matrix(-1 0 0 1 912.618 0)"
            >
                <stop offset={0} stopColor="#3f4068" />
                <stop offset={1} stopColor="#594068" />
            </linearGradient>
            <path
                d="M92.4 70.9s1 .7 1.2 1.8c-.4 1-1.2 2.5-2.9 3.8L89 78.1s.9 1.4-.9 2.7c-1.8 1.3-2.7.8-2.7.8l-.8 2.8s1.9 1.8 3.9.1c-.5.7-1.2 1.4-2.4 2.1-4.2 2.4-11.1 1-12.4-2.8C72.3 80 84 65 92.4 70.9z"
                opacity={0.25}
                fill="url(#SVGID_32_)"
            />
            <g>
                <linearGradient
                    id="SVGID_33_"
                    gradientUnits="userSpaceOnUse"
                    x1={816.8459}
                    y1={70.0933}
                    x2={852.2563}
                    y2={70.0933}
                    gradientTransform="matrix(-1 0 0 1 912.618 0)"
                >
                    <stop offset={0} stopColor="#ad286b" />
                    <stop offset={1} stopColor="#45296b" />
                </linearGradient>
                <path
                    d="M93.9 56.8s3.1 5.4 1.4 11.4c-1.6 6-12.8 16.2-18.8 17s-5.8-1.8-5.8-1.8-4 1.8-7.9-.7c-4-2.5-4.5-17.3 8.8-22.2s16.7-7.5 22.3-3.7z"
                    fill="url(#SVGID_33_)"
                />
                <g className="st13">
                    <linearGradient
                        id="SVGID_34_"
                        gradientUnits="userSpaceOnUse"
                        x1={836.4218}
                        y1={80.0487}
                        x2={844.7703}
                        y2={80.0487}
                        gradientTransform="matrix(-1 0 0 1 912.618 0)"
                    >
                        <stop offset={0.1541} stopColor="#889beb" />
                        <stop offset={1} stopColor="#889beb" />
                    </linearGradient>
                    <path
                        d="M67.8 83.7s.4 0 .9-.1 1.2-.3 1.9-.6 1.3-.8 1.7-1.2l.7-.7s1-1.1 1.8-2.3c.8-1.2 1.5-2.5 1.4-2.5-.1 0-.9 1.2-1.7 2.3-.9 1.1-1.9 2.2-1.9 2.2s-.2.3-.6.7c-.4.4-.9.8-1.5 1.2-1.3.6-2.7 1-2.7 1z"
                        fill="url(#SVGID_34_)"
                    />
                    <linearGradient
                        id="SVGID_35_"
                        gradientUnits="userSpaceOnUse"
                        x1={837.0812}
                        y1={81.6939}
                        x2={842.0597}
                        y2={81.6939}
                        gradientTransform="matrix(-1 0 0 1 912.618 0)"
                    >
                        <stop offset={0.1541} stopColor="#889beb" />
                        <stop offset={1} stopColor="#889beb" />
                    </linearGradient>
                    <path
                        d="M70.6 82.9c0 .1.7.1 1.5-.1.7-.1 1.4-.5 1.4-.5s.7-.4 1.2-.8c.6-.5 1-1.1.9-1.1-.1-.1-.6.4-1.2.8s-1.2.7-1.2.7-.6.3-1.3.6c-.6.2-1.3.3-1.3.4z"
                        fill="url(#SVGID_35_)"
                    />
                    <g>
                        <linearGradient
                            id="SVGID_36_"
                            gradientUnits="userSpaceOnUse"
                            x1={818.3638}
                            y1={64.5093}
                            x2={821.3744}
                            y2={64.5093}
                            gradientTransform="matrix(-1 0 0 1 912.618 0)"
                        >
                            <stop offset={0.1541} stopColor="#889beb" />
                            <stop offset={1} stopColor="#889beb" />
                        </linearGradient>
                        <path
                            d="M91.2 70.8c.1 0 1-1.3 1.7-2.8.7-1.5 1-3.1 1-3.1s.3-1.6.3-3.3c0-1.7-.4-3.3-.5-3.3-.1 0 .2 1.6.1 3.3-.1 1.6-.4 3.2-.4 3.2s-.3 1.6-.8 3.1c-.6 1.4-1.4 2.8-1.4 2.9z"
                            fill="url(#SVGID_36_)"
                        />
                    </g>
                    <g>
                        <linearGradient
                            id="SVGID_37_"
                            gradientUnits="userSpaceOnUse"
                            x1={823.0159}
                            y1={77.6074}
                            x2={834.4358}
                            y2={77.6074}
                            gradientTransform="matrix(-1 0 0 1 912.618 0)"
                        >
                            <stop offset={0.1541} stopColor="#889beb" />
                            <stop offset={1} stopColor="#889beb" />
                        </linearGradient>
                        <path
                            d="M78.2 82.5c0 .1 1.8-.7 3.4-1.8 1.6-1 3.1-2.3 3.1-2.3s1.4-1.3 2.7-2.7c1.3-1.4 2.3-3 2.3-3.1-.1 0-1.2 1.5-2.5 2.8-1.3 1.4-2.8 2.6-2.8 2.6s-1.4 1.3-2.9 2.3c-1.7 1.2-3.4 2.1-3.3 2.2z"
                            fill="url(#SVGID_37_)"
                        />
                    </g>
                </g>
                <linearGradient
                    id="SVGID_38_"
                    gradientUnits="userSpaceOnUse"
                    x1={816.8459}
                    y1={70.4171}
                    x2={852.2533}
                    y2={70.4171}
                    gradientTransform="matrix(-1 0 0 1 912.618 0)"
                >
                    <stop offset={0} stopColor="#ad286b" />
                    <stop offset={1} stopColor="#45296b" />
                </linearGradient>
                <path
                    d="M76.5 85.1c-6 .7-5.8-1.8-5.8-1.8s-4 1.8-7.9-.7c-3.3-2.1-4.2-12.4 3-18.7-2.5 4.1-4 10.6 0 13.6 5.1 3.8 11.9-6.3 11.9-6.3s-.8 6.5 6.8 2.1c6.4-3.7 7.2-14.2 7.2-17.6.7.3 1.4.7 2.1 1.2 0 0 3.1 5.4 1.4 11.4-1.5 5.8-12.7 16.1-18.7 16.8z"
                    fill="url(#SVGID_38_)"
                />
                <g className="st13">
                    <linearGradient
                        id="SVGID_39_"
                        gradientUnits="userSpaceOnUse"
                        x1={817.5954}
                        y1={65.1352}
                        x2={819.1333}
                        y2={65.1352}
                        gradientTransform="matrix(-1 0 0 1 912.618 0)"
                    >
                        <stop offset={0.1541} stopColor="#889beb" />
                        <stop offset={1} stopColor="#889beb" />
                    </linearGradient>
                    <path
                        d="M93.5 68.7c.1 0 .5-.8.8-1.7.3-.9.5-1.8.5-1.8s.1-.9.1-1.9c0-.9-.1-1.9-.2-1.9s-.1.9-.2 1.8-.3 1.8-.3 1.8-.1.9-.4 1.8c-.1 1-.4 1.9-.3 1.9z"
                        fill="url(#SVGID_39_)"
                    />
                    <linearGradient
                        id="SVGID_40_"
                        gradientUnits="userSpaceOnUse"
                        x1={820.7633}
                        y1={75.8464}
                        x2={829.2503}
                        y2={75.8464}
                        gradientTransform="matrix(-1 0 0 1 912.618 0)"
                    >
                        <stop offset={0.1541} stopColor="#889beb" />
                        <stop offset={1} stopColor="#889beb" />
                    </linearGradient>
                    <path
                        d="M83.4 80.1c0 .1 1.4-.7 2.6-1.6 1.2-.9 2.3-2 2.3-2s1.1-1.1 2-2.3c.9-1.2 1.7-2.5 1.6-2.6-.1 0-.9 1.2-1.9 2.3-1 1.1-2.1 2.2-2.1 2.2s-1 1.1-2.2 2.1c-1.1 1-2.4 1.8-2.3 1.9z"
                        fill="url(#SVGID_40_)"
                    />
                    <linearGradient
                        id="SVGID_41_"
                        gradientUnits="userSpaceOnUse"
                        x1={840.301}
                        y1={80.8069}
                        x2={850.231}
                        y2={80.8069}
                        gradientTransform="matrix(-1 0 0 1 912.618 0)"
                    >
                        <stop offset={0.1541} stopColor="#889beb" />
                        <stop offset={1} stopColor="#889beb" />
                    </linearGradient>
                    <path
                        d="M62.4 80.5s.2.3.6.7c.4.4.9.9 1.7 1.2.7.3 1.5.3 2.1.2.6-.1.9-.2.9-.2s1.4-.5 2.6-1.4c1.2-.8 2.2-1.9 2.1-2-.1-.1-1.1.9-2.4 1.6-1.2.7-2.6 1.2-2.6 1.2s-.3.1-.8.3c-.5.1-1.2.2-1.8 0-1.4-.5-2.3-1.7-2.4-1.6z"
                        fill="url(#SVGID_41_)"
                    />
                    <g>
                        <linearGradient
                            id="SVGID_42_"
                            gradientUnits="userSpaceOnUse"
                            x1={822.9614}
                            y1={57.7602}
                            x2={832.2209}
                            y2={57.7602}
                            gradientTransform="matrix(-1 0 0 1 912.618 0)"
                        >
                            <stop offset={0.1541} stopColor="#889beb" />
                            <stop offset={1} stopColor="#889beb" />
                        </linearGradient>
                        <path
                            d="M80.4 58.8c0 .1 1.2-.3 2.3-.6 1.1-.3 2.3-.6 2.3-.6s1.1-.3 2.3-.5c1.2-.2 2.3-.1 2.4-.2 0-.1-1.2-.3-2.4-.2-1.2.1-2.4.3-2.4.3s-1.2.3-2.3.7c-1.1.5-2.2 1-2.2 1.1z"
                            fill="url(#SVGID_42_)"
                        />
                    </g>
                    <g>
                        <linearGradient
                            id="SVGID_43_"
                            gradientUnits="userSpaceOnUse"
                            x1={834.6693}
                            y1={64.2581}
                            x2={847.3563}
                            y2={64.2581}
                            gradientTransform="matrix(-1 0 0 1 912.618 0)"
                        >
                            <stop offset={0.1541} stopColor="#889beb" />
                            <stop offset={1} stopColor="#889beb" />
                        </linearGradient>
                        <path
                            d="M65.3 68.3s.3-.4.7-1c.4-.6 1-1.3 1.7-2 1.4-1.3 3.1-2.2 3.1-2.2s.4-.2 1.1-.6c.6-.3 1.5-.7 2.4-1 1.8-.7 3.7-1.3 3.6-1.3 0 0-.5.1-1.2.2-.7.2-1.7.4-2.6.7-.9.3-1.8.6-2.5 1-.7.3-1.1.5-1.1.5s-1.8.9-3.1 2.4c-.7.7-1.3 1.5-1.6 2.2-.4.6-.6 1.1-.5 1.1z"
                            fill="url(#SVGID_43_)"
                        />
                    </g>
                </g>
            </g>
        </g>
        <g>
            <linearGradient
                id="SVGID_44_"
                gradientUnits="userSpaceOnUse"
                x1={15.1822}
                y1={99.7722}
                x2={99.9844}
                y2={99.7722}
            >
                <stop offset={0} stopColor="#903acf" />
                <stop offset={1} stopColor="#cf4a78" />
            </linearGradient>
            <path
                d="M96.5 88.8s2.2 4.9.7 9.4c0 0 4.7 2.7 1.7 8.9s-22-1.7-26-4c0 0-23.7-4.5-29.7 2 0 0 5.9 10.4-1.5 13.8s-21 .7-21 .7L15 103.3s14.3 6.4 15.1 2.2c.7-4.2-4.7-9.1 4-12.1l4.5-14.6S64.8 89.7 71.5 86c.1 0 14.1-4.4 25 2.8z"
                fill="url(#SVGID_44_)"
            />
            <path
                className="st1"
                d="M15.2 103.3s14.3 6.4 15.1 2.2c0 0 1.4 3.6-3.5 5.5-2.3.9-5.6 1.1-8.5 1.1l-3.1-8.8z"
            />
            <linearGradient
                id="SVGID_45_"
                gradientUnits="userSpaceOnUse"
                x1={34.2255}
                y1={94.1141}
                x2={99.7241}
                y2={94.1141}
            >
                <stop offset={0} stopColor="#903acf" />
                <stop offset={1} stopColor="#cf4a78" />
            </linearGradient>
            <path
                d="M40.5 95c3.5-.3 4.6-3 4.6-3s-6.2-.2-8.1.6c-.9.4-2 .7-2.8.9l4.4-14.6s26.2 10.9 32.9 7.2c0 0 14.1-4.5 25 2.7 0 0 .3.8.7 2-1.6-.8-9.9-4.6-12.3-1.1-2.4 3.5 8.8 10.3 12.5 8.2 0 .1-.1.3-.1.4 0 0 1.8 1 2.5 3.3-.6-.3-1.4-.5-2.6-.2-3.2.8-6.2.2-11.1-2.4-4.9-2.6-11.2-3.2-11.2.7 0 3.4 17.3 9.6 24.1 7.7-3.1 6-22-1.8-25.9-4 0 0-23.7-4.5-29.7 2 0 0-3.3-3-4.5-5.6-1.3-2.9-1.9-4.6 1.6-4.8z"
                fill="url(#SVGID_45_)"
            />
            <path
                className="st1"
                d="M30.5 106.6s-.3 1.2-1 2.2c-.7 1-1.8 1.6-1.8 1.5 0-.1.9-.7 1.5-1.8.6-1 .8-2.1.8-2.1s0-.1.1-.3c.1-.2.2-.3.2-.6.1-.8.1-1.6-.1-2.5-.1-.7-.1-1.2-.1-1.2.1 0 .4 1.1.5 2.3.1.6.1 1.2 0 1.7 0 .5-.1.8-.1.8zM96.7 98.2c.4-1.2.5-2.4.5-2.4s.2-1.2.1-2.4-.5-2.4-.4-2.4c.1 0 .5 1 .8 2.1.1 1.2.2 2.4-.1 3.7-.1.4-.3 1-.5 1.5-.3.6-.6 1.2-.9 1.6H96c.2-.4.5-1 .7-1.7zM97.3 100.1h-1.2l.1-.1c.7 0 1.1 0 1.1.1zM95.7 100.5s0-.2.2-.4h.2c-.2.2-.3.4-.4.4zM50 91.4c-1.6.2-3.8.6-6 .8-1.1.1-2.2.2-3.2.2s-2-.1-2.8 0c-.8.1-1.5.3-1.9.5-.4.2-.6.4-.6.4s0-.1.1-.1c.1-.1.2-.2.5-.3.4-.3 1.1-.5 1.9-.6.8-.1 1.8-.1 2.8-.1 1 0 2.1-.1 3.2-.2 2.2-.3 4.3-.7 6-.9 1.6-.3 2.7-.4 2.7-.4s4.3-.6 8.7-1.2c2.2-.3 4.3-.7 5.9-1.2.8-.2 1.4-.4 1.9-.6.4-.2.7-.3.7-.2 0 0-.2.2-.7.3-.4.2-1.1.5-1.9.7-1.6.5-3.7 1-5.9 1.3-4.3.7-8.7 1.4-8.7 1.4s-1-.1-2.7.2zM38.3 99c-.3-.6-.5-1.5-.4-2.4 0-.4.2-.9.4-1.2.2-.4.5-.7.9-.8.4 0 .6.1.8.2.2.1.2.2.2.2s-.1 0-.3-.1c-.2 0-.4-.1-.7-.1-.3 0-.5.3-.6.7-.1.3-.2.7-.2 1.1 0 .8.2 1.6.5 2.1s.5.9.5.9c-.1 0 4 5.3 3.9 5.4-.1.1-4.4-5-4.3-5.1-.2.1-.5-.3-.7-.9zM69.8 100.6c-.7-1-1.1-2.2-1.3-3-.2-.9-.3-1.5-.3-1.5s-.1-.6-.1-1.5.1-2.1.4-3.3c.3-1.2.7-2.3 1.1-3.1.4-.8.7-1.3.8-1.3 0 0-.2.5-.6 1.4-.3.8-.7 1.9-.9 3.1-.2 1.1-.3 2.3-.2 3.2 0 .9.1 1.4.1 1.4s.1.6.2 1.4c.2.8.5 2 1.1 2.9.6.9 1.5 1.7 2.2 2.2.3.2.5.4.7.5 0 0-.2 0-.4-.1-.1-.1-.3-.2-.4-.3-.7-.3-1.7-1-2.4-2zM89.5 98.7c-1.9-.6-3.7-1.5-5-2.2-1.3-.7-2.2-1.2-2.2-1.2s-.9-.5-2.1-1.3c-1.2-.8-2.9-1.9-4.4-3.3-1.5-1.3-2.8-2.9-3.5-4.2-.1-.3-.3-.5-.4-.7h.2c.1.2.2.4.4.6.8 1.2 2.1 2.7 3.6 4 1.5 1.3 3.1 2.3 4.4 3.1 1.3.8 2.1 1.3 2.1 1.3s.8.5 2.1 1.2 3.1 1.6 4.9 2.2c1.8.7 3.8 1.2 5.2 1.4.4.1.8.1 1.1.2 0 .1-.1.1-.1.2-.3 0-.7-.1-1.1-.1-1.4-.1-3.3-.5-5.2-1.2z"
            />
            <linearGradient
                id="SVGID_46_"
                gradientUnits="userSpaceOnUse"
                x1={37.8616}
                y1={94.2615}
                x2={72.6337}
                y2={94.2615}
            >
                <stop offset={0} stopColor="#903acf" />
                <stop offset={1} stopColor="#cf4a78" />
            </linearGradient>
            <path
                d="M38.1 95.8c.2.3 2.6 4.6 10.2 4.7 7.9.1 16.3-3.1 16.5-5.9.2-2.8 3.1-6.6 3.1-6.6l-5.6 1.2L44 91.9h-2.7c3-1.1 9.3-3.6 11.1-5.1 1.1-.9.2-2.2-1.1-3.5 7 2.2 15.1 4.2 19.2 3-.6 1.6-2.4 6.9-2 10.3.4 4 4.1 6.3 4.1 6.3-3.1-.5-23.8-3.9-29.3 2.1 0 0-3.3-3-4.5-5.6-.7-1.5-1.3-2.8-.7-3.6z"
                fill="url(#SVGID_46_)"
            />
            <g className="st13">
                <path
                    className="st18"
                    d="M96.3 96.7c.1 0 .3-.6.4-1.2.1-.6.1-1.3.1-1.3s-.1-.6-.3-1.2c-.2-.6-.5-1.1-.6-1.1-.1 0 .1.6.2 1.2s.1 1.2.1 1.2.1.6.1 1.2c-.1.6-.1 1.2 0 1.2zM32.8 105.3s.2-.4.3-1.1c.1-.7.1-1.6-.3-2.4-.3-.9-.8-1.6-1.1-2.2-.2-.6-.3-1-.3-1s-.1-.4.1-1c.1-.6.5-1.3 1.2-1.9 1.3-1.1 3.2-1.3 3.1-1.4 0 0-.4 0-1.1.1-.7.1-1.5.4-2.3 1-.7.5-1.3 1.4-1.4 2.1-.2.7-.1 1.2-.1 1.2s0 .5.3 1.1c.3.6.8 1.3 1.2 2.1.3.8.4 1.6.4 2.3.1.7-.1 1.1 0 1.1zM30.1 119.3s.2.1.5.1.8.1 1.3.1c1.1.1 2.6.1 4.1 0 1.5-.1 3-.3 4.1-.5 1.1-.2 1.8-.4 1.8-.4s.2-.1.5-.2.8-.4 1.2-.8c.9-.8 1.5-2.3 1.5-3.9 0-1.5-.6-3-1-4-.2-.5-.4-.9-.6-1.2-.2-.3-.2-.4-.3-.4 0 0 .3.7.6 1.7.4 1 .9 2.5.8 3.9 0 1.4-.7 2.8-1.5 3.5-.4.3-.8.6-1.1.7-.3.1-.5.2-.5.2s-.7.2-1.8.5c-1.1.2-2.5.5-4 .6-1.5.1-2.9.2-4.1.2-.8-.1-1.5-.2-1.5-.1zM22.8 117.7c0 .1.6.4 1.2.7.6.3 1.3.4 1.3.4s.7.1 1.4.1 1.4 0 1.4-.1-.7-.2-1.3-.3c-.7-.1-1.3-.3-1.3-.3s-.7-.1-1.3-.3c-.7-.1-1.4-.3-1.4-.2zM38.4 85.2c.1 0 .9-1.5 1.8-3 .1-.2.2-.4.3-.5.1-.1.2 0 .4 0 .4.2.7.3 1 .5.6.3 1 .4 1 .4s1.7.6 3.4 1 3.4.7 3.5.6c0-.1-1.7-.5-3.4-1S43.1 82 43.1 82s-.4-.2-1-.4c-.3-.1-.7-.3-1-.4-.2-.1-.5-.2-.8 0-.2.2-.3.4-.4.6-.9 1.8-1.6 3.4-1.5 3.4z"
                />
            </g>
        </g>
        <g>
            <path
                className="st56"
                d="M83.5 133.8s-.2 19.3-8.6 23c-8.4 3.7-24.9.7-31-7.7-6.1-8.4.1-31.5 4.7-36.4s32.2 3.3 34.9 21.1z"
            />
            <path
                className="st57"
                d="M74.4 129l8.2 1.3c.4 1.1.7 2.3.9 3.5 0 0-.2 19.3-8.6 23-.5.2-1.1.4-1.7.6-2.1-1.5-3.8-3.9-4.1-7-.7-7.5 5.1-21.9 5.1-21.9l.2.5z"
            />
            <path
                className="st58"
                d="M46.8 115.3c.6-1.1 1.2-2 1.8-2.6 4.6-4.9 32.2 3.3 34.9 21.1 0 0 0 .7-.1 1.9-5.4.1-36.4-18.8-36.4-18.8s-.1-.6-.2-1.6z"
            />
            <g className="st7">
                <path
                    className="st56"
                    d="M42.9 138.6v-1.3c0-.8.1-1.7.2-2.7.1-1 .3-2 .5-2.7.1-.7.2-1.2.2-1.2l.6-4c.1-1 .3-2 .4-2.7.1-.8.2-1.3.1-1.3 0 0-.2.5-.3 1.2-.2.7-.4 1.7-.6 2.7l-.8 4s-.1.5-.2 1.2-.3 1.7-.4 2.8c-.1 1-.1 2 0 2.8.1.7.3 1.2.3 1.2z"
                />
            </g>
            <g className="st7">
                <path
                    className="st56"
                    d="M68.4 150v-1.4-3.1c.1-2.2.5-4.4.5-4.4s.3-2.2 1-4.3c.3-1.1.7-2.1 1.1-2.9.3-.8.6-1.3.5-1.3 0 0-.3.5-.7 1.2-.4.7-.8 1.8-1.2 2.8-.8 2.1-1.2 4.3-1.2 4.3s-.4 2.2-.4 4.5c0 1.1.1 2.2.2 3.1 0 1 .1 1.5.2 1.5z"
                />
            </g>
            <g className="st7">
                <path
                    className="st56"
                    d="M58.8 154.6c0 .1 1.1.6 2.2 1 1.2.4 2.4.6 2.4.6s1.2.1 2.4.1 2.4-.3 2.4-.4c0-.1-1.2 0-2.4 0s-2.4-.2-2.4-.2-1.2-.1-2.3-.4c-1.1-.4-2.2-.8-2.3-.7z"
                />
            </g>
        </g>
        <g>
            <path
                className="st59"
                d="M85.6 113.5s4.9-.8 6.8 6c1.9 6.8-3.8 14-8.9 14.3-5.1.3-36.4-18.8-36.4-18.8s-2.5-12.2 2.6-15.9 35.9 14.4 35.9 14.4z"
            />
            <path
                className="st60"
                d="M80.2 118.4c-1.6 3.5-3.2 10.8.6 14.8C71.6 130 47.1 115 47.1 115s-2.5-12.2 2.6-15.9c5.1-3.6 35.9 14.3 35.9 14.3s-3.4.8-5.4 5z"
            />
            <g className="st13">
                <path
                    className="st60"
                    d="M81 116.7s0 .1.1.3c-.1.1-.1.2-.2.3 0-.4.1-.6.1-.6zM47.1 115s-2.5-12.2 2.6-15.9c.2-.1.4-.2.7-.3-.8 2.4-1.9 6.2-1.6 9 .4 4.4 16.3 14.3 23.7 15.2 3.6.4 5.6-1 6.8-2.6-1.2 3.8-1.8 9.4 1.4 12.7C71.6 130 47.1 115 47.1 115z"
                />
            </g>
            <g className="st13">
                <path
                    className="st59"
                    d="M81.9 133.2s-.7-.3-1.4-1c-.7-.8-1.3-2.1-1.5-3.5-.3-1.4-.2-2.8-.1-3.9s.2-1.7.2-1.7.1-.7.4-1.7c.3-1 .7-2.4 1.5-3.6.7-1.2 1.7-2.3 2.5-2.9.8-.7 1.5-1 1.4-1 0 0-.2 0-.5.2-.3.1-.7.4-1.1.7-.9.6-1.9 1.7-2.7 2.9-.8 1.2-1.3 2.6-1.6 3.6-.3 1-.4 1.8-.4 1.8s-.1.7-.2 1.8-.1 2.5.3 4c.3 1.4.9 2.8 1.7 3.6.4.4.8.6 1.1.7h.4z"
                />
                <path
                    className="st59"
                    d="M86.5 124.5s.2-.2.4-.7c.2-.4.5-1.1.6-1.9 0-.4.1-.9-.1-1.4-.1-.5-.4-1-.9-1.3-.2-.2-.6-.2-.9-.1-.3.1-.5.3-.7.4-.4.3-.8.8-1.1 1.3-.6 1-.9 2.1-1.1 3.1-.2 1-.3 2-.3 2.8 0 .9.2 1.6.5 2 .3.4.5.6.5.6s.2.2.7.5c.5.2 1.3.3 2.1-.1s1.5-1.1 2.1-2c.6-.9 1.1-1.9 1.4-2.9.3-1.1.5-2.2.4-3.2-.1-1-.3-2-.6-2.8-.3-.8-.7-1.3-1-1.7l-.4-.4-.1-.1c-.1 0 .7.8 1.3 2.4.3.8.5 1.7.5 2.7 0 1-.1 2.1-.5 3.1-.3 1-.8 2-1.4 2.8-.6.8-1.2 1.5-1.9 1.8-.7.3-1.3.2-1.7.1-.4-.2-.5-.4-.5-.4s-.2-.2-.4-.5c-.2-.4-.4-1-.5-1.8 0-.8.1-1.7.3-2.7.2-1 .5-2 1-2.9.3-.5.6-.9 1-1.2.4-.3.8-.6 1.2-.4.4.2.6.7.8 1.1.1.4.1.9.1 1.3-.1.8-.3 1.4-.5 1.9l-.3.6z"
                />
                <path
                    className="st59"
                    d="M81.1 127.2c.1 0 0-1.6.2-3.2.1-.8.2-1.6.4-2.2l.3-.9s.1-.4.4-.9c.3-.5.7-1.2 1.2-1.8.5-.6 1.2-1 1.7-1.3.5-.3.9-.4.9-.4s-.4 0-1 .2-1.3.7-1.9 1.2c-.6.6-1.1 1.3-1.4 1.8-.3.6-.5.9-.5.9s-.1.4-.3 1c-.2.6-.3 1.4-.3 2.3 0 1.7.2 3.3.3 3.3zM88.5 129.3c.1 0 .9-1 1.6-2.2.3-.6.6-1.2.8-1.7.2-.5.3-.8.3-.8s.1-.3.2-.9c.1-.5.1-1.2 0-1.9-.1-1.4-.5-2.7-.6-2.6-.1 0 .2 1.3.2 2.7 0 .7 0 1.3-.1 1.8s-.2.8-.2.8-.1.3-.2.8c-.2.5-.4 1.1-.7 1.7-.7 1.1-1.4 2.2-1.3 2.3zM81.3 130.1c-.1 0 0 .7.5 1.2.4.5 1.1.8 1.1.8s.7.2 1.3.1c.7-.1 1.2-.5 1.1-.6 0-.1-.6.2-1.2.2s-1.1-.2-1.1-.2-.5-.2-1-.6c-.4-.3-.6-.9-.7-.9z"
                />
            </g>
        </g>
        <g>
            <path
                className="st57"
                d="M64.2 140.9c-.4-.4-.8-.7-1.4-.9-3.5-1.1-7-2.8-10.3-4.4-1.3-.7-2.6-1.3-3.9-2.1-.5-.3-1.1-1-1.7-1.2-2.2-1-2.9 4.3-3.2 5.6-.5 2.4-.9 5.3.5 7.5 2.3 3.7 6.9 5.8 10.9 7.1 3.4 1.1 7.3 1.3 9.2-2.3 1.1-2.3 1.9-7.2-.1-9.3z"
            />
            <path
                className="st57"
                d="M46.9 132.3c.6.2 1.2.9 1.7 1.2 1.2.8 2.6 1.4 3.9 2.1 3.3 1.6 6.8 3.3 10.3 4.4.6.2 1.1.5 1.4.9.2.2.3.4.5.6-.2.7-.4 1.3-.7 1.8-1.8 3.6-5.8 3.4-9.2 2.3-4-1.3-8.6-3.4-10.9-7.1-.1-.1-.1-.3-.2-.4v-.2c.3-1.3 1-6.6 3.2-5.6z"
            />
            <g className="st7">
                <path
                    className="st56"
                    d="M54.3 143.3c0-.1-1.6-.5-3.1-1.2-.7-.3-1.4-.7-1.9-1.1-.5-.3-.8-.6-.8-.6s-.3-.2-.8-.6c-.4-.4-1-1-1.4-1.7-.4-.7-.5-1.5-.4-2.1.1-.6.3-1 .2-1 0 0-.3.3-.4 1-.2.6-.1 1.5.2 2.3.3.8.9 1.4 1.4 1.9.5.4.8.7.8.7s.3.3.9.6c.5.3 1.3.7 2.1 1 1.5.6 3.1.9 3.2.8z"
                />
            </g>
            <g className="st7">
                <path
                    className="st56"
                    d="M52.4 150.1c.1-.1-1.3-.9-2.8-1.5-.7-.3-1.4-.7-1.9-1-.5-.3-.8-.5-.8-.5s-.3-.2-.8-.6c-.4-.4-1-.9-1.3-1.6-.4-.7-.6-1.4-.6-2-.1-.6 0-1-.1-1 0 0-.1.4-.1 1s.1 1.4.5 2.2c.3.7.9 1.4 1.3 1.8.4.4.8.7.8.7s.3.2.9.5c.5.3 1.2.6 2 .9.7.3 1.5.6 2 .8.5.2.9.4.9.3z"
                />
            </g>
        </g>
        <g>
            <path className="st57" d="M80.8 140s1.1 1.1.3 4.2-2.6 7-6 5.9c-3.5-1-3.4-6.7-2.3-10.2 1.1-3.4 8 .1 8 .1z" />
            <path
                className="st57"
                d="M78.5 143c-2.4 0-3.9-2.3-4.8-4.2 2.2-1.3 7 1.2 7 1.2s.4.4.6 1.5c-.2.8-1 1.5-2.8 1.5z"
            />
            <g className="st7">
                <path
                    className="st56"
                    d="M76.7 141.8c0 .1.4.4.9.5.5.2 1.1.2 1.1.2h.4c.2 0 .6-.2.7-.4.4-.5.4-1 .3-1-.1 0-.3.5-.6.8-.3.3-.8.2-.8.2s-.5 0-1-.1c-.5-.2-1-.3-1-.2z"
                />
            </g>
            <g className="st7">
                <path
                    className="st56"
                    d="M74.9 148.7s.1.2.5.4c.3.2.9.3 1.4.2.5-.1 1-.5 1.2-.8.3-.3.4-.5.4-.5s.6-.8 1-1.8c.4-.9.6-1.9.5-1.9-.1 0-.4.9-.9 1.8-.5.8-1.1 1.6-1.1 1.6s-.1.2-.3.5c-.2.3-.5.6-.9.7-.4.1-.9.1-1.2 0-.3-.1-.5-.2-.6-.2z"
                />
            </g>
        </g>
        <g>
            <path
                className="st56"
                d="M121.3 187.9s-7.2 2.4-16.3-2.7l-3.6 27.4s9.2 3.1 19.2 1.3 11.2-6.1 8.4-8.7c-3.4-3.1-12-2.1-12-2.1s4.8-11.2 4.3-15.2z"
            />
            <path
                className="st57"
                d="M105 185.2c9 5.1 16.3 2.7 16.3 2.7.1.9 0 2.2-.3 3.6-1.4.8-2.8 1.3-2.8 1.3-4 1.9-10.3-.4-10.3-.4s-5.2 19.4 10.6 17.8c9.1-.9 10.8-3.1 10.7-4.8 2.7 2.6 1.3 6.8-8.5 8.6-10 1.8-19.2-1.3-19.2-1.3l3.5-27.5zm14.9 17.7c-1.7 0-2.9.1-2.9.1s.4-.9 1-2.4c-.8 1.5-1.3 2.6-1.3 2.6l-2.3 3.7c-.1 0 3.1-1.4 5.5-4z"
            />
            <path
                d="M115.3 205.2c.5-.9.9-1.8.9-1.8l1-1.8c.5-.9.9-1.8 1-1.8.1 0-.2 1-.6 2-.4 1-.8 1.9-.8 1.9s-.5.9-1.1 1.7c-.6.8-1.2 1.6-1.3 1.6-.2-.1.4-1 .9-1.8zm-4.8-12.8c0 .1 1.1.5 2.3.7 1.2.2 2.4.2 2.4.2s1.2-.1 2.4-.5 2.2-1 2.2-1c0-.1-1.1.4-2.3.7-1.2.3-2.3.3-2.3.3s-1.2.1-2.3 0c-1.2-.1-2.3-.5-2.4-.4zm-5-3.3c0 .1.8.6 1.7 1.2l1.8 1s1 .4 2 .6c1 .2 2.1.1 2.1 0s-1-.1-2-.4c-1-.3-1.9-.7-1.9-.7s-.9-.4-1.9-.8c-.8-.6-1.7-1-1.8-.9zm-.6 22.7s.2.1.5.2.8.2 1.4.3c1.1.3 2.7.5 4.2.6 1.5.1 3.1.1 4.3.1 1.2-.1 1.9-.1 1.9-.1s.8-.1 1.9-.3c1.1-.2 2.7-.6 4.1-1 1.5-.5 2.9-1 4-1.5.5-.2 1-.5 1.3-.6.3-.2.5-.3.5-.3s-.7.3-1.8.7c-1.1.4-2.5.9-4 1.3s-3 .7-4.1.9c-1.1.2-1.9.2-1.9.2s-.8.1-1.9.2c-1.1.1-2.7.1-4.2.1-1.5-.1-3.1-.2-4.2-.4-1.2-.3-1.9-.4-2-.4zm-1.1-.1"
                opacity={0.35}
                fill="#6560a2"
            />
            <path
                className="st56"
                d="M116 201.7c.1 0 .6-.9 1.1-1.8.5-.9.9-1.9.9-1.9s.4-1 .6-2c.3-1 .5-2 .5-2-.1 0-.4.9-.8 1.9-.4.9-.8 1.9-.8 1.9s-.4 1-.7 1.9c-.5 1-.9 2-.8 2zM114.6 205c.1 0 .5-.5.5-.5s.1-.6-.1-.6c-.1 0-.5.5-.5.5s0 .5.1.6zM123.1 204.6c0 .1.6.2 1.1.3.5.1 1.1.3 1.1.3s.5.1 1.1.3c.5.2 1.1.4 1.1.3 0-.1-.4-.4-.9-.7-.5-.3-1.1-.5-1.1-.5l-1.2-.2c-.6.1-1.2.1-1.2.2z"
            />
        </g>
        <g>
            <path
                className="st56"
                d="M74.7 194.9s-7.7.2-15.2-6.9l-10.2 25.7s8.1 5.3 18.3 5.9c10.2.7 12.4-3.2 10.2-6.4-2.6-3.9-11.1-5-11.1-5s7.5-9.3 8-13.3z"
            />
            <g opacity={0.35}>
                <path
                    className="st56"
                    d="M66.2 198.2c0 .1.8.5 1.7.7.9.2 1.8.3 1.8.3s.9 0 1.9-.1c.9-.1 1.8-.4 1.8-.5 0-.1-.9.1-1.8.1h-1.8s-.9 0-1.8-.1c-.9-.2-1.7-.5-1.8-.4zM64.4 212c0 .1.5-.2.8-.5.4-.3.7-.7.7-.7s.3-.4.4-.9c.2-.5.3-.9.2-1-.1 0-.3.4-.6.8s-.6.7-.6.7-.2.4-.5.8c-.1.4-.4.7-.4.8zM66.6 212.1c.1 0 .2-.4.4-.8.1-.4.2-.9.2-.9s0-.4-.1-.9c-.1-.4-.2-.9-.2-.9-.1 0-.1.4-.2.9-.1.4-.1.8-.1.8v1.8zM60.9 216.8s.5.2 1.2.4c.8.2 1.8.4 2.8.6 2.1.3 4.2.2 4.2.2s2.1-.1 4.1-.6c1-.3 2-.6 2.7-.8.7-.3 1.2-.5 1.2-.5s-.5.1-1.3.3c-.7.2-1.7.5-2.8.7-2 .4-4.1.4-4.1.4s-2.1.1-4.1-.1c-1-.1-2-.3-2.8-.4-.6-.1-1.1-.2-1.1-.2zM52.1 213.6c0 .1.5.6 1.1 1l1.2.8s.7.3 1.4.5 1.4.3 1.4.3c0-.1-.7-.3-1.3-.6-.6-.3-1.3-.6-1.3-.6s-.6-.3-1.3-.6c-.5-.5-1.1-.9-1.2-.8zM66.1 196c0-.1-1-.5-1.9-1-.9-.6-1.7-1.2-1.7-1.2s-.9-.6-1.6-1.4l-1.4-1.6c-.1 0 .4 1 1.1 1.9.7.9 1.5 1.6 1.5 1.6s.9.7 1.9 1.1c1 .4 2.1.7 2.1.6zM64.4 197c.1-.1-1.6-1.6-1.6-1.6s-1.8-1.2-1.9-1.1c-.1.1 1.6 1.6 1.6 1.6s1.8 1.3 1.9 1.1z"
                />
            </g>
            <path
                className="st57"
                d="M59.5 188c7.5 7.2 15.2 6.9 15.2 6.9-.1 1-.7 2.3-1.4 3.8-1.1.2-3.1.4-5 .4-1.1 1.7-2 3.4-3.1 5.1-.9 1.3-1.8 4.1-.6 5.5 1.8 2.2 1.8-1.5 2.7-1.4.5.1 1.1.2 2 .4-1.4 1.3-3.4 3.5-2 4.4 1.7 1.2 10.1 2.7 10.7.3 2 3.2-.3 6.9-10.3 6.2-10.2-.7-18.3-5.9-18.3-5.9L59.5 188z"
            />
            <path
                className="st56"
                d="M72.5 210.6c0 .1.5.3 1 .6l1 .6s.5.3 1 .7c.5.4.9.8.9.7.1 0-.3-.6-.7-1-.4-.5-.9-.8-.9-.8s-.5-.3-1.1-.5c-.6-.3-1.2-.3-1.2-.3zM70 209.8c-.1.1.1.4.1.4s.3.1.4 0c.1-.1-.1-.4-.1-.4s-.3-.1-.4 0zM66.1 208c.1 0 .6-.9 1.2-1.8s1.1-1.8 1.1-1.8.5-.9 1.1-1.8c.5-.9 1.1-1.8 1.1-1.9-.1 0-.8.8-1.4 1.6l-1.2 1.8s-.5.9-1 1.9c-.6 1-1 2-.9 2z"
            />
        </g>
        <g>
            <path transform="rotate(-9.788 55.355 96.745)" className="st0" d="M54.4 60.4H56.3V133H54.4z" />
            <path transform="rotate(-9.788 54.95 97.319)" className="st1" d="M54.5 61.5H55.4V133.1H54.5z" />
            <g>
                <path
                    className="st2"
                    d="M54.5 89.2c-1.7-9.6-3.6-19-5.3-28.6-8.1 21.6-9 25.5-9 25.5L52 101s1.9-7.4 2.5-11.8z"
                />
            </g>
        </g>
        <g>
            <path transform="rotate(-12.761 53.313 97.378)" className="st0" d="M52.4 61.1H54.3V133.7H52.4z" />
            <path transform="rotate(-12.761 52.938 97.971)" className="st1" d="M52.5 62.2H53.4V133.8H52.5z" />
            <g>
                <path
                    className="st2"
                    d="M52.1 89.9c-2.1-9.5-4.6-18.8-6.8-28.3-7 22-7.7 26-7.7 26l12.6 14.3s1.5-7.5 1.9-12z"
                />
            </g>
        </g>
        <g>
            <path transform="rotate(-16.524 51.159 97.674)" className="st0" d="M50.2 61.4H52.1V134H50.2z" />
            <path transform="rotate(-16.524 50.824 98.291)" className="st1" d="M50.4 62.5H51.3V134.1H50.4z" />
            <g>
                <path
                    className="st2"
                    d="M49.4 90.3c-2.8-9.3-5.8-18.5-8.6-27.8-5.5 22.4-6 26.4-6 26.4l13.5 13.4c0 .1 1.1-7.5 1.1-12z"
                />
            </g>
        </g>
        <g>
            <path
                className="st58"
                d="M49 118.8c3.6-1.7 2.1-7.4 6.1-14.3 4-6.9 11.2-1 11.2-1l.1-.1c1.3.7 2.7 1.2 4.2 1.4l9.2 4.7c.2.6.5 1.1.8 1.6l-.4-.2s-6.1.2-8.9 8c-2.9 7.8-.8 13.5-7.4 15.1-6.7 1.5-15.8-4.2-16.6-10.3 0 0-1.9-3.2 1.7-4.9z"
            />
            <path
                className="st56"
                d="M47.8 117.5c3.6-1.7 2.1-7.4 6.1-14.3 4-6.9 11.2-1 11.2-1l.4-.7c1.3.7 3.1 1 4.6 1.2l-.9.9 12.4 6.3s5.3-8.8 12.8-8.6c7.4.2 5.2 6 5.2 6s-8.8-5.4-14.6 6.2l-6.1-3.8s-6.1.2-8.9 8c-2.9 7.8-.8 13.5-7.4 15.1-6.7 1.5-15.8-4.2-16.6-10.3.1 0-1.8-3.2 1.8-5z"
            />
            <path
                className="st57"
                d="M80.9 110.9l.5-1.1.3.2s.7-1.1 1.9-2.6c.2 1.1.9 1.7 2.9.6 5-2.7 7.8-3.1 10.6-3.8 1.3-.3 1.4-1.1 1.2-1.9 2.6 1.7 1.4 5 1.4 5s-8.8-5.4-14.6 6.2l-4.2-2.6zM47.8 117.5c.1 0 .1-.1.1-.1.1 1.3-2.1 1-.8 3.5 2 3.9 5.7 7.3 10 8.5 1.7.4 3.5.6 5.1-.1 2.2-.9 2.7-3.6 3-5.7.9-6.4 4.1-11.4 9.3-15.1.8-.6.9-1.2.7-1.8l5.7 2.9c-.1.3-.2.7-.4 1.1l-1.6-1s-6.1.2-8.9 8c-2.9 7.8-.8 13.5-7.4 15.1-6.7 1.5-15.8-4.2-16.6-10.3.1 0-1.8-3.2 1.8-5zM64.6 101.9c.3.2.5.4.5.4l.4-.7c1.3.7 3.1 1 4.6 1.2l-.9.9c-.9 0-3.1-.2-4.6-1.8z"
            />
            <g className="st7">
                <path
                    className="st56"
                    d="M52.3 112.9c.1 0 .3-1.7.7-3.4.2-.8.4-1.6.7-2.2.2-.6.4-1 .4-1s.2-.4.5-.9c.3-.6.8-1.3 1.3-1.9.6-.6 1.2-1.2 1.8-1.5.5-.3.9-.5.9-.5s-.4.1-1 .4c-.6.3-1.3.8-1.9 1.4-.6.6-1.1 1.4-1.5 1.9l-.5 1s-.2.4-.4 1-.4 1.5-.6 2.3c-.2.9-.3 1.7-.3 2.4-.1.5-.2 1-.1 1z"
                />
            </g>
            <g className="st7">
                <path
                    className="st56"
                    d="M52.1 125.9c.1-.1-1-1.4-2.1-2.7-.5-.7-1.1-1.3-1.4-1.8-.3-.5-.3-.9-.3-.9s-.1-.4 0-1 .4-1.3 1.1-1.7c.7-.4 1.4-1.1 1.7-1.7.3-.6.4-1 .4-1s-.2.4-.5.9c-.4.5-1 1.1-1.7 1.5-.4.2-.7.5-1 .9-.2.4-.4.7-.4 1.1-.1.7 0 1.1 0 1.1s0 .1.1.3c.1.2.2.5.4.8.4.6 1 1.2 1.5 1.8 1 1.2 2.1 2.4 2.2 2.4z"
                />
            </g>
            <g className="st7">
                <path
                    className="st56"
                    d="M86.1 106.2s.3-.1.8-.4c.4-.3 1-.7 1.5-1.1.5-.4 1-.8 1.5-1 .4-.2.7-.3.7-.3s.3-.1.7-.3c.5-.2 1.1-.3 1.7-.4 1.3-.2 2.6-.1 2.6-.2s-1.3-.3-2.7-.2c-.7 0-1.3.2-1.8.3-.5.1-.8.3-.8.3s-.3.1-.8.4c-.4.3-1 .7-1.5 1.1-.5.5-1 .9-1.3 1.2-.4.4-.7.6-.6.6z"
                />
            </g>
        </g>
        <path
            d="M216.2 15s-2.4-7.5-6.2-9.4c17.6 2.7 27.3 7.8 27.3 7.8S222.9 33.2 220.5 35c.7-8.8-1.8-12.8-1.8-12.8s-22 2.1-44.5 28.9c6.4-28.6 42-36.1 42-36.1z"
            fill="#ff6c23"
        />
    </svg>
)

export const MenWithFlagIcon = () => (
    <svg id="OBJECT" x="0px" y="0px" viewBox="0 0 145.5 224.4" xmlSpace="preserve">
        <style>
            {
                '.st0flag{fill:#fff}.st1flag{opacity:.45;fill:#c3bcf5}.st2flag{fill:#6dd5b0}.st3flag{opacity:.45;fill:#db4b86}.st7flag{opacity:.5}.st13flag{opacity:.45}.st18flag{fill:#c3bcf5}.st56,.st57,.st58{fill:#6560a2}.st57,.st58{opacity:.25}.st58{opacity:.45}.st59,.st60{fill:#858bcf}.st60{opacity:.45}'
            }
        </style>
        <path className="st0flag" d="M132.9 11H135.6V195.1H132.9z" />
        <path className="st1flag" d="M132.9 12.4H134.20000000000002V195.1H132.9z" />
        <path
            className="st2flag"
            d="M61.6 52.2c24.8 11.7 49.5-11.7 74.3 0V10.4c-24.8-11.7-49.5 11.7-74.3 0 4 8.7 7.9 16.6 11.9 23.8-4 6.7-7.9 12.8-11.9 18z"
        />
        <path
            className="st3flag"
            d="M115.8 49c-3.3.3-6.6.9-9.9 1.6V8.8c3.3-.7 6.6-1.3 9.9-1.6V49zM66 12.1c4.7 1.5 9.4 1.8 14.1 1.6v41.8c-4.7.3-9.4-.1-14.1-1.6V46c2.5-3.7 5-7.6 7.5-11.9-2.5-4.5-5-9.3-7.5-14.4v-7.6zM91.9 12c2-.4 3.9-.9 5.9-1.3v41.8c-2 .5-3.9.9-5.9 1.3V12z"
        />
        <path
            d="M61.6 52.2c2.4-3.1 4.7-6.5 7.1-10.2 5.9 19.6 41.3 6.5 56.6-2.1 11.7-6.6 8.8-22.4 5.9-31.3 1.5.5 3.1 1.1 4.6 1.8v41.8c-24.7-11.7-49.4 11.7-74.2 0z"
            fill="#53bc93"
        />
        <linearGradient
            id="SVGID_1_"
            gradientUnits="userSpaceOnUse"
            x1={790.7953}
            y1={171.6832}
            x2={855.7634}
            y2={171.6832}
            gradientTransform="matrix(-1 0 0 1 912.618 0)"
        >
            <stop offset={0} stopColor="#ad286b" />
            <stop offset={1} stopColor="#45296b" />
        </linearGradient>
        <path
            d="M100.5 147.8s16.6 9.6 19.8 21.7c3.2 12.1.2 20.8.2 20.8s-6 2.2-14.5-1.7c0 0 1.4-7-.7-9.6-2-2.6-13.5-9.6-17.1-15.2l-15.4 35.3s-9.7 3.8-16-1.7L69 159.6s-3.6-9.9-.3-15c3.2-5.1 31.8 3.2 31.8 3.2z"
            fill="url(#SVGID_1_)"
        />
        <linearGradient
            id="SVGID_2_"
            gradientUnits="userSpaceOnUse"
            x1={790.8042}
            y1={169.4994}
            x2={854.0726}
            y2={169.4994}
            gradientTransform="matrix(-1 0 0 1 912.618 0)"
        >
            <stop offset={0} stopColor="#ad286b" />
            <stop offset={1} stopColor="#45296b" />
        </linearGradient>
        <path
            d="M69 159.6s-3.6-9.9-.3-15c3.2-5.1 31.9 3.2 31.9 3.2s.9.5 2.4 1.5c-2.3 5.5-16.1 5.6-14.5 9 1.8 3.8 18.3 16.2 26.7 18.8 3.3 1 5.3.4 6.5-.7.8 8.4-1.1 13.9-1.1 13.9s-6 2.2-14.5-1.7c0 0 1.4-7-.7-9.6-2-2.6-13.5-9.6-17.1-15.2l-.3.6c-1.9-2.2-3.4-.6-3.4-.6s-7.7 17-9.6 23.9c-.9 3.3-.6 5.5-.1 6.8l-.6 1.4-15.7-3.9L69 159.6z"
            fill="url(#SVGID_2_)"
        />
        <g className="st7flag">
            <linearGradient
                id="SVGID_3_"
                gradientUnits="userSpaceOnUse"
                x1={802.0344}
                y1={180.8854}
                x2={806.9919}
                y2={180.8854}
                gradientTransform="matrix(-1 0 0 1 912.618 0)"
            >
                <stop offset={0.1541} stopColor="#889beb" />
                <stop offset={1} stopColor="#889beb" />
            </linearGradient>
            <path
                d="M110.6 182.7c.1-.1-2.3-2.1-2.3-2.1s-2.6-1.7-2.6-1.6c-.1.1 2.3 2.1 2.3 2.1s2.5 1.8 2.6 1.6z"
                fill="url(#SVGID_3_)"
            />
            <linearGradient
                id="SVGID_4_"
                gradientUnits="userSpaceOnUse"
                x1={823.9196}
                y1={161.2623}
                x2={832.5079}
                y2={161.2623}
                gradientTransform="matrix(-1 0 0 1 912.618 0)"
            >
                <stop offset={0.1541} stopColor="#889beb" />
                <stop offset={1} stopColor="#889beb" />
            </linearGradient>
            <path
                d="M80.1 158.2c-.1 0 .5 1.3 1.6 2.2.5.4 1.1.8 1.5 1.1.4.3.7.4.7.4l2.4 1.2c1.2.6 2.2 1.4 2.3 1.3.1-.1-.9-1-2.1-1.7-.6-.3-1.2-.7-1.6-.9-.4-.2-.7-.4-.7-.4s-.3-.2-.7-.4c-.4-.2-1-.6-1.5-1-1.1-.7-1.8-1.9-1.9-1.8z"
                fill="url(#SVGID_4_)"
            />
            <linearGradient
                id="SVGID_5_"
                gradientUnits="userSpaceOnUse"
                x1={841.2853}
                y1={160.3712}
                x2={843.4875}
                y2={160.3712}
                gradientTransform="matrix(-1 0 0 1 912.618 0)"
            >
                <stop offset={0.1541} stopColor="#889beb" />
                <stop offset={1} stopColor="#889beb" />
            </linearGradient>
            <path
                d="M71.3 162c0-.1-.3-.4-.6-.8s-.5-.8-.5-.8-.3-.4-.5-.8-.4-.9-.5-.9c-.1 0-.1.5.1 1.1.1.5.4 1 .4 1s.3.4.7.8c.4.3.9.5.9.4z"
                fill="url(#SVGID_5_)"
            />
            <g>
                <linearGradient
                    id="SVGID_6_"
                    gradientUnits="userSpaceOnUse"
                    x1={811.075}
                    y1={152.1316}
                    x2={822.1273}
                    y2={152.1316}
                    gradientTransform="matrix(-1 0 0 1 912.618 0)"
                >
                    <stop offset={0.1541} stopColor="#889beb" />
                    <stop offset={1} stopColor="#889beb" />
                </linearGradient>
                <path
                    d="M90.5 154.2c0 .1 1.5.2 3.1 0 1.5-.2 3-.7 3-.7s1.4-.6 2.7-1.5c1.3-.9 2.3-2 2.3-2.1-.1-.1-1.2 1-2.5 1.7-1.3.8-2.7 1.3-2.7 1.3s-1.4.6-2.9.9c-1.5.3-3 .3-3 .4z"
                    fill="url(#SVGID_6_)"
                />
            </g>
            <g>
                <linearGradient
                    id="SVGID_7_"
                    gradientUnits="userSpaceOnUse"
                    x1={826.1943}
                    y1={154.0639}
                    x2={830.9155}
                    y2={154.0639}
                    gradientTransform="matrix(-1 0 0 1 912.618 0)"
                >
                    <stop offset={0.1541} stopColor="#889beb" />
                    <stop offset={1} stopColor="#889beb" />
                </linearGradient>
                <path
                    d="M81.7 153.7c0 .1.6.3 1.1.4.6.2 1.2.3 1.2.3s.6.1 1.2.1 1.2 0 1.2-.1-.6-.2-1.2-.3l-1.2-.2s-.6-.1-1.2-.1c-.5-.1-1.1-.2-1.1-.1z"
                    fill="url(#SVGID_7_)"
                />
            </g>
        </g>
        <g className="st13flag">
            <linearGradient
                id="SVGID_8_"
                gradientUnits="userSpaceOnUse"
                x1={792.6992}
                y1={170.8392}
                x2={795.6309}
                y2={170.8392}
                gradientTransform="matrix(-1 0 0 1 912.618 0)"
            >
                <stop offset={0.1541} stopColor="#889beb" />
                <stop offset={1} stopColor="#889beb" />
            </linearGradient>
            <path
                d="M117 165.9c-.1 0 .6 1.2 1 2.4.5 1.2.8 2.5.8 2.5s.4 1.2.6 2.5c.2 1.3.3 2.6.4 2.6.1 0 .2-1.3 0-2.6-.1-1.3-.5-2.6-.5-2.6s-.4-1.3-1-2.5c-.5-1.3-1.2-2.4-1.3-2.3z"
                fill="url(#SVGID_8_)"
            />
            <linearGradient
                id="SVGID_9_"
                gradientUnits="userSpaceOnUse"
                x1={796.6043}
                y1={162.2132}
                x2={799.0945}
                y2={162.2132}
                gradientTransform="matrix(-1 0 0 1 912.618 0)"
            >
                <stop offset={0.1541} stopColor="#889beb" />
                <stop offset={1} stopColor="#889beb" />
            </linearGradient>
            <path
                d="M113.5 160.4c-.1 0 .2.5.5 1s.6.9.6.9.3.4.7.9c.3.4.7.9.7.8.1 0-.2-.5-.4-1-.3-.5-.5-1-.5-1s-.3-.4-.7-.9c-.4-.3-.8-.7-.9-.7z"
                fill="url(#SVGID_9_)"
            />
            <g>
                <linearGradient
                    id="SVGID_10_"
                    gradientUnits="userSpaceOnUse"
                    x1={829.3475}
                    y1={177.9742}
                    x2={834.4534}
                    y2={177.9742}
                    gradientTransform="matrix(-1 0 0 1 912.618 0)"
                >
                    <stop offset={0.1541} stopColor="#889beb" />
                    <stop offset={1} stopColor="#889beb" />
                </linearGradient>
                <path
                    d="M78.2 184.4c.1 0 .8-1.5 1.6-3.1l1.4-3.2 1.2-3.2c.6-1.6 1.1-3.3 1-3.3-.1 0-.7 1.6-1.4 3.2s-1.3 3.2-1.3 3.2l-1.2 3.2c-.8 1.5-1.4 3.1-1.3 3.2z"
                    fill="url(#SVGID_10_)"
                />
            </g>
            <g>
                <linearGradient
                    id="SVGID_11_"
                    gradientUnits="userSpaceOnUse"
                    x1={835.551}
                    y1={187.706}
                    x2={836.7198}
                    y2={187.706}
                    gradientTransform="matrix(-1 0 0 1 912.618 0)"
                >
                    <stop offset={0.1541} stopColor="#889beb" />
                    <stop offset={1} stopColor="#889beb" />
                </linearGradient>
                <path
                    d="M75.9 188.7c.1.1.8-.9.8-.9s.4-1.1.3-1.1c-.1-.1-.8.9-.8.9s-.4 1-.3 1.1z"
                    fill="url(#SVGID_11_)"
                />
            </g>
        </g>
        <path
            className="st18flag"
            d="M125.4 138.9s9.1 2.5 11.7-3.5c2.7-6-1.2-9.3-1.2-9.3l-3 1.4v-2.3s-8.3 1.3-11 6.5c-2.5 5.2 3.5 7.2 3.5 7.2z"
        />
        <path
            className="st1flag"
            d="M125.4 138.9s-6-2-3.4-7.2c2.7-5.2 11-6.5 11-6.5v2.1c-1 .6-2.8.6-3.8.8-1.9.4-5.4 5 1.1 5.4 4.7.3 6.4-3.6 6.9-5.7.8 1.6 1.4 4.1-.2 7.5-2.5 6.1-11.6 3.6-11.6 3.6z"
        />
        <g className="st7flag">
            <path
                className="st18flag"
                d="M128.4 128.3c0 .1.9 0 1.7 0 .9 0 1.7-.1 1.7-.1s.9-.1 1.7-.5c.8-.3 1.5-1 1.4-1.1 0 0-.7.5-1.5.7-.8.2-1.6.3-1.6.3s-.8.1-1.7.2c-.9.2-1.8.4-1.7.5zM126.2 134.9c.1 0 .2-.5.2-1.1 0-.5-.1-1.1-.1-1.1s-.2-.5-.5-1-.7-.8-.8-.8c-.1.1.2.5.4 1s.3.9.3.9.2.5.3 1c.1.6.1 1.1.2 1.1zM127.1 138.1c.1 0 .3-.5.4-1.1.1-.6.1-1.1.1-1.1s0-.6-.2-1.1c-.1-.6-.4-1.1-.5-1.1-.1 0 0 .6.1 1.1v2.2c.1.5.1 1 .1 1.1zM135.8 134.8c.1 0 .2-.7.6-1.4.3-.7.7-1.4.7-1.4s.3-.7.6-1.5c.2-.8.1-1.6 0-1.6s-.1.8-.4 1.5c-.3.7-.7 1.4-.7 1.4s-.3.7-.6 1.5c-.3.7-.3 1.5-.2 1.5z"
            />
        </g>
        <g>
            <linearGradient
                id="SVGID_12_"
                gradientUnits="userSpaceOnUse"
                x1={786.9285}
                y1={126.114}
                x2={852.3305}
                y2={126.114}
                gradientTransform="matrix(-1 0 0 1 912.618 0)"
            >
                <stop offset={0} stopColor="#faf453" />
                <stop offset={0.6645} stopColor="#cc795a" />
                <stop offset={1} stopColor="#bb3e64" />
            </linearGradient>
            <path
                d="M99 105.9s3.4 6.4 4.8 12.5c1.4 6 2.2 11.2 2.2 11.2s10.8 4 17.1 1c0 0 3.2 3 2.4 10.6 0 0-9.8 6.6-24.3 3v4.8s-8.6 5.4-23.5 3c-14.9-2.4-17.5-8.8-17.5-8.8s3.8-39.8 10.6-43c7-3.2 28.2 5.7 28.2 5.7z"
                fill="url(#SVGID_12_)"
            />
            <linearGradient
                id="SVGID_13_"
                gradientUnits="userSpaceOnUse"
                x1={786.9282}
                y1={126.114}
                x2={852.3305}
                y2={126.114}
                gradientTransform="matrix(-1 0 0 1 912.618 0)"
            >
                <stop offset={0} stopColor="#faf453" />
                <stop offset={0.6645} stopColor="#cc795a" />
                <stop offset={1} stopColor="#bb3e64" />
            </linearGradient>
            <path
                d="M70.9 100.2c6.8-3.2 28.1 5.6 28.1 5.6s.5.9 1.1 2.2c-1.6 0-3.5.3-5.1 1.2-4 2.1-1.6 24.5 4 24.7 4.2.2 5.7-6.5 6.1-9.8.6 3.2 1 5.4 1 5.4s.6.2 1.6.5c.6 3.7 2.8 11.7 10.2 10 6.9-1.6 5.9-7.6 5.4-9.4.4.5 3.1 3.6 2.3 10.6 0 0-9.8 6.6-24.3 3v4.8s-8.6 5.4-23.5 3c-14.9-2.4-17.5-8.8-17.5-8.8s3.8-39.7 10.6-43z"
                fill="url(#SVGID_13_)"
            />
            <linearGradient
                id="SVGID_14_"
                gradientUnits="userSpaceOnUse"
                x1={790.3484}
                y1={136.5104}
                x2={791.9768}
                y2={136.5104}
                gradientTransform="matrix(-1 0 0 1 912.618 0)"
            >
                <stop offset={0} stopColor="#3f4068" />
                <stop offset={1} stopColor="#594068" />
            </linearGradient>
            <path
                d="M121.7 141c.1 0 .4-1.1.5-2.3.1-1.2 0-2.3 0-2.3s-.2-1.2-.6-2.3c-.4-1.1-.9-2.1-1-2.1-.1 0 .4 1.1.6 2.2.3 1.1.4 2.2.4 2.2s.2 1.1.2 2.2c0 1.2-.1 2.3-.1 2.4z"
                fill="url(#SVGID_14_)"
            />
            <linearGradient
                id="SVGID_15_"
                gradientUnits="userSpaceOnUse"
                x1={791.9919}
                y1={135.8136}
                x2={792.8029}
                y2={135.8136}
                gradientTransform="matrix(-1 0 0 1 912.618 0)"
            >
                <stop offset={0} stopColor="#3f4068" />
                <stop offset={1} stopColor="#594068" />
            </linearGradient>
            <path
                d="M120.4 138.4c.1 0 .2-.6.2-1.3v-1.3s-.1-.7-.3-1.3c-.2-.6-.4-1.3-.5-1.2-.1 0 0 .7.1 1.3.1.6.1 1.3.1 1.3s.1.6.2 1.3c.1.5.1 1.2.2 1.2z"
                fill="url(#SVGID_15_)"
            />
            <linearGradient
                id="SVGID_16_"
                gradientUnits="userSpaceOnUse"
                x1={806.2582}
                y1={132.2651}
                x2={806.9769}
                y2={132.2651}
                gradientTransform="matrix(-1 0 0 1 912.618 0)"
            >
                <stop offset={0} stopColor="#3f4068" />
                <stop offset={1} stopColor="#594068" />
            </linearGradient>
            <path
                d="M105.7 135.6c.1 0 .3-.8.5-1.6s.2-1.7.2-1.7 0-.8-.1-1.7c-.1-.8-.3-1.6-.3-1.6-.1 0 0 .8-.1 1.7 0 .8-.1 1.6-.1 1.6s0 .8-.1 1.6c0 .8-.1 1.6 0 1.7z"
                fill="url(#SVGID_16_)"
            />
            <linearGradient
                id="SVGID_17_"
                gradientUnits="userSpaceOnUse"
                x1={804.9127}
                y1={132.9749}
                x2={805.937}
                y2={132.9749}
                gradientTransform="matrix(-1 0 0 1 912.618 0)"
            >
                <stop offset={0} stopColor="#3f4068" />
                <stop offset={1} stopColor="#594068" />
            </linearGradient>
            <path
                d="M107.6 135.7c.1 0 .1-.7 0-1.4 0-.7-.1-1.4-.1-1.4s-.1-.7-.3-1.3c-.2-.7-.4-1.3-.5-1.3-.1 0 0 .7.1 1.4l.2 1.4s.1.7.3 1.3c.1.6.3 1.3.3 1.3z"
                fill="url(#SVGID_17_)"
            />
            <g>
                <linearGradient
                    id="SVGID_18_"
                    gradientUnits="userSpaceOnUse"
                    x1={812.2211}
                    y1={126.3195}
                    x2={824.3411}
                    y2={126.3195}
                    gradientTransform="matrix(-1 0 0 1 912.618 0)"
                >
                    <stop offset={0} stopColor="#3f4068" />
                    <stop offset={1} stopColor="#594068" />
                </linearGradient>
                <path
                    d="M92.4 108.6s-.1 0-.2.1-.3.2-.5.4c-.4.3-1 .9-1.6 1.8-.5.8-1 1.9-1.3 3.1-.3 1.2-.5 2.5-.5 3.8-.1 2.6.2 5.2.4 7.1.2 1.9.5 3.2.5 3.2s.2 1.3.7 3.1c.5 1.9 1.3 4.3 2.7 6.6 1.3 2.2 3.2 4.1 4.9 5.1.8.5 1.5.9 2.1 1.1.3.1.5.2.6.2.1 0 .2.1.2.1s-.3-.1-.8-.4c-.5-.2-1.2-.6-2-1.2-1.6-1.1-3.4-3-4.6-5.2-1.3-2.2-2.1-4.6-2.6-6.5-.5-1.9-.7-3.1-.7-3.1s-.2-1.3-.5-3.2c-.3-1.9-.6-4.4-.6-7 0-1.3.2-2.5.4-3.7.3-1.2.7-2.2 1.2-3 1.1-1.8 2.3-2.4 2.2-2.4z"
                    fill="url(#SVGID_18_)"
                />
            </g>
            <g>
                <linearGradient
                    id="SVGID_19_"
                    gradientUnits="userSpaceOnUse"
                    x1={812.4616}
                    y1={149.1445}
                    x2={824.3341}
                    y2={149.1445}
                    gradientTransform="matrix(-1 0 0 1 912.618 0)"
                >
                    <stop offset={0} stopColor="#3f4068" />
                    <stop offset={1} stopColor="#594068" />
                </linearGradient>
                <path
                    d="M88.3 150.5c0 .1 1.5.2 3.1.1s3.1-.4 3.1-.4 1.5-.4 3-1c1.4-.6 2.8-1.4 2.7-1.5 0-.1-1.4.6-2.9 1.1-1.4.5-2.9.8-2.9.8s-1.5.4-3 .6c-1.6.2-3.1.2-3.1.3z"
                    fill="url(#SVGID_19_)"
                />
            </g>
            <g>
                <linearGradient
                    id="SVGID_20_"
                    gradientUnits="userSpaceOnUse"
                    x1={818.5452}
                    y1={149.3743}
                    x2={827.5625}
                    y2={149.3743}
                    gradientTransform="matrix(-1 0 0 1 912.618 0)"
                >
                    <stop offset={0} stopColor="#3f4068" />
                    <stop offset={1} stopColor="#594068" />
                </linearGradient>
                <path
                    d="M85.1 149.4c0 .1 1.1.5 2.2.6 1.2.2 2.3.1 2.3.1s1.2-.1 2.3-.5c1.1-.3 2.2-.9 2.1-.9 0-.1-1.1.3-2.2.6-1.1.2-2.2.3-2.2.3s-1.1.1-2.3.1c-1.1-.2-2.2-.4-2.2-.3z"
                    fill="url(#SVGID_20_)"
                />
            </g>
            <g className="st13flag">
                <linearGradient
                    id="SVGID_21_"
                    gradientUnits="userSpaceOnUse"
                    x1={794.4963}
                    y1={133.3594}
                    x2={797.1304}
                    y2={133.3594}
                    gradientTransform="matrix(-1 0 0 1 912.618 0)"
                >
                    <stop offset={0} stopColor="#3f4068" />
                    <stop offset={1} stopColor="#594068" />
                </linearGradient>
                <path
                    d="M115.5 133.4c0 .1.3.2.7.2.3.1.7.1.7.1s.3 0 .7-.1c.3-.1.6-.2.6-.3s-.3-.1-.7-.1h-.7s-.3 0-.6.1c-.4-.1-.7 0-.7.1z"
                    fill="url(#SVGID_21_)"
                />
                <linearGradient
                    id="SVGID_22_"
                    gradientUnits="userSpaceOnUse"
                    x1={799.0708}
                    y1={132.482}
                    x2={803.0941}
                    y2={132.482}
                    gradientTransform="matrix(-1 0 0 1 912.618 0)"
                >
                    <stop offset={0} stopColor="#3f4068" />
                    <stop offset={1} stopColor="#594068" />
                </linearGradient>
                <path
                    d="M109.5 131.8c0 .1.4.4.9.6.5.3 1 .4 1 .4s.5.1 1.1.2c.5.1 1.1 0 1.1 0 0-.1-.5-.2-1-.4s-1-.3-1-.3-.5-.1-1-.3c-.5 0-1-.2-1.1-.2z"
                    fill="url(#SVGID_22_)"
                />
                <g>
                    <linearGradient
                        id="SVGID_23_"
                        gradientUnits="userSpaceOnUse"
                        x1={809.6295}
                        y1={118.3906}
                        x2={812.8251}
                        y2={118.3906}
                        gradientTransform="matrix(-1 0 0 1 912.618 0)"
                    >
                        <stop offset={0} stopColor="#3f4068" />
                        <stop offset={1} stopColor="#594068" />
                    </linearGradient>
                    <path
                        d="M103 124.9c.1 0-.1-1.7-.3-3.4-.3-1.7-.6-3.3-.6-3.3s-.4-1.6-1-3.2c-.5-1.6-1.2-3.2-1.2-3.1-.1 0 .4 1.6.9 3.2l.8 3.2s.4 1.6.8 3.3c.2 1.7.5 3.3.6 3.3z"
                        fill="url(#SVGID_23_)"
                    />
                </g>
                <g>
                    <linearGradient
                        id="SVGID_24_"
                        gradientUnits="userSpaceOnUse"
                        x1={808.3777}
                        y1={128.848}
                        x2={808.9947}
                        y2={128.848}
                        gradientTransform="matrix(-1 0 0 1 912.618 0)"
                    >
                        <stop offset={0} stopColor="#3f4068" />
                        <stop offset={1} stopColor="#594068" />
                    </linearGradient>
                    <path
                        d="M104.1 131c.2 0 .1-2.2.1-2.2s-.3-2.1-.5-2.1-.1 2.2-.1 2.2.4 2.1.5 2.1z"
                        fill="url(#SVGID_24_)"
                    />
                </g>
            </g>
        </g>
        <g>
            <g fill="#ffc3a9">
                <path d="M96.4 64.9s3.3 7.5 2.5 16.6c-.8 9.1-4.7 11.6-13.6 10.8-8.9-.8-11.6-8.6-11.6-8.6s16-24.9 22.7-18.8z" />
                <path
                    d="M96.4 64.9s1 2.2 1.8 5.7c-.5-.1-1-.2-1.7-.6l-1.9 1.9s1.4.9-.5 3.6c0 0 1.3 4.3-3 6.6l-.7 2.5s4.9 2.2 7.8 1.2c-1.5 5-4.7 6.7-10.5 6.6-4-4.9-6.7-11.2-8.4-16.4 5.2-6.7 13-14.9 17.1-11.1z"
                    opacity={0.45}
                />
            </g>
            <linearGradient
                id="SVGID_25_"
                gradientUnits="userSpaceOnUse"
                x1={810.7844}
                y1={62.7477}
                x2={819.2053}
                y2={62.7477}
                gradientTransform="matrix(-1 0 0 1 912.618 0)"
            >
                <stop offset={0} stopColor="#3f4068" />
                <stop offset={1} stopColor="#594068" />
            </linearGradient>
            <path
                d="M94 58.5s1-3.4 3.5-2.3c2.5 1.2.5 3.8.5 3.8s2.1-1.3 3.1 1.2c1 2.6-1 2.8-1 2.8s3.8 3.4.3 5.1c-3.6 1.8-8.7-4.9-6.4-10.6z"
                fill="url(#SVGID_25_)"
            />
            <linearGradient
                id="SVGID_26_"
                gradientUnits="userSpaceOnUse"
                x1={818.9841}
                y1={78.6034}
                x2={839.0576}
                y2={78.6034}
                gradientTransform="matrix(-1 0 0 1 912.618 0)"
            >
                <stop offset={0} stopColor="#3f4068" />
                <stop offset={1} stopColor="#594068" />
            </linearGradient>
            <path
                d="M92.4 70.9s2.7 1.9.3 4.1c0 0 1.8 4.7-3.6 6 0 0 1.2 3.2-2.9 5.6-4.2 2.4-11.1 1-12.4-2.8C72.3 80 84 65 92.4 70.9z"
                fill="url(#SVGID_26_)"
            />
            <g className="st13flag">
                <linearGradient
                    id="SVGID_27_"
                    gradientUnits="userSpaceOnUse"
                    x1={813.8239}
                    y1={62.5012}
                    x2={816.1072}
                    y2={62.5012}
                    gradientTransform="matrix(-1 0 0 1 912.618 0)"
                >
                    <stop offset={0} stopColor="#3f4068" />
                    <stop offset={1} stopColor="#594068" />
                </linearGradient>
                <path
                    d="M97.6 65.8s.3 0 .6-.4c.3-.3.6-.8.6-1.4 0-.6-.2-1.2-.6-1.5-.2-.2-.4-.2-.5-.3h-.1v-.1c.1-.4.2-.9.1-1.4-.1-.5-.3-1-.6-1.2-.2-.3-.5-.4-.5-.4s.6.7.7 1.7c0 .4 0 .9-.2 1.2 0 0 0 .1-.1.1 0 .1-.1.2-.1.2-.1.1-.2.3-.2.4-.1.2-.2.3-.2.4.4-.1.6-.2.7-.2h.4c.1 0 .2.1.3.2.3.2.5.6.5 1.1 0 .5-.1.9-.3 1.2-.3.3-.5.4-.5.4z"
                    fill="url(#SVGID_27_)"
                />
                <linearGradient
                    id="SVGID_28_"
                    gradientUnits="userSpaceOnUse"
                    x1={823.6951}
                    y1={80.312}
                    x2={826.332}
                    y2={80.312}
                    gradientTransform="matrix(-1 0 0 1 912.618 0)"
                >
                    <stop offset={0} stopColor="#3f4068" />
                    <stop offset={1} stopColor="#594068" />
                </linearGradient>
                <path
                    d="M86.3 81.5c0 .1.5.2 1 0s.9-.5.9-.5.4-.4.6-.9c.2-.5.1-1 .1-1-.1 0-.2.5-.4.9s-.6.7-.6.7-.3.3-.7.6c-.4 0-.9.1-.9.2z"
                    fill="url(#SVGID_28_)"
                />
                <g>
                    <linearGradient
                        id="SVGID_29_"
                        gradientUnits="userSpaceOnUse"
                        x1={827.6131}
                        y1={84.3029}
                        x2={834.4791}
                        y2={84.3029}
                        gradientTransform="matrix(-1 0 0 1 912.618 0)"
                    >
                        <stop offset={0} stopColor="#3f4068" />
                        <stop offset={1} stopColor="#594068" />
                    </linearGradient>
                    <path
                        d="M78.2 84.3s-.1.3.2.8c.2.4.9.9 1.6.8.3 0 .7-.2.9-.4l.2-.1.1.1c.2.2.4.3.5.4.1.1.2.1.2.1s.4.1.9.1c.5-.1 1.2-.4 1.5-.9.8-1.1.8-2.4.7-2.4-.1 0-.2 1.2-1 2.1-.4.4-.9.6-1.3.7-.4 0-.6-.1-.6-.1s-.1 0-.2-.1c-.1 0-.2-.1-.4-.2v-.1l-.1-.1c-.1-.1-.2-.1-.3-.1-.1 0-.2.1-.3.1l-.2.2c-.2.2-.4.3-.7.3-.5.1-1.1-.2-1.3-.5-.3-.4-.4-.7-.4-.7z"
                        fill="url(#SVGID_29_)"
                    />
                </g>
            </g>
            <linearGradient
                id="SVGID_30_"
                gradientUnits="userSpaceOnUse"
                x1={812.1647}
                y1={63.9444}
                x2={812.4573}
                y2={63.9444}
                gradientTransform="matrix(-1 0 0 1 912.618 0)"
            >
                <stop offset={0} stopColor="#3f4068" />
                <stop offset={1} stopColor="#594068" />
            </linearGradient>
            <path d="M100.3 64l-.2-.2c.1 0 .2.1.3.1 0 .1 0 .1-.1.1z" opacity={0.25} fill="url(#SVGID_30_)" />
            <linearGradient
                id="SVGID_31_"
                gradientUnits="userSpaceOnUse"
                x1={810.7838}
                y1={62.7477}
                x2={819.2053}
                y2={62.7477}
                gradientTransform="matrix(-1 0 0 1 912.618 0)"
            >
                <stop offset={0} stopColor="#3f4068" />
                <stop offset={1} stopColor="#594068" />
            </linearGradient>
            <path
                d="M97.5 56.2c.3.1.5.3.6.4-1.5 0-3.2.3-1.7 1.9 2.1 2.4.8 3.8.5 4.1.3-.2 1.1-.7 1.7.7.7 1.7-1.5 4.3 1 3.5 1.3-.5 1.4-1.2 1.2-1.9.9 1.1 2 3.2-.4 4.4-3.5 1.7-8.6-5-6.4-10.7 0-.1 1-3.5 3.5-2.4z"
                opacity={0.25}
                fill="url(#SVGID_31_)"
            />
            <linearGradient
                id="SVGID_32_"
                gradientUnits="userSpaceOnUse"
                x1={819.036}
                y1={78.6033}
                x2={839.0576}
                y2={78.6033}
                gradientTransform="matrix(-1 0 0 1 912.618 0)"
            >
                <stop offset={0} stopColor="#3f4068" />
                <stop offset={1} stopColor="#594068" />
            </linearGradient>
            <path
                d="M92.4 70.9s1 .7 1.2 1.8c-.4 1-1.2 2.5-2.9 3.8L89 78.1s.9 1.4-.9 2.7c-1.8 1.3-2.7.8-2.7.8l-.8 2.8s1.9 1.8 3.9.1c-.5.7-1.2 1.4-2.4 2.1-4.2 2.4-11.1 1-12.4-2.8C72.3 80 84 65 92.4 70.9z"
                opacity={0.25}
                fill="url(#SVGID_32_)"
            />
            <g>
                <linearGradient
                    id="SVGID_33_"
                    gradientUnits="userSpaceOnUse"
                    x1={816.8459}
                    y1={70.0933}
                    x2={852.2563}
                    y2={70.0933}
                    gradientTransform="matrix(-1 0 0 1 912.618 0)"
                >
                    <stop offset={0} stopColor="#ad286b" />
                    <stop offset={1} stopColor="#45296b" />
                </linearGradient>
                <path
                    d="M93.9 56.8s3.1 5.4 1.4 11.4c-1.6 6-12.8 16.2-18.8 17s-5.8-1.8-5.8-1.8-4 1.8-7.9-.7c-4-2.5-4.5-17.3 8.8-22.2s16.7-7.5 22.3-3.7z"
                    fill="url(#SVGID_33_)"
                />
                <g className="st13flag">
                    <linearGradient
                        id="SVGID_34_"
                        gradientUnits="userSpaceOnUse"
                        x1={836.4218}
                        y1={80.0487}
                        x2={844.7703}
                        y2={80.0487}
                        gradientTransform="matrix(-1 0 0 1 912.618 0)"
                    >
                        <stop offset={0.1541} stopColor="#889beb" />
                        <stop offset={1} stopColor="#889beb" />
                    </linearGradient>
                    <path
                        d="M67.8 83.7s.4 0 .9-.1 1.2-.3 1.9-.6 1.3-.8 1.7-1.2l.7-.7s1-1.1 1.8-2.3c.8-1.2 1.5-2.5 1.4-2.5-.1 0-.9 1.2-1.7 2.3-.9 1.1-1.9 2.2-1.9 2.2s-.2.3-.6.7c-.4.4-.9.8-1.5 1.2-1.3.6-2.7 1-2.7 1z"
                        fill="url(#SVGID_34_)"
                    />
                    <linearGradient
                        id="SVGID_35_"
                        gradientUnits="userSpaceOnUse"
                        x1={837.0812}
                        y1={81.6939}
                        x2={842.0597}
                        y2={81.6939}
                        gradientTransform="matrix(-1 0 0 1 912.618 0)"
                    >
                        <stop offset={0.1541} stopColor="#889beb" />
                        <stop offset={1} stopColor="#889beb" />
                    </linearGradient>
                    <path
                        d="M70.6 82.9c0 .1.7.1 1.5-.1.7-.1 1.4-.5 1.4-.5s.7-.4 1.2-.8c.6-.5 1-1.1.9-1.1-.1-.1-.6.4-1.2.8s-1.2.7-1.2.7-.6.3-1.3.6c-.6.2-1.3.3-1.3.4z"
                        fill="url(#SVGID_35_)"
                    />
                    <g>
                        <linearGradient
                            id="SVGID_36_"
                            gradientUnits="userSpaceOnUse"
                            x1={818.3638}
                            y1={64.5093}
                            x2={821.3744}
                            y2={64.5093}
                            gradientTransform="matrix(-1 0 0 1 912.618 0)"
                        >
                            <stop offset={0.1541} stopColor="#889beb" />
                            <stop offset={1} stopColor="#889beb" />
                        </linearGradient>
                        <path
                            d="M91.2 70.8c.1 0 1-1.3 1.7-2.8.7-1.5 1-3.1 1-3.1s.3-1.6.3-3.3c0-1.7-.4-3.3-.5-3.3-.1 0 .2 1.6.1 3.3-.1 1.6-.4 3.2-.4 3.2s-.3 1.6-.8 3.1c-.6 1.4-1.4 2.8-1.4 2.9z"
                            fill="url(#SVGID_36_)"
                        />
                    </g>
                    <g>
                        <linearGradient
                            id="SVGID_37_"
                            gradientUnits="userSpaceOnUse"
                            x1={823.0159}
                            y1={77.6074}
                            x2={834.4358}
                            y2={77.6074}
                            gradientTransform="matrix(-1 0 0 1 912.618 0)"
                        >
                            <stop offset={0.1541} stopColor="#889beb" />
                            <stop offset={1} stopColor="#889beb" />
                        </linearGradient>
                        <path
                            d="M78.2 82.5c0 .1 1.8-.7 3.4-1.8 1.6-1 3.1-2.3 3.1-2.3s1.4-1.3 2.7-2.7c1.3-1.4 2.3-3 2.3-3.1-.1 0-1.2 1.5-2.5 2.8-1.3 1.4-2.8 2.6-2.8 2.6s-1.4 1.3-2.9 2.3c-1.7 1.2-3.4 2.1-3.3 2.2z"
                            fill="url(#SVGID_37_)"
                        />
                    </g>
                </g>
                <linearGradient
                    id="SVGID_38_"
                    gradientUnits="userSpaceOnUse"
                    x1={816.8459}
                    y1={70.4171}
                    x2={852.2533}
                    y2={70.4171}
                    gradientTransform="matrix(-1 0 0 1 912.618 0)"
                >
                    <stop offset={0} stopColor="#ad286b" />
                    <stop offset={1} stopColor="#45296b" />
                </linearGradient>
                <path
                    d="M76.5 85.1c-6 .7-5.8-1.8-5.8-1.8s-4 1.8-7.9-.7c-3.3-2.1-4.2-12.4 3-18.7-2.5 4.1-4 10.6 0 13.6 5.1 3.8 11.9-6.3 11.9-6.3s-.8 6.5 6.8 2.1c6.4-3.7 7.2-14.2 7.2-17.6.7.3 1.4.7 2.1 1.2 0 0 3.1 5.4 1.4 11.4-1.5 5.8-12.7 16.1-18.7 16.8z"
                    fill="url(#SVGID_38_)"
                />
                <g className="st13flag">
                    <linearGradient
                        id="SVGID_39_"
                        gradientUnits="userSpaceOnUse"
                        x1={817.5954}
                        y1={65.1352}
                        x2={819.1333}
                        y2={65.1352}
                        gradientTransform="matrix(-1 0 0 1 912.618 0)"
                    >
                        <stop offset={0.1541} stopColor="#889beb" />
                        <stop offset={1} stopColor="#889beb" />
                    </linearGradient>
                    <path
                        d="M93.5 68.7c.1 0 .5-.8.8-1.7.3-.9.5-1.8.5-1.8s.1-.9.1-1.9c0-.9-.1-1.9-.2-1.9s-.1.9-.2 1.8-.3 1.8-.3 1.8-.1.9-.4 1.8c-.1 1-.4 1.9-.3 1.9z"
                        fill="url(#SVGID_39_)"
                    />
                    <linearGradient
                        id="SVGID_40_"
                        gradientUnits="userSpaceOnUse"
                        x1={820.7633}
                        y1={75.8464}
                        x2={829.2503}
                        y2={75.8464}
                        gradientTransform="matrix(-1 0 0 1 912.618 0)"
                    >
                        <stop offset={0.1541} stopColor="#889beb" />
                        <stop offset={1} stopColor="#889beb" />
                    </linearGradient>
                    <path
                        d="M83.4 80.1c0 .1 1.4-.7 2.6-1.6 1.2-.9 2.3-2 2.3-2s1.1-1.1 2-2.3c.9-1.2 1.7-2.5 1.6-2.6-.1 0-.9 1.2-1.9 2.3-1 1.1-2.1 2.2-2.1 2.2s-1 1.1-2.2 2.1c-1.1 1-2.4 1.8-2.3 1.9z"
                        fill="url(#SVGID_40_)"
                    />
                    <linearGradient
                        id="SVGID_41_"
                        gradientUnits="userSpaceOnUse"
                        x1={840.301}
                        y1={80.8069}
                        x2={850.231}
                        y2={80.8069}
                        gradientTransform="matrix(-1 0 0 1 912.618 0)"
                    >
                        <stop offset={0.1541} stopColor="#889beb" />
                        <stop offset={1} stopColor="#889beb" />
                    </linearGradient>
                    <path
                        d="M62.4 80.5s.2.3.6.7c.4.4.9.9 1.7 1.2.7.3 1.5.3 2.1.2.6-.1.9-.2.9-.2s1.4-.5 2.6-1.4c1.2-.8 2.2-1.9 2.1-2-.1-.1-1.1.9-2.4 1.6-1.2.7-2.6 1.2-2.6 1.2s-.3.1-.8.3c-.5.1-1.2.2-1.8 0-1.4-.5-2.3-1.7-2.4-1.6z"
                        fill="url(#SVGID_41_)"
                    />
                    <g>
                        <linearGradient
                            id="SVGID_42_"
                            gradientUnits="userSpaceOnUse"
                            x1={822.9614}
                            y1={57.7602}
                            x2={832.2209}
                            y2={57.7602}
                            gradientTransform="matrix(-1 0 0 1 912.618 0)"
                        >
                            <stop offset={0.1541} stopColor="#889beb" />
                            <stop offset={1} stopColor="#889beb" />
                        </linearGradient>
                        <path
                            d="M80.4 58.8c0 .1 1.2-.3 2.3-.6 1.1-.3 2.3-.6 2.3-.6s1.1-.3 2.3-.5c1.2-.2 2.3-.1 2.4-.2 0-.1-1.2-.3-2.4-.2-1.2.1-2.4.3-2.4.3s-1.2.3-2.3.7c-1.1.5-2.2 1-2.2 1.1z"
                            fill="url(#SVGID_42_)"
                        />
                    </g>
                    <g>
                        <linearGradient
                            id="SVGID_43_"
                            gradientUnits="userSpaceOnUse"
                            x1={834.6693}
                            y1={64.2581}
                            x2={847.3563}
                            y2={64.2581}
                            gradientTransform="matrix(-1 0 0 1 912.618 0)"
                        >
                            <stop offset={0.1541} stopColor="#889beb" />
                            <stop offset={1} stopColor="#889beb" />
                        </linearGradient>
                        <path
                            d="M65.3 68.3s.3-.4.7-1c.4-.6 1-1.3 1.7-2 1.4-1.3 3.1-2.2 3.1-2.2s.4-.2 1.1-.6c.6-.3 1.5-.7 2.4-1 1.8-.7 3.7-1.3 3.6-1.3 0 0-.5.1-1.2.2-.7.2-1.7.4-2.6.7-.9.3-1.8.6-2.5 1-.7.3-1.1.5-1.1.5s-1.8.9-3.1 2.4c-.7.7-1.3 1.5-1.6 2.2-.4.6-.6 1.1-.5 1.1z"
                            fill="url(#SVGID_43_)"
                        />
                    </g>
                </g>
            </g>
        </g>
        <g>
            <linearGradient
                id="SVGID_44_"
                gradientUnits="userSpaceOnUse"
                x1={15.1822}
                y1={99.7722}
                x2={99.9844}
                y2={99.7722}
            >
                <stop offset={0} stopColor="#903acf" />
                <stop offset={1} stopColor="#cf4a78" />
            </linearGradient>
            <path
                d="M96.5 88.8s2.2 4.9.7 9.4c0 0 4.7 2.7 1.7 8.9s-22-1.7-26-4c0 0-23.7-4.5-29.7 2 0 0 5.9 10.4-1.5 13.8s-21 .7-21 .7L15 103.3s14.3 6.4 15.1 2.2c.7-4.2-4.7-9.1 4-12.1l4.5-14.6S64.8 89.7 71.5 86c.1 0 14.1-4.4 25 2.8z"
                fill="url(#SVGID_44_)"
            />
            <path
                className="st1flag"
                d="M15.2 103.3s14.3 6.4 15.1 2.2c0 0 1.4 3.6-3.5 5.5-2.3.9-5.6 1.1-8.5 1.1l-3.1-8.8z"
            />
            <linearGradient
                id="SVGID_45_"
                gradientUnits="userSpaceOnUse"
                x1={34.2255}
                y1={94.1141}
                x2={99.7241}
                y2={94.1141}
            >
                <stop offset={0} stopColor="#903acf" />
                <stop offset={1} stopColor="#cf4a78" />
            </linearGradient>
            <path
                d="M40.5 95c3.5-.3 4.6-3 4.6-3s-6.2-.2-8.1.6c-.9.4-2 .7-2.8.9l4.4-14.6s26.2 10.9 32.9 7.2c0 0 14.1-4.5 25 2.7 0 0 .3.8.7 2-1.6-.8-9.9-4.6-12.3-1.1-2.4 3.5 8.8 10.3 12.5 8.2 0 .1-.1.3-.1.4 0 0 1.8 1 2.5 3.3-.6-.3-1.4-.5-2.6-.2-3.2.8-6.2.2-11.1-2.4-4.9-2.6-11.2-3.2-11.2.7 0 3.4 17.3 9.6 24.1 7.7-3.1 6-22-1.8-25.9-4 0 0-23.7-4.5-29.7 2 0 0-3.3-3-4.5-5.6-1.3-2.9-1.9-4.6 1.6-4.8z"
                fill="url(#SVGID_45_)"
            />
            <path
                className="st1flag"
                d="M30.5 106.6s-.3 1.2-1 2.2c-.7 1-1.8 1.6-1.8 1.5 0-.1.9-.7 1.5-1.8.6-1 .8-2.1.8-2.1s0-.1.1-.3c.1-.2.2-.3.2-.6.1-.8.1-1.6-.1-2.5-.1-.7-.1-1.2-.1-1.2.1 0 .4 1.1.5 2.3.1.6.1 1.2 0 1.7 0 .5-.1.8-.1.8zM96.7 98.2c.4-1.2.5-2.4.5-2.4s.2-1.2.1-2.4-.5-2.4-.4-2.4c.1 0 .5 1 .8 2.1.1 1.2.2 2.4-.1 3.7-.1.4-.3 1-.5 1.5-.3.6-.6 1.2-.9 1.6H96c.2-.4.5-1 .7-1.7zM97.3 100.1h-1.2l.1-.1c.7 0 1.1 0 1.1.1zM95.7 100.5s0-.2.2-.4h.2c-.2.2-.3.4-.4.4zM50 91.4c-1.6.2-3.8.6-6 .8-1.1.1-2.2.2-3.2.2s-2-.1-2.8 0c-.8.1-1.5.3-1.9.5-.4.2-.6.4-.6.4s0-.1.1-.1c.1-.1.2-.2.5-.3.4-.3 1.1-.5 1.9-.6.8-.1 1.8-.1 2.8-.1 1 0 2.1-.1 3.2-.2 2.2-.3 4.3-.7 6-.9 1.6-.3 2.7-.4 2.7-.4s4.3-.6 8.7-1.2c2.2-.3 4.3-.7 5.9-1.2.8-.2 1.4-.4 1.9-.6.4-.2.7-.3.7-.2 0 0-.2.2-.7.3-.4.2-1.1.5-1.9.7-1.6.5-3.7 1-5.9 1.3-4.3.7-8.7 1.4-8.7 1.4s-1-.1-2.7.2zM38.3 99c-.3-.6-.5-1.5-.4-2.4 0-.4.2-.9.4-1.2.2-.4.5-.7.9-.8.4 0 .6.1.8.2.2.1.2.2.2.2s-.1 0-.3-.1c-.2 0-.4-.1-.7-.1-.3 0-.5.3-.6.7-.1.3-.2.7-.2 1.1 0 .8.2 1.6.5 2.1s.5.9.5.9c-.1 0 4 5.3 3.9 5.4-.1.1-4.4-5-4.3-5.1-.2.1-.5-.3-.7-.9zM69.8 100.6c-.7-1-1.1-2.2-1.3-3-.2-.9-.3-1.5-.3-1.5s-.1-.6-.1-1.5.1-2.1.4-3.3c.3-1.2.7-2.3 1.1-3.1.4-.8.7-1.3.8-1.3 0 0-.2.5-.6 1.4-.3.8-.7 1.9-.9 3.1-.2 1.1-.3 2.3-.2 3.2 0 .9.1 1.4.1 1.4s.1.6.2 1.4c.2.8.5 2 1.1 2.9.6.9 1.5 1.7 2.2 2.2.3.2.5.4.7.5 0 0-.2 0-.4-.1-.1-.1-.3-.2-.4-.3-.7-.3-1.7-1-2.4-2zM89.5 98.7c-1.9-.6-3.7-1.5-5-2.2-1.3-.7-2.2-1.2-2.2-1.2s-.9-.5-2.1-1.3c-1.2-.8-2.9-1.9-4.4-3.3-1.5-1.3-2.8-2.9-3.5-4.2-.1-.3-.3-.5-.4-.7h.2c.1.2.2.4.4.6.8 1.2 2.1 2.7 3.6 4 1.5 1.3 3.1 2.3 4.4 3.1 1.3.8 2.1 1.3 2.1 1.3s.8.5 2.1 1.2 3.1 1.6 4.9 2.2c1.8.7 3.8 1.2 5.2 1.4.4.1.8.1 1.1.2 0 .1-.1.1-.1.2-.3 0-.7-.1-1.1-.1-1.4-.1-3.3-.5-5.2-1.2z"
            />
            <linearGradient
                id="SVGID_46_"
                gradientUnits="userSpaceOnUse"
                x1={37.8616}
                y1={94.2615}
                x2={72.6337}
                y2={94.2615}
            >
                <stop offset={0} stopColor="#903acf" />
                <stop offset={1} stopColor="#cf4a78" />
            </linearGradient>
            <path
                d="M38.1 95.8c.2.3 2.6 4.6 10.2 4.7 7.9.1 16.3-3.1 16.5-5.9.2-2.8 3.1-6.6 3.1-6.6l-5.6 1.2L44 91.9h-2.7c3-1.1 9.3-3.6 11.1-5.1 1.1-.9.2-2.2-1.1-3.5 7 2.2 15.1 4.2 19.2 3-.6 1.6-2.4 6.9-2 10.3.4 4 4.1 6.3 4.1 6.3-3.1-.5-23.8-3.9-29.3 2.1 0 0-3.3-3-4.5-5.6-.7-1.5-1.3-2.8-.7-3.6z"
                fill="url(#SVGID_46_)"
            />
            <g className="st13flag">
                <path
                    className="st18flag"
                    d="M96.3 96.7c.1 0 .3-.6.4-1.2.1-.6.1-1.3.1-1.3s-.1-.6-.3-1.2c-.2-.6-.5-1.1-.6-1.1-.1 0 .1.6.2 1.2s.1 1.2.1 1.2.1.6.1 1.2c-.1.6-.1 1.2 0 1.2zM32.8 105.3s.2-.4.3-1.1c.1-.7.1-1.6-.3-2.4-.3-.9-.8-1.6-1.1-2.2-.2-.6-.3-1-.3-1s-.1-.4.1-1c.1-.6.5-1.3 1.2-1.9 1.3-1.1 3.2-1.3 3.1-1.4 0 0-.4 0-1.1.1-.7.1-1.5.4-2.3 1-.7.5-1.3 1.4-1.4 2.1-.2.7-.1 1.2-.1 1.2s0 .5.3 1.1c.3.6.8 1.3 1.2 2.1.3.8.4 1.6.4 2.3.1.7-.1 1.1 0 1.1zM30.1 119.3s.2.1.5.1.8.1 1.3.1c1.1.1 2.6.1 4.1 0 1.5-.1 3-.3 4.1-.5 1.1-.2 1.8-.4 1.8-.4s.2-.1.5-.2.8-.4 1.2-.8c.9-.8 1.5-2.3 1.5-3.9 0-1.5-.6-3-1-4-.2-.5-.4-.9-.6-1.2-.2-.3-.2-.4-.3-.4 0 0 .3.7.6 1.7.4 1 .9 2.5.8 3.9 0 1.4-.7 2.8-1.5 3.5-.4.3-.8.6-1.1.7-.3.1-.5.2-.5.2s-.7.2-1.8.5c-1.1.2-2.5.5-4 .6-1.5.1-2.9.2-4.1.2-.8-.1-1.5-.2-1.5-.1zM22.8 117.7c0 .1.6.4 1.2.7.6.3 1.3.4 1.3.4s.7.1 1.4.1 1.4 0 1.4-.1-.7-.2-1.3-.3c-.7-.1-1.3-.3-1.3-.3s-.7-.1-1.3-.3c-.7-.1-1.4-.3-1.4-.2zM38.4 85.2c.1 0 .9-1.5 1.8-3 .1-.2.2-.4.3-.5.1-.1.2 0 .4 0 .4.2.7.3 1 .5.6.3 1 .4 1 .4s1.7.6 3.4 1 3.4.7 3.5.6c0-.1-1.7-.5-3.4-1S43.1 82 43.1 82s-.4-.2-1-.4c-.3-.1-.7-.3-1-.4-.2-.1-.5-.2-.8 0-.2.2-.3.4-.4.6-.9 1.8-1.6 3.4-1.5 3.4z"
                />
            </g>
        </g>
        <g>
            <path
                className="st56"
                d="M83.5 133.8s-.2 19.3-8.6 23c-8.4 3.7-24.9.7-31-7.7-6.1-8.4.1-31.5 4.7-36.4s32.2 3.3 34.9 21.1z"
            />
            <path
                className="st57"
                d="M74.4 129l8.2 1.3c.4 1.1.7 2.3.9 3.5 0 0-.2 19.3-8.6 23-.5.2-1.1.4-1.7.6-2.1-1.5-3.8-3.9-4.1-7-.7-7.5 5.1-21.9 5.1-21.9l.2.5z"
            />
            <path
                className="st58"
                d="M46.8 115.3c.6-1.1 1.2-2 1.8-2.6 4.6-4.9 32.2 3.3 34.9 21.1 0 0 0 .7-.1 1.9-5.4.1-36.4-18.8-36.4-18.8s-.1-.6-.2-1.6z"
            />
            <g className="st7flag">
                <path
                    className="st56"
                    d="M42.9 138.6v-1.3c0-.8.1-1.7.2-2.7.1-1 .3-2 .5-2.7.1-.7.2-1.2.2-1.2l.6-4c.1-1 .3-2 .4-2.7.1-.8.2-1.3.1-1.3 0 0-.2.5-.3 1.2-.2.7-.4 1.7-.6 2.7l-.8 4s-.1.5-.2 1.2-.3 1.7-.4 2.8c-.1 1-.1 2 0 2.8.1.7.3 1.2.3 1.2z"
                />
            </g>
            <g className="st7flag">
                <path
                    className="st56"
                    d="M68.4 150v-1.4-3.1c.1-2.2.5-4.4.5-4.4s.3-2.2 1-4.3c.3-1.1.7-2.1 1.1-2.9.3-.8.6-1.3.5-1.3 0 0-.3.5-.7 1.2-.4.7-.8 1.8-1.2 2.8-.8 2.1-1.2 4.3-1.2 4.3s-.4 2.2-.4 4.5c0 1.1.1 2.2.2 3.1 0 1 .1 1.5.2 1.5z"
                />
            </g>
            <g className="st7flag">
                <path
                    className="st56"
                    d="M58.8 154.6c0 .1 1.1.6 2.2 1 1.2.4 2.4.6 2.4.6s1.2.1 2.4.1 2.4-.3 2.4-.4c0-.1-1.2 0-2.4 0s-2.4-.2-2.4-.2-1.2-.1-2.3-.4c-1.1-.4-2.2-.8-2.3-.7z"
                />
            </g>
        </g>
        <g>
            <path
                className="st59"
                d="M85.6 113.5s4.9-.8 6.8 6c1.9 6.8-3.8 14-8.9 14.3-5.1.3-36.4-18.8-36.4-18.8s-2.5-12.2 2.6-15.9 35.9 14.4 35.9 14.4z"
            />
            <path
                className="st60"
                d="M80.2 118.4c-1.6 3.5-3.2 10.8.6 14.8C71.6 130 47.1 115 47.1 115s-2.5-12.2 2.6-15.9c5.1-3.6 35.9 14.3 35.9 14.3s-3.4.8-5.4 5z"
            />
            <g className="st13flag">
                <path
                    className="st60"
                    d="M81 116.7s0 .1.1.3c-.1.1-.1.2-.2.3 0-.4.1-.6.1-.6zM47.1 115s-2.5-12.2 2.6-15.9c.2-.1.4-.2.7-.3-.8 2.4-1.9 6.2-1.6 9 .4 4.4 16.3 14.3 23.7 15.2 3.6.4 5.6-1 6.8-2.6-1.2 3.8-1.8 9.4 1.4 12.7C71.6 130 47.1 115 47.1 115z"
                />
            </g>
            <g className="st13flag">
                <path
                    className="st59"
                    d="M81.9 133.2s-.7-.3-1.4-1c-.7-.8-1.3-2.1-1.5-3.5-.3-1.4-.2-2.8-.1-3.9s.2-1.7.2-1.7.1-.7.4-1.7c.3-1 .7-2.4 1.5-3.6.7-1.2 1.7-2.3 2.5-2.9.8-.7 1.5-1 1.4-1 0 0-.2 0-.5.2-.3.1-.7.4-1.1.7-.9.6-1.9 1.7-2.7 2.9-.8 1.2-1.3 2.6-1.6 3.6-.3 1-.4 1.8-.4 1.8s-.1.7-.2 1.8-.1 2.5.3 4c.3 1.4.9 2.8 1.7 3.6.4.4.8.6 1.1.7h.4z"
                />
                <path
                    className="st59"
                    d="M86.5 124.5s.2-.2.4-.7c.2-.4.5-1.1.6-1.9 0-.4.1-.9-.1-1.4-.1-.5-.4-1-.9-1.3-.2-.2-.6-.2-.9-.1-.3.1-.5.3-.7.4-.4.3-.8.8-1.1 1.3-.6 1-.9 2.1-1.1 3.1-.2 1-.3 2-.3 2.8 0 .9.2 1.6.5 2 .3.4.5.6.5.6s.2.2.7.5c.5.2 1.3.3 2.1-.1s1.5-1.1 2.1-2c.6-.9 1.1-1.9 1.4-2.9.3-1.1.5-2.2.4-3.2-.1-1-.3-2-.6-2.8-.3-.8-.7-1.3-1-1.7l-.4-.4-.1-.1c-.1 0 .7.8 1.3 2.4.3.8.5 1.7.5 2.7 0 1-.1 2.1-.5 3.1-.3 1-.8 2-1.4 2.8-.6.8-1.2 1.5-1.9 1.8-.7.3-1.3.2-1.7.1-.4-.2-.5-.4-.5-.4s-.2-.2-.4-.5c-.2-.4-.4-1-.5-1.8 0-.8.1-1.7.3-2.7.2-1 .5-2 1-2.9.3-.5.6-.9 1-1.2.4-.3.8-.6 1.2-.4.4.2.6.7.8 1.1.1.4.1.9.1 1.3-.1.8-.3 1.4-.5 1.9l-.3.6z"
                />
                <path
                    className="st59"
                    d="M81.1 127.2c.1 0 0-1.6.2-3.2.1-.8.2-1.6.4-2.2l.3-.9s.1-.4.4-.9c.3-.5.7-1.2 1.2-1.8.5-.6 1.2-1 1.7-1.3.5-.3.9-.4.9-.4s-.4 0-1 .2-1.3.7-1.9 1.2c-.6.6-1.1 1.3-1.4 1.8-.3.6-.5.9-.5.9s-.1.4-.3 1c-.2.6-.3 1.4-.3 2.3 0 1.7.2 3.3.3 3.3zM88.5 129.3c.1 0 .9-1 1.6-2.2.3-.6.6-1.2.8-1.7.2-.5.3-.8.3-.8s.1-.3.2-.9c.1-.5.1-1.2 0-1.9-.1-1.4-.5-2.7-.6-2.6-.1 0 .2 1.3.2 2.7 0 .7 0 1.3-.1 1.8s-.2.8-.2.8-.1.3-.2.8c-.2.5-.4 1.1-.7 1.7-.7 1.1-1.4 2.2-1.3 2.3zM81.3 130.1c-.1 0 0 .7.5 1.2.4.5 1.1.8 1.1.8s.7.2 1.3.1c.7-.1 1.2-.5 1.1-.6 0-.1-.6.2-1.2.2s-1.1-.2-1.1-.2-.5-.2-1-.6c-.4-.3-.6-.9-.7-.9z"
                />
            </g>
        </g>
        <g>
            <path
                className="st57"
                d="M64.2 140.9c-.4-.4-.8-.7-1.4-.9-3.5-1.1-7-2.8-10.3-4.4-1.3-.7-2.6-1.3-3.9-2.1-.5-.3-1.1-1-1.7-1.2-2.2-1-2.9 4.3-3.2 5.6-.5 2.4-.9 5.3.5 7.5 2.3 3.7 6.9 5.8 10.9 7.1 3.4 1.1 7.3 1.3 9.2-2.3 1.1-2.3 1.9-7.2-.1-9.3z"
            />
            <path
                className="st57"
                d="M46.9 132.3c.6.2 1.2.9 1.7 1.2 1.2.8 2.6 1.4 3.9 2.1 3.3 1.6 6.8 3.3 10.3 4.4.6.2 1.1.5 1.4.9.2.2.3.4.5.6-.2.7-.4 1.3-.7 1.8-1.8 3.6-5.8 3.4-9.2 2.3-4-1.3-8.6-3.4-10.9-7.1-.1-.1-.1-.3-.2-.4v-.2c.3-1.3 1-6.6 3.2-5.6z"
            />
            <g className="st7flag">
                <path
                    className="st56"
                    d="M54.3 143.3c0-.1-1.6-.5-3.1-1.2-.7-.3-1.4-.7-1.9-1.1-.5-.3-.8-.6-.8-.6s-.3-.2-.8-.6c-.4-.4-1-1-1.4-1.7-.4-.7-.5-1.5-.4-2.1.1-.6.3-1 .2-1 0 0-.3.3-.4 1-.2.6-.1 1.5.2 2.3.3.8.9 1.4 1.4 1.9.5.4.8.7.8.7s.3.3.9.6c.5.3 1.3.7 2.1 1 1.5.6 3.1.9 3.2.8z"
                />
            </g>
            <g className="st7flag">
                <path
                    className="st56"
                    d="M52.4 150.1c.1-.1-1.3-.9-2.8-1.5-.7-.3-1.4-.7-1.9-1-.5-.3-.8-.5-.8-.5s-.3-.2-.8-.6c-.4-.4-1-.9-1.3-1.6-.4-.7-.6-1.4-.6-2-.1-.6 0-1-.1-1 0 0-.1.4-.1 1s.1 1.4.5 2.2c.3.7.9 1.4 1.3 1.8.4.4.8.7.8.7s.3.2.9.5c.5.3 1.2.6 2 .9.7.3 1.5.6 2 .8.5.2.9.4.9.3z"
                />
            </g>
        </g>
        <g>
            <path className="st57" d="M80.8 140s1.1 1.1.3 4.2-2.6 7-6 5.9c-3.5-1-3.4-6.7-2.3-10.2 1.1-3.4 8 .1 8 .1z" />
            <path
                className="st57"
                d="M78.5 143c-2.4 0-3.9-2.3-4.8-4.2 2.2-1.3 7 1.2 7 1.2s.4.4.6 1.5c-.2.8-1 1.5-2.8 1.5z"
            />
            <g className="st7flag">
                <path
                    className="st56"
                    d="M76.7 141.8c0 .1.4.4.9.5.5.2 1.1.2 1.1.2h.4c.2 0 .6-.2.7-.4.4-.5.4-1 .3-1-.1 0-.3.5-.6.8-.3.3-.8.2-.8.2s-.5 0-1-.1c-.5-.2-1-.3-1-.2z"
                />
            </g>
            <g className="st7flag">
                <path
                    className="st56"
                    d="M74.9 148.7s.1.2.5.4c.3.2.9.3 1.4.2.5-.1 1-.5 1.2-.8.3-.3.4-.5.4-.5s.6-.8 1-1.8c.4-.9.6-1.9.5-1.9-.1 0-.4.9-.9 1.8-.5.8-1.1 1.6-1.1 1.6s-.1.2-.3.5c-.2.3-.5.6-.9.7-.4.1-.9.1-1.2 0-.3-.1-.5-.2-.6-.2z"
                />
            </g>
        </g>
        <g>
            <path
                className="st56"
                d="M121.3 187.9s-7.2 2.4-16.3-2.7l-3.6 27.4s9.2 3.1 19.2 1.3 11.2-6.1 8.4-8.7c-3.4-3.1-12-2.1-12-2.1s4.8-11.2 4.3-15.2z"
            />
            <path
                className="st57"
                d="M105 185.2c9 5.1 16.3 2.7 16.3 2.7.1.9 0 2.2-.3 3.6-1.4.8-2.8 1.3-2.8 1.3-4 1.9-10.3-.4-10.3-.4s-5.2 19.4 10.6 17.8c9.1-.9 10.8-3.1 10.7-4.8 2.7 2.6 1.3 6.8-8.5 8.6-10 1.8-19.2-1.3-19.2-1.3l3.5-27.5zm14.9 17.7c-1.7 0-2.9.1-2.9.1s.4-.9 1-2.4c-.8 1.5-1.3 2.6-1.3 2.6l-2.3 3.7c-.1 0 3.1-1.4 5.5-4z"
            />
            <path
                d="M115.3 205.2c.5-.9.9-1.8.9-1.8l1-1.8c.5-.9.9-1.8 1-1.8.1 0-.2 1-.6 2-.4 1-.8 1.9-.8 1.9s-.5.9-1.1 1.7c-.6.8-1.2 1.6-1.3 1.6-.2-.1.4-1 .9-1.8zm-4.8-12.8c0 .1 1.1.5 2.3.7 1.2.2 2.4.2 2.4.2s1.2-.1 2.4-.5 2.2-1 2.2-1c0-.1-1.1.4-2.3.7-1.2.3-2.3.3-2.3.3s-1.2.1-2.3 0c-1.2-.1-2.3-.5-2.4-.4zm-5-3.3c0 .1.8.6 1.7 1.2l1.8 1s1 .4 2 .6c1 .2 2.1.1 2.1 0s-1-.1-2-.4c-1-.3-1.9-.7-1.9-.7s-.9-.4-1.9-.8c-.8-.6-1.7-1-1.8-.9zm-.6 22.7s.2.1.5.2.8.2 1.4.3c1.1.3 2.7.5 4.2.6 1.5.1 3.1.1 4.3.1 1.2-.1 1.9-.1 1.9-.1s.8-.1 1.9-.3c1.1-.2 2.7-.6 4.1-1 1.5-.5 2.9-1 4-1.5.5-.2 1-.5 1.3-.6.3-.2.5-.3.5-.3s-.7.3-1.8.7c-1.1.4-2.5.9-4 1.3s-3 .7-4.1.9c-1.1.2-1.9.2-1.9.2s-.8.1-1.9.2c-1.1.1-2.7.1-4.2.1-1.5-.1-3.1-.2-4.2-.4-1.2-.3-1.9-.4-2-.4zm-1.1-.1"
                opacity={0.35}
                fill="#6560a2"
            />
            <path
                className="st56"
                d="M116 201.7c.1 0 .6-.9 1.1-1.8.5-.9.9-1.9.9-1.9s.4-1 .6-2c.3-1 .5-2 .5-2-.1 0-.4.9-.8 1.9-.4.9-.8 1.9-.8 1.9s-.4 1-.7 1.9c-.5 1-.9 2-.8 2zM114.6 205c.1 0 .5-.5.5-.5s.1-.6-.1-.6c-.1 0-.5.5-.5.5s0 .5.1.6zM123.1 204.6c0 .1.6.2 1.1.3.5.1 1.1.3 1.1.3s.5.1 1.1.3c.5.2 1.1.4 1.1.3 0-.1-.4-.4-.9-.7-.5-.3-1.1-.5-1.1-.5l-1.2-.2c-.6.1-1.2.1-1.2.2z"
            />
        </g>
        <g>
            <path
                className="st56"
                d="M74.7 194.9s-7.7.2-15.2-6.9l-10.2 25.7s8.1 5.3 18.3 5.9c10.2.7 12.4-3.2 10.2-6.4-2.6-3.9-11.1-5-11.1-5s7.5-9.3 8-13.3z"
            />
            <g opacity={0.35}>
                <path
                    className="st56"
                    d="M66.2 198.2c0 .1.8.5 1.7.7.9.2 1.8.3 1.8.3s.9 0 1.9-.1c.9-.1 1.8-.4 1.8-.5 0-.1-.9.1-1.8.1h-1.8s-.9 0-1.8-.1c-.9-.2-1.7-.5-1.8-.4zM64.4 212c0 .1.5-.2.8-.5.4-.3.7-.7.7-.7s.3-.4.4-.9c.2-.5.3-.9.2-1-.1 0-.3.4-.6.8s-.6.7-.6.7-.2.4-.5.8c-.1.4-.4.7-.4.8zM66.6 212.1c.1 0 .2-.4.4-.8.1-.4.2-.9.2-.9s0-.4-.1-.9c-.1-.4-.2-.9-.2-.9-.1 0-.1.4-.2.9-.1.4-.1.8-.1.8v1.8zM60.9 216.8s.5.2 1.2.4c.8.2 1.8.4 2.8.6 2.1.3 4.2.2 4.2.2s2.1-.1 4.1-.6c1-.3 2-.6 2.7-.8.7-.3 1.2-.5 1.2-.5s-.5.1-1.3.3c-.7.2-1.7.5-2.8.7-2 .4-4.1.4-4.1.4s-2.1.1-4.1-.1c-1-.1-2-.3-2.8-.4-.6-.1-1.1-.2-1.1-.2zM52.1 213.6c0 .1.5.6 1.1 1l1.2.8s.7.3 1.4.5 1.4.3 1.4.3c0-.1-.7-.3-1.3-.6-.6-.3-1.3-.6-1.3-.6s-.6-.3-1.3-.6c-.5-.5-1.1-.9-1.2-.8zM66.1 196c0-.1-1-.5-1.9-1-.9-.6-1.7-1.2-1.7-1.2s-.9-.6-1.6-1.4l-1.4-1.6c-.1 0 .4 1 1.1 1.9.7.9 1.5 1.6 1.5 1.6s.9.7 1.9 1.1c1 .4 2.1.7 2.1.6zM64.4 197c.1-.1-1.6-1.6-1.6-1.6s-1.8-1.2-1.9-1.1c-.1.1 1.6 1.6 1.6 1.6s1.8 1.3 1.9 1.1z"
                />
            </g>
            <path
                className="st57"
                d="M59.5 188c7.5 7.2 15.2 6.9 15.2 6.9-.1 1-.7 2.3-1.4 3.8-1.1.2-3.1.4-5 .4-1.1 1.7-2 3.4-3.1 5.1-.9 1.3-1.8 4.1-.6 5.5 1.8 2.2 1.8-1.5 2.7-1.4.5.1 1.1.2 2 .4-1.4 1.3-3.4 3.5-2 4.4 1.7 1.2 10.1 2.7 10.7.3 2 3.2-.3 6.9-10.3 6.2-10.2-.7-18.3-5.9-18.3-5.9L59.5 188z"
            />
            <path
                className="st56"
                d="M72.5 210.6c0 .1.5.3 1 .6l1 .6s.5.3 1 .7c.5.4.9.8.9.7.1 0-.3-.6-.7-1-.4-.5-.9-.8-.9-.8s-.5-.3-1.1-.5c-.6-.3-1.2-.3-1.2-.3zM70 209.8c-.1.1.1.4.1.4s.3.1.4 0c.1-.1-.1-.4-.1-.4s-.3-.1-.4 0zM66.1 208c.1 0 .6-.9 1.2-1.8s1.1-1.8 1.1-1.8.5-.9 1.1-1.8c.5-.9 1.1-1.8 1.1-1.9-.1 0-.8.8-1.4 1.6l-1.2 1.8s-.5.9-1 1.9c-.6 1-1 2-.9 2z"
            />
        </g>
        <g>
            <path transform="rotate(-9.788 55.355 96.745)" className="st0flag" d="M54.4 60.4H56.3V133H54.4z" />
            <path transform="rotate(-9.788 54.95 97.319)" className="st1flag" d="M54.5 61.5H55.4V133.1H54.5z" />
            <g>
                <path
                    className="st2flag"
                    d="M54.5 89.2c-1.7-9.6-3.6-19-5.3-28.6-8.1 21.6-9 25.5-9 25.5L52 101s1.9-7.4 2.5-11.8z"
                />
            </g>
        </g>
        <g>
            <path transform="rotate(-12.761 53.313 97.378)" className="st0flag" d="M52.4 61.1H54.3V133.7H52.4z" />
            <path transform="rotate(-12.761 52.938 97.971)" className="st1flag" d="M52.5 62.2H53.4V133.8H52.5z" />
            <g>
                <path
                    className="st2flag"
                    d="M52.1 89.9c-2.1-9.5-4.6-18.8-6.8-28.3-7 22-7.7 26-7.7 26l12.6 14.3s1.5-7.5 1.9-12z"
                />
            </g>
        </g>
        <g>
            <path transform="rotate(-16.524 51.159 97.674)" className="st0flag" d="M50.2 61.4H52.1V134H50.2z" />
            <path transform="rotate(-16.524 50.824 98.291)" className="st1flag" d="M50.4 62.5H51.3V134.1H50.4z" />
            <g>
                <path
                    className="st2flag"
                    d="M49.4 90.3c-2.8-9.3-5.8-18.5-8.6-27.8-5.5 22.4-6 26.4-6 26.4l13.5 13.4c0 .1 1.1-7.5 1.1-12z"
                />
            </g>
        </g>
        <g>
            <path
                className="st58"
                d="M49 118.8c3.6-1.7 2.1-7.4 6.1-14.3 4-6.9 11.2-1 11.2-1l.1-.1c1.3.7 2.7 1.2 4.2 1.4l9.2 4.7c.2.6.5 1.1.8 1.6l-.4-.2s-6.1.2-8.9 8c-2.9 7.8-.8 13.5-7.4 15.1-6.7 1.5-15.8-4.2-16.6-10.3 0 0-1.9-3.2 1.7-4.9z"
            />
            <path
                className="st56"
                d="M47.8 117.5c3.6-1.7 2.1-7.4 6.1-14.3 4-6.9 11.2-1 11.2-1l.4-.7c1.3.7 3.1 1 4.6 1.2l-.9.9 12.4 6.3s5.3-8.8 12.8-8.6c7.4.2 5.2 6 5.2 6s-8.8-5.4-14.6 6.2l-6.1-3.8s-6.1.2-8.9 8c-2.9 7.8-.8 13.5-7.4 15.1-6.7 1.5-15.8-4.2-16.6-10.3.1 0-1.8-3.2 1.8-5z"
            />
            <path
                className="st57"
                d="M80.9 110.9l.5-1.1.3.2s.7-1.1 1.9-2.6c.2 1.1.9 1.7 2.9.6 5-2.7 7.8-3.1 10.6-3.8 1.3-.3 1.4-1.1 1.2-1.9 2.6 1.7 1.4 5 1.4 5s-8.8-5.4-14.6 6.2l-4.2-2.6zM47.8 117.5c.1 0 .1-.1.1-.1.1 1.3-2.1 1-.8 3.5 2 3.9 5.7 7.3 10 8.5 1.7.4 3.5.6 5.1-.1 2.2-.9 2.7-3.6 3-5.7.9-6.4 4.1-11.4 9.3-15.1.8-.6.9-1.2.7-1.8l5.7 2.9c-.1.3-.2.7-.4 1.1l-1.6-1s-6.1.2-8.9 8c-2.9 7.8-.8 13.5-7.4 15.1-6.7 1.5-15.8-4.2-16.6-10.3.1 0-1.8-3.2 1.8-5zM64.6 101.9c.3.2.5.4.5.4l.4-.7c1.3.7 3.1 1 4.6 1.2l-.9.9c-.9 0-3.1-.2-4.6-1.8z"
            />
            <g className="st7flag">
                <path
                    className="st56"
                    d="M52.3 112.9c.1 0 .3-1.7.7-3.4.2-.8.4-1.6.7-2.2.2-.6.4-1 .4-1s.2-.4.5-.9c.3-.6.8-1.3 1.3-1.9.6-.6 1.2-1.2 1.8-1.5.5-.3.9-.5.9-.5s-.4.1-1 .4c-.6.3-1.3.8-1.9 1.4-.6.6-1.1 1.4-1.5 1.9l-.5 1s-.2.4-.4 1-.4 1.5-.6 2.3c-.2.9-.3 1.7-.3 2.4-.1.5-.2 1-.1 1z"
                />
            </g>
            <g className="st7flag">
                <path
                    className="st56"
                    d="M52.1 125.9c.1-.1-1-1.4-2.1-2.7-.5-.7-1.1-1.3-1.4-1.8-.3-.5-.3-.9-.3-.9s-.1-.4 0-1 .4-1.3 1.1-1.7c.7-.4 1.4-1.1 1.7-1.7.3-.6.4-1 .4-1s-.2.4-.5.9c-.4.5-1 1.1-1.7 1.5-.4.2-.7.5-1 .9-.2.4-.4.7-.4 1.1-.1.7 0 1.1 0 1.1s0 .1.1.3c.1.2.2.5.4.8.4.6 1 1.2 1.5 1.8 1 1.2 2.1 2.4 2.2 2.4z"
                />
            </g>
            <g className="st7flag">
                <path
                    className="st56"
                    d="M86.1 106.2s.3-.1.8-.4c.4-.3 1-.7 1.5-1.1.5-.4 1-.8 1.5-1 .4-.2.7-.3.7-.3s.3-.1.7-.3c.5-.2 1.1-.3 1.7-.4 1.3-.2 2.6-.1 2.6-.2s-1.3-.3-2.7-.2c-.7 0-1.3.2-1.8.3-.5.1-.8.3-.8.3s-.3.1-.8.4c-.4.3-1 .7-1.5 1.1-.5.5-1 .9-1.3 1.2-.4.4-.7.6-.6.6z"
                />
            </g>
        </g>
    </svg>
)

export const FlagIcon = () => (
    <svg id="OBJECT" x="0px" y="0px" viewBox="0 0 94.3 164.6" xmlSpace="preserve">
        <style>{'.st3_flag{opacity:.45;fill:#db4b86}'}</style>
        <path fill="#fff" d="M81.6 11.8H84.3V155.9H81.6z" />
        <path opacity={0.45} fill="#c3bcf5" d="M81.6 13.3H82.89999999999999V156H81.6z" />
        <g>
            <path
                d="M10.3 53.1c24.8 11.7 49.5-11.7 74.3 0V11.3C59.8-.5 35.1 23 10.3 11.3c4 8.7 7.9 16.6 11.9 23.8-4 6.7-7.9 12.8-11.9 18z"
                fill="#6dd5b0"
            />
            <path
                className="st3_flag"
                d="M64.6 49.9c-3.3.3-6.6.9-9.9 1.6V9.6c3.3-.7 6.6-1.3 9.9-1.6v41.9zM14.7 13c4.7 1.5 9.4 1.8 14.1 1.6v41.8c-4.7.3-9.4-.1-14.1-1.6v-7.9c2.5-3.7 5-7.6 7.5-11.9-2.5-4.5-5-9.3-7.5-14.4V13zM40.7 12.8c2-.4 3.9-.9 5.9-1.3v41.8c-2 .5-3.9.9-5.9 1.3V12.8z"
            />
            <path
                d="M10.3 53.1c2.4-3.1 4.7-6.5 7.1-10.2 5.9 19.6 41.3 6.5 56.6-2.1 11.7-6.6 8.8-22.4 5.9-31.3 1.5.5 3.1 1.1 4.6 1.8v41.8c-24.7-11.7-49.4 11.7-74.2 0z"
                fill="#53bc93"
            />
        </g>
    </svg>
)

export const MarketPlaceIcon = () => (
    <svg data-name="Layer 1" viewBox="0 0 32 32">
        <path d="M28.22 1.7H3.78A3.27 3.27 0 00.52 5v2.81a.85.85 0 000 .72V27a3.27 3.27 0 003.26 3.3h24.44a3.27 3.27 0 003.26-3.3V5a3.27 3.27 0 00-3.26-3.3zM3.78 3.5h24.44A1.47 1.47 0 0129.68 5v2.3H2.32V5a1.47 1.47 0 011.46-1.5zm24.44 25H3.78A1.47 1.47 0 012.32 27V9h27.36v18a1.47 1.47 0 01-1.46 1.5z" />
        <path d="M20.42 16h-.18a4.24 4.24 0 00-8.32 0h-.34A1.63 1.63 0 0010 17.61v5.1a1.63 1.63 0 001.63 1.62h8.84a1.63 1.63 0 001.63-1.62v-5.1A1.63 1.63 0 0020.42 16zm-4.34-1.61A2.46 2.46 0 0118.37 16h-4.58a2.44 2.44 0 012.29-1.63zm4.17 8.16h-8.5v-4.76h8.5z" />
    </svg>
)
export const MyUploadsIcon = () => (
    <svg x="0px" y="0px" viewBox="0 0 28.5 25.5" xmlSpace="preserve">
        <path d="M22.2 24.7h-16c-1.1 0-2-.9-2-2v-13c0-1.1.9-2 2-2h4c.6 0 1 .4 1 1s-.4 1-1 1h-4v13h16v-13h-4c-.6 0-1-.4-1-1s.4-1 1-1h4c1.1 0 2 .9 2 2v13c0 1.1-.9 2-2 2z" />
        <path d="M14.2 16.7c-.6 0-1-.4-1-1v-14c0-.6.4-1 1-1s1 .4 1 1v14c0 .6-.4 1-1 1z" />
        <path d="M17.2 5.7c-.3 0-.5-.1-.7-.3l-2.3-2.3-2.3 2.3c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4l3-3c.4-.4 1-.4 1.4 0l3 3c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3z" />
    </svg>
)
export const DownloadFromMarketplace = () => (
    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 12 12" xmlSpace="preserve">
        <path d="M5.5 8.8c.2.2.3.3.5.3s.3-.1.5-.2l2.4-2.4c.2-.2.2-.6 0-.8-.1-.2-.3-.3-.4-.3-.2 0-.3.1-.4.2L6.6 7V.7c0-.3-.3-.6-.6-.6s-.6.3-.6.6V7L3.9 5.6c-.1-.1-.2-.2-.4-.2s-.3.1-.4.2c-.1.1-.2.2-.2.4s.1.3.2.4l2.4 2.4z" />
        <path d="M11.3 7.5c-.3 0-.6.3-.6.6v2.6H1.3V8.1c0-.3-.3-.6-.6-.6s-.6.3-.6.6v2.8c0 .5.4.9.9.9h9.9c.5 0 .9-.4.9-.9V8.1c.1-.3-.2-.6-.5-.6z" />
    </svg>
)

export const PriceFreeIcon = () => (
    <svg x="0px" y="0px" viewBox="0 0 96 96">
        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 97.41 121">
            <path
                className="cls-1"
                d="M118.9,125.09h-35a4.69,4.69,0,0,1-4.71-4.57L76.6,40l-2.83,80.52a4.69,4.69,0,0,1-4.71,4.55H32.26a5.38,5.38,0,0,1-4.9-7.61L70.72,22.21a6.18,6.18,0,0,1,5.69-3.67h0a6.2,6.2,0,0,1,5.69,3.75l41.68,95.27a5.38,5.38,0,0,1-4.93,7.53ZM77.26,19.94a.58.58,0,0,1,0,.19l3.2,100.35a3.37,3.37,0,0,0,3.38,3.28h35a4,4,0,0,0,3.71-5.67L80.93,22.82A4.87,4.87,0,0,0,77.26,19.94ZM76,19.88a4.86,4.86,0,0,0-4.09,2.88L28.57,118a4.05,4.05,0,0,0,3.69,5.73h36.8a3.38,3.38,0,0,0,3.39-3.27L76,20.13A1,1,0,0,1,76,19.88Z"
                transform="translate(-26.87 -18.54)"
            ></path>
            <path
                className="cls-1"
                d="M54.63,71.66a.28.28,0,0,1-.13,0,.34.34,0,0,1-.18-.44l4.4-10.32a.35.35,0,0,1,.44-.18.34.34,0,0,1,.17.44l-4.4,10.32A.32.32,0,0,1,54.63,71.66Z"
                transform="translate(-26.87 -18.54)"
            ></path>
            <path
                className="cls-1"
                d="M60.19,120.61H39.78a4.3,4.3,0,0,1-4-6l17-39.82a.34.34,0,0,1,.44-.17.32.32,0,0,1,.17.43l-17,39.82a3.62,3.62,0,0,0,3.34,5H60.19a.34.34,0,0,1,0,.67Z"
                transform="translate(-26.87 -18.54)"
            ></path>
            <path
                className="cls-1"
                d="M101.7,82.42a.35.35,0,0,1-.31-.21L87.66,49.46a.33.33,0,0,1,.18-.43.32.32,0,0,1,.43.17L102,82a.33.33,0,0,1-.18.44A.31.31,0,0,1,101.7,82.42Z"
                transform="translate(-26.87 -18.54)"
            ></path>
            <path
                className="cls-1"
                d="M86.62,46.46a.35.35,0,0,1-.31-.21L81.74,35.36a.34.34,0,0,1,.62-.26L86.92,46a.33.33,0,0,1-.17.44A.31.31,0,0,1,86.62,46.46Z"
                transform="translate(-26.87 -18.54)"
            ></path>
            <path
                className="cls-1"
                d="M81.23,33.6a.34.34,0,0,1-.31-.2l-1.11-2.66A.34.34,0,0,1,80,30.3a.33.33,0,0,1,.43.18l1.11,2.66a.33.33,0,0,1-.17.43Z"
                transform="translate(-26.87 -18.54)"
            ></path>
            <path
                className="cls-1"
                d="M77.4,139.54H73.79a3.54,3.54,0,0,1-3.05-1.75l-7.64-13a.67.67,0,1,1,1.15-.67l7.63,13a2.24,2.24,0,0,0,1.91,1.09H77.4a2.19,2.19,0,0,0,1.85-1l8.61-13.15a.66.66,0,1,1,1.11.73l-8.61,13.15A3.53,3.53,0,0,1,77.4,139.54Z"
                transform="translate(-26.87 -18.54)"
            ></path>
            <path
                className="cls-1"
                d="M76.05,137.38h0a.34.34,0,0,1-.33-.34l.92-80.7A.32.32,0,0,1,77,56h0a.33.33,0,0,1,.33.33l-.91,80.7A.33.33,0,0,1,76.05,137.38Z"
                transform="translate(-26.87 -18.54)"
            ></path>
        </svg>
    </svg>
)
export const BasicIcon = () => (
    <svg x="0px" y="0px" viewBox="0 0 91 125.1">
        <path
            className="st0"
            d="M949.5 532.2c-.3 0-.6-.2-.7-.4-1.3-2.9-2.5-5.5-2.5-5.5-2.3-5.5-3.6-11.3-3.6-17.3 0-.4.3-.8.7-.8.4 0 .8.3.8.7 0 5.8 1.2 11.4 3.5 16.7 0 0 1.2 2.6 2.5 5.5.2.4 0 .8-.4 1-.1.1-.2.1-.3.1zM943.6 504.9c-.5 0-.8-.4-.7-.8 1.1-14.7 8.5-25.8 17.1-25.8 8.6 0 15.9 11 17.1 25.6 0 .4-.3.8-.7.8-.4 0-.8-.3-.8-.7-1.1-13.8-7.8-24.2-15.6-24.2s-14.5 10.5-15.6 24.4c-.1.4-.4.7-.8.7zM970.3 531.9c-.1 0-.2 0-.3-.1-.4-.2-.5-.6-.4-1 1.2-2.6 2.3-4.9 2.3-4.9 2.4-5.2 3.6-10.8 3.8-16.5 0-.4.3-.7.8-.7.4 0 .7.4.7.8-.1 5.9-1.4 11.7-3.9 17.1 0 0-1.1 2.3-2.3 4.9-.2.2-.5.4-.7.4zM959.7 602.7c-3.4 0-3.6-2.6-3.7-4-.1-1.3-.5-6.2-.6-8.1h-14.9c-.4 0-.8-.3-.8-.8v-7.6c0-.4.3-.8.8-.8h14.7c-.2-4.7-1.3-28.7-1.5-32.8-.2-3.8-1-7.6-2.4-11.1-.3-.7-.7-1.7-1.2-2.8-.2-.4 0-.8.4-1 .4-.2.8 0 1 .4.5 1.1.9 2.1 1.2 2.8 1.5 3.7 2.4 7.6 2.5 11.6l1.5 33.6c0 .2-.1.4-.2.6-.1.1-.3.2-.5.2h-14.7v6.1h14.9c.4 0 .7.3.7.7 0 0 .5 7.2.7 8.8.1 1.7.4 2.5 2.2 2.5s2.1-.8 2.2-2.5c.1-1.6.7-8.8.7-8.8 0-.4.4-.7.7-.7h14.8v-6.1h-14.7c-.2 0-.4-.1-.5-.2-.1-.1-.2-.3-.2-.6 0 0 1.3-29 1.5-33.6.2-4 1-7.9 2.5-11.6.3-.7.7-1.7 1.2-2.8.2-.4.6-.5 1-.4.4.2.5.6.4 1-.5 1.1-.9 2.1-1.2 2.8-1.5 3.5-2.3 7.3-2.4 11.1-.2 4.1-1.3 28.1-1.5 32.8H979c.4 0 .8.3.8.8v7.6c0 .4-.3.8-.8.8h-15c-.1 1.8-.5 6.8-.6 8.1-.1 1.4-.2 4-3.7 4z"
            transform="translate(-914.238 -477.587)"
        />
        <path
            className="st0"
            d="M947.4 498.9c-.1 0-.2 0-.3-.1-.1-.1-.1-.2-.1-.3 1.7-9.9 6.9-16.5 12.9-16.5 5.9 0 11.1 6.6 12.9 16.5 0 .1 0 .2-.1.3s-.2.1-.3.1h-25zm12.5-16.3c-5.4 0-10.4 6.4-12.1 15.5H972c-1.7-9.1-6.6-15.5-12.1-15.5z"
            transform="translate(-914.238 -477.587)"
        />
        <path
            className="st0"
            d="M918.1 568.7h-.2c-1-.5-1.5-1.3-1.7-2.4-.2-1.7.6-3.6 1.6-4.5 1.5-1.4 35.7-34.4 38.5-37.1-.4-1-.4-2.1 0-3l-42.1-40.4c-.1-.1-.1-.3 0-.5.8-.9 1.8-1.4 2.9-1.5 1.6 0 3.6 1 5.2 2.7 1.9 2 33.3 35 35.9 37.7.9-.4 1.8-.4 2.7-.1l40.5-41.9c.1-.1.3-.1.5 0 .1.1 1.8 1.5 1.9 3.5.1 1.2-.4 2.3-1.5 3.3-3.2 3.1-36.4 34.9-39.1 37.4.3.8.3 1.7 0 2.6l41.8 40.2c.1.1.1.2.1.3-.1.8-.8 1.5-1.7 1.8-.8.3-3.1.6-5.9-2.2-3.5-3.4-33.9-35.3-36.4-38-.9.3-1.8.3-2.7 0l-40.1 42c0 .1-.1.1-.2.1zm-3-87.8l42 40.3c.1.1.1.3.1.4-.5.9-.5 2 0 2.9.1.1 0 .3-.1.4-.4.4-37.1 35.8-38.7 37.3-1 .9-1.6 2.6-1.4 3.9.1.8.5 1.4 1.1 1.8l40.1-41.9c.1-.1.3-.1.4-.1.8.4 1.7.4 2.6 0 .1-.1.3 0 .4.1.3.3 33 34.6 36.6 38.1 1.8 1.7 3.7 2.5 5.2 2 .6-.2 1.1-.6 1.2-1.1l-41.8-40.3c-.1-.1-.1-.3-.1-.4.3-.8.4-1.7 0-2.5-.1-.1 0-.3.1-.4.4-.3 35.9-34.4 39.2-37.6.9-.9 1.3-1.8 1.3-2.8-.1-1.3-1-2.3-1.4-2.7l-40.4 41.8c-.1.1-.3.1-.4.1-.8-.3-1.8-.3-2.6.1-.1.1-.3 0-.4-.1 0 0-34.2-35.9-36.1-37.9-1.5-1.6-3.3-2.5-4.7-2.4-.9 0-1.6.4-2.2 1zM956.1 588.8c-.2 0-.3-.2-.4-.3l-.1-4.3c0-.2.1-.4.3-.4.2 0 .4.1.4.3l.1 4.3c.1.2-.1.4-.3.4zM963.5 588.7c-.2 0-.4-.2-.3-.4v-4.7c0-.2.2-.3.3-.3.2 0 .3.2.3.4v4.7c.1.1-.1.3-.3.3z"
            transform="translate(-914.238 -477.587)"
        />
    </svg>
)

export const PriceStandardIcon = () => (
    <svg id="Layer_3" data-name="Layer 3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 143.07 114.21">
        <path
            className="cls-1"
            d="M75.28,127.19H73.14a.54.54,0,0,1-.54-.54v-7.22c-.53-1.65-8.51-27-9.3-51.19L7.12,64.44a3.75,3.75,0,0,1-3.49-3.73V45.14a4.77,4.77,0,0,1,4.43-4.73l53.73-3.7A4.42,4.42,0,0,1,62,33.8a1.88,1.88,0,0,1,.58-.64,3.32,3.32,0,0,1-.25-2,2.16,2.16,0,0,1,1-1.56c0-1,.06-2.18.08-3.29,0-1.47,0-2.63.12-3.1l0-.15c.14-.91.49-3.32,3.3-3.42a.54.54,0,0,1,.56.52.54.54,0,0,1-.52.56c-1.77.06-2.1,1.32-2.27,2.5l0,.15c-.06.4-.08,1.64-.1,3s0,2.61-.11,3.64a.53.53,0,0,1-.35.48,1.11,1.11,0,0,0-.62.9A1.93,1.93,0,0,0,63.74,33a.53.53,0,0,1,.18.54.54.54,0,0,1-.4.4.83.83,0,0,0-.58.43A4.28,4.28,0,0,0,63,37a.56.56,0,0,1-.07.47.54.54,0,0,1-.41.23L8.13,41.48a3.68,3.68,0,0,0-3.42,3.66V60.71a2.68,2.68,0,0,0,2.48,2.66L63.86,67.2a.53.53,0,0,1,.5.52c.71,24.89,9.2,51.2,9.29,51.46a.47.47,0,0,1,0,.17v6.76h1.6a.54.54,0,1,1,0,1.08Z"
            transform="translate(-3.63 -12.97)"
        ></path>
        <path
            className="cls-1"
            d="M71.68,123.54h0l-18.06-.22a5.09,5.09,0,0,1-5.08-5.08v-5.09a4.88,4.88,0,0,1,3.12-4.56l16.42-6.43a.54.54,0,1,1,.39,1L52,109.59a3.8,3.8,0,0,0-2.43,3.56v5.09a4,4,0,0,0,4,4l17.68.21.83-2.28a.55.55,0,0,1,.69-.33.54.54,0,0,1,.32.69l-1,2.65A.55.55,0,0,1,71.68,123.54Z"
            transform="translate(-3.63 -12.97)"
        ></path>
        <path
            className="cls-1"
            d="M56.16,20.7a1.94,1.94,0,0,1-1.27-.44,1.35,1.35,0,0,1-.41-1V17.64a1.61,1.61,0,0,1,1.72-1.47H70.39l-.06-.66a.51.51,0,0,1,.13-.41.53.53,0,0,1,.4-.18h1.67V13.51a.54.54,0,0,1,.54-.54h2.21a.54.54,0,0,1,.54.54.54.54,0,0,1-.54.54H73.6v1.41a.54.54,0,0,1-.53.54H71.46l.07.65a.57.57,0,0,1-.14.42.54.54,0,0,1-.4.18H56.23s-.67.05-.67.39v1.61a.27.27,0,0,0,.07.22,1,1,0,0,0,.57.15H72.81a.54.54,0,1,1,0,1.08H56.16Z"
            transform="translate(-3.63 -12.97)"
        ></path>
        <path
            className="cls-1"
            d="M29.32,65l-.53,0s.21-3,.37-5.08a3.41,3.41,0,0,0-.83-2.62,2.85,2.85,0,0,0-2.15-.9c-2.1,0-11.35-.16-14.06-.26a3.51,3.51,0,0,0-2.61.7,2.27,2.27,0,0,0-.62,1.69V64a.27.27,0,0,1-.54,0V58.51a2.8,2.8,0,0,1,.79-2.08,4,4,0,0,1,3-.85c2.71.1,11.94.26,14,.26a3.46,3.46,0,0,1,2.55,1.08,3.94,3.94,0,0,1,1,3C29.54,62,29.32,65,29.32,65Z"
            transform="translate(-3.63 -12.97)"
        ></path>
        <path
            className="cls-1"
            d="M6,50.05a.27.27,0,0,1-.27-.27v-3.4c0-.62.34-2.63,4.77-2.93,3.89-.27,44-2.8,44.43-2.82a.26.26,0,0,1,.29.25.27.27,0,0,1-.26.28c-.4,0-40.53,2.56-44.42,2.82-3.15.22-4.28,1.38-4.28,2.4v3.4A.27.27,0,0,1,6,50.05Z"
            transform="translate(-3.63 -12.97)"
        ></path>
        <path
            className="cls-1"
            d="M57.45,64.79H57.2c-1.64,0-10.65-.63-17.92-1.13a.27.27,0,0,1-.25-.29.29.29,0,0,1,.29-.25c7.26.5,16.26,1.1,17.89,1.13a4,4,0,0,0,2.63-.57,2.91,2.91,0,0,0,.87-2.41c0-2.57-.37-10-.37-10.09a.26.26,0,0,1,.25-.28h0a.27.27,0,0,1,.27.25c0,.07.42,7.54.37,10.13a3.46,3.46,0,0,1-1.07,2.83A4.28,4.28,0,0,1,57.45,64.79Z"
            transform="translate(-3.63 -12.97)"
        ></path>
        <path
            className="cls-1"
            d="M37.08,63.51h0l-2.22-.16a.27.27,0,0,1,0-.53L37.1,63a.28.28,0,0,1,.25.29A.27.27,0,0,1,37.08,63.51Z"
            transform="translate(-3.63 -12.97)"
        ></path>
        <path
            className="cls-1"
            d="M56.35,110.23a.26.26,0,0,1-.25-.19.27.27,0,0,1,.17-.34l10.53-3.45a.27.27,0,1,1,.17.51l-10.53,3.46Z"
            transform="translate(-3.63 -12.97)"
        ></path>
        <path
            className="cls-1"
            d="M60.85,122.47a.27.27,0,0,1-.26-.27v-4.47a.27.27,0,1,1,.53,0v4.47A.27.27,0,0,1,60.85,122.47Z"
            transform="translate(-3.63 -12.97)"
        ></path>
        <path className="cls-1" d="M67.84,122.78" transform="translate(-3.63 -12.97)"></path>
        <path
            className="cls-1"
            d="M67.84,123.05a.27.27,0,0,1-.26-.27v-4.36a.27.27,0,1,1,.53,0v4.36A.27.27,0,0,1,67.84,123.05Z"
            transform="translate(-3.63 -12.97)"
        ></path>
        <path
            className="cls-1"
            d="M63.53,66.74a.54.54,0,0,1-.53-.51c0-.2-1.36-20.67-1.28-28.53a.49.49,0,0,1,.55-.53.52.52,0,0,1,.53.54c-.08,7.82,1.26,28.25,1.27,28.45a.53.53,0,0,1-.5.57Z"
            transform="translate(-3.63 -12.97)"
        ></path>
        <path
            className="cls-1"
            d="M62.79,20.18a.27.27,0,0,1-.27-.27V17.44a.27.27,0,1,1,.54,0v2.47A.27.27,0,0,1,62.79,20.18Z"
            transform="translate(-3.63 -12.97)"
        ></path>
        <path
            className="cls-1"
            d="M68.2,20.43a.27.27,0,0,1-.27-.27V17.07a.27.27,0,0,1,.54,0v3.09A.27.27,0,0,1,68.2,20.43Z"
            transform="translate(-3.63 -12.97)"
        ></path>
        <path
            className="cls-1"
            d="M77.2,127.19H75.05a.54.54,0,0,1,0-1.08h1.61v-6.76a.88.88,0,0,1,0-.17c.09-.26,8.58-26.57,9.29-51.46a.54.54,0,0,1,.5-.52l56.67-3.83a2.68,2.68,0,0,0,2.48-2.66V45.14a3.68,3.68,0,0,0-3.42-3.66L87.83,37.74a.54.54,0,0,1-.41-.23.56.56,0,0,1-.07-.47,4.22,4.22,0,0,0,0-2.71.81.81,0,0,0-.58-.43.56.56,0,0,1-.4-.4.57.57,0,0,1,.18-.54A2,2,0,0,0,87,31.33a1.13,1.13,0,0,0-.62-.9A.53.53,0,0,1,86,30c-.06-1-.09-2.4-.11-3.64s0-2.56-.1-3l0-.15c-.18-1.18-.51-2.44-2.27-2.5a.54.54,0,0,1-.52-.56.56.56,0,0,1,.55-.52c2.81.1,3.17,2.51,3.3,3.42l0,.15a30.66,30.66,0,0,1,.12,3.1c0,1.11,0,2.31.09,3.29a2.22,2.22,0,0,1,1,1.56,3.48,3.48,0,0,1-.25,2,1.86,1.86,0,0,1,.57.64,4.49,4.49,0,0,1,.22,2.91l53.73,3.7a4.76,4.76,0,0,1,4.42,4.73V60.71a3.75,3.75,0,0,1-3.49,3.73L87,68.24c-.78,24.2-8.77,49.54-9.3,51.19v7.22A.54.54,0,0,1,77.2,127.19Z"
            transform="translate(-3.63 -12.97)"
        ></path>
        <path
            className="cls-1"
            d="M78.66,123.54a.55.55,0,0,1-.51-.36l-1-2.65a.54.54,0,0,1,.32-.69.55.55,0,0,1,.69.33l.83,2.28,17.68-.21a4,4,0,0,0,4-4v-5.09a3.8,3.8,0,0,0-2.43-3.56l-16.42-6.43a.54.54,0,1,1,.39-1l16.43,6.43a4.87,4.87,0,0,1,3.11,4.56v5.09a5.09,5.09,0,0,1-5.08,5.08l-18.06.22Z"
            transform="translate(-3.63 -12.97)"
        ></path>
        <path
            className="cls-1"
            d="M94.16,20.7H77.53a.54.54,0,1,1,0-1.08H94.1a.93.93,0,0,0,.6-.15.26.26,0,0,0,.08-.22V17.64c0-.34-.69-.39-.7-.39H79.34a.55.55,0,0,1-.4-.18.57.57,0,0,1-.14-.42l.07-.65h-1.6a.54.54,0,0,1-.54-.54V14.05H75.05a.54.54,0,0,1-.54-.54.54.54,0,0,1,.54-.54h2.22a.54.54,0,0,1,.54.54v1.41h1.66a.52.52,0,0,1,.4.18.51.51,0,0,1,.13.41l-.06.66H94.11c.85,0,1.74.51,1.74,1.47v1.61a1.35,1.35,0,0,1-.41,1A1.94,1.94,0,0,1,94.16,20.7Z"
            transform="translate(-3.63 -12.97)"
        ></path>
        <path
            className="cls-1"
            d="M121,65s-.21-3-.37-5.08a3.9,3.9,0,0,1,1-3,3.42,3.42,0,0,1,2.54-1.08c2.1,0,11.34-.16,14-.26a3.93,3.93,0,0,1,3,.85,2.8,2.8,0,0,1,.79,2.08V64a.27.27,0,0,1-.27.27.28.28,0,0,1-.27-.27V58.51a2.27,2.27,0,0,0-.62-1.69,3.49,3.49,0,0,0-2.61-.7c-2.71.1-12,.26-14.06.26a2.85,2.85,0,0,0-2.15.9,3.45,3.45,0,0,0-.83,2.62c.16,2.1.38,5.08.38,5.08Z"
            transform="translate(-3.63 -12.97)"
        ></path>
        <path
            className="cls-1"
            d="M89.48,122.47a.27.27,0,0,1-.27-.27v-4.47a.27.27,0,0,1,.54,0v4.47A.27.27,0,0,1,89.48,122.47Z"
            transform="translate(-3.63 -12.97)"
        ></path>
        <path className="cls-1" d="M82.49,122.78" transform="translate(-3.63 -12.97)"></path>
        <path
            className="cls-1"
            d="M82.49,123.05a.27.27,0,0,1-.27-.27v-4.36a.27.27,0,1,1,.54,0v4.36A.27.27,0,0,1,82.49,123.05Z"
            transform="translate(-3.63 -12.97)"
        ></path>
        <path
            className="cls-1"
            d="M86.8,67.75h0a.54.54,0,0,1-.51-.57c0-.22,1.27-21.65,1.18-29.47a.53.53,0,0,1,.53-.54.56.56,0,0,1,.55.53c.08,7.86-1.17,29.33-1.18,29.54A.55.55,0,0,1,86.8,67.75Z"
            transform="translate(-3.63 -12.97)"
        ></path>
        <path
            className="cls-1"
            d="M87.54,20.18a.27.27,0,0,1-.27-.27V17.44a.27.27,0,0,1,.54,0v2.47A.27.27,0,0,1,87.54,20.18Z"
            transform="translate(-3.63 -12.97)"
        ></path>
        <path
            className="cls-1"
            d="M82.13,20.43a.28.28,0,0,1-.27-.27V17.07a.27.27,0,0,1,.27-.26.27.27,0,0,1,.27.26v3.09A.27.27,0,0,1,82.13,20.43Z"
            transform="translate(-3.63 -12.97)"
        ></path>
        <path
            className="cls-1"
            d="M71.49,20.43a.27.27,0,0,1-.27-.25c0-.56-.14-3.33,1.11-3.6a.25.25,0,0,1,.22.05C74,17.75,74,17.75,75.28,17.75c.73.13,1,.05,2.5-1.12a.25.25,0,0,1,.22-.05c1.26.27,1.15,3,1.11,3.6a.27.27,0,0,1-.27.25h0a.27.27,0,0,1-.25-.28c.06-1.12-.08-2.71-.59-3-1.42,1.09-1.83,1.31-2.75,1.15-1.37,0-1.44,0-2.9-1.15-.51.3-.65,1.89-.58,3a.28.28,0,0,1-.26.28Z"
            transform="translate(-3.63 -12.97)"
        ></path>
        <path
            className="cls-1"
            d="M74.18,24.14a42.22,42.22,0,0,1-7.46-.61.27.27,0,0,1-.21-.31.28.28,0,0,1,.32-.22,44.63,44.63,0,0,0,16.42-.35.27.27,0,0,1,.32.21.28.28,0,0,1-.2.32A42.94,42.94,0,0,1,74.18,24.14Z"
            transform="translate(-3.63 -12.97)"
        ></path>
        <path
            className="cls-1"
            d="M74.71,31A26.64,26.64,0,0,1,66.43,30a.26.26,0,0,1-.16-.34.27.27,0,0,1,.34-.16c.07,0,6.62,2.32,17.55,0a.25.25,0,0,1,.32.2.27.27,0,0,1-.2.32A46.06,46.06,0,0,1,74.71,31Z"
            transform="translate(-3.63 -12.97)"
        ></path>
        <path
            className="cls-1"
            d="M75,34.84a36.66,36.66,0,0,1-9-1,.27.27,0,0,1,.15-.52,38.87,38.87,0,0,0,17.61,0,.27.27,0,0,1,.13.53A38.83,38.83,0,0,1,75,34.84Z"
            transform="translate(-3.63 -12.97)"
        ></path>
        <path
            className="cls-1"
            d="M74.65,38.66A31.32,31.32,0,0,1,66,37.57a.26.26,0,0,1-.17-.34.28.28,0,0,1,.34-.17,34.45,34.45,0,0,0,18.25-.31.27.27,0,0,1,.15.52A36.06,36.06,0,0,1,74.65,38.66Z"
            transform="translate(-3.63 -12.97)"
        ></path>
        <path
            className="cls-1"
            d="M74.63,85.45a38.43,38.43,0,0,1-6.53-.56.27.27,0,0,1-.22-.31.28.28,0,0,1,.31-.22c.08,0,8.11,1.49,13.71-.49a.26.26,0,0,1,.34.16.26.26,0,0,1-.16.34A22.91,22.91,0,0,1,74.63,85.45Z"
            transform="translate(-3.63 -12.97)"
        ></path>
        <path
            className="cls-1"
            d="M75.05,88.18a31.51,31.51,0,0,1-7-.71.27.27,0,0,1-.2-.32.28.28,0,0,1,.33-.2,33.5,33.5,0,0,0,13.52,0,.27.27,0,0,1,.11.53A32.49,32.49,0,0,1,75.05,88.18Z"
            transform="translate(-3.63 -12.97)"
        ></path>
        <path
            className="cls-1"
            d="M75.8,72.73a8.19,8.19,0,0,1-8.18-8.18V51.62a8.18,8.18,0,0,1,16.36,0V64.55A8.19,8.19,0,0,1,75.8,72.73ZM75.8,44a7.65,7.65,0,0,0-7.64,7.65V64.55a7.64,7.64,0,0,0,15.28,0V51.62A7.65,7.65,0,0,0,75.8,44Z"
            transform="translate(-3.63 -12.97)"
        ></path>
        <path
            className="cls-1"
            d="M75.7,57.72a26.11,26.11,0,0,1-7.9-1.29.26.26,0,0,1-.16-.34.26.26,0,0,1,.34-.16c.09,0,9.27,3.15,15.34-.69a.28.28,0,0,1,.37.09.27.27,0,0,1-.09.37A14.71,14.71,0,0,1,75.7,57.72Z"
            transform="translate(-3.63 -12.97)"
        ></path>
        <path
            className="cls-1"
            d="M75.62,66.76a25.63,25.63,0,0,1-7.78-1.19.27.27,0,0,1-.16-.35.26.26,0,0,1,.34-.16c.08,0,8,2.8,15.33-.31a.27.27,0,1,1,.21.5A20.49,20.49,0,0,1,75.62,66.76Z"
            transform="translate(-3.63 -12.97)"
        ></path>
        <path
            className="cls-1"
            d="M75.8,72.42a.27.27,0,0,1-.27-.27V66.83a.27.27,0,0,1,.54,0v5.32A.27.27,0,0,1,75.8,72.42Z"
            transform="translate(-3.63 -12.97)"
        ></path>
        <path
            className="cls-1"
            d="M90.31,54.36h0a.28.28,0,0,1-.27-.28c0-.08.2-8.09.29-9.87.12-2.09,1-3.42,5-3.58.44,0,40.57,2.55,44.46,2.82a.26.26,0,0,1,.25.28c0,.15-.14.3-.28.25-3.9-.26-44-2.79-44.43-2.82-4,.17-4.39,1.49-4.48,3.08-.09,1.77-.29,9.77-.29,9.85A.27.27,0,0,1,90.31,54.36Z"
            transform="translate(-3.63 -12.97)"
        ></path>
    </svg>
)

export const PriceProIcon = () => (
    <svg data-name="Layer 2" viewBox="0 0 86.4 139.36">
        <path
            className="cls-1"
            d="M87 129.65h-9.76a.27.27 0 010-.54H87a.27.27 0 010 .54z"
            transform="translate(-31.61 -1.63)"
        />
        <path
            className="cls-2"
            d="M87.57 52a.25.25 0 01-.26-.27c0-.28.12-28 0-31 0-.76-.93-18.62-12-18.62h-.08a9.16 9.16 0 00-6.7 3c-4.57 4.72-5.82 14-5.75 16.8.08 3.66.17 28.94.17 29.2a.27.27 0 01-.27.27.27.27 0 01-.27-.27c0-.26-.09-25.53-.17-29.19-.05-2.15.85-12 5.91-17.19a9.69 9.69 0 017.08-3.12h.09C86.88 1.63 87.8 20 87.83 20.77c.13 2.93 0 30.71 0 31a.26.26 0 01-.26.23z"
            transform="translate(-31.61 -1.63)"
        />
        <path
            className="cls-2"
            d="M66.17 20a7.44 7.44 0 01-3.55-.9.27.27 0 11.28-.46 7 7 0 006.09.19.28.28 0 01.36.13.28.28 0 01-.13.36 7.27 7.27 0 01-3.05.68zM66 22.42a9.31 9.31 0 01-3.53-.76.27.27 0 01.23-.49s3.43 1.56 6 0a.28.28 0 01.37.09.26.26 0 01-.09.37 5.62 5.62 0 01-2.98.79zM67.12 13.1h-.06a.27.27 0 01-.2-.33c0-.23 1.35-5.75 6-8.06a.27.27 0 01.36.12.26.26 0 01-.12.36c-4.4 2.2-5.68 7.65-5.7 7.7a.26.26 0 01-.28.21zM83.92 19.89a16 16 0 01-3.06-.32.26.26 0 01-.2-.32A.27.27 0 0181 19s4.14.89 6.1-.39a.27.27 0 11.29.45 6.47 6.47 0 01-3.47.83zM84 22a10.63 10.63 0 01-2.8-.36.27.27 0 01-.18-.33.28.28 0 01.33-.19 9.57 9.57 0 005.76-.28.27.27 0 11.23.49A8 8 0 0184 22zM50.27 90.42a.27.27 0 01-.27-.27c0-.29-.08-29.19 0-31.71v-4.42c-.07-4.17-.17-9.89.21-11.79 1.31-6.57 3.48-10.11 6.45-10.54a2.69 2.69 0 012.19.68c2.62 2.24 3.54 9.35 3.57 11.68v11.61a.27.27 0 01-.26.27.26.26 0 01-.26-.27v-11.6c0-2.18-.94-9.18-3.39-11.28a2.12 2.12 0 00-1.77-.56c-2.71.39-4.73 3.8-6 10.12-.37 1.84-.27 7.52-.2 11.67 0 2 .06 3.63 0 4.45-.08 2.51 0 31.4 0 31.69a.27.27 0 01-.27.27z"
            transform="translate(-31.61 -1.63)"
        />
        <path
            className="cls-2"
            d="M55.92 46.63a13.22 13.22 0 01-5.84-1.32.27.27 0 01-.1-.37.25.25 0 01.36-.1 13 13 0 0011.12 0 .27.27 0 01.36.13.27.27 0 01-.13.36 13.39 13.39 0 01-5.77 1.3zM55.62 48.85a12 12 0 01-3.31-.43.27.27 0 11.16-.51 12.5 12.5 0 006.24 0 .26.26 0 11.14.51 11.69 11.69 0 01-3.23.43zM53.49 42.07a.29.29 0 01-.25-.3 19.89 19.89 0 011.94-6.71.26.26 0 01.36-.11.27.27 0 01.11.36 19.63 19.63 0 00-1.87 6.51.27.27 0 01-.29.25zM56.29 59.33a17.54 17.54 0 01-5.29-.79.27.27 0 01-.16-.35.26.26 0 01.34-.16A16.68 16.68 0 0061 58a.26.26 0 01.34.16.27.27 0 01-.16.35 14.74 14.74 0 01-4.89.82zM56 61.53a19.19 19.19 0 01-5.36-.79.28.28 0 01-.18-.34.27.27 0 01.34-.17c.06 0 5.38 1.68 9.55 0a.27.27 0 01.35.15.26.26 0 01-.15.35 12.18 12.18 0 01-4.55.8zM55.81 71.87a17.31 17.31 0 01-5.51-1.06.27.27 0 01-.15-.35.26.26 0 01.35-.15s5 1.89 8.13.51A.26.26 0 0159 71a.27.27 0 01-.14.35 7.64 7.64 0 01-3.05.52zM55.56 74.62a13.11 13.11 0 01-5.28-1.28.28.28 0 01-.12-.37.27.27 0 01.36-.11s4.38 2.16 7.69.71a.26.26 0 01.35.14.26.26 0 01-.14.35 7 7 0 01-2.86.56zM53.26 85.36a5.18 5.18 0 01-3.19-1.27.27.27 0 010-.38.26.26 0 01.38 0 4 4 0 004.37.75.27.27 0 01.24.49 4.12 4.12 0 01-1.8.41zM99.38 90a.27.27 0 01-.27-.27c0-.29.09-28.77 0-31.28v-4.44c.07-4.15.17-9.84-.2-11.68-1.27-6.32-3.28-9.73-6-10.12a2.1 2.1 0 00-1.76.56c-2.46 2.09-3.36 9.1-3.39 11.28v11.6a.28.28 0 01-.27.27.27.27 0 01-.27-.27V44.04c0-2.33.95-9.44 3.58-11.68a2.68 2.68 0 012.2-.67c3 .43 5.13 4 6.45 10.54.38 1.9.28 7.63.21 11.8 0 1.94-.07 3.61 0 4.41.09 2.52 0 31 0 31.3a.27.27 0 01-.28.26z"
            transform="translate(-31.61 -1.63)"
        />
        <path
            className="cls-2"
            d="M93.73 46.63A13.39 13.39 0 0188 45.32a.27.27 0 01-.12-.36.26.26 0 01.35-.13 12.92 12.92 0 0011.12 0 .27.27 0 01.37.1.28.28 0 01-.11.37 13.12 13.12 0 01-5.88 1.33zM94 48.85a11.79 11.79 0 01-3.23-.43.27.27 0 01-.19-.33.26.26 0 01.33-.18 12.55 12.55 0 006.25 0 .27.27 0 01.15.51 11.9 11.9 0 01-3.31.43zM90.33 42.07a.29.29 0 01-.24-.3A19.63 19.63 0 0192 35.06a.26.26 0 01.36-.11.27.27 0 01.11.36 19.63 19.63 0 00-1.87 6.51.28.28 0 01-.27.25zM93.37 59.33a14.7 14.7 0 01-4.87-.79.28.28 0 01-.17-.35.27.27 0 01.35-.16 16.68 16.68 0 009.77 0 .27.27 0 01.34.16.28.28 0 01-.17.35 17.52 17.52 0 01-5.25.79zM93.64 61.53a12.27 12.27 0 01-4.56-.8.26.26 0 01-.15-.35.27.27 0 01.35-.15c4.17 1.68 9.5 0 9.55 0a.26.26 0 01.34.17.27.27 0 01-.17.34 19.27 19.27 0 01-5.36.79zM93.85 71.87a7.57 7.57 0 01-3-.56.26.26 0 01-.14-.35.25.25 0 01.35-.14c3.17 1.37 8.09-.5 8.14-.51a.27.27 0 01.35.15.28.28 0 01-.16.35 17.14 17.14 0 01-5.54 1.06zM94.09 74.62a7 7 0 01-2.86-.56.26.26 0 01-.14-.35.27.27 0 01.36-.14c3.31 1.45 7.64-.69 7.68-.71a.27.27 0 01.37.11.29.29 0 01-.12.37 13.18 13.18 0 01-5.29 1.28zM96.39 85.36a4 4 0 01-1.78-.42.27.27 0 01-.13-.36.26.26 0 01.36-.13 4.06 4.06 0 004.37-.75.27.27 0 11.37.39 5.14 5.14 0 01-3.19 1.27zM94.61 129.79H92c-1.21 0-3.72 0-4.69-2.41a.27.27 0 01.15-.35.28.28 0 01.35.15c.73 1.82 2.45 2.07 4.19 2.07h4.59c2.11-.06 3.48-1.05 3.48-2.54v-5a.27.27 0 11.54 0v5c0 1.8-1.57 3-4 3.08z"
            transform="translate(-31.61 -1.63)"
        />
        <path
            className="cls-1"
            d="M75.54 137.93a2.24 2.24 0 01-2.21-2.15v-1.63c-2.58-.31-10.57-1.52-10.85-4.73 0-.62-.07-1.21-.09-1.77-.09-2.4-.2-3.48-2.07-4-1.32-.35-5.7-1.15-10.34-2-5.37-1-11.45-2.07-14.09-2.73-5-1.26-4.36-6.18-4.08-8.27l.06-.45a15.4 15.4 0 013.76-7.7c1-1.07 4.33-4 7.84-7.06 3.81-3.34 7.74-6.8 9.48-8.54 3.36-3.35 4-5.71 4.92-10.3C59.19 70.23 62.28 53.92 64 44c.17-1 .34-2 .53-3.2 1.85-11.14 4.65-28 11-28.36h.16c5.59 0 8.83 18.3 11.44 35.49.28 1.84.52 3.44.73 4.7.31 1.84.63 4 1 6.23C90.19 68 92.09 80.53 94.73 84c1.46 1.92 5.18 5.29 9.13 8.85 5.14 4.65 10.45 9.45 11.93 12.09 1.82 3.26 3 8.43 1.62 11.6a4.21 4.21 0 01-2.91 2.52c-2.67.65-9.7 1.93-15.34 3-3.79.68-7.06 1.28-8 1.49-2.1.49-2.73 1.13-3.1 3.08a10.29 10.29 0 00-.13 1.47c0 1.6-.12 3.41-2.9 4.46a24.72 24.72 0 01-6.91 1.27 4.59 4.59 0 01-.61 3.24 2.43 2.43 0 01-1.97.86zm0-1.07a1.37 1.37 0 001.16-.48c.63-.79.43-2.41.3-3a.54.54 0 01.1-.46.57.57 0 01.42-.21 25.1 25.1 0 007.17-1.22c2.11-.8 2.15-1.93 2.21-3.49a11.7 11.7 0 01.14-1.63c.44-2.35 1.43-3.35 3.91-3.93.93-.22 4.22-.81 8-1.51 5.63-1 12.64-2.29 15.28-2.93a3.13 3.13 0 002.17-1.91c1.2-2.75.14-7.57-1.57-10.64C113.46 103 108 98 103.14 93.67c-4-3.6-7.75-7-9.26-9C91.07 81 89.22 68.78 87.74 59c-.34-2.26-.66-4.38-1-6.22-.21-1.26-.45-2.86-.73-4.71-1.55-10.37-5.22-34.58-10.34-34.58h-.1c-5.46.33-8.28 17.31-10 27.46-.19 1.15-.37 2.23-.54 3.21-1.73 9.95-4.83 26.28-6.15 32.66-1 4.68-1.65 7.29-5.22 10.85-1.76 1.77-5.71 5.23-9.53 8.59-3.49 3.06-6.79 6-7.76 7a14.39 14.39 0 00-3.48 7.09l-.06.46c-.28 2.12-.81 6.06 3.27 7.08 2.61.65 8.67 1.75 14 2.72 4.86.88 9.06 1.65 10.43 2 2.71.74 2.78 2.71 2.86 5 0 .54 0 1.11.1 1.72.17 2 6.45 3.39 10.37 3.8a.54.54 0 01.48.54v2.11a1.18 1.18 0 001.13 1.08z"
            transform="translate(-31.61 -1.63)"
        />
        <path
            className="cls-1"
            d="M61 79.22h-.1a.53.53 0 01-.43-.62 77.43 77.43 0 012.31-9.76.54.54 0 011 .32 77.1 77.1 0 00-2.28 9.63.54.54 0 01-.5.43zM62.11 121.25a.54.54 0 01-.53-.44c0-.08-1.36-7.92-2.29-16.06A94.41 94.41 0 0159.47 86a.54.54 0 01.59-.48.53.53 0 01.48.59 93.62 93.62 0 00-.18 18.48c.93 8.1 2.27 15.92 2.28 16a.53.53 0 01-.44.62zM90 110.75h-.12a.52.52 0 01-.4-.64c3.3-14.12-.9-31.1-.94-31.27a.53.53 0 01.39-.65.52.52 0 01.65.39c.05.17 4.31 17.4 1 31.77a.54.54 0 01-.58.4zM88.11 120.58h-.15a.54.54 0 01-.37-.66l.94-3.37a.56.56 0 01.67-.37.54.54 0 01.37.66l-.94 3.37a.54.54 0 01-.52.37zM70.14 19.06a9.93 9.93 0 0010.33 0c-1.89-3.92-3-6.89-4.94-6.1s-4.6 3.98-5.39 6.1zM73.86 133.94a.28.28 0 01-.26-.28l1.85-60.06a.26.26 0 01.27-.26.27.27 0 01.27.26l1.61 59.23a.27.27 0 01-.26.28.28.28 0 01-.27-.27l-1.36-50-1.57 50.8a.27.27 0 01-.28.3zM62.25 105.23a.28.28 0 01-.24-.15.27.27 0 01.11-.36c.19-.1 4.6-2.42 8.68-1.35a.27.27 0 01-.14.53c-3.88-1-8.24 1.27-8.29 1.29a.19.19 0 01-.12.04zM88.11 105.23a.3.3 0 01-.15 0c-2.46-1.57-8-1.28-8-1.28a.27.27 0 110-.53c.23 0 5.76-.31 8.37 1.36a.27.27 0 01.09.37.29.29 0 01-.31.08z"
            transform="translate(-31.61 -1.63)"
        />
        <path
            className="cls-1"
            d="M63.32 125.7a.27.27 0 01-.11-.51c.15-.08 3.72-1.77 10.68-1a.27.27 0 01.24.3.26.26 0 01-.3.23c-6.8-.79-10.35.9-10.39.92a.27.27 0 01-.12.06zM87 125.7h-.11c-3.53-1.58-9.51-1.14-9.57-1.14a.27.27 0 01-.28-.24.26.26 0 01.24-.29c.25 0 6.18-.45 9.83 1.17a.27.27 0 01.14.36.28.28 0 01-.25.14zM73.86 129.65H63a.27.27 0 010-.54h10.86a.27.27 0 010 .54z"
            transform="translate(-31.61 -1.63)"
        />
        <path
            className="cls-1"
            d="M65.86 131.94a.27.27 0 01-.27-.27v-2a.27.27 0 01.54 0v2a.27.27 0 01-.27.27zM68.1 132.77a.27.27 0 01-.27-.27v-2.86a.27.27 0 11.54 0v2.86a.27.27 0 01-.27.27zM70.34 132.77a.27.27 0 01-.27-.27v-3.12a.27.27 0 11.54 0v3.12a.27.27 0 01-.27.27zM79.62 133.17a.27.27 0 01-.27-.27v-3.52a.27.27 0 11.54 0v3.52a.27.27 0 01-.27.27zM82.14 132.36a.27.27 0 01-.27-.27v-2.45a.27.27 0 11.53 0v2.45a.27.27 0 01-.26.27zM84.46 131.94a.27.27 0 01-.26-.27v-2a.27.27 0 11.53 0v2a.27.27 0 01-.27.27zM93.5 119.37a.27.27 0 01-.27-.22.28.28 0 01.22-.32l19.4-3.5a.28.28 0 01.31.22.27.27 0 01-.22.31l-19.4 3.5zM55.92 119.37h-.05l-19-3.5a.26.26 0 01-.22-.31.28.28 0 01.31-.22l19 3.5a.27.27 0 01.21.32.27.27 0 01-.25.21zM36.12 108.86a.16.16 0 01-.1 0 .26.26 0 01-.16-.34c.11-.28 2.74-6.78 15.07-14.28a.27.27 0 01.37.09.28.28 0 01-.09.37c-12.15 7.4-14.82 13.94-14.84 14a.27.27 0 01-.25.16zM75.6 68.45a.26.26 0 01-.27-.26L75 53.24a.26.26 0 01.3-.24.27.27 0 01.27.27l.3 15a.27.27 0 01-.27.27zM75.3 35.45a.27.27 0 01-.26-.27v-2.56a.27.27 0 01.53 0v2.56a.27.27 0 01-.27.27zM75.48 24.21a12.12 12.12 0 01-6.54-2.06.27.27 0 010-.37.27.27 0 01.38-.06c.06 0 6 4.36 12 0a.26.26 0 01.37.06.26.26 0 01-.06.38 10.29 10.29 0 01-6.15 2.05zM104.61 112.5a3.84 3.84 0 110-7.68 3.67 3.67 0 011.14.18.27.27 0 01.18.33.26.26 0 01-.34.18 3.31 3.31 0 102.06 1.87.28.28 0 01.14-.36.28.28 0 01.36.15 3.78 3.78 0 01.3 1.49 3.84 3.84 0 01-3.84 3.84zM70.36 50.64a2.5 2.5 0 01-1.31-.42 2.56 2.56 0 01-1.24-2.11c-.07-2.09 1.9-4.51 3.26-5.5a7.81 7.81 0 019.15.88c2.1 2.13 2.49 4.38 2 5.66a1.67 1.67 0 01-1.56 1.11 4.4 4.4 0 01-2.56-1.34 4.55 4.55 0 00-3-1.42 3.9 3.9 0 00-2.3 1.61 3.47 3.47 0 01-2.44 1.53zM75 42.08a6.5 6.5 0 00-3.65 1c-1.31 1-3.09 3.23-3 5a2 2 0 001 1.67c1.27.79 2 .13 3-1A4.32 4.32 0 0175 47c1.37-.14 2.47.75 3.43 1.54a4.12 4.12 0 002.22 1.21 1.13 1.13 0 001.06-.78c.45-1.08.07-3.13-1.84-5.07A6.74 6.74 0 0075 42.08zm0 5.15z"
            transform="translate(-31.61 -1.63)"
        />
        <path
            className="cls-1"
            d="M72.92 46.36a.27.27 0 01-.12 0c-.65-.32-.58-1.48-.57-1.61a.27.27 0 11.53 0c0 .37 0 1 .28 1.09a.27.27 0 01.12.36.26.26 0 01-.24.16zM77.66 46.61a.3.3 0 01-.2-.08.28.28 0 010-.39s.74-.68.31-1.24a.27.27 0 11.42-.33 1.48 1.48 0 01-.37 2 .26.26 0 01-.16.04z"
            transform="translate(-31.61 -1.63)"
        />
        <path
            className="cls-2"
            d="M55.84 129.94h-2c-2.43-.07-4-1.28-4-3.08v-5a.28.28 0 01.27-.27.27.27 0 01.27.27v5c0 1.49 1.37 2.48 3.48 2.54h4.6c1.74 0 3.45-.25 4.19-2.07a.26.26 0 01.35-.15.28.28 0 01.15.35c-1 2.41-3.49 2.41-4.69 2.41h-1.2z"
            transform="translate(-31.61 -1.63)"
        />
        <path
            className="cls-2"
            d="M58.12 141h-.77a16.45 16.45 0 00-2.53 0 3.6 3.6 0 01-2.7-1 4.35 4.35 0 01-1.32-3v-8.2a.27.27 0 11.54 0v8.2a3.73 3.73 0 001.15 2.64 3 3 0 002.29.83 15.52 15.52 0 012.6 0h.8c1 0 4-1 4.12-3.85.07-3.12 0-7.18 0-7.22a.27.27 0 01.26-.27.28.28 0 01.27.26s.07 4.11 0 7.24c-.08 3.31-3.44 4.37-4.66 4.38z"
            transform="translate(-31.61 -1.63)"
        />
        <path
            className="cls-2"
            d="M51.07 137.24a.28.28 0 01-.27-.22.28.28 0 01.22-.32 51.62 51.62 0 0111.57-.36.27.27 0 01.25.29.29.29 0 01-.29.25 50 50 0 00-11.43.35zM61.38 139.59h-.09c-3.86-1.49-8.82-.14-8.86-.12a.27.27 0 11-.15-.52c.21-.06 5.17-1.41 9.2.13a.26.26 0 01.15.35.26.26 0 01-.25.16z"
            transform="translate(-31.61 -1.63)"
        />
        <path
            className="cls-2"
            d="M56.87 136.72a.27.27 0 01-.27-.27v-4.78a.27.27 0 11.54 0v4.78a.27.27 0 01-.27.27zM52.93 133.94a.27.27 0 01-.27-.27V130a.27.27 0 01.54 0v3.68a.27.27 0 01-.27.26zM60.27 134.33a.27.27 0 01-.27-.27v-4.58a.27.27 0 01.27-.27.28.28 0 01.27.27v4.58a.28.28 0 01-.27.27zM95.87 140.84h-.24a18.11 18.11 0 00-2.54 0 6.47 6.47 0 01-.83 0c-1.21 0-4.58-1.06-4.65-4.37-.08-3.14 0-7.2 0-7.24a.27.27 0 01.27-.27.26.26 0 01.26.28s-.07 4.09 0 7.21c.07 2.88 3.09 3.84 4.13 3.85h.79a15.52 15.52 0 012.6 0 2.93 2.93 0 002.29-.83 3.74 3.74 0 001.16-2.64v-8.2a.27.27 0 11.53 0v8.2a4.29 4.29 0 01-1.32 3 3.52 3.52 0 01-2.45 1.01z"
            transform="translate(-31.61 -1.63)"
        />
        <path
            className="cls-2"
            d="M99.38 137.09a50.79 50.79 0 00-11.43-.35.28.28 0 01-.29-.25.27.27 0 01.25-.29 50.79 50.79 0 0111.56.36.27.27 0 01.22.32.27.27 0 01-.31.21zM89.06 139.45a.27.27 0 01-.25-.18.27.27 0 01.15-.35c4-1.54 9-.19 9.2-.13a.27.27 0 11-.14.52s-5-1.36-8.86.12z"
            transform="translate(-31.61 -1.63)"
        />
        <path
            className="cls-2"
            d="M93.57 136.57a.27.27 0 01-.26-.27v-4.78a.27.27 0 11.53 0v4.78a.27.27 0 01-.27.27zM97.51 133.79a.27.27 0 01-.26-.27v-3.68a.27.27 0 11.53 0v3.68a.27.27 0 01-.27.27zM90.18 134.18a.27.27 0 01-.27-.27v-4.58a.27.27 0 01.54 0v4.58a.27.27 0 01-.27.27z"
            transform="translate(-31.61 -1.63)"
        />
    </svg>
)

export const PriceEnterpriseIcon = () => (
    <svg data-name="Layer 4" viewBox="0 0 93.19 135.32">
        <path
            className="cls-1"
            d="M120.46 88.42L87.51 88a.54.54 0 01-.53-.54.55.55 0 01.54-.54l32.44.4c.08-1.09.12-2.19.12-3.31s0-2.21-.12-3.3l-32.23.59a.55.55 0 01-.54-.5.54.54 0 01.46-.57l32.1-5a.55.55 0 01.62.45.54.54 0 01-.46.61L95.6 80.1l24.86-.45a.53.53 0 01.53.49c.11 1.28.16 2.59.16 3.89s0 2.63-.16 3.9a.54.54 0 01-.53.49z"
            transform="translate(-29.27 -2.56)"
        />
        <path
            className="cls-1"
            d="M119.83 76a.55.55 0 01-.53-.43 45.31 45.31 0 00-2.2-7.77.54.54 0 01.31-.69.54.54 0 01.7.31 46.24 46.24 0 012.25 8 .53.53 0 01-.43.62zM44.43 118.78a.53.53 0 01-.36-.13A46.48 46.48 0 0129.28 92.4a.58.58 0 01.09-.41.51.51 0 01.36-.22l31.88-5.14a.54.54 0 11.17 1.06l-31.34 5a45.45 45.45 0 0014.35 25.1.54.54 0 010 .76.52.52 0 01-.36.23z"
            transform="translate(-29.27 -2.56)"
        />
        <path
            className="cls-1"
            d="M74.85 134.14a50.07 50.07 0 01-33.19-12.56.54.54 0 010-.76l24-27.18a.54.54 0 01.8.72l-23.68 26.77a49 49 0 0063.28.71l-2.22-3a.54.54 0 11.86-.64l2.53 3.44a.53.53 0 01-.09.73 50.11 50.11 0 01-32.29 11.77z"
            transform="translate(-29.27 -2.56)"
        />
        <path
            className="cls-1"
            d="M74.85 137.87a53.71 53.71 0 01-36.4-14.16.54.54 0 11.73-.79 52.83 52.83 0 0053.91 10.64.54.54 0 01.7.31.55.55 0 01-.32.7 53.84 53.84 0 01-18.62 3.3zM101.28 130.87a.54.54 0 01-.26-1 52.94 52.94 0 008.39-6 .55.55 0 01.76 0 .54.54 0 010 .76 53.43 53.43 0 01-8.57 6.08.5.5 0 01-.32.16zM55.54 106.42a.54.54 0 01-.34-.12A30.1 30.1 0 0145 90.22a.54.54 0 01.4-.65.53.53 0 01.6.43 28.94 28.94 0 009.85 15.5.54.54 0 01.07.76.53.53 0 01-.38.16zM93.28 105.75a.56.56 0 01-.41-.19.54.54 0 01.06-.76 28.67 28.67 0 009-14.74.52.52 0 01.65-.39.54.54 0 01.4.65 29.65 29.65 0 01-9.38 15.29.52.52 0 01-.32.14zM102.91 78.47a.55.55 0 01-.54-.44 28.06 28.06 0 00-1.19-4.54.54.54 0 111-.36 31.37 31.37 0 011.24 4.71.54.54 0 01-.44.62zM97.23 65.67a.51.51 0 01-.42-.21 29.05 29.05 0 00-15.18-10.17.54.54 0 11.28-1A30.07 30.07 0 0197.66 64.8a.54.54 0 01-.1.76.51.51 0 01-.33.11zM45.2 78h-.11a.55.55 0 01-.43-.64 29.85 29.85 0 0122.7-23.44.53.53 0 01.64.4.55.55 0 01-.41.65 28.77 28.77 0 00-21.87 22.6.53.53 0 01-.52.43zM74.65 97.66a13.94 13.94 0 1113.94-13.94 14 14 0 01-13.94 13.94zm0-26.8a12.87 12.87 0 1012.87 12.86 12.88 12.88 0 00-12.87-12.86z"
            transform="translate(-29.27 -2.56)"
        />
        <path
            className="cls-1"
            d="M74.65 88.46a4.74 4.74 0 114.74-4.74 4.75 4.75 0 01-4.74 4.74zm0-8.94a4.2 4.2 0 104.2 4.2 4.21 4.21 0 00-4.2-4.2zM59.89 36.5a4.74 4.74 0 01-4.74-4.74 5.15 5.15 0 01.11-1 .28.28 0 01.33-.21.28.28 0 01.2.32 4.05 4.05 0 00-.1.92 4.21 4.21 0 102.2-3.69.27.27 0 01-.36-.11.28.28 0 01.11-.37 4.74 4.74 0 112.25 8.91zM89.69 36.5a4.74 4.74 0 114.74-4.74 4.74 4.74 0 01-4.74 4.74zm0-8.94a4.2 4.2 0 104.2 4.2 4.21 4.21 0 00-4.2-4.2zM86.12 21.34a3.22 3.22 0 01-3.22-3.22 3.26 3.26 0 01.24-1.24.26.26 0 01.35-.15.28.28 0 01.15.36 2.56 2.56 0 00-.2 1 2.68 2.68 0 102.68-2.69 2.73 2.73 0 00-1.05.21.26.26 0 01-.35-.14.27.27 0 01.14-.35 3.18 3.18 0 011.26-.25 3.22 3.22 0 010 6.44zM63.16 21.34a3.22 3.22 0 113.22-3.22 3.22 3.22 0 01-3.22 3.22zm0-5.91a2.69 2.69 0 102.68 2.69 2.69 2.69 0 00-2.68-2.69zM74.57 112.73a3.35 3.35 0 113.35-3.35 3.35 3.35 0 01-3.35 3.35zm0-6.16a2.81 2.81 0 102.81 2.81 2.81 2.81 0 00-2.81-2.81zM74.57 121.84a3.35 3.35 0 113.35-3.35 3.35 3.35 0 01-3.35 3.35zm0-6.16a2.82 2.82 0 102.81 2.81 2.81 2.81 0 00-2.81-2.81zM85.92 120a3.35 3.35 0 113.36-3.35 3.28 3.28 0 01-.12.88.27.27 0 01-.33.19.27.27 0 01-.19-.33 3.07 3.07 0 00.1-.74 2.82 2.82 0 10-2.82 2.81 2.86 2.86 0 001.46-.4.27.27 0 01.37.08.28.28 0 01-.08.38 3.36 3.36 0 01-1.75.48zM83.73 111a3.35 3.35 0 113.35-3.35 3.36 3.36 0 01-3.35 3.35zm0-6.17a2.82 2.82 0 102.81 2.82 2.82 2.82 0 00-2.81-2.85zM65.12 110.74a3.37 3.37 0 01-3.36-3.35.28.28 0 01.27-.27.27.27 0 01.27.27 2.83 2.83 0 10.83-2 .28.28 0 01-.38 0 .26.26 0 010-.38 3.3 3.3 0 012.37-1 3.36 3.36 0 010 6.71zM63.27 120a3.35 3.35 0 113.36-3.35 3.36 3.36 0 01-3.36 3.35zm0-6.16a2.81 2.81 0 102.82 2.81 2.81 2.81 0 00-2.82-2.83zM80.33 72.12a.54.54 0 01-.18-1.05l32.48-11.93a45.13 45.13 0 00-31.87-20 .54.54 0 01-.47-.6.55.55 0 01.61-.47 46.2 46.2 0 0133 21 .54.54 0 01.06.46.58.58 0 01-.33.34L80.52 72.08a.43.43 0 01-.19.04zM110.12 65.4a.26.26 0 01-.25-.17.27.27 0 01.16-.35l7.27-2.76a.27.27 0 01.35.15.27.27 0 01-.16.35l-7.27 2.77zM84.67 75.08a.28.28 0 01-.26-.17.27.27 0 01.16-.35L104 67.18a.28.28 0 01.35.16.28.28 0 01-.16.35l-19.43 7.37a.15.15 0 01-.09.02zM110.82 88.21a.54.54 0 01-.53-.54v-7.31a.54.54 0 111.07 0v7.31a.54.54 0 01-.54.54zM120.62 84.3h-2.45a.27.27 0 110-.54h2.45a.27.27 0 010 .54z"
            transform="translate(-29.27 -2.56)"
        />
        <path
            className="cls-1"
            d="M115.72 84.29h-4.9a.27.27 0 010-.53h4.9a.28.28 0 01.28.24.27.27 0 01-.28.29zM104.57 119.39a.54.54 0 01-.37-.19L83 94.21a.53.53 0 01.06-.76.54.54 0 01.76.06l20.8 24.57A45.32 45.32 0 00119.2 93l-31.76-5a.54.54 0 01.16-1l32.32 5a.51.51 0 01.35.22.5.5 0 01.09.41 46.42 46.42 0 01-15.44 26.6.56.56 0 01-.35.16zM29.86 88.21a.51.51 0 01-.38-.16.53.53 0 01-.16-.38v-7.36a.54.54 0 01.54-.54h24.53L29.78 76a.55.55 0 01-.36-.22.56.56 0 01-.09-.42A46.29 46.29 0 0168.07 38.2a.56.56 0 01.61.46.53.53 0 01-.45.61A45.19 45.19 0 0030.5 75.05l31.09 4.73a.54.54 0 01.46.57.54.54 0 01-.54.5H30.4v6.27l31.29-.5c.34 0 .54.23.54.53a.54.54 0 01-.53.55l-31.83.51z"
            transform="translate(-29.27 -2.56)"
        />
        <path
            className="cls-1"
            d="M38.85 88.07a.54.54 0 01-.54-.54v-7.22a.54.54 0 111.08 0v7.22a.54.54 0 01-.54.54z"
            transform="translate(-29.27 -2.56)"
        />
        <path
            className="cls-1"
            d="M38.85 84.19h-9a.27.27 0 110-.54h9a.27.27 0 010 .54zM61.51 80.85H29.86a.54.54 0 010-1.08h31.65a.54.54 0 010 1.08zM64.91 75.05a.54.54 0 01-.34-.12L51.64 64.1a.54.54 0 01.69-.83L65.26 74.1a.53.53 0 01.06.76.52.52 0 01-.41.19zM72.72 75.38a.28.28 0 01-.27-.27V62.93a.28.28 0 01.27-.27.27.27 0 01.27.27v12.18a.27.27 0 01-.27.27zM76.29 75.77a.27.27 0 01-.27-.26V62.93a.27.27 0 01.54 0v12.58a.27.27 0 01-.27.26z"
            transform="translate(-29.27 -2.56)"
        />
        <path
            className="cls-1"
            d="M82.11 67.54H67.68a.55.55 0 01-.39-.16.54.54 0 01-.15-.4l1.71-41.91a.54.54 0 01.54-.51h10.94a.53.53 0 01.54.51L82.65 67a.51.51 0 01-.15.39.52.52 0 01-.39.15zm-13.87-1.08h13.31l-1.73-40.83H69.9z"
            transform="translate(-29.27 -2.56)"
        />
        <path
            className="cls-1"
            d="M35.34 61.42a.46.46 0 01-.23-.05.54.54 0 01-.25-.72l27.6-57.79a.55.55 0 01.49-.3h7.72a.54.54 0 01.54.54v22a.54.54 0 01-1.08 0V3.64h-6.84L35.83 61.12a.55.55 0 01-.49.3zM87.12 79.32a.54.54 0 01-.19-1l33.88-12.72-7.69-5.76a.45.45 0 01-.16-.2l-26.14-56h-7V25.1a.54.54 0 01-.54.53.54.54 0 01-.54-.53v-22a.54.54 0 01.54-.54h7.92a.54.54 0 01.49.31l26.23 56.19 8.37 6.27a.54.54 0 01-.14.94l-34.8 13z"
            transform="translate(-29.27 -2.56)"
        />
        <path
            className="cls-1"
            d="M94.14 32h-8.92a.27.27 0 01-.27-.27.28.28 0 01.27-.27h8.92a.28.28 0 01.27.27.27.27 0 01-.27.27zM94.46 52.31a.33.33 0 01-.16-.05.27.27 0 010-.38l5-6.58a.26.26 0 01.38 0 .27.27 0 010 .37l-5 6.59a.28.28 0 01-.22.05zM89.69 58.54a.28.28 0 01-.22-.44l2.39-3.1a.27.27 0 11.43.33l-2.39 3.1a.26.26 0 01-.21.11zM121.92 66.18a.54.54 0 01-.53-.54V53.23h-7.78v6.32a.54.54 0 01-.54.53.54.54 0 01-.54-.53v-6.86a.54.54 0 01.54-.54h8.85a.54.54 0 01.54.54v13a.54.54 0 01-.54.49z"
            transform="translate(-29.27 -2.56)"
        />
        <path
            className="cls-1"
            d="M113.07 53.23h-.18a.53.53 0 01-.32-.69l1.6-4.53a.54.54 0 01.51-.36h5.49a.53.53 0 01.5.34l1.76 4.54a.54.54 0 01-.31.7.56.56 0 01-.7-.31l-1.62-4.22h-4.74l-1.48 4.17a.55.55 0 01-.51.36z"
            transform="translate(-29.27 -2.56)"
        />
        <path
            className="cls-1"
            d="M117.4 62.77a.27.27 0 01-.27-.27v-9.81a.27.27 0 11.53 0v9.81a.27.27 0 01-.26.27z"
            transform="translate(-29.27 -2.56)"
        />
    </svg>
)

export const DeployBotIcon = () => (
    <svg x="0px" y="0px" viewBox="0 0 32 32" xmlSpace="preserve">
        <path d="M6 30c-.4 0-.7-.2-.9-.5-.2-.3-.2-.8.1-1.1 0 0 1.6-2.2 1.8-4.8-4.5-2.4-7-5.8-7-9.6C0 7.4 7.2 2 16 2s16 5.4 16 12-7.2 12-16 12h-2.4c-2.4 3.7-7.3 4-7.6 4zM16 4.6c-7.4 0-13.3 4.3-13.3 9.5 0 4.1 3.8 6.6 6.1 7.8.3.2.5.5.5.9 0 1.7-.5 3.2-1 4.4 1.3-.4 3.1-1.2 4-2.9.2-.3.5-.5.8-.5H16c7.4 0 13.3-4.3 13.3-9.5S23.4 4.6 16 4.6z" />
        <circle cx={10} cy={16} r={2} />
        <circle cx={16} cy={16} r={2} />
        <circle cx={22} cy={16} r={2} />
    </svg>
)

export const TimerIcon = () => (
    <svg width={23.817} height={23.817} viewBox="0 0 23.817 23.817">
        <g data-name="Group 6207">
            <g data-name="Group 6205">
                <g data-name="Group 6202">
                    <path
                        data-name="Path 3249"
                        d="M1478.909 3599.817a11.923 11.923 0 0011.909-11.909.744.744 0 10-1.489 0 10.413 10.413 0 11-1.043-4.549.744.744 0 101.339-.651 11.91 11.91 0 10-10.716 17.108z"
                        transform="translate(-1467 -3576) translate(1467 3576) translate(-1467 -3576)"
                    />
                </g>
                <g data-name="Group 6203">
                    <path
                        data-name="Path 3250"
                        d="M1482.744 3590.931a.744.744 0 01-.744-.744v-7.443a.744.744 0 011.489 0v7.443a.744.744 0 01-.745.744z"
                        transform="translate(-1467 -3576) translate(1467 3576) translate(11.164 4.466) translate(-1482 -3582)"
                    />
                </g>
                <g data-name="Group 6204">
                    <path
                        data-name="Path 3251"
                        d="M1487.21 3593.489h-4.466a.744.744 0 110-1.489h4.466a.744.744 0 110 1.489z"
                        transform="translate(-1467 -3576) translate(1467 3576) translate(11.164 11.909) translate(-1482 -3592)"
                    />
                </g>
            </g>
            <g data-name="Group 6206">
                <path
                    data-name="Path 3252"
                    d="M1490.744 3584.7h4.466a.744.744 0 00.744-.744v-5.21a.744.744 0 10-1.489 0v4.466h-3.721a.744.744 0 100 1.489z"
                    transform="translate(-1467 -3576) translate(1467 3576) translate(17.119 1.489) translate(-1490 -3578)"
                />
            </g>
        </g>
        <g data-name="Group 6208">
            <circle
                data-name="Ellipse 243"
                cx={1.5}
                cy={1.5}
                r={1.5}
                transform="translate(-1467 -3576) translate(1477.42 3587.164) translate(-.42 -.347)"
            />
        </g>
    </svg>
)

export const WidgetCloseIcon = () => (
    <svg x="0px" y="0px" viewBox="0 0 72 72" xmlSpace="preserve">
        <path d="M36 1C16.7 1 1 16.7 1 36s15.7 35 35 35 35-15.7 35-35S55.3 1 36 1zm11.8 44c.8.8.8 2 0 2.8-.4.4-.9.6-1.4.6-.5 0-1-.2-1.4-.6l-8.6-8.6-8.6 8.6c-.4.4-.9.6-1.4.6-.5 0-1-.2-1.4-.6-.8-.8-.8-2 0-2.8l8.6-8.6-8.6-8.6c-.8-.8-.8-2 0-2.8.8-.8 2-.8 2.8 0l8.6 8.6L45 25c.8-.8 2-.8 2.8 0 .8.8.8 2 0 2.8l-8.6 8.6 8.6 8.6z" />
    </svg>
)

export const WidgetMinimizeIcon = () => (
    <svg x="0px" y="0px" viewBox="0 0 32 32" xmlSpace="preserve">
        <path d="M31 32H1c-.6 0-1-.4-1-1V1c0-.6.4-1 1-1h19c.6 0 1 .4 1 1s-.4 1-1 1H2v28h28V12c0-.6.4-1 1-1s1 .4 1 1v19c0 .6-.4 1-1 1z" />{' '}
        <path d="M21 22H11c-.6 0-1-.4-1-1V11c0-.6.4-1 1-1s1 .4 1 1v9h9c.6 0 1 .4 1 1s-.4 1-1 1z" />
        <path d="M11 22c-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4l20-20c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-20 20c-.2.2-.4.3-.7.3z" />
    </svg>
)

export const WidgetSendIcon = () => (
    <svg x="0px" y="0px" viewBox="0 0 32 32" xmlSpace="preserve">
        <path d="M24 30c-.2 0-.3 0-.5-.1l-12-7c-.5-.3-.6-.9-.4-1.4.3-.5.9-.6 1.4-.4l10.8 6.3 6.1-24.6L3.2 16l5.6 3.1c.5.3.7.9.4 1.4-.3.5-.9.7-1.4.4l-7.3-4c-.3-.2-.5-.5-.5-.9s.2-.7.6-.9l30-15c.3-.2.8-.1 1.1.1.3.2.4.6.3 1l-7 28c-.1.3-.3.6-.6.7-.1.1-.3.1-.4.1z" />
        <path d="M12 32h-.3c-.4-.1-.7-.5-.7-1v-9c0-.6.4-1 1-1s1 .4 1 1v5.7l2.2-3.3c.3-.5.9-.6 1.4-.3.5.3.6.9.3 1.4l-4 6c-.3.3-.6.5-.9.5z" />
        <path d="M12 23c-.2 0-.5-.1-.7-.3-.4-.4-.4-1-.1-1.4l19-21c.4-.4 1-.4 1.4-.1.4.4.4 1 .1 1.4l-19 21c-.2.3-.4.4-.7.4z" />
    </svg>
)

export const WidgetCopyIcon = () => (
    <svg x="0px" y="0px" viewBox="0 0 24 24" xmlSpace="preserve">
        <path d="M22.4 23.2H5.5c-.4 0-.6-.3-.6-.6V5.7c0-.4.3-.6.6-.6h16.9c.4 0 .6.3.6.6v16.9c0 .4-.3.6-.6.6zM6.1 21.9h15.6V6.4H6.1v15.5z" />
        <path d="M1.4 20.5c-.4 0-.7-.3-.7-.7V1.6c0-.4.3-.7.7-.7h18.1c.4 0 .7.3.7.7s-.3.7-.7.7H2.1v17.5c0 .3-.4.7-.7.7z" />
    </svg>
)

export const RestartIcon = () => (
    <svg x="0px" y="0px" viewBox="0 0 24 24">
        <path d="M20.6 12.1c-.8 0-1.4.6-1.4 1.4 0 4.1-3.3 7.4-7.4 7.4s-7.4-3.3-7.4-7.4c0-3.7 2.7-6.7 6.3-7.2l-.3.3c-.3.3-.4.6-.4 1s.1.7.4 1c.3.3.6.4 1 .4s.7-.1 1-.4l2.8-2.8c.3-.3.4-.6.4-1s-.1-.7-.4-1L12.4 1c-.5-.5-1.4-.5-2 0-.2.3-.4.6-.4 1s.1.7.4 1l.5.5c-5.2.5-9.2 4.8-9.2 10 0 5.6 4.6 10.2 10.2 10.2S22 19.1 22 13.5c0-.8-.6-1.4-1.4-1.4z" />
    </svg>
)
// export const ExitICon = () => (
//     <svg viewBox="0 0 512 512">
//     <path d="M255.15 468.625H63.787c-11.737 0-21.262-9.526-21.262-21.262V64.638c0-11.737 9.526-21.262 21.262-21.262H255.15c11.758 0 21.262-9.504 21.262-21.262S266.908.85 255.15.85H63.787C28.619.85 0 29.47 0 64.638v382.724c0 35.168 28.619 63.787 63.787 63.787H255.15c11.758 0 21.262-9.504 21.262-21.262 0-11.758-9.504-21.262-21.262-21.262z"></path>
//     <path d="M505.664 240.861L376.388 113.286c-8.335-8.25-21.815-8.143-30.065.213s-8.165 21.815.213 30.065l92.385 91.173H191.362c-11.758 0-21.262 9.504-21.262 21.262 0 11.758 9.504 21.263 21.262 21.263h247.559l-92.385 91.173c-8.377 8.25-8.441 21.709-.213 30.065a21.255 21.255 0 0015.139 6.336c5.401 0 10.801-2.041 14.926-6.124l129.276-127.575A21.303 21.303 0 00512 255.998c0-5.696-2.275-11.118-6.336-15.137z"></path>
// </svg>
// )
export const ConversationMessageIcon = () => (
    <svg id="Layer_1" x="0px" y="0px" viewBox="0 0 32 32" xmlSpace="preserve">
        <style>{'.st2w{fill:currentcolour}'}</style>
        <g opacity={0.5}>
            <circle cx={16} cy={16} r={15.5} fill="#fff" />
            <path
                className="st2w"
                d="M16 1c8.3 0 15 6.7 15 15s-6.7 15-15 15S1 24.3 1 16 7.7 1 16 1m0-1C7.2 0 0 7.2 0 16s7.2 16 16 16 16-7.2 16-16S24.8 0 16 0z"
            />
        </g>
        <g id="icon_3" transform="translate(-1021 -304)">
            <g id="Group_7725" transform="translate(1028.96 313.96)">
                <path
                    className="st2w"
                    d="M11.7 9.2H5.8c-.2 0-.5-.2-.5-.5s.2-.5.5-.5h5.3V.5H.5v7.7h2.4c.3 0 .5.2.5.5s-.2.5-.5.5H0c-.3 0-.5-.2-.5-.5V0c0-.3.2-.5.5-.5h11.7c.3 0 .5.2.5.5v8.7c0 .3-.3.5-.5.5z"
                    id="Path_4123"
                />
                <path
                    className="st2w"
                    d="M9 3.5H3c-.2 0-.5-.2-.5-.5s.3-.5.5-.5h6c.3 0 .5.2.5.5s-.2.5-.5.5z"
                    id="Line_349"
                />
                <path
                    className="st2w"
                    d="M7 6.5H3c-.2 0-.5-.2-.5-.5s.3-.5.5-.5h4c.3 0 .5.2.5.5s-.2.5-.5.5z"
                    id="Line_350"
                />
                <path
                    className="st2w"
                    d="M2.9 12.2h-.2c-.2-.1-.3-.3-.3-.5v-3c0-.3.2-.5.5-.5s.5.2.5.5v1.7l2.1-2.1c.2-.2.5-.2.7 0s.2.5 0 .7l-2.9 3c-.1.1-.3.2-.4.2z"
                    id="Path_4124"
                />
                <g id="Group_7724" transform="translate(6.562 5.833)">
                    <path
                        className="st2w"
                        d="M9.5 7.8H6.6c-.3 0-.5-.2-.5-.5s.2-.5.5-.5H9V.5H8c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h1.5c.3 0 .5.2.5.5v7.3c0 .3-.2.5-.5.5z"
                        id="Path_4125"
                    />
                    <path
                        className="st2w"
                        d="M3.6 7.8H0c-.3 0-.5-.2-.5-.5V5.8c0-.3.2-.5.5-.5s.5.2.5.5v1h3.1c.3 0 .5.2.5.5s-.2.5-.5.5z"
                        id="Path_4126"
                    />
                    <path
                        className="st2w"
                        d="M6.6 10.7c-.1 0-.3-.1-.4-.1l-2.9-3c-.2-.2-.2-.5 0-.7s.5-.2.7 0L6.1 9V7.3c0-.3.2-.5.5-.5s.5.2.5.5v2.9c0 .2-.1.4-.3.5h-.2z"
                        id="Path_4127"
                    />
                </g>
            </g>
        </g>
    </svg>
)
export const BotsIcon = () => (
    <svg id="Layer_1" x="0px" y="0px" viewBox="0 0 32 32" xmlSpace="preserve">
        <style>{'.st0{fill:currentcolour}'}</style>
        <g id="icon_2" transform="translate(-601 -304)">
            <g id="Group_3492" transform="translate(219.593 -411.171)">
                <path
                    id="Path_2408"
                    className="st0"
                    d="M394.4 738.3h-.2c-.2-.1-.3-.3-.3-.5v-2.5c-3.1-.4-5.3-3.3-4.9-6.4.4-2.8 2.8-4.9 5.6-4.9h5.4c3.1 0 5.7 2.5 5.7 5.7s-2.5 5.7-5.7 5.7h-2l-3.3 2.8c0 .1-.1.1-.3.1zm.5-3.3v1.8l2.6-2.3c.1-.1.2-.1.3-.1h2.3c2.6 0 4.7-2.1 4.7-4.7s-2.1-4.7-4.7-4.7h-5.4c-2.6 0-4.7 2.2-4.6 4.8 0 2.5 1.9 4.5 4.4 4.6.3 0 .5.2.5.5-.1 0-.1.1-.1.1z"
                />
            </g>
        </g>
        <path
            className="st0"
            d="M16 31.6C7.4 31.6.4 24.6.4 16S7.4.4 16 .4s15.6 7 15.6 15.6-7 15.6-15.6 15.6zM16 .9C7.7.9.9 7.7.9 16S7.7 31.1 16 31.1 31.1 24.3 31.1 16 24.3.9 16 .9z"
            opacity={0.5}
        />
    </svg>
)

export const StandardPlanIcon = () => (
    <svg id="Layer_1" x="0px" y="0px" viewBox="0 0 32 32" xmlSpace="preserve">
        <style>{'.st2{fill:currentcolour}'}</style>
        <g opacity={0.5}>
            <circle cx={16} cy={16} r={15.5} fill="#fff" />
            <path
                className="st2"
                d="M16 1c8.3 0 15 6.7 15 15s-6.7 15-15 15S1 24.3 1 16 7.7 1 16 1m0-1C7.2 0 0 7.2 0 16s7.2 16 16 16 16-7.2 16-16S24.8 0 16 0z"
            />
        </g>
        <g id="Group_7698" transform="translate(1449 312.947)">
            <g id="Group_7697">
                <g id="Group_7696" transform="translate(.042)">
                    <path
                        className="st2"
                        d="M-1440.5-288.9c-.6 0-1-.5-1-1v-10.6c0-.6.5-1 1-1h15c.6 0 1 .5 1 1v10.6c0 .6-.5 1-1 1h-15zm0-11.7v10.6h15v-11.1.5h-15z"
                        id="Path_4115"
                    />
                    <path
                        className="st2"
                        d="M-1430.1-300.6c-.3 0-.5-.2-.5-.5v-1.7c0-.4-.3-.7-.7-.7h-3.5c-.4 0-.7.3-.7.7v1.7c0 .3-.2.5-.5.5s-.5-.2-.5-.5v-1.7c0-.9.7-1.7 1.7-1.7h3.5c.9 0 1.7.8 1.7 1.7v1.8c0 .2-.2.4-.5.4z"
                        id="Path_4116"
                    />
                </g>
                <path
                    className="st2"
                    d="M-1425-295.4h-16c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h16c.3 0 .5.2.5.5s-.2.5-.5.5z"
                    id="Line_340"
                />
            </g>
            <path
                className="st2"
                d="M-1433-297.4h-.2c-.1 0-.1-.1-.2-.1s-.1-.1-.1-.2v-.2-.2c0-.1.1-.1.1-.2s.1-.1.2-.1c.1-.1.3-.1.4 0 .1 0 .1.1.2.1s.1.1.1.2v.4c0 .1-.1.1-.1.2s-.1.1-.2.1c-.1-.1-.1 0-.2 0z"
                id="Line_341"
            />
        </g>
    </svg>
)

export const StarIcon = () => (
    <svg x="0px" y="0px" viewBox="0 0 60 60" enableBackground="new 0 0 60 60" xmlSpace="preserve">
        <g>
            <circle fill="currentcolour" className="star0" cx="30" cy="30" r="30" />
        </g>
        <polygon
            className="star1"
            fill="#FFFFFF"
            points="46.9,26.2 35.7,23.9 30,13.9 24.3,23.9 13.1,26.2 20.8,34.7 19.6,46.1 30,41.4 40.4,46.1 39.2,34.7 "
        />
    </svg>
)

export const InformationIcon = () => (
    <svg x="0px" y="0px" viewBox="0 0 26.8 26.8" xmlSpace="preserve">
        <path
            d="M22.9 3.9c-5.2-5.2-13.7-5.2-19 0s-5.2 13.7 0 19 13.7 5.2 19 0c2.5-2.5 3.9-5.9 3.9-9.5.1-3.5-1.4-7-3.9-9.5zm-8.9 2c.9 0 1.7.8 1.7 1.7s-.8 1.6-1.7 1.6c-.9 0-1.7-.8-1.7-1.7 0-.9.8-1.6 1.7-1.6zM15.7 21h-3.4c-.5 0-.8-.4-.8-.8 0-.5.4-.8.8-.8h.8v-6.7h-.8c-.5 0-.8-.4-.8-.8 0-.5.4-.8.8-.8H14c.5 0 .8.4.8.8v7.6h.8c.5 0 .8.4.8.8.1.3-.3.7-.7.7z"
            fill="currentcolour"
        />
    </svg>
)

export const PricingYesIcon = () => (
    <svg x="0px" y="0px" viewBox="0 0 32 32" xmlSpace="preserve" fill="#466AF3">
        <path d="M16 32C7.2 32 0 24.8 0 16S7.2 0 16 0s16 7.2 16 16-7.2 16-16 16zm0-30C8.3 2 2 8.3 2 16s6.3 14 14 14 14-6.3 14-14S23.7 2 16 2z" />
        <path d="M14.1 22c-.2 0-.5-.1-.6-.2l-6.1-5.2c-.4-.4-.5-1-.1-1.4.4-.4 1-.5 1.4-.1l5.4 4.6 9.3-9.3c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-9.9 10c-.3.1-.6.2-.8.2z" />
    </svg>
)

export const PricingNoIcon = () => (
    <svg x="0px" y="0px" viewBox="0 0 32 32" xmlSpace="preserve" fill="#E05959">
        <path d="M4.7 27.3c-3-3-4.7-7-4.7-11.3 0-4.3 1.7-8.3 4.7-11.3S11.7 0 16 0c4.3 0 8.3 1.7 11.3 4.7S32 11.7 32 16c0 4.3-1.7 8.3-4.7 11.3S20.3 32 16 32c-4.3 0-8.3-1.7-11.3-4.7zM25.9 6.1C23.3 3.5 19.7 2 16 2S8.7 3.5 6.1 6.1C3.5 8.7 2 12.3 2 16s1.5 7.3 4.1 9.9C8.7 28.5 12.3 30 16 30s7.3-1.5 9.9-4.1c2.6-2.6 4.1-6.2 4.1-9.9s-1.5-7.3-4.1-9.9z" />
        <path d="M20.2 21.7l-9.9-9.9c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l9.9 9.9c.4.4.4 1 0 1.4s-1 .3-1.4 0z" />
        <path d="M10.3 21.7c-.4-.4-.4-1 0-1.4l9.9-9.9c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-9.9 9.9c-.3.3-1 .3-1.4 0z" />
    </svg>
)

export const WorkflowExecutionIcon = () => (
    <svg id="Layer_1" x="0px" y="0px" viewBox="0 0 32 32" xmlSpace="preserve">
        <style>{'.st2w{fill:currentcolour}'}</style>
        <g opacity={0.5}>
            <circle cx={16} cy={16} r={15.5} fill="#fff" />
            <path
                className="st2w"
                d="M16 1c8.3 0 15 6.7 15 15s-6.7 15-15 15S1 24.3 1 16 7.7 1 16 1m0-1C7.2 0 0 7.2 0 16s7.2 16 16 16 16-7.2 16-16S24.8 0 16 0z"
            />
        </g>
        <g id="icon_2" transform="translate(-601 -304)">
            <g id="Group_7693" transform="translate(608 312.325)">
                <path
                    className="st2w"
                    d="M12.6 15.4c-.1 0-.2 0-.2-.1l-6.7-3.7c-.2-.1-.3-.4-.2-.7.1-.2.4-.3.7-.2l6.1 3.4L15.6.9 1.1 8.2l2.6 1.3c.3.1.4.4.2.6-.1.2-.4.3-.7.2L-.3 8.6c-.2-.1-.3-.3-.3-.4s.1-.4.3-.4L16-.4c.2-.1.4-.1.5.1.2.1.2.3.2.5L13.1 15c0 .2-.1.3-.3.3 0 0-.1.1-.2.1z"
                    id="Path_4112"
                />
                <path
                    className="st2w"
                    d="M6 16.8h-.2c-.2-.1-.3-.3-.3-.5v-5.2c0-.3.2-.5.5-.5s.5.2.5.5v3.7L7.8 13c.2-.2.5-.3.7-.1.2.2.3.5.1.7l-2.2 3c-.1.2-.2.2-.4.2z"
                    id="Path_4113"
                />
                <path
                    className="st2w"
                    d="M6 11.5c-.1 0-.2 0-.3-.1-.2-.2-.2-.5 0-.7l10-11c.2-.2.5-.2.7 0 .2.2.2.5 0 .7l-10 11c-.1 0-.3.1-.4.1z"
                    id="Line_332"
                />
            </g>
        </g>
    </svg>
)

export const WorkflowIcon = () => (
    <svg id="Layer_1" x="0px" y="0px" viewBox="0 0 32 32" xmlSpace="preserve">
        <style>{'.st2w{fill:currentcolour}'}</style>
        <g opacity={0.5}>
            <circle cx={16} cy={16} r={15.5} fill="#fff" />
            <path
                className="st2w"
                d="M16 1c8.3 0 15 6.7 15 15s-6.7 15-15 15S1 24.3 1 16 7.7 1 16 1m0-1C7.2 0 0 7.2 0 16s7.2 16 16 16 16-7.2 16-16S24.8 0 16 0z"
            />
        </g>
        <g id="icon_1" transform="translate(-181 -304)">
            <g id="Group_7695" transform="translate(189 311.115)">
                <g id="Group_7694" transform="translate(1 3.463)">
                    <path
                        className="st2w"
                        d="M7.4 5.7c-.3 0-.5-.2-.5-.5V0c0-.3.2-.5.5-.5s.5.2.5.5v5.2c0 .3-.3.5-.5.5z"
                        id="Line_334"
                    />
                    <path
                        className="st2w"
                        d="M7.4 11.2c-.3 0-.5-.2-.5-.5V5.8c0-.3.2-.5.5-.5s.5.2.5.5v4.9c0 .3-.3.5-.5.5z"
                        id="Line_335"
                    />
                    <path
                        className="st2w"
                        d="M15 11.9c-.3 0-.5-.2-.5-.5v-6c0-.3.2-.5.5-.5s.5.2.5.5v6c0 .3-.2.5-.5.5z"
                        id="Line_336"
                    />
                    <path
                        className="st2w"
                        d="M0 11.9c-.3 0-.5-.2-.5-.5v-6c0-.3.2-.5.5-.5s.5.2.5.5v6c0 .3-.2.5-.5.5z"
                        id="Line_337"
                    />
                    <path
                        className="st2w"
                        d="M15 5.9H0c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h15c.3 0 .5.2.5.5s-.2.5-.5.5z"
                        id="Line_338"
                    />
                </g>
                <path
                    className="st2w"
                    d="M13.1 3.6H3.6c-1.1 0-2-.9-2-2 0-.6.2-1.1.6-1.5.4-.4.9-.6 1.5-.6h9.4c1.1 0 2 .9 2 2 0 .6-.2 1.1-.6 1.5-.3.4-.9.6-1.4.6zm0-3.1H3.6c-.3 0-.5.1-.7.3s-.3.5-.3.8c0 .6.5 1 1.1 1.1h9.4c.3 0 .6-.1.7-.3.2-.2.3-.5.3-.8 0-.6-.4-1.1-1-1.1z"
                    id="Path_4114"
                />
                <path
                    className="st2w"
                    d="M8.5 17.4c-1.1 0-2-.7-2-1.5s.9-1.5 2-1.5 2 .7 2 1.5-.9 1.5-2 1.5zm0-2c-.6 0-1 .3-1 .5s.4.5 1 .5 1-.3 1-.5-.4-.5-1-.5z"
                    id="Ellipse_235"
                />
                <path
                    className="st2w"
                    d="M15.5 17.4c-1.1 0-2-.7-2-1.5s.9-1.5 2-1.5 2 .7 2 1.5-.9 1.5-2 1.5zm0-2c-.6 0-1 .3-1 .5s.4.5 1 .5 1-.3 1-.5-.4-.5-1-.5z"
                    id="Ellipse_236"
                />
                <path
                    className="st2w"
                    d="M1.5 17.4c-1.1 0-2-.7-2-1.5s.9-1.5 2-1.5 2 .7 2 1.5-.9 1.5-2 1.5zm0-2c-.6 0-1 .3-1 .5s.4.5 1 .5 1-.3 1-.5-.4-.5-1-.5z"
                    id="Ellipse_237"
                />
            </g>
        </g>
    </svg>
)

export const DashBoardIcons: any = {
    TotalIcon: () => (
        <svg width={64} height={64} viewBox="0 0 64 64">
            <g data-name="Group 5971">
                <rect
                    data-name="Rectangle 192"
                    width={64}
                    height={64}
                    rx={6}
                    transform="translate(-189 -222) translate(10 10) translate(179 212)"
                    fill="#d2f2f7"
                />
            </g>
            <g data-name="Group 6109">
                <g data-name="Group 6108">
                    <g data-name="Group 6107" fill="#3f9bc4" stroke="#3f9bc4" strokeWidth={1}>
                        <path
                            data-name="Path 4021"
                            d="M32.381 0H8.758A1.439 1.439 0 007.32 1.438v6.516l-1.08-1.62a1.671 1.671 0 00-2.255-.507L1.762 7.163A3.26 3.26 0 00.273 9.095c-.811 2.952-.209 8.038 7.256 15.5 5.937 5.93 10.363 7.528 13.414 7.528a7.874 7.874 0 002.092-.273 3.266 3.266 0 001.933-1.488l1.334-2.225a1.671 1.671 0 00-.507-2.252l-5.322-3.547a1.68 1.68 0 00-2.248.365l-1.549 1.992a.54.54 0 01-.69.146l-.295-.162a17.722 17.722 0 01-4.617-3.626c-.264-.264-.5-.511-.727-.747h22.035a1.437 1.437 0 001.438-1.431V1.438A1.439 1.439 0 0032.381 0zm-17.23 25.671l.286.157a1.661 1.661 0 002.128-.439l1.549-1.992a.548.548 0 01.733-.119l5.322 3.547a.545.545 0 01.165.733l-1.335 2.225a2.141 2.141 0 01-1.263.981c-2.665.733-7.329.113-14.408-6.967S.628 12.054 1.362 9.391a2.143 2.143 0 01.98-1.263l2.225-1.335a.545.545 0 01.733.165l3.549 5.322a.547.547 0 01-.119.733l-1.992 1.55a1.66 1.66 0 00-.439 2.128l.158.286a25.694 25.694 0 008.693 8.694zm17.541-6.794a.308.308 0 01-.31.3H9.329a14.217 14.217 0 01-1.881-2.742l-.162-.3a.537.537 0 01.146-.689l1.992-1.55a1.679 1.679 0 00.365-2.249l-1.34-2.01V1.429a.307.307 0 01.31-.31h23.623a.306.306 0 01.31.31v17.439z"
                            transform="translate(-189 -222) translate(25.027 55.225) translate(179.157 183)"
                        />
                        <path
                            data-name="Path 4022"
                            d="M30.44 2.61l-9.423 7.146a.761.761 0 01-.894 0L10.704 2.61a.565.565 0 10-.682.9l9.42 7.146a1.9 1.9 0 002.255 0L31.12 3.51a.564.564 0 00-.681-.9z"
                            transform="translate(-189 -222) translate(25.027 55.225) translate(179.157 183)"
                        />
                        <path
                            data-name="Path 4023"
                            d="M15.758 10.702l-5.775 6.185a.564.564 0 10.825.769l5.776-6.188a.564.564 0 00-.825-.766z"
                            transform="translate(-189 -222) translate(25.027 55.225) translate(179.157 183)"
                        />
                        <path
                            data-name="Path 4024"
                            d="M25.418 10.702a.564.564 0 10-.825.769l5.774 6.185a.564.564 0 00.825-.769z"
                            transform="translate(-189 -222) translate(25.027 55.225) translate(179.157 183)"
                        />
                    </g>
                </g>
            </g>
        </svg>
    ),

    Automations: () => (
        <svg width={64} height={64} viewBox="0 0 64 64">
            <g transform="translate(-525 -222)">
                <rect
                    data-name="Rectangle 192"
                    width={64}
                    height={64}
                    rx={6}
                    transform="translate(525 222)"
                    fill="#f7dedf"
                />
                <g data-name="Group 4166">
                    <g data-name="Group 2076">
                        <g
                            data-name="Group 410"
                            fill="none"
                            stroke="#c75960"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            transform="translate(534.816 241.399)"
                        >
                            <path data-name="Rectangle 37" transform="translate(16.819)" d="M0 0H10.825V7.276H0z" />
                            <path data-name="Rectangle 760" transform="translate(0 .591)" d="M0 0H10.825V6.093H0z" />
                            <path data-name="Rectangle 761" transform="translate(33.379)" d="M0 0H10.825V7.276H0z" />
                            <path data-name="Line 23" transform="translate(22.231 7.868)" d="M0 0L0 10.063" />
                            <path data-name="Line 220" transform="translate(11.16 4.051)" d="M5.323 0L0 0" />
                            <path data-name="Line 221" transform="translate(27.979 4.051)" d="M5.323 0L0 0" />
                            <path
                                data-name="Rectangle 39"
                                transform="translate(17.018 18.677)"
                                d="M0 0H10.825V10.825H0z"
                            />
                        </g>
                        <g data-name="Group 2062">
                            <g data-name="Group 2003">
                                <path
                                    data-name="Path 1728"
                                    d="M2.542 4.525a.252.252 0 01-.176-.072L.071 2.19a.251.251 0 01.353-.358l2.111 2.081L6.098.08a.251.251 0 11.368.342L2.727 4.445a.251.251 0 01-.179.08z"
                                    fill="none"
                                    stroke="#c75960"
                                    strokeMiterlimit={10}
                                    strokeWidth={1}
                                    transform="translate(534.816 241.399) translate(19.358 22.191)"
                                />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    ),
    AutoResolvedICon: () => (
        <svg width={64} height={64} viewBox="0 0 64 64">
            <g transform="translate(-861 -222)">
                <rect
                    data-name="Rectangle 194"
                    width={64}
                    height={64}
                    rx={6}
                    transform="translate(861 222)"
                    fill="#d6f4e1"
                />
                <circle data-name="Ellipse 25" cx={19} cy={19} r={19} transform="translate(874 235)" fill="#5ec985" />
                <path
                    data-name="Path 3850"
                    d="M901.869 250.552l-9.431 9.512a.951.951 0 01-1.291.055l-5.789-4.922a.952.952 0 011.233-1.45l5.117 4.351 8.81-8.886a.951.951 0 111.351 1.339z"
                    fill="#fff"
                    stroke="#fff"
                    strokeWidth={1}
                />
            </g>
        </svg>
    ),
    HoursSavedIcon: () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64">
            <g id="icon_4" transform="translate(-1197 -222)">
                <rect
                    id="Rectangle_192"
                    data-name="Rectangle 192"
                    width="64"
                    height="64"
                    rx="6"
                    transform="translate(1197 222)"
                    fill="#f3e2f5"
                />
                <g id="Group_5977" data-name="Group 5977" transform="translate(372.869 -182.145)">
                    <path
                        id="Path_3944"
                        data-name="Path 3944"
                        d="M910.545,481.847a11.45,11.45,0,1,1-11.247-11.57A11.5,11.5,0,0,1,910.545,481.847ZM899.6,492.216a10.4,10.4,0,0,0,6.618-2.777,6.17,6.17,0,0,1-.892-.817c-.123-.167-.069-.466-.094-.706.241.014.564-.065.706.06a6.263,6.263,0,0,1,.769,1.006,10.473,10.473,0,0,0,2.842-6.773,6.778,6.778,0,0,1-1.2-.019c-.21-.041-.383-.271-.573-.417.181-.159.343-.416.547-.455a6.8,6.8,0,0,1,1.238-.021,10.391,10.391,0,0,0-2.793-6.718,5.334,5.334,0,0,1-.786.917c-.179.132-.5.067-.761.09.034-.239-.015-.55.118-.7a6.414,6.414,0,0,1,.974-.767,10.458,10.458,0,0,0-6.755-2.847,4.161,4.161,0,0,1-.018,1.023,3.3,3.3,0,0,1-.472.781,2.97,2.97,0,0,1-.413-.747,5.189,5.189,0,0,1-.017-1.07,10.542,10.542,0,0,0-6.721,2.82,4.274,4.274,0,0,1,.857.722,2.118,2.118,0,0,1,.151.827c-.259-.049-.593-.016-.76-.167a5,5,0,0,1-.671-.98,10.538,10.538,0,0,0-2.868,6.818,4.7,4.7,0,0,1,1.045.017,3.014,3.014,0,0,1,.74.43,2.62,2.62,0,0,1-.712.453,4.858,4.858,0,0,1-1.087.019A10.551,10.551,0,0,0,891.4,488.9a6.11,6.11,0,0,1,.8-.892c.169-.128.47-.083.711-.116-.025.26.042.593-.095.763a4.972,4.972,0,0,1-.94.729,10.5,10.5,0,0,0,6.687,2.818c.027-.2.035-.333.064-.459.1-.45-.283-1.239.442-1.26.761-.021.377.776.477,1.22A4.855,4.855,0,0,1,899.6,492.216Z"
                        transform="translate(-43.096 -45.65)"
                        fill="#bd61c7"
                        stroke="#bd61c7"
                        stroke-width="0.5"
                    />
                    <path
                        id="Path_3945"
                        data-name="Path 3945"
                        d="M936.659,425.382c-.669.2-1.328.441-2.009.576a4.634,4.634,0,0,1-3.03-.481c-1.753-.851-3.577-1.567-5.4-2.258A4.9,4.9,0,0,1,923.8,421.9c-1.754.327-3.365.681-4.994.908a1.457,1.457,0,0,1-1.55-1.059,1.777,1.777,0,0,1,.375-1.944,1.857,1.857,0,0,1,.356-.326,25.406,25.406,0,0,1,7.326-3.453,6.984,6.984,0,0,1,3.969.234c2.018.629,4.059,1.18,6.229,1.8-.206-1.075.376-1.164,1.048-1.266,1.727-.262,3.448-.566,5.164-.89.639-.12.938.047,1.045.719.382,2.415.795,4.826,1.225,7.233.106.591-.08.83-.664.922-1.831.288-3.652.638-5.485.912a4.331,4.331,0,0,1-1.208-.164Zm-12.241-3.963c.725.318,1.341.607,1.971.862a46.9,46.9,0,0,1,5.193,2.127,4.877,4.877,0,0,0,4.54.129.583.583,0,0,0,.431-.782c-.282-1.423-.47-2.864-.759-4.285a1.037,1.037,0,0,0-.635-.631c-2.089-.6-4.18-1.2-6.3-1.69a7.412,7.412,0,0,0-3.01-.251,20.178,20.178,0,0,0-7.262,3.35,1.3,1.3,0,0,0-.4,1.145c.069.254.673.527,1.026.51a9.243,9.243,0,0,0,4.9-1.633,3.86,3.86,0,0,1,4.167-.373c.7.326,1.462.519,2.172.827.247.107.423.379.631.575-.288.111-.617.372-.856.306a15.667,15.667,0,0,1-2.333-.856A2.69,2.69,0,0,0,924.418,421.419Zm17.426-4.567-5.365.927,1.195,7.011,5.357-.91C942.632,421.517,942.245,419.226,941.844,416.852Z"
                        transform="translate(-67.812 0)"
                        fill="#bd61c7"
                        stroke="#bd61c7"
                        stroke-width="0.5"
                    />
                    <path
                        id="Path_3946"
                        data-name="Path 3946"
                        d="M856.487,605.166c1.629-.355,3.076-.761,4.55-.963a1.625,1.625,0,0,1,1.989,1.124,1.779,1.779,0,0,1-.811,2.237,23.661,23.661,0,0,1-7.4,3.453,7.1,7.1,0,0,1-3.814-.254c-2.023-.62-4.063-1.181-6.224-1.8.159,1.024-.365,1.16-1.058,1.261-1.727.251-3.447.563-5.163.889-.693.132-.961-.1-1.068-.788q-.548-3.544-1.2-7.072c-.121-.658.047-.925.718-1.027,1.806-.274,3.6-.629,5.407-.9a2,2,0,0,1,1.176.317c.7-.2,1.382-.445,2.089-.586a4.552,4.552,0,0,1,2.952.478c1.757.844,3.577,1.566,5.4,2.265A4.732,4.732,0,0,1,856.487,605.166Zm-.685.42c-.691-.3-1.325-.6-1.972-.859a47.36,47.36,0,0,1-5.188-2.136,4.7,4.7,0,0,0-4.527-.062.847.847,0,0,0-.375.7c.2,1.436.491,2.859.693,4.3.068.479.309.594.712.7,2,.516,3.983,1.1,5.992,1.579a8.208,8.208,0,0,0,2.924.352,18.866,18.866,0,0,0,7.712-3.458,1.1,1.1,0,0,0,.327-1.022,1.306,1.306,0,0,0-1.015-.547,8.954,8.954,0,0,0-4.909,1.606,3.867,3.867,0,0,1-4.232.377c-.673-.321-1.411-.5-2.092-.81-.26-.117-.444-.4-.663-.611.3-.1.632-.334.88-.263a18.692,18.692,0,0,1,2.4.9A2.558,2.558,0,0,0,855.8,605.586Zm-17.381,4.581,5.365-.926-1.192-7.011-5.358.906Z"
                        transform="translate(0 -155.253)"
                        fill="#bd61c7"
                        stroke="#bd61c7"
                        stroke-width="0.5"
                    />
                    <path
                        id="Path_3947"
                        data-name="Path 3947"
                        d="M952.488,497.458c-.987,1.036-2.087,2.21-3.217,3.357a3.114,3.114,0,0,1-.791.431,2.894,2.894,0,0,1-.29-.843c-.027-1.773-.012-3.547-.016-5.32,0-.285-.027-.571-.048-.99a3.452,3.452,0,0,1-.689.572.776.776,0,0,1-.626-.028.566.566,0,0,1-.03-.548,18.336,18.336,0,0,1,1.6-1.587.671.671,0,0,1,.623.09,12.544,12.544,0,0,1,1.366,1.366c.131.154.086.458.121.693a3,3,0,0,1-.765-.066c-.184-.063-.319-.267-.566-.489v5.493l3.119-3.278a2.843,2.843,0,0,1-.849-.08c-.2-.1-.337-.327-.5-.5.167-.141.33-.4.5-.4.643-.014,1.287.054,1.93.092.027,0,.068,0,.077.017.128.234.376.484.354.7-.074.713-.249,1.416-.385,2.123Z"
                        transform="translate(-92.641 -64.251)"
                        fill="#bd61c7"
                        stroke="#bd61c7"
                        stroke-width="0.5"
                    />
                    <path
                        id="Path_3948"
                        data-name="Path 3948"
                        d="M1051.36,447.384a1.4,1.4,0,0,1,1.362,1.318,1.361,1.361,0,0,1-1.367,1.378,1.323,1.323,0,0,1-1.345-1.3A1.36,1.36,0,0,1,1051.36,447.384Z"
                        transform="translate(-179.252 -26.456)"
                        fill="#bd61c7"
                        stroke="#bd61c7"
                        stroke-width="0.5"
                    />
                    <path
                        id="Path_3949"
                        data-name="Path 3949"
                        d="M855.9,617.3a1.356,1.356,0,1,1-2.712-.019,1.354,1.354,0,0,1,1.411-1.332A1.335,1.335,0,0,1,855.9,617.3Z"
                        transform="translate(-14.201 -167.806)"
                        fill="#bd61c7"
                        stroke="#bd61c7"
                        stroke-width="0.5"
                    />
                </g>
            </g>
        </svg>
    ),
    CostSavedIcon: () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64">
            <g id="icon_5" transform="translate(-1533 -222)">
                <rect
                    id="Rectangle_194"
                    data-name="Rectangle 194"
                    width="64"
                    height="64"
                    rx="6"
                    transform="translate(1533 222)"
                    fill="#e2ecf8"
                />
                <g id="Group_5881" data-name="Group 5881" transform="translate(711.01 -158.243)">
                    <path
                        id="Path_3952"
                        data-name="Path 3952"
                        d="M847.534,572.169c.489,1.521-.29,2.269-1.463,2.838-.745.362-1.445.816-2.165,1.229a1.781,1.781,0,0,1-2.667-.712q-2.771-4.871-5.54-9.743a1.8,1.8,0,0,1,.724-2.772c.8-.466,1.617-.91,2.422-1.371,1.39-.8,2.191-.6,3.055.76.052.081.116.154.183.242.853-.637,1.682-1.279,2.534-1.888,2.014-1.442,4.178-1.337,6.445-.7a27.978,27.978,0,0,0,4.288.847,15.858,15.858,0,0,0,2.619-.17,4.226,4.226,0,0,1,3.719,1.25,20.033,20.033,0,0,1,1.412-1.756,24.608,24.608,0,0,1,2.7-2.437,2.883,2.883,0,0,1,2.733-.356,1.658,1.658,0,0,1,1.254,2.207,17.268,17.268,0,0,1-1.664,3.557,26.718,26.718,0,0,1-7.1,7.724,6.384,6.384,0,0,1-3.964,1.266c-2.885-.064-5.772-.019-8.658-.019Zm12.773-8.7c-.662-.941-1.578-.83-2.438-.8-.779.029-1.553.2-2.332.22a13.826,13.826,0,0,1-5.012-.931,5.13,5.13,0,0,0-5.476.9c-.5.434-1.029.827-1.559,1.219a.552.552,0,0,0-.159.859q1.371,2.339,2.677,4.715a1.023,1.023,0,0,0,1.041.6c3.253-.022,6.508-.054,9.76.01a5.291,5.291,0,0,0,3.452-1.17,26.975,26.975,0,0,0,6.12-6.762c.607-.924,1.076-1.939,1.634-2.959a1.942,1.942,0,0,0-2.149.773c-1.294,1.43-2.514,2.927-3.779,4.383a6.106,6.106,0,0,1-3.827,2.282c-2.144.247-4.319.223-6.508.316v-2.083c1.67,0,3.279-.021,4.887.006A5.119,5.119,0,0,0,860.307,563.471Zm-22.935,1.277,5.56,9.776,2.714-1.546-5.562-9.77Z"
                        transform="translate(0 -142.088)"
                        fill="#3e78be"
                    />
                    <path
                        id="Path_3953"
                        data-name="Path 3953"
                        d="M898.9,414.269l-1.815-.707a13.717,13.717,0,0,0,1.1-11.627,13.505,13.505,0,0,0-5.9-7.241,13.846,13.846,0,0,0-17.032,21.546c-.508.24-1,.51-1.522.7a.676.676,0,0,1-.593-.179,15.137,15.137,0,0,1-3.547-12.627c1.135-6.59,5.021-10.881,11.406-12.815a15.783,15.783,0,0,1,18.046,22.724A2.3,2.3,0,0,1,898.9,414.269Z"
                        transform="translate(-29.034)"
                        fill="#3e78be"
                    />
                    <path
                        id="Path_3954"
                        data-name="Path 3954"
                        d="M948.256,442.849c-.611,0-1.148.032-1.676-.018a.708.708,0,0,1-.489-.374c-.384-.964-1.174-1.217-2.19-1.332,0,1.417-.013,2.779.019,4.139,0,.143.246.333.418.41.713.318,1.453.574,2.161.9a3.345,3.345,0,0,1,2.119,3.435,3.732,3.732,0,0,1-2.358,3.413,4.354,4.354,0,0,1-1.172.4c-.773.117-1.481.232-1.178,1.329H942.2l-.062-1.07c-1.559-.143-3.162-.234-4.143-1.643a9.828,9.828,0,0,1-.812-2.151c.832,0,1.412-.022,1.988.016.138.009.316.192.386.339a2.4,2.4,0,0,0,2.6,1.436c0-1.53.011-3.064-.019-4.6,0-.134-.261-.306-.435-.386-.861-.4-1.777-.7-2.591-1.176a3.121,3.121,0,0,1-1.618-3.14,3.389,3.389,0,0,1,2.337-2.932,20.525,20.525,0,0,1,2.3-.622c.015-.243.038-.595.063-.992h1.648l.1,1.077C945.988,439.646,947.966,440.13,948.256,442.849Zm-4.334,9.206c1.5-.132,2.492-.931,2.5-1.959.012-1.09-1.053-2-2.5-2.107Zm-1.805-7.18v-3.744c-1.388.067-2.346.743-2.392,1.649C939.67,443.873,940.5,444.608,942.117,444.874Z"
                        transform="translate(-86.907 -40.546)"
                        fill="#3e78be"
                    />
                    <path
                        id="Path_3955"
                        data-name="Path 3955"
                        d="M878.779,642.9c.807.019,2.2,2.325,1.843,3.043a.948.948,0,0,1-1.633.168,12.177,12.177,0,0,1-1.086-1.82A.947.947,0,0,1,878.779,642.9Z"
                        transform="translate(-36.237 -215.17)"
                        fill="#3e78be"
                    />
                </g>
            </g>
        </svg>
    ),
    AverageTime: () => (
        <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 64 64" xmlSpace="preserve">
            <style>
                {
                    '.st1{fill:#c75960}.st2{fill:none;stroke:#000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round}'
                }
            </style>
            <g id="avg_time" transform="translate(-1040 -1099)">
                <path
                    id="Rectangle_192"
                    d="M1046 1099h52c3.3 0 6 2.7 6 6v52c0 3.3-2.7 6-6 6h-52c-3.3 0-6-2.7-6-6v-52c0-3.3 2.7-6 6-6z"
                    fill="#ffe6e7"
                />
                <g id="Group_6132" transform="translate(1061.081 1116)">
                    <g id="Group_6121">
                        <g id="Group_6114">
                            <g id="Group_6109">
                                <path
                                    id="Path_4012"
                                    className="st1"
                                    d="M23 2H1c-.6 0-1-.4-1-1s.4-1 1-1h22c.6 0 1 .4 1 1s-.4 1-1 1z"
                                />
                            </g>
                            <g id="Group_6111" transform="translate(19)">
                                <path
                                    id="Path_4014"
                                    className="st1"
                                    d="M1 10c-.6 0-1-.4-1-1V1c0-.6.4-1 1-1s1 .4 1 1v8c0 .6-.4 1-1 1z"
                                />
                            </g>
                            <g id="Group_6112" transform="translate(3)">
                                <path
                                    id="Path_4015"
                                    className="st1"
                                    d="M1 10c-.6 0-1-.4-1-1V1c0-.6.4-1 1-1s1 .4 1 1v8c0 .6-.4 1-1 1z"
                                />
                            </g>
                            <g id="Group_6113" transform="translate(3 8)">
                                <path
                                    id="Path_4016"
                                    className="st1"
                                    d="M9 9C7.7 9 0 6.8 0 1c0-.6.4-1 1-1s1 .4 1 1c0 4.3 6.3 6 7 6 .7 0 7-1.7 7-6 0-.6.4-1 1-1s1 .4 1 1c0 5.8-7.7 8-9 8z"
                                />
                            </g>
                        </g>
                        <g id="Group_6120" transform="translate(0 15)">
                            <g id="Group_6115" transform="translate(0 15)">
                                <path
                                    id="Path_4017"
                                    className="st1"
                                    d="M23 2H1c-.6 0-1-.4-1-1s.4-1 1-1h22c.6 0 1 .4 1 1s-.4 1-1 1z"
                                />
                            </g>
                            <g id="Group_6117" transform="translate(3 7)">
                                <path
                                    id="Path_4019"
                                    className="st1"
                                    d="M1 10c-.6 0-1-.4-1-1V1c0-.6.4-1 1-1s1 .4 1 1v8c0 .6-.4 1-1 1z"
                                />
                            </g>
                            <g id="Group_6118" transform="translate(19 7)">
                                <path
                                    id="Path_4020"
                                    className="st1"
                                    d="M1 10c-.6 0-1-.4-1-1V1c0-.6.4-1 1-1s1 .4 1 1v8c0 .6-.4 1-1 1z"
                                />
                            </g>
                            <g id="Group_6119" transform="translate(3)">
                                <path
                                    id="Path_4021"
                                    className="st1"
                                    d="M17 9c-.6 0-1-.4-1-1 0-4.3-6.3-6-7-6-.7 0-7 1.7-7 6 0 .6-.4 1-1 1s-1-.4-1-1c0-5.8 7.7-8 9-8s9 2.2 9 8c0 .6-.4 1-1 1z"
                                />
                            </g>
                        </g>
                    </g>
                    <g id="Group_6122" transform="translate(7 6)">
                        <path id="Rectangle_829" d="M0 0H2V2H0z" />
                    </g>
                    <g id="Group_6123" transform="translate(9 10)">
                        <path id="Rectangle_830" d="M0 0H2V2H0z" />
                    </g>
                    <g id="Group_6124" transform="translate(13 10)">
                        <path id="Rectangle_831" d="M0 0H2V2H0z" />
                    </g>
                    <g id="Group_6125" transform="translate(9 22)">
                        <path id="Rectangle_832" d="M0 0H2V2H0z" />
                    </g>
                    <g id="Group_6126" transform="translate(13 22)">
                        <path id="Rectangle_833" d="M0 0H2V2H0z" />
                    </g>
                    <g id="Group_6127" transform="translate(11 6)">
                        <path id="Rectangle_834" d="M0 0H2V2H0z" />
                    </g>
                    <g id="Group_6128" transform="translate(15 6)">
                        <path id="Rectangle_835" d="M0 0H2V2H0z" />
                    </g>
                    <g id="Group_6129" transform="translate(7 26)">
                        <path id="Rectangle_836" d="M0 0H2V2H0z" />
                    </g>
                    <g id="Group_6130" transform="translate(11 26)">
                        <path id="Rectangle_837" d="M0 0H2V2H0z" />
                    </g>
                    <g id="Group_6131" transform="translate(15 26)">
                        <path id="Rectangle_838" d="M0 0H2V2H0z" />
                    </g>
                </g>
            </g>
        </svg>
    ),
    WorkFlowExecutions: () => (
        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 64 64" xmlSpace="preserve">
            <path
                d="M6 0h52c3.3 0 6 2.7 6 6v52c0 3.3-2.7 6-6 6H6c-3.3 0-6-2.7-6-6V6c0-3.3 2.7-6 6-6z"
                fill="#e0f6ff"
                transform="translate(-944 -1089) translate(944 1089)"
            />
            <path
                d="M975 1122.3l-15-2.5 32.3-14.8-15.6 31.5-1.7-14.2z"
                fill="#355d8b"
                transform="translate(-944 -1089)"
            />
        </svg>
    ),
    SuccessfulExecutions: () => (
        <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 64 64" xmlSpace="preserve">
            <style>{'.st111{fill:#5ec985}'}</style>
            <g id="workflow_2" transform="translate(-944 -1173)">
                <g id="Group_9690" transform="translate(944 1173)">
                    <path
                        id="Rectangle_192"
                        d="M6 0h52c3.3 0 6 2.7 6 6v52c0 3.3-2.7 6-6 6H6c-3.3 0-6-2.7-6-6V6c0-3.3 2.7-6 6-6z"
                        fill="#e6ffef"
                    />
                </g>
                <g id="Group_9699" transform="translate(-4 -7)">
                    <g id="Group_9692" transform="translate(964 1193)">
                        <path
                            id="Path_4810"
                            className="st111"
                            d="M16 32C7.2 32 0 24.9 0 16S7.2 0 16 0s16 7.2 16 16-7.2 16-16 16zm0-29.3C8.6 2.7 2.7 8.6 2.7 16s6 13.3 13.3 13.3c7.4 0 13.3-6 13.3-13.3 0-7.4-5.9-13.3-13.3-13.3z"
                        />
                    </g>
                    <g id="Group_9693" transform="translate(970.671 1202.339)">
                        <path
                            id="Path_4811"
                            className="st111"
                            d="M8 13.3c-.3 0-.6-.1-.8-.3L.5 7.7c-.6-.5-.7-1.3-.2-1.9.5-.6 1.3-.7 1.9-.2l5.7 4.5L16.4.4c.5-.6 1.3-.6 1.9-.2.6.5.6 1.3.2 1.9L9 12.9c-.2.3-.6.4-1 .4z"
                        />
                    </g>
                </g>
            </g>
        </svg>
    ),
    FailedExecutions: () => (
        <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 64 64" xmlSpace="preserve">
            <style>{'.st121{fill:#c75960}'}</style>
            <g id="workflow_3" transform="translate(-944 -1257)">
                <g id="Group_9691" transform="translate(944 1257)">
                    <path
                        id="Rectangle_192"
                        d="M6 0h52c3.3 0 6 2.7 6 6v52c0 3.3-2.7 6-6 6H6c-3.3 0-6-2.7-6-6V6c0-3.3 2.7-6 6-6z"
                        fill="#ffe6e7"
                    />
                </g>
                <g id="Group_9698" transform="translate(22 791)">
                    <g id="Group_9695" transform="translate(938 482)">
                        <path
                            id="Path_4812"
                            className="st121"
                            d="M16.1 32.1C7.2 32.1 0 24.9 0 16.1 0 7.2 7.2 0 16 0c8.9 0 16.1 7.2 16.1 16 0 8.9-7.2 16.1-16 16.1zm0-29.4C8.7 2.7 2.7 8.7 2.7 16s6 13.4 13.4 13.4 13.4-6 13.4-13.4c-.1-7.3-6.1-13.3-13.4-13.3z"
                        />
                    </g>
                    <g id="Group_9696" transform="translate(947.363 491.363)">
                        <path
                            id="Path_4813"
                            className="st121"
                            d="M12 13.4c-.4 0-.7-.1-.9-.4L.4 2.3C-.1 1.8-.1.9.4.4s1.4-.5 1.9 0L13 11.1c.5.5.5 1.4 0 1.9-.3.2-.6.4-1 .4z"
                        />
                    </g>
                    <g id="Group_9697" transform="translate(947.363 491.363)">
                        <path
                            id="Path_4814"
                            className="st121"
                            d="M1.3 13.4C.6 13.4 0 12.8 0 12c0-.4.1-.7.4-.9L11.1.4c.5-.5 1.4-.5 1.9 0s.5 1.4 0 1.9L2.3 13c-.3.2-.6.4-1 .4z"
                        />
                    </g>
                </g>
            </g>
        </svg>
    )
}

export const BotDropdown = () => (
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 24 24" xmlSpace="preserve">
        <style>{'.st012{fill:#555}'}</style>
        <g id="Group_9262" transform="translate(-938 -2108)">
            <g id="Group_8957">
                <path
                    id="Path_4530"
                    className="st012"
                    d="M950 2132c-6.6 0-12-5.4-12-12s5.4-12 12-12 12 5.4 12 12-5.4 12-12 12zm0-22c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10-4.5-10-10-10z"
                />
            </g>
            <g id="Group_8958">
                <path
                    id="Path_4531"
                    className="st012"
                    d="M950 2123c-.3 0-.5-.1-.7-.3l-4-4c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l3.3 3.3 3.3-3.3c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-4 4c-.2.2-.4.3-.7.3z"
                />
            </g>
        </g>
    </svg>
)

export const FaqICon = () => {
    return (
        <svg
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 35.3 32.6"
            xmlSpace="preserve"
        >
            {/* <style>{'.st01{fill:currentColor}'}</style> */}
            <g id="faq" transform="translate(-172.909 -98.972)">
                <g id="Group_7719" transform="translate(172.909 98.972)">
                    <path
                        id="Path_4118"
                        className="st01"
                        d="M16.7 8.2c-.2-.4-.5-.7-.9-.6-.4 0-.8.2-.9.6l-3.1 8.1c-.2.4.1.9.5 1.1.4.2.9-.1 1-.5l.6-1.5h3.8l.6 1.5c.2.4.6.6 1.1.5s.6-.6.5-1.1l-3.2-8.1zm-2.3 5.6l1.3-3.4 1.3 3.4h-2.6z"
                    />
                    <path
                        id="Path_4119"
                        className="st01"
                        d="M9.6 7.6H6.3c-.5 0-.9.4-.9.8v8.1c0 .5.3.8.8.9s.8-.3.9-.8v-3.4h2.2c.5 0 .8-.4.8-.9 0-.4-.4-.8-.8-.8H7.1V9.3h2.5c.5 0 .8-.3.9-.8-.1-.5-.4-.9-.9-.9z"
                    />
                    <path
                        id="Path_4120"
                        className="st01"
                        d="M29.9 15.3c1.6-2.2 1-5.3-1.2-6.8s-5.3-1-6.8 1.2c-1.6 2.2-1 5.3 1.2 6.8 1.7 1.2 4 1.2 5.7-.1l.7.7c.3.3.9.3 1.2 0 .3-.3.3-.8 0-1.1l-.8-.7zm-4 .5c-1.8 0-3.3-1.5-3.3-3.3 0-1.8 1.5-3.3 3.3-3.3s3.3 1.5 3.3 3.3c0 .6-.1 1.1-.4 1.6l-.8-.7c-.3-.3-.8-.3-1.2 0s-.3.8 0 1.2l.8.8c-.5.2-1.1.4-1.7.4z"
                    />
                    <path
                        id="Path_4121"
                        className="st01"
                        d="M31.2 0H4.1C1.8 0 0 1.8 0 4.1v16.3c0 1.9 1.4 3.6 3.2 4v6.9c0 .7.6 1.3 1.3 1.3.4 0 .8-.2 1-.5l5.9-7.4c.1-.1.2-.2.4-.2h19.3c2.3 0 4.1-1.8 4.1-4.1V4.1c.1-2.3-1.7-4.1-4-4.1zm2.4 20.4c0 1.4-1.1 2.5-2.5 2.5H11.9c-.7 0-1.3.3-1.7.8l-5.3 6.7v-6.7c0-.5-.4-.8-.8-.8-1.3 0-2.4-1.1-2.4-2.5V4.1c0-1.4 1.1-2.5 2.5-2.5h27.1c1.4 0 2.5 1.1 2.5 2.5v16.3z"
                    />
                </g>
            </g>
        </svg>
    )
}

export const BotHomeIcon = () => (
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 32 31" xmlSpace="preserve">
        <style>{'.st01{fill:currentColor}'}</style>
        <path
            className="st01"
            d="M12.3 14.3H2.9c-1.1 0-1.9-.9-1.9-1.9V2.9C1 1.9 1.9 1 2.9 1h9.4c1.1 0 1.9.9 1.9 1.9v9.4c.1 1.1-.8 2-1.9 2zM2.9 2.5c-.2 0-.4.2-.4.4v9.4c0 .2.2.4.4.4h9.4c.2 0 .4-.2.4-.4V2.9c0-.2-.2-.4-.4-.4H2.9zM29 14.3h-9.4c-1.1 0-1.9-.9-1.9-1.9V2.9c0-1.1.9-1.9 1.9-1.9H29c1.1 0 1.9.9 1.9 1.9v9.4c0 1.1-.9 2-1.9 2zM19.5 2.5c-.2 0-.4.2-.4.4v9.4c0 .2.2.4.4.4H29c.2 0 .4-.2.4-.4V2.9c0-.2-.2-.4-.4-.4h-9.5zM12.3 29.9H2.9c-1 0-1.9-.8-1.9-1.9v-9.4c0-1.1.9-1.9 1.9-1.9h9.4c1.1 0 1.9.9 1.9 1.9V28c.1 1.1-.8 1.9-1.9 1.9zM2.9 18.2c-.2 0-.4.2-.4.4V28c0 .2.2.4.4.4h9.4c.2 0 .4-.2.4-.4v-9.4c0-.2-.2-.4-.4-.4H2.9zM29 29.9h-9.4c-1.1 0-1.9-.9-1.9-1.9v-9.4c0-1.1.9-1.9 1.9-1.9H29c1.1 0 1.9.9 1.9 1.9V28c0 1.1-.9 1.9-1.9 1.9zm-9.5-11.7c-.2 0-.4.2-.4.4V28c0 .2.2.4.4.4H29c.2 0 .4-.2.4-.4v-9.4c0-.2-.2-.4-.4-.4h-9.5z"
        />
    </svg>
)
export const BotQaICon = () => (
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 18 18" xmlSpace="preserve">
        <style>{'.st011{fill:#999}'}</style>
        <g id="Group_9382" transform="translate(-642 -556)">
            <g id="Group_9264" transform="translate(642 556)">
                <g id="Group_9263">
                    <path
                        id="Path_4618"
                        className="st011"
                        d="M9 18c-5 0-9-4-9-9s4-9 9-9 9 4 9 9-4 9-9 9zM9 1.5C4.9 1.5 1.5 4.9 1.5 9s3.4 7.5 7.5 7.5 7.5-3.4 7.5-7.5S13.1 1.5 9 1.5z"
                    />
                </g>
            </g>
            <g id="Group_9267" transform="translate(648 559.707)">
                <g id="Group_9265">
                    <path
                        id="Path_4619"
                        className="st011"
                        d="M3 8.2c-.4 0-.7-.2-.7-.6 0-1.3.6-2.4 1.6-3.2.4-.3.7-.8.7-1.3 0-.9-.6-1.6-1.5-1.6-.8 0-1.5.6-1.5 1.4V3c0 .4-.3.8-.8.8S0 3.4 0 3c0-1.6 1.3-3 2.9-3H3c1.7 0 3 1.4 3 3.1 0 1-.4 1.9-1.2 2.5-.6.4-1 1.1-1 1.9 0 .4-.3.7-.8.7z"
                    />
                </g>
                <g id="Group_9266" transform="translate(2.243 9.022)">
                    <path
                        id="Path_4620"
                        className="st011"
                        d="M.8 1.5c-.5 0-.8-.3-.8-.7V.7C.1.2.5-.1.9 0c.4.1.7.4.6.8-.1.5-.4.7-.7.7z"
                    />
                </g>
            </g>
        </g>
    </svg>
)
export const CloseBtnWithCircle = () => (
    <svg id="Group_11731" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 18 18" xmlSpace="preserve">
        <style>{'.st2{fill:#999}'}</style>
        <g id="Ellipse_691">
            <circle cx={9} cy={9} r={9} fill="#fff" />
            <circle cx={9} cy={9} r={8.8} fill="none" stroke="#999" strokeWidth={0.5} />
        </g>
        <g id="Group_10986" transform="translate(5.256 5.252)">
            <g id="Group_10984">
                <path
                    id="Path_7896"
                    className="st2"
                    d="M6.7 7.5c-.2 0-.4-.1-.5-.2l-6-6C-.1 1-.1.5.2.2S1-.1 1.3.2l6 6c.3.3.3.8 0 1.1-.2.1-.4.2-.6.2z"
                />
            </g>
            <g id="Group_10985">
                <path
                    id="Path_7897"
                    className="st2"
                    d="M.8 7.5c-.5 0-.8-.3-.8-.8 0-.2.1-.4.2-.5l6-6c.3-.3.8-.3 1.1 0s.3.8 0 1.1l-6 6c-.2.1-.4.2-.5.2z"
                />
            </g>
        </g>
    </svg>
)

export const VideoIcon = () => (
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 16 16" xmlSpace="preserve">
        <style>{'.st10{fill:#28e4c3}'}</style>
        <g id="Group_8872" transform="translate(-181 -1137.076)">
            <g id="Group_7837" transform="translate(181 1137.076)">
                <circle id="Ellipse_247" cx={8} cy={8} r={8} fill="#e56b6b" />
            </g>
            <path
                id="Path_3858"
                d="M193.2 1144.6l-5.6-3.2c-.3-.2-.8-.1-1 .3-.1.1-.1.2-.1.3v6.5c0 .4.3.7.7.7.1 0 .2 0 .4-.1l5.6-3.2c.3-.2.5-.6.3-1-.1-.2-.2-.2-.3-.3z"
                fill="#fff"
            />
        </g>
    </svg>
)

export const HelpDocIcon = () => (
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 20 20" xmlSpace="preserve">
        <style>
            {
                '.help_doc_icon1{fill:#28e4c3}.help_doc_icon2{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round}'
            }
        </style>
        <g id="Group_8715" transform="translate(-106 -879)">
            <g id="Group_8713" transform="translate(106 879)">
                <circle id="Ellipse_247" cx={10} cy={10} r={10} fill="#5ba9f8" />
            </g>
            <g id="Group_8722" transform="translate(-605.497 -5656)">
                <g id="Group_8717" transform="translate(717 6541)">
                    <path id="Path_4382" className="help_doc_icon2" d="M3.3 7.8H0V0h3.3" />
                    <path id="Line_345" className="help_doc_icon2" d="M4.5 8.7L4.5 1.2" />
                    <path id="Path_4383" className="help_doc_icon2" d="M3.3 7.8c.7 0 1.2.5 1.2 1.2" />
                    <path id="Path_4384" className="help_doc_icon2" d="M3.3 0C4 0 4.5.5 4.5 1.2" />
                    <g id="Group_8716" transform="translate(4.494)">
                        <path id="Path_4385" className="help_doc_icon2" d="M1.2 7.8h3.3V0H1.2" />
                        <path id="Path_4386" className="help_doc_icon2" d="M1.2 7.8C.6 7.8 0 8.3 0 9" />
                        <path id="Path_4387" className="help_doc_icon2" d="M1.2 0C.5 0 0 .5 0 1.2" />
                    </g>
                </g>
                <g id="Group_8719" transform="translate(722.722 6543.045)">
                    <g id="Group_8718">
                        <path id="Line_346" className="help_doc_icon2" d="M2 0L0 0" />
                        <path id="Line_347" className="help_doc_icon2" d="M2 1.6L0 1.6" />
                        <path id="Line_348" className="help_doc_icon2" d="M2 3.3L0 3.3" />
                    </g>
                </g>
                <g id="Group_8721" transform="translate(718.222 6543.045)">
                    <g id="Group_8720">
                        <path id="Line_349" className="help_doc_icon2" d="M2 0L0 0" />
                        <path id="Line_350" className="help_doc_icon2" d="M2 1.6L0 1.6" />
                        <path id="Line_351" className="help_doc_icon2" d="M2 3.3L0 3.3" />
                    </g>
                </g>
            </g>
        </g>
    </svg>
)

export const MiniIcon = () => (
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 24 18" xmlSpace="preserve">
        <style>{'.mini-button{fill:#333}'}</style>
        <g id="Group_13703" transform="translate(-543 -5824)">
            <g id="Group_13699" transform="translate(543 5824)">
                <path
                    id="Path_10201"
                    className="mini-button"
                    d="M5.3 0c.4 0 .7.3.7.8v4.5c0 .4-.3.7-.7.7H.8C.3 6 0 5.7 0 5.3s.3-.8.8-.8h3.7V.8c0-.5.3-.8.8-.8-.1 0 0 0 0 0z"
                />
            </g>
            <g id="Group_13700" transform="translate(560.982 5824)">
                <path
                    id="Path_10202"
                    className="mini-button"
                    d="M.7 0c.4 0 .7.3.8.8v3.8h3.8c.4-.1.7.2.7.6s-.3.8-.7.8H.7C.3 6 0 5.7 0 5.2V.8C0 .3.3 0 .7 0z"
                />
            </g>
            <g id="Group_13701" transform="translate(561.003 5835.98)">
                <path
                    id="Path_10203"
                    className="mini-button"
                    d="M.7 0h4.5c.5 0 .8.3.8.8s-.3.7-.8.7H1.5v3.8c0 .4-.3.7-.8.7S0 5.7 0 5.3V.8C0 .3.3 0 .7 0z"
                />
            </g>
            <g id="Group_13702" transform="translate(543 5836.002)">
                <path
                    id="Path_10204"
                    className="mini-button"
                    d="M.8 0h4.5c.4 0 .7.3.7.8v4.5c0 .4-.3.7-.7.7s-.8-.3-.8-.8V1.5H.8c-.5 0-.8-.3-.8-.7S.3 0 .8 0z"
                />
            </g>
        </g>
    </svg>
)

export const MaxiIcon = () => (
    <svg id="Group_13703" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 24 18" xmlSpace="preserve">
        <style>{'.maxi-button{fill:#333}'}</style>
        <g id="Group_13699">
            <path
                id="Path_10201"
                className="maxi-button"
                d="M.8 6C.3 6 0 5.7 0 5.3V.8C0 .3.3 0 .8 0h4.5c.4 0 .7.3.7.8s-.3.7-.8.7H1.5v3.8c0 .4-.3.7-.7.7z"
            />
        </g>
        <g id="Group_13700" transform="translate(17.981)">
            <path
                id="Path_10202"
                className="maxi-button"
                d="M5.3 6c-.4 0-.8-.3-.8-.8V1.5H.8c-.5 0-.8-.3-.8-.7S.3 0 .8 0h4.5c.4 0 .7.3.7.8v4.5c0 .4-.3.7-.7.7z"
            />
        </g>
        <g id="Group_13701" transform="translate(18.003 11.98)">
            <path
                id="Path_10203"
                className="maxi-button"
                d="M5.3 6H.8C.3 6 0 5.7 0 5.3s.3-.8.8-.8h3.7V.8c0-.5.3-.8.8-.8s.7.3.7.8v4.5c0 .4-.3.7-.7.7z"
            />
        </g>
        <g id="Group_13702" transform="translate(0 12.002)">
            <path
                id="Path_10204"
                className="maxi-button"
                d="M5.3 6H.8C.3 6 0 5.7 0 5.2V.7C0 .3.3 0 .8 0s.8.3.8.8v3.8h3.8c.3-.1.6.2.6.6s-.3.8-.7.8z"
            />
        </g>
    </svg>
)

export const MaxiArrowUpIcon = () => (
    <svg
        id="Group_13746"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 21.3 14.4"
        xmlSpace="preserve"
    >
        <style>{'.maxi-arrow-up-icon{fill:#333}'}</style>
        <g id="Group_13741" transform="translate(0 12.924)">
            <g id="Group_13740">
                <path
                    id="Path_10510"
                    className="maxi-arrow-up-icon"
                    d="M20.5 1.5H.8c-.5 0-.8-.3-.8-.7S.3 0 .8 0h19.8c.4 0 .8.3.8.8s-.5.7-.9.7z"
                />
            </g>
        </g>
        <g id="Group_13745" transform="translate(6.082)">
            <g id="Group_13744">
                <g id="Group_13742">
                    <path
                        id="Path_10511"
                        className="maxi-arrow-up-icon"
                        d="M.8 9.1c-.5 0-.8-.3-.8-.7 0-.2.1-.4.2-.6L7.8.2c.3-.3.8-.3 1.1 0 .3.3.3.7 0 1L1.3 8.9c-.1.1-.3.2-.5.2z"
                    />
                </g>
                <g id="Group_13743" transform="translate(0 2.281)">
                    <path
                        id="Path_10512"
                        className="maxi-arrow-up-icon"
                        d="M6.1 6.8H.8c-.5 0-.8-.3-.8-.7V.8C0 .3.3 0 .8 0s.8.3.8.8v4.6h4.6c.4 0 .8.3.8.8s-.5.6-.9.6z"
                    />
                </g>
            </g>
        </g>
    </svg>
)

export const MaxiArrowDownIcon = () => (
    <svg
        id="Group_13746"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 21.3 14.4"
        xmlSpace="preserve"
    >
        <style>{'maxi-arrow-down-icon{fill:#333}'}</style>
        <g id="Group_13741" transform="translate(0 12.924)">
            <g id="Group_13740">
                <path
                    id="Path_10510"
                    className="maxi-arrow-down-icon"
                    d="M20.5 1.5H.8c-.5 0-.8-.3-.8-.7S.3 0 .8 0h19.8c.4 0 .8.3.8.8s-.5.7-.9.7z"
                />
            </g>
        </g>
        <g id="Group_13745" transform="translate(6.082)">
            <g id="Group_13744">
                <g id="Group_13742">
                    <path
                        id="Path_10511"
                        className="maxi-arrow-down-icon"
                        d="M8.4 0c.4 0 .8.3.8.8-.1.2-.2.4-.3.5L1.3 8.9c-.3.3-.8.3-1.1 0s-.3-.8 0-1.1L7.8.2c.2-.1.4-.2.6-.2z"
                    />
                </g>
                <g id="Group_13743" transform="translate(2.281)">
                    <path
                        id="Path_10512"
                        className="maxi-arrow-down-icon"
                        d="M.8 0h5.3c.4 0 .8.3.8.8v5.3c0 .4-.3.8-.8.8s-.8-.4-.8-.8V1.5H.8c-.5 0-.8-.3-.8-.7S.3 0 .8 0z"
                    />
                </g>
            </g>
        </g>
    </svg>
)

export const DialogCardIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 16 16" xmlSpace="preserve">
        <g transform="translate(-.7 -3)">
            <path
                d="M5.2 14.7c-.1 0-.1 0-.2-.1-.2-.1-.3-.2-.3-.4v-2.4c-2.9-.4-5-3.1-4.6-6 .4-2.7 2.6-4.7 5.3-4.6h5.1c3 0 5.4 2.4 5.4 5.4 0 2.9-2.3 5.3-5.2 5.3H8.6l-3.1 2.7c-.1.1-.2.1-.3.1zm.4-3.1v1.7L8 11.2c.2-.1.3-.2.4-.2h2.2C13 11 15 9 15 6.6c0-2.4-1.9-4.4-4.3-4.4H5.4C3 2.1 1 4.1 1 6.6 1 9 2.8 10.9 5.2 11c.3 0 .5.2.5.5-.1 0-.1 0-.1.1z"
                transform="translate(.7 3)"
            />
            <circle cx={5.5} cy={9.5} r={1.1} />
            <circle cx={8.9} cy={9.5} r={1.1} />
            <circle cx={12.4} cy={9.5} r={1.1} />
        </g>
    </svg>
)

export const ApprovalIcon = () => (
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 32 32" xmlSpace="preserve">
        <style>{'.st0{fill:#315b8b}'}</style>
        <g id="Group_13590" transform="translate(-1236 -3349)">
            <path
                id="Path_4325"
                className="st0"
                d="M1257.2 3368.2v2.5c0 .7-.6 1.3-1.3 1.3H1247.1c-.7 0-1.3-.5-1.4-1.2v-.1-1-9.9c0-1.2.5-1.7 1.7-1.7h8.3c.7-.1 1.4.4 1.5 1.2v.8c.1 1.1-.3 2.1-1.2 2.7v-.5-2.3c0-.5-.1-.6-.6-.6h-8c-.5 0-.6.1-.6.6v10.3c0 .5.1.6.6.6h8c.3 0 .6-.1.6-.4 0-.6.2-1.1.6-1.5.2-.4.4-.6.6-.8z"
            />
            <path
                id="Path_4326"
                className="st0"
                d="M1254.5 3366.4l3.8-4.7.3-.3c.3-.5 1-.7 1.5-.4 0 0 .1 0 .1.1.5.4.5 1 .2 1.5l-.1.1c-.9 1.1-1.8 2.3-2.7 3.4-.7.8-1.3 1.6-2 2.5-.3.5-1 .7-1.5.4-.1-.1-.3-.2-.4-.3l-1.8-2.1c-.4-.4-.4-1.1 0-1.5s1.1-.4 1.5 0c0 0 .1.1.1.2.2.2.3.4.5.6l.5.5z"
            />
        </g>
    </svg>
)

export const ErrorIcon = () => (
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 16 16" xmlSpace="preserve">
        <style>{'.st10{fill:#fc2a2a}'}</style>
        <g id="Group_10972" transform="translate(-1086 -482)">
            <g id="Group_10695" transform="translate(1086 482)">
                <path
                    id="Path_7875"
                    className="st10"
                    d="M8 16c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8zM8 1.3A6.7 6.7 0 1014.7 8c0-3.7-3-6.7-6.7-6.7z"
                />
            </g>
            <g id="Group_10696" transform="translate(1093.333 485.333)">
                <path
                    id="Path_7876"
                    className="st10"
                    d="M.7 6.7C.3 6.7 0 6.4 0 6V.7C0 .3.3 0 .6 0c.4 0 .7.2.7.6V6c0 .4-.3.7-.6.7z"
                />
            </g>
            <g id="Group_10697" transform="translate(1093.333 493.342)">
                <path
                    id="Path_7877"
                    className="st10"
                    d="M.7 1.3C.3 1.3 0 1 0 .7 0 .5.1.4.2.2c.3-.2.7-.2.9 0 .1.1.2.3.2.5 0 .3-.3.6-.6.6z"
                />
            </g>
        </g>
    </svg>
)

export const EditIconWithCircle = () => (
    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 16.8 16.8" xmlSpace="preserve">
        <path
            d="M11.9 5.5c-.4-.4-1.2-.4-1.6 0L5.9 10l-.1.1-.6 2.1c0 .1 0 .3.2.3h.1l2.1-.5s.1 0 .1-.1l4.5-4.5c.4-.4.4-1.2 0-1.6l-.3-.3zm-5.5 4.7l3.7-3.7 1.2 1.2-3.7 3.7-1.2-1.2zm-.2.5l.9.9-1.3.4.4-1.3zm5.7-3.6l-.3.3-1.2-1.2.3-.3c.2-.2.6-.2.9 0l.3.3c.2.2.2.6 0 .9z"
            transform="translate(-.5 -.5)"
        />
        <path
            d="M8.9.9c4.4 0 8 3.6 8 8 0 3.2-1.9 6.1-4.9 7.3C7.9 17.9 3.3 16 1.5 12s.2-8.7 4.3-10.5c1-.4 2-.6 3.1-.6m0-.4C4.3.5.5 4.3.5 8.9s3.8 8.4 8.4 8.4 8.4-3.8 8.4-8.4c0-4.6-3.8-8.4-8.4-8.4z"
            transform="translate(-.5 -.5)"
        />
    </svg>
)

export const ExecutionReportIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 14 13" xmlSpace="preserve">
        <path
            d="M.5 6.4c-.3 0-.5-.2-.5-.5 0-.1.1-.3.1-.4L5.5.1c.3-.1.6-.1.8.1.2.2.2.5 0 .7L.9 6.3c-.1.1-.3.1-.4.1z"
            transform="translate(5 2.298) translate(.843) translate(0 .316)"
        />
        <path
            d="M.5 6.4c-.3 0-.5-.2-.5-.5 0-.1.1-.3.1-.4L5.5.1c.3-.1.6-.1.8 0 .2.2.2.5 0 .7L.9 6.3c-.1.1-.3.1-.4.1z"
            transform="translate(5 2.298) translate(.843) translate(0 .316) translate(1.4 1.401)"
        />
        <g>
            <path
                d="M1.9 2.7c-.3 0-.5-.2-.5-.5 0-.1.1-.3.1-.4.2-.2.2-.5 0-.7-.1-.2-.5-.2-.6 0-.2.2-.5.2-.7 0C0 .9 0 .6.2.4c.6-.6 1.5-.6 2.1 0 .6.6.6 1.5 0 2.1-.1.1-.3.2-.4.2z"
                transform="translate(5 2.298) translate(.843) translate(5.467)"
            />
        </g>
        <g>
            <path
                d="M.5 3.2C.2 3.2 0 3 0 2.7v-.2L.8.3c.2-.2.5-.4.7-.3s.4.4.3.6l-.4 1.3 1.2-.5c.3-.1.5 0 .7.3.1.3 0 .5-.3.7l-2.3.8H.5z"
                transform="translate(5 2.298) translate(0 5.743)"
            />
        </g>
        <g>
            <path
                d="M7.5 3c-.3 0-.5-.2-.5-.5V1H.5C.2 1 0 .8 0 .5S.2 0 .5 0H7c.6 0 1 .4 1 1v1.5c0 .3-.2.5-.5.5z"
                transform="translate(4 .001)"
            />
            <path
                d="M11 9H1c-.6 0-1-.3-1-.8V.4C0 .2.2 0 .5 0s.5.2.5.4v7.9h10v-3c0-.2.2-.4.5-.4s.5.1.5.3v3c0 .5-.4.8-1 .8z"
                transform="translate(0 4.001)"
            />
            <path d="M4.5 5h-4C.2 5 0 4.8 0 4.5c0-.1.1-.3.1-.4l4-4c.2-.1.6-.1.8 0 0 .1.1.3.1.4v4c0 .3-.2.5-.5.5zM1.7 4H4V1.7L1.7 4z" />
        </g>
        <g>
            <path
                d="M1.9 2.4c-.1 0-.3-.1-.4-.1L.1.9C-.1.7-.1.4.1.2.3 0 .7 0 .8.1l1.4 1.4c.2.2.2.5 0 .7 0 .1-.2.2-.3.2z"
                transform="translate(10.554 3.94)"
            />
        </g>
    </svg>
)

export const AutoResolvedIcon = () => (
    <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 18.1 18.1"
    >
        <style>{'.st10{fill:currentColor}'}</style>
        <g id="Group_12261" transform="translate(-680.104 -246.104)">
            <g id="Group_12260" transform="translate(680.104 246.104)">
                <g id="Group_9692">
                    <path
                        id="Path_4810"
                        // className="st0"
                        d="M9,18.1c-5,0-9-4-9-9s4-9,9-9c5,0,9,4,9,9C18.1,14,14,18.1,9,18.1z M9,1.5
				C4.9,1.5,1.5,4.9,1.5,9s3.4,7.5,7.5,7.5c4.2,0,7.5-3.4,7.5-7.5c0,0,0,0,0,0C16.6,4.9,13.2,1.5,9,1.5L9,1.5z"
                    />
                </g>
                <g id="Group_9693" transform="translate(3.766 5.272)">
                    <path
                        id="Path_4811"
                        // className="st0"
                        d="M4.5,7.5C4.3,7.5,4.2,7.5,4,7.4l-3.8-3C0,4.1-0.1,3.6,0.2,3.3C0.4,3,0.9,2.9,1.2,3.2l0,0
				l3.2,2.6l4.8-5.5c0.3-0.3,0.7-0.3,1.1-0.1c0.3,0.3,0.3,0.7,0.1,1.1c0,0,0,0,0,0l-5.3,6C4.9,7.4,4.7,7.5,4.5,7.5z"
                    />
                </g>
            </g>
        </g>
    </svg>
)

export const TryMeanalyticsIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 24 24" xmlSpace="preserve">
        <g transform="translate(-997 -656)">
            <circle cx={1009} cy={668} r={12} fill="#355d8b" />
            <path
                d="M4 10.5c-.2 0-.4-.2-.4-.4V8.3C1.3 8-.3 5.9 0 3.6.3 1.5 2.1 0 4.2 0h4c2.3 0 4.2 1.9 4.2 4.2s-1.9 4.2-4.2 4.2H6.6l-2.4 2.1c-.1-.1-.1 0-.2 0zM4.3 8v1.3l1.9-1.6c.1-.1.2-.1.2-.1h1.7c1.9 0 3.4-1.6 3.4-3.5S10 .8 8.1.7h-4C2.2.7.7 2.2.6 4.1.7 6 2.1 7.5 4 7.6c.2 0 .3.1.3.4 0-.1 0-.1 0 0z"
                fill="#fff"
                transform="translate(614.043 -61.11) translate(389 724)"
            />
        </g>
    </svg>
)

export const TestanalyticsIcon = () => (
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 24 24" xmlSpace="preserve">
        <style>{'.st1{fill:#fff}'}</style>
        <g id="Group_12816" transform="translate(-997 -699)">
            <circle id="Ellipse_751" cx={1009} cy={711} r={12} fill="#355d8b" />
            <g id="Group_12813" transform="translate(948.301 704.638)">
                <path
                    id="Path_16"
                    className="st1"
                    d="M62.5 11.4h-2.6c-1.9 0-2.2-1.3-2.2-2.5v-6h.8v6c0 1.3.3 1.7 1.3 1.7h2.6l.1.8z"
                />
                <path id="Rectangle_4" className="st1" d="M58.2 5.8H62.400000000000006V6.6H58.2z" />
                <path
                    id="Path_17"
                    className="st1"
                    d="M58.1 3.2c-.8 0-1.5-.7-1.5-1.5S57.3.2 58.1.2s1.5.7 1.5 1.5-.7 1.5-1.5 1.5zm-.6-2c-.3.3-.3.9 0 1.2.3.3.9.3 1.2 0 .3-.3.3-.9 0-1.2-.3-.4-.8-.4-1.2 0z"
                />
                <path
                    id="Path_18"
                    className="st1"
                    d="M63.7 7.7c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5c-.1.9-.7 1.5-1.5 1.5zm0-2.3c-.5 0-.9.4-.9.9s.4.9.9.9.9-.4.9-.9c-.1-.5-.5-.9-.9-.9z"
                />
                <path
                    id="Path_19"
                    className="st1"
                    d="M63.7 12.5c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5c-.1.8-.7 1.5-1.5 1.5zm0-2.4c-.5 0-.9.4-.9.9s.4.9.9.9.9-.4.9-.9c-.1-.5-.5-.9-.9-.9z"
                />
            </g>
        </g>
    </svg>
)

export const AbandonedIcon = () => (
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 18 18" xmlSpace="preserve">
        <style>{'.st0{fill:currentColor}'}</style>
        <g id="Group_12264" transform="translate(-683.939 -248.841)">
            <g id="Group_8123" transform="translate(479.139 43.871)">
                <g id="Group_8120" transform="translate(204.8 204.97)">
                    <g id="Group_8119">
                        <path
                            id="Path_4297"
                            // className="st0"
                            d="M9 16.5H2.2c-.4 0-.7-.3-.7-.7V2.2c0-.4.3-.7.7-.7H9c.4 0 .8-.3.8-.8S9.4 0 9 0H2.2C1 0 0 1 0 2.2v13.5C0 17 1 18 2.2 18H9c.4 0 .8-.3.8-.8s-.4-.7-.8-.7z"
                        />
                    </g>
                </g>
                <g id="Group_8122" transform="translate(210.793 208.716)">
                    <g id="Group_8121">
                        <path
                            id="Path_4298"
                            // className="st0"
                            d="M11.8 4.7L7.3.2C7-.1 6.5-.1 6.2.2c-.3.3-.3.8 0 1.1l3.3 3.2H.7c-.4 0-.7.3-.7.7s.3.8.7.8h8.7L6.2 9.2c-.3.3-.3.8 0 1.1.3.3.8.3 1.1 0l4.6-4.5c.2-.3.2-.8-.1-1.1z"
                        />
                    </g>
                </g>
            </g>
        </g>
    </svg>
)

export const OnGoingIcon = () => (
    <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 18.1 18.1"
    xmlSpace="preserve"
  >
    <style>{".ongoing-st0{fill:#355d8b}"}</style>
    <path
      className="ongoing-st0"
      d="M15.3 8.9l-2.7-1.8c-.3-.2-.4-.5-.2-.8.2-.3.6-.4.9-.2l2.1 1.4 1.4-2.3c.2-.3.5-.4.8-.2.3.2.4.5.2.8l-1.7 2.9c-.1.2-.2.2-.4.3h-.1c-.1-.1-.2-.1-.3-.1z"
    />
    <path
      className="ongoing-st0"
      d="M14.9 8c-.4-3.1-2.8-5.2-5.9-5.2-2.7 0-5.1 1.7-5.9 4.2-.1.4-.4.6-.7.4-.4 0-.5-.4-.4-.7 1-3 3.8-5.1 7.1-5.1 3.7 0 6.6 2.7 7.1 6.3 0 .3-.2.6-.5.7h-.1c-.4 0-.7-.3-.7-.6z"
    />
    <g>
      <path
        className="ongoing-st0"
        d="M.5 13.1c-.3-.2-.4-.5-.2-.8L2 9.5c0-.2.2-.3.3-.3.2-.1.4-.1.5.1L5.5 11c.3.2.4.5.2.8s-.6.4-.9.2l-2.1-1.4-1.4 2.3c-.1.2-.4.3-.5.3-.1 0-.2 0-.3-.1z"
      />
      <path
        className="ongoing-st0"
        d="M2 10.2c0-.3.2-.6.5-.7.3 0 .6.2.7.5.4 3.2 2.8 5.3 5.8 5.3 2.7 0 5.2-1.8 5.9-4.3.1-.4.4-.5.7-.4.4.1.5.4.4.7-1 3-3.8 5.1-7.1 5.1-3.5.1-6.5-2.6-6.9-6.2z"
      />
    </g>
  </svg>
)

export const IgnoredIcon = () => (
    <svg
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 18.1 18.1"
      xmlSpace="preserve"
    >
      <style>{".ignored-st0{fill:#355d8b}"}</style>
      <g id="Group_12261" transform="translate(-680.104 -246.104)">
        <g id="Group_12260" transform="translate(680.104 246.104)">
          <g id="Group_9692">
            <path
              id="Path_4810"
              className="ignored-st0"
              d="M9 18.1c-5 0-9-4-9-9s4-9 9-9 9 4 9 9c.1 4.9-4 9-9 9zM9 1.5C4.9 1.5 1.5 4.9 1.5 9s3.4 7.5 7.5 7.5c4.2 0 7.5-3.4 7.5-7.5.1-4.1-3.3-7.5-7.5-7.5z"
            />
          </g>
        </g>
      </g>
      <path
        transform="rotate(-45.001 8.658 9.216)"
        className="ignored-st0"
        d="M7.9 1.3H9.4V17.2H7.9z"
      />
    </svg>
)

export const UnresolvedIcon = () =>(
    <svg
      id="Group_14012"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 18 18"
      xmlSpace="preserve"
    >
      <style>{".unresolved-st1{fill:#355d8b}"}</style>
      <defs>
        <path id="SVGID_1_" d="M0 0H18V18H0z" />
      </defs>
      <clipPath id="SVGID_00000176750584724750112780000002457815556960901252_">
        <use xlinkHref="#SVGID_1_" overflow="visible" />
      </clipPath>
      <g
        id="Group_14005"
        clipPath="url(#SVGID_00000176750584724750112780000002457815556960901252_)"
      >
        <path
          id="Path_10532"
          className="unresolved-st1"
          d="M2.6 15.4C-.9 11.9-1 6.2 2.5 2.7s9.2-3.6 12.7-.1l.1.1c3.5 3.5 3.6 9.2.1 12.7s-9.1 3.5-12.8 0c.1 0 .1 0 0 0m12-12C11.5.3 6.5.3 3.5 3.4s-3.1 8.1 0 11.1 8.1 3.1 11.1 0 3-8 0-11.1"
        />
        <path
          id="Path_10533"
          className="unresolved-st1"
          d="M11.4 12.2L5.8 6.6c-.2-.2-.2-.6 0-.8.2-.2.6-.2.8 0l5.6 5.6c.2.2.2.6 0 .8-.3.2-.6.2-.8 0"
        />
        <path
          id="Path_10534"
          className="unresolved-st1"
          d="M5.8 12.2c-.2-.2-.2-.6 0-.8l5.6-5.6c.2-.2.6-.2.8 0s.2.6 0 .8l-5.6 5.6c-.3.2-.6.2-.8 0"
        />
      </g>
    </svg>
)

export const FaqAnsweredIcon = () =>(
    <svg
    id="Group_14068"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 18.1 16.7"
    xmlSpace="preserve"
  >
    <style>{".faq-st0{fill:#355d8b}"}</style>
    <g id="Group_7719">
      <path
        id="Path_4121"
        className="faq-st0"
        d="M16 0H2.1C.9 0 0 .9 0 2.1v8.4c0 1 .7 1.8 1.7 2.1V16c0 .4.3.7.7.7.2 0 .4-.1.5-.3l3-3.8c0-.1.1-.1.2-.1H16c1.2 0 2.1-.9 2.1-2.1V2.1C18.1.9 17.1 0 16 0zm1.2 10.5c0 .7-.6 1.3-1.3 1.3H6.1c-.3 0-.7.2-.9.4l-2.7 3.4v-3.4c0-.2-.2-.4-.4-.4-.7 0-1.2-.6-1.2-1.3V2.1c0-.7.6-1.3 1.3-1.3H16c.7 0 1.3.6 1.3 1.3l-.1 8.4z"
      />
    </g>
    <g id="Group_9693" transform="translate(3.766 5.272)">
      <path
        id="Path_4811"
        className="faq-st0"
        d="M4.6 4.5c-.2 0-.3-.1-.5-.2l-3.8-3C0 1.1-.1.6.2.3.5 0 .9-.1 1.3.2l3.2 2.6 4.8-5.5c.3-.3.7-.3 1.1-.1.3.3.3.7.1 1.1l-5.3 6c-.2.1-.4.2-.6.2z"
      />
    </g>
  </svg>
)

export const HrRightArrow = () => (
    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 24 24" xmlSpace="preserve">
        <g transform="translate(-992.33 -514.33)">
            <path opacity={0.3} d="M992.3 514.3H1016.3V538.3H992.3z" />
            <path
                d="M1001.9 531.9c-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4l3.8-3.8-3.8-3.8c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l4.5 4.5c.4.4.4 1 0 1.4l-4.5 4.5c-.2.3-.4.3-.7.3z"
                fill="#fff"
            />
        </g>
    </svg>
)

export const HrLeftArrow = () => (
    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 24 24" xmlSpace="preserve">
        <g transform="translate(-992.33 -514.33)">
            <path opacity={0.3} d="M992.3 514.3H1016.3V538.3H992.3z" />
            <path
                d="M1006.5 531.9c.3 0 .5-.1.7-.3.4-.4.4-1 0-1.4l-3.8-3.8 3.8-3.8c.4-.4.4-1 0-1.4s-1-.4-1.4 0l-4.5 4.5c-.4.4-.4 1 0 1.4l4.5 4.5c.2.3.4.3.7.3z"
                fill="#fff"
            />
        </g>
    </svg>
)

export function HelpDocIconV2() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 32 32" xmlSpace="preserve">
            <path
                d="M376 728.8c-8.2 0-14.9 6.7-14.9 14.9s6.7 14.9 14.9 14.9 14.9-6.7 14.9-14.9c0-8.3-6.7-14.9-14.9-14.9zm0 28.2c-7.4 0-13.3-6-13.3-13.3 0-7.4 6-13.3 13.3-13.3 7.4 0 13.3 6 13.3 13.3 0 7.3-5.9 13.3-13.3 13.3z"
                transform="translate(-360.13 -726.68)"
            />
            <path
                d="M7.3 15.6H2.7c-.4 0-.7-.3-.7-.6V4c0-.4.3-.6.6-.6h4.7c.4-.1.7.2.7.6s-.3.6-.7.6h-4v9.7h4c.4 0 .7.3.7.7s-.3.6-.7.6zM9 16.9c-.4 0-.6-.3-.6-.7V5.7c0-.4.3-.7.6-.7s.6.3.6.6v10.6c.1.4-.2.7-.6.7z"
                transform="translate(-360.13 -726.68) translate(-349.87 -5806.539) translate(717 6541)"
            />
            <path
                d="M9 17.3c-.4 0-.6-.3-.6-.7 0-.6-.5-1.1-1.1-1.1-.4 0-.6-.3-.6-.7s.3-.7.6-.7c1.3 0 2.4 1.1 2.4 2.4 0 .6-.3.8-.7.8zM9 5.7h-.6c0-.3-.1-.5-.3-.7s-.5-.4-.8-.4c-.3 0-.6-.3-.6-.6s.3-.7.6-.7c.6 0 1.2.3 1.7.7.4.4.7 1 .7 1.7H9z"
                transform="translate(-360.13 -726.68) translate(-349.87 -5806.539) translate(717 6541)"
            />
            <path
                d="M10.3 15.6H5.6c-.4 0-.6-.3-.6-.6s.3-.7.7-.7h4V4.6h-4c-.5 0-.7-.3-.7-.6s.3-.6.7-.6h4.7c.4 0 .7.3.7.6v11c-.2.3-.5.6-.8.6z"
                transform="translate(-360.13 -726.68) translate(-349.87 -5806.539) translate(717 6541) translate(5.124)"
            />
            <path
                d="M3.9 17.3c-.4 0-.7-.3-.6-.7 0-1.3 1.1-2.4 2.4-2.4.4 0 .7.3.7.7s-.4.7-.8.7c-.6 0-1.1.5-1.1 1.1 0 .4-.2.6-.6.6zM3.9 6.3c-.4 0-.7-.3-.7-.6 0-.7.3-1.3.7-1.7.4-.4 1-.7 1.7-.7.4 0 .6.3.6.7 0 .4-.3.6-.7.6-.2 0-.5.1-.6.3-.2.2-.4.5-.4.8 0 .3-.2.6-.6.6z"
                transform="translate(-360.13 -726.68) translate(-349.87 -5806.539) translate(717 6541) translate(5.124)"
            />
            <g>
                <path
                    d="M7.1 5.2H4.2c-.4 0-.7-.3-.7-.6s.3-.6.7-.6h2.9c.4 0 .7.3.7.6s-.3.6-.7.6zM7.1 7.5H4.2c-.4 0-.7-.3-.7-.6s.3-.6.7-.6h2.9c.4 0 .7.3.7.6s-.3.6-.7.6zM7.1 9.8H4.2c-.4 0-.7-.3-.7-.7s.3-.7.7-.7h2.9c.4 0 .7.3.7.7s-.3.7-.7.7z"
                    transform="translate(-360.13 -726.68) translate(-349.87 -5806.539) translate(723.524 6543.332)"
                />
            </g>
            <g>
                <path
                    d="M5.9 5.2H3c-.4 0-.6-.3-.6-.6s.2-.7.6-.7h2.9c.4 0 .6.3.6.6s-.3.7-.6.7zM5.9 7.5H3c-.4 0-.6-.3-.6-.6s.2-.7.6-.7h2.9c.4 0 .6.3.6.6s-.3.7-.6.7zM5.9 9.8H3c-.4 0-.6-.3-.6-.7s.2-.6.6-.6h2.9c.4 0 .6.3.6.7s-.3.6-.6.6z"
                    transform="translate(-360.13 -726.68) translate(-349.87 -5806.539) translate(718.393 6543.332)"
                />
            </g>
        </svg>
    )
}

export const ApptriggerIcon = () => (
    <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 16.1 28.5"
    xmlSpace="preserve"
  >
    {/* <style>{".apptriggerIcon{fill:#355d8b}"}</style> */}
    <g id="Group_5752" transform="translate(-6.931 -.026)">
      <g id="Group_5750" transform="translate(11.39 .075)">
        <path
          id="Path_3816"
          className="apptriggerIcon"
          d="M1 28.5c-.2 0-.4-.1-.5-.2-.5-.3-.6-.8-.4-1.2l9.2-13.7H5.9c-.5 0-1-.2-1.2-.6-.4-.4-.5-1-.4-1.5v-.1L7.2.6c.2-.4.6-.7 1.1-.6.4.2.7.6.6 1.1L6 11.5h4.2c.4 0 1.1 0 1.3.6.2.4.1 1-.2 1.3L1.7 28c-.2.3-.5.4-.7.5z"
        />
      </g>
      <g id="Group_5751" transform="translate(6.931 .026)">
        <path
          id="Path_3817"
          className="apptriggerIcon"
          d="M5.4 28.5h-.2c-.5-.1-.8-.6-.7-1.1l1.7-9.6H1.5c-.6 0-1.1-.3-1.3-.8-.3-.5-.2-1.1.3-1.5L11.8.3c.3-.4.8-.4 1.2-.2.4.3.4.8.2 1.2L2.3 16h4c.5 0 1.1.2 1.4.5.3.3.4.7.4 1.2L6.3 27.8c-.1.4-.5.7-.9.7z"
        />
      </g>
    </g>
  </svg>
)

export const WebhooksIcon = () => (
    <svg
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 27.9 25.7"
      xmlSpace="preserve"
    >
      {/* <style>{".webhooksIcon{fill:#355d8b}"}</style> */}
      <g id="Group_5772" transform="translate(-587.94 -593.72)">
        <path
          id="Path_3825"
          className="webhooksIcon"
          d="M609.3 606.4c-.8 0-1.7.2-2.5.5l-2.5-4.2c1.2-1.2 1.3-3.2.1-4.5-1.2-1.2-3.2-1.3-4.5-.1-1.2 1.2-1.3 3.2-.1 4.5.7.8 1.8 1.1 2.9.9l3 4.9c.2.4.8.5 1.2.3 2.3-1.3 5.2-.5 6.5 1.8 1.3 2.3.5 5.2-1.8 6.5-1.8 1-4 .8-5.6-.6-.4-.3-.9-.3-1.2.1s-.3.9.1 1.2c2.7 2.4 6.8 2.2 9.2-.5 2.4-2.7 2.2-6.8-.5-9.2-1.1-1-2.7-1.6-4.3-1.6z"
        />
        <path
          id="Path_3826"
          className="webhooksIcon"
          d="M593 610c-1.5.9-2 2.8-1.1 4.3.4.7 1.1 1.3 1.9 1.5.3.1.5.1.8.1 1.7 0 3.2-1.4 3.2-3.2 0-.8-.3-1.5-.8-2.1l2.8-5.1c.2-.4.1-.9-.3-1.2-2.3-1.3-3.1-4.2-1.7-6.5s4.2-3.1 6.5-1.7c1.8 1 2.7 3.1 2.3 5.1-.1.5.2.9.7 1 .5.1.9-.2 1-.7.7-3.5-1.5-7-5.1-7.7-3.5-.7-7 1.5-7.7 5.1-.5 2.4.4 5 2.4 6.5l-2.3 4.3c-1-.2-1.9-.1-2.6.3z"
        />
        <path
          id="Path_3827"
          className="webhooksIcon"
          d="M605.8 613.9c.4 1.7 2.1 2.7 3.8 2.3s2.7-2.1 2.3-3.8c-.4-1.7-2.1-2.7-3.8-2.3-.8.2-1.5.7-1.9 1.4l-.3.6h-5.8c-.5 0-.9.4-.9.9-.1 2.6-2.2 4.7-4.9 4.7-2.6-.1-4.7-2.2-4.7-4.9 0-2.1 1.4-3.8 3.4-4.5.5-.1.7-.6.6-1.1-.1-.5-.6-.7-1.1-.6-3.4 1.1-5.4 4.7-4.3 8.2s4.7 5.4 8.2 4.3c2.4-.7 4.1-2.8 4.5-5.2h4.9c0-.1 0 0 0 0z"
        />
      </g>
    </svg>
)

export const WebhookFirstStepIcon = () =>(
    <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 32 32"
    xmlSpace="preserve"
  >
    <style>{".st1{fill:#367af2}"}</style>
    <g id="Group_14013" transform="translate(-660 -551.599)">
      <g id="Group_9217" transform="translate(660 551.599)">
        <circle id="Ellipse_489" cx={16} cy={16} r={16} fill="#c7e3ff" />
      </g>
      <g id="Group_5772" transform="translate(667.111 558.71)">
        <path
          id="Path_3825"
          className="st1"
          d="M13.7 8.1c-.5 0-1.1.1-1.6.3l-1.6-2.7c.8-.8.8-2.1 0-2.9-.8-.8-2.1-.8-2.9 0s-.8 2.1 0 2.9c.5.5 1.2.7 1.9.6l1.9 3.2c.2.3.5.4.8.2 1.5-.8 3.3-.3 4.2 1.1.8 1.5.3 3.3-1.1 4.2-1.1.7-2.6.5-3.6-.4-.2-.2-.6-.2-.8 0-.2.2-.2.6 0 .8 1.7 1.5 4.4 1.4 5.9-.3s1.4-4.4-.3-5.9c-.8-.7-1.8-1.1-2.8-1.1z"
        />
        <path
          id="Path_3826"
          className="st1"
          d="M3.2 10.4c-1 .6-1.3 1.8-.7 2.8.6 1 1.8 1.3 2.8.7s1.3-1.8.7-2.8c-.1-.1-.2-.2-.2-.3l1.8-3.2c.1-.3 0-.6-.3-.8C5.9 6 5.4 4.1 6.2 2.7s2.7-2 4.2-1.1c1.1.7 1.7 2 1.5 3.3-.1.3.1.6.4.7.3-.1.6-.3.7-.6.5-2.3-1-4.5-3.3-5s-4.5 1-5 3.3c-.3 1.6.3 3.2 1.6 4.2l-1.5 2.7c-.5-.1-1.1 0-1.6.2z"
        />
        <path
          id="Path_3827"
          className="st1"
          d="M11.5 12.9c.2.9 1 1.5 2 1.5 1.1 0 2-.9 2-2 0-.2 0-.3-.1-.5-.3-1.1-1.4-1.7-2.5-1.5-.7.2-1.2.7-1.4 1.3H7.8c-.3 0-.6.2-.6.6 0 1.7-1.4 3-3.1 3-1.7 0-3-1.4-3-3.1 0-1.3.9-2.5 2.2-2.9.3-.1.5-.4.4-.7s-.5-.4-.8-.3C.7 9-.5 11.3.1 13.5c.7 2.2 3 3.4 5.2 2.8 1.5-.5 2.7-1.8 2.9-3.4h3.3z"
        />
      </g>
    </g>
  </svg>
)

export const UserTriggerIcon = () => (
    <svg
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 27 29.2"
      xmlSpace="preserve"
    >
      <style>{".userTriggerIcon{fill:#355d8b}"}</style>
      <g id="Group_14155" transform="translate(-77.89 -83.453)">
        <g id="Group_14153" transform="translate(83.289 83.453)">
          <path
            id="Path_10706"
            className="userTriggerIcon"
            d="M6.7 0c3.3 0 6.1 2.4 6.6 5.6.3 1.7-.1 3.5-.9 5.1-.6 1.2-1.5 2.2-2.6 3-1.9 1.4-4.5 1.4-6.3-.1C1.2 12-.1 9.3 0 6.5.1 3.3 2.4.6 5.6.1c.3 0 .7-.1 1.1-.1z"
          />
          <path
            id="Path_10707"
            className="userTriggerIcon"
            d="M14.5 24.1V22c0-.3.2-.6.5-.6.1 0 .3 0 .4.1 1.3.7 2.5 1.4 3.8 2.1.3.1.4.5.3.7-.1.1-.1.2-.3.3-.8.5-1.6.9-2.4 1.4l-1.3.7c-.2.2-.6.1-.8-.1-.1-.1-.1-.3-.1-.4-.1-.7-.1-1.4-.1-2.1z"
          />
        </g>
        <g id="Group_14154" transform="translate(77.89 99.154)">
          <path
            id="Path_10708"
            className="userTriggerIcon"
            d="M21.7 13.3c-2.8 0-5.1-2.3-5.1-5.1s2.3-5.1 5.1-5.1C20 1.2 17.6.1 15 0H9.6C9 0 8.5.1 7.9.2 4.8.7 2.2 2.8.9 5.6.1 7.3-.2 9.1 0 11c0 .2 0 .3.1.5.3 1.2 1.4 2 2.7 2h18.9c.5 0 .9-.1 1.3-.3-.5 0-.9.1-1.3.1z"
          />
          <path
            id="Path_10709"
            className="userTriggerIcon"
            d="M21.7 3.3c2.7 0 4.9 2.2 4.9 4.9s-2.2 4.9-4.9 4.9-4.9-2.2-4.9-4.9 2.2-4.9 4.9-4.9m0-.4c-2.9 0-5.3 2.4-5.3 5.3s2.4 5.3 5.3 5.3S27 11.1 27 8.2s-2.4-5.3-5.3-5.3z"
          />
        </g>
      </g>
    </svg>
)

export const AutomateInfoIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 18 18"
      xmlSpace="preserve"
    >
      <path
        d="M9 18c-5 0-9-4-9-9s4-9 9-9 9 4 9 9-4 9-9 9zm-.2-6.2c-.4 0-.7.3-.8.7 0 .2.1.4.2.5.3.3.8.3 1.1 0 .1-.1.2-.3.2-.5s-.1-.4-.2-.5c-.2-.2-.3-.2-.5-.2zm0-6.8c-.5 0-.8.3-.8.7v4.5c0 .5.3.8.8.8.4 0 .8-.3.8-.8V5.8c-.1-.5-.4-.8-.8-.8z"
        fill="#fdb93a"
      />
    </svg>
  )


// export const CopyIocn = () => (
//     <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 16.1 16.1" xmlSpace="preserve">
//         <path
//             d="M12.6 13H.4c-.2 0-.4-.1-.4-.4V.4C0 .2.2 0 .4 0h12.2c.2 0 .4.2.4.4v12.2c0 .2-.1.4-.4.4zM.9 12.1h11.2V.9H.9v11.2z"
//             transform="translate(-.7 -.9) translate(3.724 3.924)"
//         />
//         <path
//             d="M.5 14.1c-.3 0-.5-.2-.5-.5V.5C0 .2.2 0 .5 0h13c.3 0 .5.2.5.5s-.2.5-.4.5H1v12.6c0 .3-.2.5-.5.5z"
//             transform="translate(-.7 -.9) translate(.7 .9)"
//         />
//     </svg>
// )

export const WebhookIcon = 'data:image/svg+xml;base64,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'
export const AppTriggersIcon = 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI0LjIuMywgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAyNCAyNCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjQgMjQ7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojNDI3N0MzO30KCS5zdDF7ZmlsbDojRkZGRkZGO30KPC9zdHlsZT4KPGcgaWQ9ImFwcF90cmlnZ2VyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTY1Ljk1NyAtOTYwLjk1NykiPgoJPGNpcmNsZSBpZD0iRWxsaXBzZV8yMCIgY2xhc3M9InN0MCIgY3g9IjE3OCIgY3k9Ijk3MyIgcj0iMTIiLz4KCTxnIGlkPSJHcm91cF81ODAyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNzIuODkxIDk2NC45NjUpIj4KCQk8ZyBpZD0iR3JvdXBfNTc1MCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMi40MTQgMC4wMjcpIj4KCQkJPHBhdGggaWQ9IlBhdGhfMzgxNiIgY2xhc3M9InN0MSIgZD0iTTAuNSwxNS40Yy0wLjEsMC0wLjIsMC0wLjMtMC4xYy0wLjItMC4xLTAuMy0wLjQtMC4yLTAuN2MwLDAsMCwwLDAsMGw1LTcuNEgzLjIKCQkJCUMzLDcuMiwyLjcsNy4xLDIuNSw2LjlDMi4zLDYuNiwyLjMsNi4zLDIuMyw2djBsMS42LTUuN0M0LDAuMSw0LjIsMCw0LjUsMGMwLjIsMC4xLDAuNCwwLjMsMC4zLDAuNkwzLjMsNi4yaDIuMwoJCQkJYzAuMiwwLDAuNiwwLDAuNywwLjNjMC4xLDAuMiwwLjEsMC41LTAuMSwwLjdsLTUuMyw3LjlDMC44LDE1LjMsMC43LDE1LjQsMC41LDE1LjR6Ii8+CgkJPC9nPgoJCTxnIGlkPSJHcm91cF81NzUxIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDApIj4KCQkJPHBhdGggaWQ9IlBhdGhfMzgxNyIgY2xhc3M9InN0MSIgZD0iTTIuOSwxNS40SDIuOGMtMC4zLTAuMS0wLjQtMC4zLTAuNC0wLjZsMC45LTUuMkgwLjhjLTAuMywwLTAuNi0wLjItMC43LTAuNAoJCQkJQy0wLjEsOC45LDAsOC42LDAuMiw4LjRsNi4yLTguMkM2LjYsMCw2LjktMC4xLDcuMSwwLjFjMC4yLDAuMiwwLjIsMC41LDAuMSwwLjdMMS4yLDguN2gyLjJDMy43LDguNyw0LDguOCw0LjIsOQoJCQkJYzAuMiwwLjIsMC4yLDAuNCwwLjIsMC42bC0xLDUuNUMzLjQsMTUuMywzLjIsMTUuNCwyLjksMTUuNHoiLz4KCQk8L2c+Cgk8L2c+CjwvZz4KPC9zdmc+Cg=='
export const TimerNodeIcon = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI3LjIuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAzMiAzMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMzIgMzI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojRTBGNkZGO30KCS5zdDF7ZmlsbDojMzA1QjhCO30KPC9zdHlsZT4KPGcgaWQ9Ikdyb3VwXzE0NTMwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNzg4IC0yNzIpIj4KCTxnIGlkPSJHcm91cF8xMjcwNiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzQxLjE0NiAzNy4xNDYpIj4KCQk8Y2lyY2xlIGlkPSJFbGxpcHNlXzI3IiBjbGFzcz0ic3QwIiBjeD0iNDYyLjkiIGN5PSIyNTAuOSIgcj0iMTYiLz4KCTwvZz4KCTxnIGlkPSJHcm91cF8xMzk0MiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNzk3IDI4MCkiPgoJCTxnPgoJCQk8ZyBpZD0iR3JvdXBfMTM5NDEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMCkiPgoJCQkJPHBhdGggaWQ9IlBhdGhfMTA1MjQiIGNsYXNzPSJzdDEiIGQ9Ik03LjQsMi44YzMuNiwwLjQsNi4yLDMuNyw1LjgsNy40UzkuNSwxNi40LDUuOCwxNlMtMC40LDEyLjIsMCw4LjZDMC40LDUuNSwzLDMsNi4yLDIuOAoJCQkJCVYxLjdjMCwwLDAsMCwwLDBINC45Yy0wLjIsMC0wLjQtMC4yLTAuNC0wLjRWMC40QzQuNSwwLjIsNC43LDAsNC45LDBjMCwwLDAsMCwwLDBoMy43QzguOCwwLDksMC4yLDksMC40djAuOQoJCQkJCWMwLDAuMi0wLjIsMC40LTAuNCwwLjRINy40YzAsMCwwLDAsMCwwVjIuOHogTTcuMSw4LjRjMC41LDAuMywwLjcsMSwwLjUsMS41Yy0wLjMsMC41LTEsMC43LTEuNSwwLjVzLTAuNy0xLTAuNS0xLjUKCQkJCQljMC4xLTAuMiwwLjMtMC40LDAuNS0wLjVWNS44YzAtMC4zLDAuMi0wLjUsMC41LTAuNmMwLjMsMCwwLjUsMC4yLDAuNiwwLjVjMCwwLDAsMCwwLDBMNy4xLDguNHogTTEyLjUsNC44CgkJCQkJYzAuMy0wLjUsMC4yLTEuMi0wLjEtMS43Yy0wLjUtMC41LTEuMy0wLjYtMi0wLjJDMTEuMiwzLjUsMTEuOSw0LjEsMTIuNSw0LjggTTAuNyw0LjhDMC40LDQuMywwLjUsMy42LDAuOCwzLjEKCQkJCQljMC41LTAuNSwxLjMtMC42LDItMC4yQzIsMy41LDEuMyw0LjEsMC43LDQuOCBNMTAuNSw1LjVjLTIuMi0yLjItNS43LTIuMi03LjgsMHMtMi4yLDUuNywwLDcuOHM1LjcsMi4yLDcuOCwwCgkJCQkJYzEtMSwxLjYtMi41LDEuNi0zLjlDMTIuMiw3LjksMTEuNiw2LjUsMTAuNSw1LjUiLz4KCQkJPC9nPgoJCTwvZz4KCTwvZz4KPC9nPgo8L3N2Zz4K"
export const SendExecutionReportIcon = "data:image/svg+xml;base64,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"

export const SatisfiedEmoji = "data:image/svg+xml;base64,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"
export const UnSatisfiedEmoji = "data:image/svg+xml;base64,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"

export const ApptriggerIconNew= 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI3LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAyNCAyNCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjQgMjQ7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojQzdFM0ZGO30KCS5zdDF7ZmlsbDojMzY3QUYyO30KPC9zdHlsZT4KPGNpcmNsZSBjbGFzcz0ic3QwIiBjeD0iMTIiIGN5PSIxMiIgcj0iMTIiLz4KPGcgaWQ9Ikdyb3VwXzU3NTIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC02LjkzMSAtMC4wMjYpIj4KCTxnIGlkPSJHcm91cF81NzUwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMS4zOSAwLjA3NSkiPgoJCTxwYXRoIGlkPSJQYXRoXzM4MTYiIGNsYXNzPSJzdDEiIGQ9Ik02LDIwLjZjLTAuMSwwLTAuMi0wLjEtMC4zLTAuMWMtMC4zLTAuMi0wLjQtMC41LTAuMi0wLjdsMCwwbDUuNi04LjNIOC45CgkJCWMtMC4zLDAtMC42LTAuMS0wLjctMC40QzgsMTAuOSw3LjksMTAuNSw4LDEwLjJ2LTAuMWwxLjgtNi40YzAuMS0wLjIsMC40LTAuNCwwLjctMC40YzAuMiwwLjEsMC40LDAuNCwwLjQsMC43TDksMTAuM2gyLjUKCQkJYzAuMiwwLDAuNywwLDAuOCwwLjRjMC4xLDAuMiwwLjEsMC42LTAuMSwwLjhsLTUuOCw4LjhDNi4zLDIwLjUsNi4xLDIwLjUsNiwyMC42eiIvPgoJPC9nPgoJPGcgaWQ9Ikdyb3VwXzU3NTEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDYuOTMxIDAuMDI2KSI+CgkJPHBhdGggaWQ9IlBhdGhfMzgxNyIgY2xhc3M9InN0MSIgZD0iTTEwLjQsMjAuNmgtMC4xYy0wLjMtMC4xLTAuNS0wLjQtMC40LTAuN2wxLTUuOEg4Yy0wLjQsMC0wLjctMC4yLTAuOC0wLjUKCQkJYy0wLjItMC4zLTAuMS0wLjcsMC4yLTAuOWw2LjgtOS4yYzAuMi0wLjIsMC41LTAuMiwwLjctMC4xYzAuMiwwLjIsMC4yLDAuNSwwLjEsMC43bC02LjYsOC45aDIuNGMwLjMsMCwwLjcsMC4xLDAuOCwwLjMKCQkJYzAuMiwwLjIsMC4yLDAuNCwwLjIsMC43bC0xLjEsNi4xQzEwLjksMjAuNCwxMC42LDIwLjYsMTAuNCwyMC42eiIvPgoJPC9nPgo8L2c+Cjwvc3ZnPgo='
export const AppTriggerFilterIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 11.7 13.7"
      xmlSpace="preserve"
    >
      <path
        d="M65 118.7c-.4-.2-.6-.6-.5-1V113c0-.2 0-.4-.1-.5l-3.6-5.7c-.1-.2-.3-.5-.4-.7-.2-.4 0-.9.5-1.1h.1s.1 0 .1-.1h10.2c.1 0 .1.1.2.1.4.2.7.6.5 1-.1.3-.2.5-.4.8l-3.6 5.7c-.1.1-.1.3-.1.5v2.8c0 .5-.2.9-.6 1.3-.5.4-1.1.9-1.6 1.3-.1.1-.3.2-.4.2l-.3.1zm.6-1.5c.1-.1.1-.1.2-.1.3-.2.6-.5.9-.7.2-.1.3-.3.3-.6v-3.1c0-.1 0-.3.1-.4 1.3-2 2.5-4 3.8-6 0-.1.1-.1.1-.2h-9.3c0 .1 0 .1.1.2 1.3 2 2.5 4 3.8 6 .1.2.2.3.2.5v4.2l-.2.2z"
        transform="translate(-60.368 -105)"
      />
    </svg>
)
export const CopyIocn = () => (
    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 16.1 16.1" xmlSpace="preserve">
        <path
            d="M12.6 13H.4c-.2 0-.4-.1-.4-.4V.4C0 .2.2 0 .4 0h12.2c.2 0 .4.2.4.4v12.2c0 .2-.1.4-.4.4zM.9 12.1h11.2V.9H.9v11.2z"
            transform="translate(-.7 -.9) translate(3.724 3.924)"
        />
        <path
            d="M.5 14.1c-.3 0-.5-.2-.5-.5V.5C0 .2.2 0 .5 0h13c.3 0 .5.2.5.5s-.2.5-.4.5H1v12.6c0 .3-.2.5-.5.5z"
            transform="translate(-.7 -.9) translate(.7 .9)"
        />
    </svg>
)

export const FolderIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 28 23"
      xmlSpace="preserve"
    >
      <path
        d="M26.8 22.4H1.3c-.5 0-.9-.4-.9-.9V1.4c0-.5.4-.9.9-.9h7.5c.3 0 .5.1.7.3l2.7 3.3h14.6c.5 0 .9.4.9.9v16.4c0 .6-.4 1-.9 1M2.2 20.6h23.7V6H11.7c-.3 0-.5-.1-.7-.3L8.3 2.4H2.2v18.2z"
        transform="translate(-.262) translate(.262)"
      />
    </svg>
  )
  
  export const ForEachIconNew = () => (
    <svg
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 32 32"
      xmlSpace="preserve"
    >
      <g id="Group_12705" transform="translate(-314 -407)">
        <g id="Group_11624" transform="translate(313.92 406.92)">
          <circle id="Ellipse_700" cx={16.1} cy={16.1} r={16} fill="#e0f6ff" />
        </g>
        <g id="Group_11545" transform="translate(-540.47 -1539.186)">
          <g id="Group_11552" transform="translate(863.413 1960.297)">
            <g id="Group_11548" transform="translate(0 3.778)">
              <g id="Group_11547">
                <g id="Group_11546">
                  <g id="Group_11545-2">
                    <path
                      id="Path_7909"
                      className="forEachIconNew"
                      d="M3.1 6.3c-.1 0-.3-.1-.4-.2L.2 3.6C0 3.4 0 3 .2 2.7L2.7.2c.3-.2.7-.2.9 0 .2.2.2.6 0 .8L1.5 3.2l2.1 2.1c.2.2.2.6 0 .9-.1 0-.3.1-.5.1z"
                    />
                  </g>
                </g>
              </g>
            </g>
            <g id="Group_11551">
              <g id="Group_11549" transform="translate(0 6.297)">
                <path
                  id="Path_7910"
                  className="forEachIconNew"
                  d="M11.3 1.3H.6C.3 1.3 0 1 0 .6S.3 0 .6 0h10.7c.4 0 .7.3.7.6s-.3.7-.7.7z"
                />
              </g>
              <g id="Group_11550" transform="translate(10.705)">
                <path
                  id="Path_7911"
                  className="forEachIconNew"
                  d="M.6 7.6c-.3 0-.6-.3-.6-.7s.3-.6.6-.6c1.4 0 2.5-1.1 2.5-2.5V.6c0-.3.3-.6.7-.6s.6.3.6.6v3.1c0 2.2-1.7 3.9-3.8 3.9z"
                />
              </g>
            </g>
          </g>
          <g id="Group_11560" transform="translate(862.414 1954)">
            <g id="Group_11556" transform="translate(11.334)">
              <g id="Group_11555">
                <g id="Group_11554">
                  <g id="Group_11553">
                    <path
                      id="Path_7912"
                      className="forEachIconNew"
                      d="M.6 6.3C.3 6.3 0 6 0 5.7c0-.2.1-.3.2-.4l2.1-2.1L.2 1.1C0 .8 0 .4.2.2c.3-.2.6-.2.9 0l2.5 2.5c.2.2.2.6 0 .9L1.1 6.1c-.1.1-.3.2-.5.2z"
                    />
                  </g>
                </g>
              </g>
            </g>
            <g id="Group_11559" transform="translate(0 2.519)">
              <g id="Group_11557" transform="translate(3.148)">
                <path
                  id="Path_7913"
                  className="forEachIconNew"
                  d="M11.3 1.3H.6C.3 1.3 0 1 0 .6S.3 0 .6 0h10.7c.4 0 .7.3.7.6s-.3.7-.7.7z"
                />
              </g>
              <g id="Group_11558">
                <path
                  id="Path_7914"
                  className="forEachIconNew"
                  d="M.6 7.6c-.3 0-.6-.3-.6-.7V3.8C0 1.7 1.7 0 3.8 0c.3 0 .6.3.6.6s-.3.7-.6.7c-1.4 0-2.5 1.1-2.5 2.5v3.1c0 .4-.3.7-.7.7z"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
  export const AppTriggerCardIcon = () => (
    <svg
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 24 24"
      xmlSpace="preserve"
    >
      {/* <style>{".appTriggerCardIcon{fill:##367AF2}"}</style> */}
      <g id="Group_5752" transform="translate(-6.931 -.026)">
        <g id="Group_5750" transform="translate(11.39 .075)">
          <path
            id="Path_3816"
            className="appTriggerCardIcon"
            d="M0 23.7c-.2 0-.3-.1-.4-.2-.4-.2-.5-.7-.3-1l7.6-11.3H4.1c-.4 0-.8-.2-1-.5-.4-.2-.4-.7-.4-1.1v-.1L5.1.8c.2-.4.5-.6.9-.6.3.2.6.5.5.9L4.1 9.7h3.5c.3 0 .9 0 1.1.5.2.3.1.8-.2 1.1l-7.9 12c-.2.3-.4.4-.6.4z"
          />
        </g>
        <g id="Group_5751" transform="translate(6.931 .026)">
          <path
            id="Path_3817"
            className="appTriggerCardIcon"
            d="M4.4 23.8h-.1c-.4-.1-.7-.5-.6-.9L5.1 15H1.2c-.5 0-.9-.2-1.1-.7-.2-.4-.1-.9.3-1.3L9.7.5c.2-.3.7-.3 1-.2.3.3.3.7.2 1l-9 12.1h3.3c.4 0 .9.2 1.2.4.2.2.3.6.3 1l-1.5 8.3c-.1.4-.4.7-.8.7z"
          />
        </g>
      </g>
    </svg>
  )


  export const WebhookCardIcon = () => (
    <svg
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 24 24"
      xmlSpace="preserve"
    >
      {/* <style>{".webhookCardIcon{fill:#355d8b}"}</style> */}
      <g id="Group_5772" transform="translate(-587.94 -593.72)">
        <path
          id="Path_3825"
          className="webhookCardIcon"
          d="M606.3 605.6c-.7 0-1.4.2-2.1.4l-2.1-3.6c1-1 1.1-2.7.1-3.8-1-1-2.7-1.1-3.8-.1-1 1-1.1 2.7-.1 3.8.6.7 1.5.9 2.5.8l2.5 4.2c.2.3.7.4 1 .3 2-1.1 4.4-.4 5.5 1.5 1.1 2 .4 4.4-1.5 5.5-1.5.8-3.4.7-4.8-.5-.3-.3-.8-.3-1 .1-.3.3-.3.8.1 1 2.3 2 5.8 1.9 7.8-.4s1.9-5.8-.4-7.8c-1-.9-2.4-1.4-3.7-1.4z"
        />
        <path
          id="Path_3826"
          className="webhookCardIcon"
          d="M592.4 608.6c-1.3.8-1.7 2.4-.9 3.7.3.6.9 1.1 1.6 1.3.3.1.4.1.7.1 1.4 0 2.7-1.2 2.7-2.7 0-.7-.3-1.3-.7-1.8l2.4-4.3c.2-.3.1-.8-.3-1-2-1.1-2.6-3.6-1.4-5.5 1.2-2 3.6-2.6 5.5-1.4 1.5.8 2.3 2.6 2 4.3-.1.4.2.8.6.8.4.1.8-.2.8-.6.6-3-1.3-5.9-4.3-6.5-3-.6-5.9 1.3-6.5 4.3-.4 2 .3 4.2 2 5.5l-2 3.7c-.8-.3-1.6-.2-2.2.1z"
        />
        <path
          id="Path_3827"
          className="webhookCardIcon"
          d="M603.3 611.9c.3 1.4 1.8 2.3 3.2 2 1.4-.3 2.3-1.8 2-3.2-.3-1.4-1.8-2.3-3.2-2-.7.2-1.3.6-1.6 1.2-.1.2-.2.3-.3.5h-4.9c-.4 0-.8.3-.8.8-.1 2.2-1.9 4-4.2 4-2.2-.1-4-1.9-4-4.2 0-1.8 1.2-3.2 2.9-3.8.4-.1.6-.5.5-.9-.1-.4-.5-.6-.9-.5-2.9.9-4.6 4-3.7 7 .9 3 4 4.6 7 3.7 2-.6 3.5-2.4 3.8-4.4l4.2-.2z"
        />
      </g>
    </svg>
  )

  export const TimerCardIcon = () => (
    <svg
      id="timer"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 24 24"
      xmlSpace="preserve"
    >
      {/* <style>{".timerCardIcon{fill:#355d8b}"}</style> */}
      <g id="Group_6207">
        <g id="Group_6205">
          <g id="Group_6202">
            <path
              id="Path_3249"
              className="timerCardIcon"
              d="M12 23.8c6.6 0 11.7-5.3 11.8-11.8 0-.4-.4-.7-.8-.7s-.7.4-.7.7c0 5.7-4.6 10.3-10.3 10.3S1.8 17.7 1.8 11.9 6.3 1.6 12 1.6c4 0 7.5 2.2 9.2 5.8.2.4.6.5.9.4.4-.2.5-.6.4-.9-2.8-5.8-9.8-8.3-15.7-5.5s-8.3 9.8-5.5 15.7c2.1 4.1 6.2 6.7 10.7 6.7z"
            />
          </g>
          <g id="Group_6203" transform="translate(9.427 3.771)">
            <path
              id="Path_3250"
              className="timerCardIcon"
              d="M2.5 9.7c-.3 0-.7-.3-.7-.7V1.6c0-.4.4-.7.7-.7.5 0 .8.4.8.7V9c.1.4-.3.7-.8.7z"
            />
          </g>
          <g id="Group_6204" transform="translate(9.427 10.055)">
            <path
              id="Path_3251"
              className="timerCardIcon"
              d="M7 3.5H2.5c-.4 0-.7-.4-.7-.8s.4-.7.7-.7H7c.4 0 .7.4.7.7 0 .4-.4.8-.7.8z"
            />
          </g>
        </g>
        <g id="Group_6206" transform="translate(14.454 1.257)">
          <path
            id="Path_3252"
            className="timerCardIcon"
            d="M3.4 7.1h4.4c.4 0 .7-.4.7-.8V1.2c0-.4-.4-.7-.7-.7-.4 0-.7.4-.7.7v4.4H3.4c-.4 0-.7.4-.7.7 0 .5.3.8.7.8z"
          />
        </g>
      </g>
      <g id="Group_6208" transform="translate(8.362 10.064)">
        <ellipse
          id="Ellipse_243"
          className="timerCardIcon"
          cx={3.6}
          cy={2.7}
          rx={1.9}
          ry={1.8}
        />
      </g>
    </svg>
  )

  export const AppTriggerCardIconNew = () => (
    <svg
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 16 24"
      xmlSpace="preserve"
    >
      {/* <style>{".appTriggerCardIconNew{fill:#355d8b}"}</style> */}
      <g id="Group_5752" transform="translate(-6.931 -.026)">
        <g id="Group_5750" transform="translate(11.39 .075)">
          <path
            id="Path_3816"
            className="appTriggerCardIconNew"
            d="M1.4 23.9c-.2 0-.3-.1-.4-.2-.4-.3-.5-.7-.3-1l7.7-11.5H5.5c-.4 0-.8-.2-1-.5-.4-.3-.5-.8-.4-1.2v-.1L6.5.5c.2-.3.6-.5 1-.4.3.1.6.5.5.9L5.6 9.7h3.5c.3 0 .9 0 1.1.5.2.3.1.8-.2 1.1L2 23.5c-.2.2-.5.3-.6.4z"
          />
        </g>
        <g id="Group_5751" transform="translate(6.931 .026)">
          <path
            id="Path_3817"
            className="appTriggerCardIconNew"
            d="M5.8 23.9h-.2c-.4-.1-.7-.5-.6-.9l1.4-8H2.5c-.5 0-.9-.3-1.1-.7-.3-.4-.2-.9.3-1.3L11.2.3c.3-.3.7-.3 1-.2.3.3.3.7.2 1L3.2 13.5h3.3c.4 0 .9.2 1.2.4.3.2.3.6.3 1l-1.5 8.4c0 .4-.4.6-.7.6z"
          />
        </g>
      </g>
    </svg>
  )

  export const FcrIcon = () => (
    <svg
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 22.8 20.1"
      xmlSpace="preserve"
    >
      <style />
      <g id="Group_14350" transform="translate(-1343.539 -224.131)">
        <g id="Group_14346" transform="translate(1343.539 224.131)">
          <g id="Group_14349">
            <path
              id="Path_10570"
              d="M4 15.2c-.4-.1-.7-.1-1-.2-1.5-.4-2.5-1.8-2.5-3.3V3.9C.5 2.1 1.9.5 3.8.5h15c1.8 0 3.4 1.4 3.4 3.3v8c0 1.8-1.4 3.4-3.3 3.4H10c-.5 0-.9.2-1.3.5l-3.6 3.6c-.2.2-.6.3-.9.3-.2 0-.3-.5-.3-.8.1-1.1.1-2.3.1-3.6"
              fill="#73a4db"
            />
          </g>
        </g>
        <g transform="translate(1349.982 228.155)" id="Group_14348">
          <defs>
            <path id="SVGID_1_" d="M0.2 0.3H10.1V6.8H0.2z" />
          </defs>
          <clipPath id="SVGID_00000022528551333644481190000016880573709068890281_">
            <use xlinkHref="#SVGID_1_" overflow="visible" />
          </clipPath>
          <g
            id="Group_14347"
            clipPath="url(#SVGID_00000022528551333644481190000016880573709068890281_)"
          >
            <path
              id="Path_10572"
              d="M4.1 6.8c-.1 0-.2 0-.3-.1L.4 3.8c-.2-.2-.3-.5-.1-.7.2-.3.6-.3.8-.1L4 5.5 9.1.4c.2-.2.5-.2.7 0 .2.2.2.5 0 .7L4.5 6.6c-.1.1-.3.1-.4.2"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  )

  export const QueriesIcon = () => (
    <svg
      id="Group_14345"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 24.5 21.6"
      xmlSpace="preserve"
    >
      <style>{".queriesIcon{fill:#73a4db}"}</style>
      <g id="Group_14344">
        <path
          id="Path_10570"
          className="queriesIcon"
          d="M3 18c-.3-.1-.5-.1-.7-.2-1.1-.3-1.9-1.3-1.9-2.5V9.6C.4 8.2 1.5 7.1 2.8 7h11.1c1.4 0 2.5 1.1 2.5 2.4v6c0 1.4-1.1 2.5-2.4 2.5H7.5c-.4 0-.7.2-.9.4-.9.9-1.7 1.9-2.6 2.7-.2.2-.4.3-.7.2-.1 0-.2-.4-.3-.6V18m5.6-9.3c-1.2 0-2.2.7-2.5 1.8-.1.4 0 .8.4.9s.7-.1.8-.5c.1-.2.2-.5.3-.7.4-.4 1.1-.5 1.6-.1.4.4.4.9-.1 1.4-.3.2-.6.5-.9.9-.2.4-.4.9-.5 1.3 0 .2.3.5.5.5s.4-.1.6-.3c.2-.9.9-1.4 1.5-2 .7-.6.8-1.7.2-2.4l-.3-.3c-.5-.1-1.1-.3-1.6-.5m-.2 7.5c.4 0 .7-.2.7-.6v-.1c0-.4-.2-.7-.6-.7h-.1c-.4-.1-.7.2-.8.5v.1c0 .4.2.7.6.8h.2"
        />
        <path
          id="Path_10571"
          className="queriesIcon"
          d="M21.5 11.3V14c0 .2-.1.5-.3.6-.1.1-.4-.1-.6-.3l-3-3c-.2-.2-.5-.5-.2-.8.3-.3.6-.1.8.2.8.7 1.6 1.5 2.4 2.2v-1.8c0-.5.2-.7.7-.7 1.3 0 1.9-.6 1.9-1.9V3.2c.1-.9-.6-1.7-1.5-1.9h-11c-.9-.2-1.7.5-1.8 1.4v3c0 .2-.3.6-.4.6-.4.1-.5-.3-.5-.6V2.9C8 1.5 9.1.4 10.4.4h11c1.4-.1 2.5 1 2.6 2.4v5.5c.1 1.8-.6 2.6-2.5 3"
        />
      </g>
    </svg>
  )

  export const GroupPersonIcon = () => (
    <svg
      id="Group_14343"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 32.1 19.8"
      xmlSpace="preserve"
    >
      <style>{".groupPersonIcon{fill:#73a4db}"}</style>
      <g id="Group_14342">
        <path
          id="Path_10564"
          className="groupPersonIcon"
          d="M16.1 10.9c.4-.6.7-1.1 1-1.5.3-.5.9-.8 1.4-.5l3 .9c.9.3 1 1.1 1 1.8.2 1.5.3 3.1.5 4.6.2.7-.3 1.4-1 1.6h-.1c-1.9.5-3.8 1.1-5.7 1.6-.3.1-.6 0-.8 0-1.8-.5-3.6-1-5.3-1.5-.7-.1-1.2-.8-1.1-1.5v-.2c.2-1.5.4-3 .5-4.5.1-1.2.3-1.6 1.5-1.9.9-.2 1.8-.5 2.6-.8.5-.2 1.1 0 1.4.5.4.2.7.7 1.1 1.4"
        />
        <path
          id="Path_10565"
          className="groupPersonIcon"
          d="M6.3 9.1c.2-.4.4-.7.7-1 .2-.2.6-.5.8-.5 1 .2 2 .6 3.2.9-.5.2-1 .5-1.4.7-.8.5-.8 1.4-.9 2.2-.1 1.2-.3 2.3-.3 3.5 0 .3-.2.4-.5.5-1.1.4-2.4.3-3.5-.2-.9-.3-1.7-.5-2.6-.7-.5-.1-.9-.6-.8-1.1 0-1.4.2-2.8.3-4.2 0-.4.3-.8.7-.9.8-.2 1.7-.5 2.5-.8.4-.2.9 0 1 .4.3.5.5.8.8 1.2"
        />
        <path
          id="Path_10566"
          className="groupPersonIcon"
          d="M25.9 9.1c.3-.4.5-.8.7-1.1.2-.4.7-.6 1.1-.4.8.3 1.6.5 2.4.7.4.1.7.5.7.9.2 1.4.3 2.8.5 4.2.1.5-.3 1-.8 1.1-1.4.4-2.9.9-4.3 1.1-.7 0-1.5-.1-2.2-.3-.1-1.3-.2-2.5-.4-3.8 0-.4-.1-.9-.2-1.3-.3-1-1.1-1.5-2.2-1.7.4-.1.5-.2.7-.3.7-.2 1.3-.4 2-.7.5-.2 1.1 0 1.3.5.2.5.4.8.7 1.1"
        />
        <path
          id="Path_10567"
          className="groupPersonIcon"
          d="M18.9 3.4c-.1 1.4-.7 2.8-1.7 3.8-.5.6-1.5.7-2.1.1l-.2-.2c-.8-1-1.4-2.2-1.5-3.4-.2-1.5.8-2.9 2.3-3.1h.1c1.4-.2 2.6.7 2.9 2.1.1.2.2.5.2.7"
        />
        <path
          id="Path_10568"
          className="groupPersonIcon"
          d="M8.4 3.7c0 1.1-.5 2.1-1.2 2.9-.4.5-1.1.6-1.6.2 0-.1-.1-.1-.2-.2C4.4 5.7 4 4.3 4.2 3c.2-1 1.1-1.7 2.1-1.6 1.1.1 2 .9 2.1 2v.3"
        />
        <path
          id="Path_10569"
          className="groupPersonIcon"
          d="M23.7 3.7c0-.9.5-1.7 1.3-2.1.7-.4 1.6-.3 2.2.3.7.5 1.1 1.5.8 2.4-.2.9-.6 1.7-1.2 2.4-.4.5-1.1.5-1.6.1l-.1-.1c-.9-.9-1.3-1.9-1.4-3"
        />
      </g>
    </svg>
  )
  export const TriangleIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 12 10"
      xmlSpace="preserve"
    >
      <path
        d="M5.1 1.4c.3-.4.9-.6 1.4-.3.1.1.3.2.3.3L11 8.5c.3.5.1 1.1-.3 1.4-.1.1-.3.1-.5.1H1.8c-.6 0-1-.4-1-1 0-.2 0-.4.1-.5l4.2-7.1z"
      />
    </svg>
  )
  export const AvatarBot1 = ()=>(
    <svg
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 49 49"
      xmlSpace="preserve"
    >
      <style>
        {
          ".abo1{fill:#f18185}.abo2{fill:#1c1c2f}.abo3{fill:#fff}.abo4{fill:#f7b2b4}"
        }
      </style>
      <g id="bot_1" transform="translate(-1108.5 -418.5)">
        <g id="Group_12156" transform="translate(108.5 -29.5)">
          <circle
            id="Ellipse_719"
            cx={1024.5}
            cy={472.5}
            r={24}
            fill="#e0efff"
            stroke="#cecece"
          />
        </g>
        <g id="Group_12433" transform="translate(332.979 -45.231)">
          <g id="Group_12398">
            <g id="Group_12397">
              <path
                id="Path_10345"
                className="abo1"
                d="M811.8 483v14.4s-.3 2.4-4 3.2c-3.7.8-6.1 1.4-8.2 1.4s-4.4-.6-8.2-1.4c-3.7-.8-4-3.2-4-3.2V483c0-9.5 6.4-13.4 12.2-13.4 5.7 0 12.2 3.9 12.2 13.4z"
              />
              <path
                id="Path_10346"
                className="abo2"
                d="M799.6 502.4c-2.1-.1-4.3-.5-6.4-1-.6-.1-1.2-.3-1.9-.4-3.9-.9-4.3-3.4-4.3-3.5V483c0-9.5 6.3-13.7 12.6-13.7s12.6 4.2 12.6 13.7v14.5c0 .1-.4 2.6-4.3 3.5l-1.5.3c-2.2.6-4.5 1-6.8 1.1zm-11.8-5c0 .2.5 2.1 3.7 2.8.7.1 1.3.3 1.9.4 2 .6 4.1.9 6.2 1 2.2-.1 4.5-.5 6.6-1.1l1.5-.3c3.2-.7 3.7-2.6 3.7-2.9V483c0-9-5.9-13-11.8-13s-11.8 4-11.8 13v14.4zm24 0z"
              />
            </g>
          </g>
          <g id="Group_12399">
            <path
              id="Path_10347"
              className="abo3"
              d="M803.3 505.5c-2 2-5.2 2.1-7.2.2l-.2-.2c-1.1-.8-2-2-.8-2.4.7-.3.8-2.7.8-4.6 0-1.1-.1-2-.1-2h7.6c-.1 1.3-.1 2.6-.1 3.8.1 1.3.3 2.5.8 2.7 1.2.5.3 1.7-.8 2.5z"
            />
          </g>
          <g id="Group_12400">
            <path
              id="Path_10348"
              className="abo1"
              d="M803.2 500.1c-1.4-1.5-6.3-1.7-7.1-1.7 0-.8-.1-1.6-.1-1.9h.1c2.2 1.4 5 1.4 7.1 0h.1c-.1 1.3-.2 2.5-.1 3.6z"
            />
          </g>
          <g id="Group_12401">
            <path
              id="Path_10349"
              className="abo2"
              d="M799.6 507.4c-1.5-.1-2.8-.7-3.9-1.7-.4-.3-1.6-1.2-1.5-2.2.1-.4.4-.8.8-.9 0 0 .6-.3.5-4.2 0-1.1-.1-2-.1-2 0-.2.1-.4.4-.4h7.6c.2 0 .4.2.4.4-.1 1.3-.1 2.5-.1 3.8.1 2.2.5 2.4.5 2.4.4.1.7.5.8.9.1 1-1.1 1.9-1.5 2.2-1.1 1-2.5 1.6-3.9 1.7zm-3.4-10.6c0 .4.1 1 .1 1.6.1 4-.5 4.7-1 4.9-.3.1-.3.2-.3.3 0 .3.4.9 1.2 1.5 1.8 1.9 4.8 2 6.7.2l.2-.2c.8-.6 1.2-1.2 1.2-1.5 0 0 0-.2-.3-.3-.6-.2-.9-1.2-1-3.1v-3.5h-6.8zm7.1 8.7z"
            />
          </g>
          <g id="Group_12404">
            <g id="Group_12402">
              <path
                id="Path_10350"
                className="abo3"
                d="M790.4 484s-1.7-.4-2.4.8c-.6 2 .5 4.1 2.4 4.7.1 0 .3.1.4.1 3 .6 1.3-5.1-.4-5.6z"
              />
            </g>
            <g id="Group_12403">
              <path
                id="Path_10351"
                className="abo2"
                d="M791.3 490.1h-.5c-1.3-.2-2.4-1.1-3-2.3-.5-1-.6-2.1-.2-3.1.8-1.5 2.7-1 2.8-1 1.4.5 2.7 3.6 2.3 5.3-.1.6-.7 1.1-1.4 1.1zm-1.5-5.8c-.6-.1-1.1.2-1.4.7-.3.8-.2 1.7.2 2.4.4 1 1.4 1.7 2.4 1.9.8.2 1-.2 1.1-.6.4-1.3-.7-4-1.8-4.4h-.5z"
              />
            </g>
          </g>
          <g id="Group_12407">
            <g id="Group_12405">
              <path
                id="Path_10352"
                className="abo2"
                d="M790.5 486.8c-.1 0-.3-.1-.3-.2-.3-.5-.8-.9-1.4-1.1-.2 0-.3-.2-.3-.5 0-.2.2-.3.4-.3.8.2 1.5.8 1.9 1.5.1.2.1.4-.1.5-.1.1-.1.1-.2.1z"
              />
            </g>
            <g id="Group_12406">
              <path
                id="Path_10353"
                className="abo2"
                d="M789 487c-.3-.1-.4-.3-.4-.5.2-.5.5-.9.9-1.2.2-.1.4-.1.5.1.1.2.1.4-.1.5-.3.2-.5.5-.7.8.2.2 0 .3-.2.3z"
              />
            </g>
          </g>
          <g id="Group_12410">
            <g id="Group_12408">
              <path
                id="Path_10354"
                className="abo3"
                d="M808.9 484s1.7-.4 2.4.8c.6 2-.5 4.1-2.4 4.7-.1 0-.3.1-.4.1-3 .6-1.3-5.1.4-5.6z"
              />
            </g>
            <g id="Group_12409">
              <path
                id="Path_10355"
                className="abo2"
                d="M808 490.1c-.7 0-1.3-.5-1.5-1.2-.5-1.7.9-4.8 2.3-5.3.1 0 2-.4 2.8 1 .4 1 .3 2.2-.2 3.1-.6 1.2-1.7 2.1-3 2.3-.1 0-.2.1-.4.1zm1-5.8c-1 .4-2.1 3-1.8 4.4.1.3.3.7 1.1.6 1.1-.2 2-.9 2.4-1.9.4-.7.5-1.6.2-2.4-.4-.9-1.7-.7-1.9-.7z"
              />
            </g>
          </g>
          <g id="Group_12413">
            <g id="Group_12411">
              <path
                id="Path_10356"
                className="abo2"
                d="M808.8 486.8c-.1 0-.1 0-.2-.1-.2-.1-.2-.3-.1-.5.4-.7 1.1-1.2 1.9-1.5.2 0 .4.1.5.3 0 .2-.1.4-.3.5-.6.2-1.1.6-1.4 1.1-.1.1-.3.2-.4.2z"
              />
            </g>
            <g id="Group_12412">
              <path
                id="Path_10357"
                className="abo2"
                d="M810.3 487c-.2 0-.3-.1-.4-.3-.1-.3-.4-.6-.7-.8-.2-.1-.2-.4-.1-.5.1-.2.4-.2.5-.1.4.3.8.7.9 1.2.1.2-.1.4-.3.5h.1z"
              />
            </g>
          </g>
          <g id="Group_12416">
            <g id="Group_12414">
              <path
                id="Path_10358"
                className="abo4"
                d="M804.6 476.1c-1.5 1-3.3 1.3-5 .7-3.1-.9-6.4 2.2-6.8 4.4-.2 1.2-1.1 2.2-2.4 2.6.2-4.3 1.6-8.5 9.2-8.5 1.7-.1 3.4.2 5 .8z"
              />
            </g>
            <g id="Group_12415">
              <path
                id="Path_10359"
                className="abo2"
                d="M790.4 484.1c-.2 0-.4-.2-.4-.4 0-2.2.6-4.3 1.9-6.1 1.5-1.9 4-2.8 7.6-2.8 1.8-.1 3.5.2 5.1.9.1.1.2.2.2.4 0 .1-.1.3-.2.4-1.5 1-3.5 1.3-5.3.7-1.2-.3-2.6-.1-3.6.6-1.3.8-2.3 2-2.7 3.5-.2 1.4-1.3 2.5-2.6 2.9.1-.1.1-.1 0-.1zm9.2-8.5c-7 0-8.4 3.5-8.7 7.5.8-.4 1.4-1.2 1.5-2.1.5-1.7 1.6-3.1 3.1-4 1.2-.8 2.8-1.1 4.2-.7 1.3.4 2.7.4 4-.2-1.3-.3-2.7-.5-4.1-.5z"
              />
            </g>
          </g>
          <g id="Group_12419">
            <g id="Group_12417">
              <path
                id="Path_10360"
                className="abo4"
                d="M808.8 483.8c-1.4-.1-.3-2.3-2-3.4s-2.2-4.2-2.2-4.2c3.3 1.3 4 4.4 4.2 7.6z"
              />
            </g>
            <g id="Group_12418">
              <path
                id="Path_10361"
                className="abo2"
                d="M808.8 484.2c-1-.1-1.2-.9-1.3-1.6 0-.7-.3-1.4-.9-1.9-1.8-1.2-2.4-4.3-2.4-4.5 0-.2.1-.4.3-.4h.2c3.6 1.6 4.3 4.9 4.4 8 .1.2-.1.3-.3.4 0-.1 0 0 0 0zm-3.7-7.4c.3 1.2.9 2.4 1.9 3.2.8.6 1.2 1.4 1.2 2.4v.2c-.1-2.2-.8-4.5-3.1-5.8z"
              />
            </g>
          </g>
          <g id="Group_12420">
            <path
              id="Path_10362"
              className="abo1"
              d="M810.9 483c-.5.6-1.3.9-2.1.8-1.4-.1-.3-2.3-2-3.4s-2.2-4.2-2.2-4.2c-1.5 1-3.3 1.3-5 .7-3.1-.9-6.4 2.2-6.8 4.4-.2 1.2-1.1 2.2-2.4 2.6-.1 0-.4-.3-.4-.3l.4-9.2 10.7-1.8 6.8 1.7 3 8.7z"
            />
          </g>
          <g id="Group_12423">
            <g id="Group_12421">
              <path
                id="Path_10363"
                className="abo3"
                d="M808.8 486.3c-.1 4-2.1 7.8-5.4 10.1-2.3 1.6-5.3 1.6-7.6 0-3.3-2.3-5.3-6.1-5.4-10.1v-2.6c1.2-.3 2.1-1.3 2.4-2.6.4-2.2 3.7-5.3 6.8-4.4 1.7.6 3.5.3 5-.7 0 0 .5 3.1 2.2 4.2s.5 3.3 2 3.4v2.7z"
              />
            </g>
            <g id="Group_12422">
              <path
                id="Path_10364"
                className="abo2"
                d="M799.6 498c-1.4 0-2.8-.5-4-1.2-3.4-2.4-5.5-6.3-5.6-10.4 0-.9 0-1.7.1-2.6 0-.2.1-.3.3-.3 1.1-.3 1.9-1.2 2.1-2.3.5-1.7 1.6-3.1 3.1-4 1.2-.8 2.8-1.1 4.2-.7 1.5.6 3.3.3 4.6-.6.2-.1.4-.1.5.1 0 .1.1.1.1.2 0 0 .5 2.9 2.1 4 .8.6 1.2 1.4 1.2 2.4.1.8.2.9.5 1 .2 0 .3.2.3.4v2.6c-.1 4.2-2.2 8-5.6 10.4-1.1.6-2.5 1-3.9 1zm-8.8-14v2.3c.1 3.9 2.1 7.5 5.2 9.8 2.2 1.5 5 1.5 7.2 0 3.2-2.3 5.1-5.9 5.2-9.8v-2.2c-.7-.2-.8-1-.9-1.6 0-.7-.3-1.4-.9-1.9-1.4-.9-2-2.9-2.3-3.9-1.5.8-3.2.9-4.8.4-1.2-.3-2.6-.1-3.6.6-1.3.8-2.3 2-2.7 3.5-.3 1.3-1.2 2.4-2.4 2.8zm12.6 12.5z"
              />
            </g>
          </g>
          <g id="Group_12424">
            <path
              id="Path_10365"
              className="abo2"
              d="M796.6 484.4c0 .4-.3.8-.8.8-.4 0-.8-.3-.8-.8 0-.4.3-.8.8-.8.4 0 .8.3.8.8z"
            />
          </g>
          <g id="Group_12425">
            <path
              id="Path_10366"
              className="abo2"
              d="M804.1 484.4c0 .4-.3.8-.8.8-.4 0-.8-.3-.8-.8 0-.4.3-.8.8-.8.4 0 .8.3.8.8z"
            />
          </g>
          <g id="Group_12426">
            <path
              id="Path_10367"
              className="abo2"
              d="M800 489.3c-.3 0-.6 0-.9-.1-.2 0-.4-.2-.3-.4s.2-.4.4-.3c.4.1.8.1 1.2 0 0-.2-.1-.5-.1-.7-.1-.4-.2-1-.3-1.6-.1-1.3 0-2.7.2-4 0-.2.2-.4.4-.3.2 0 .4.2.3.4-.2 1.2-.3 2.5-.2 3.7.1.7.2 1.2.3 1.6.2.8.3 1.4-.3 1.6-.2.1-.4.1-.7.1z"
            />
          </g>
          <g id="Group_12427">
            <path
              id="Path_10368"
              className="abo2"
              d="M796.6 482s-2.2-.5-2.9.3c0 0-.2-1.1 1.1-1.1.7-.1 1.4.2 1.8.8z"
            />
          </g>
          <g id="Group_12428">
            <path
              id="Path_10369"
              className="abo2"
              d="M802.6 482s2.2-.5 2.9.3c0 0 .2-1.1-1.1-1.1-.7-.1-1.4.2-1.8.8z"
            />
          </g>
          <g id="Group_12429">
            <path
              id="Path_10370"
              className="abo2"
              d="M796.6 491.2s3.4-.9 5.7 0c-.6.9-1.7 1.5-2.8 1.5-2 0-2.9-1.1-2.9-1.5z"
            />
          </g>
          <g id="Group_12430">
            <path
              id="Path_10371"
              className="abo1"
              d="M797.8 492.4c.3-.5 1-.7 1.6-.5.3-.2.7-.3 1-.1.5.2.7.5.7.5-1.1.5-2.3.5-3.3.1z"
            />
          </g>
          <g id="Group_12431">
            <path
              id="Path_10372"
              className="abo1"
              d="M795.8 487.3c0 .5-.8.9-1.8.9s-1.8-.4-1.8-.9.8-.9 1.8-.9 1.8.4 1.8.9z"
            />
          </g>
          <g id="Group_12432">
            <path
              id="Path_10373"
              className="abo1"
              d="M807 487.3c0 .5-.8.9-1.8.9s-1.8-.4-1.8-.9.8-.9 1.8-.9 1.8.4 1.8.9z"
            />
          </g>
        </g>
      </g>
    </svg>
  )

  export const AvatarBot2 =()=>(
    <svg
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 49 49"
      xmlSpace="preserve"
    >
      <style>
        {".ava1{fill:#fff}.ava2{fill:#1c1c2f}.ava3{fill:#f18185}"}
        </style>
      <g id="bot_2" transform="translate(-1166.5 -418.5)">
        <g id="Group_12157" transform="translate(166.5 -29.5)">
          <circle
            id="Ellipse_719"
            cx={1024.5}
            cy={472.5}
            r={24}
            fill="#c2c1e6"
            stroke="#cecece"
          />
        </g>
        <g id="Group_12462" transform="translate(234.422 -43.089)">
          <g id="Group_12434">
            <path
              id="Path_10374"
              className="ava1"
              d="M960.4 504.5c-2 2-5.2 2.1-7.2.2l-.2-.2c-1.1-.8-2-2-.8-2.4.7-.3.8-2.7.8-4.6 0-1.1-.1-2-.1-2h7.6c-.1 1.3-.1 2.6-.1 3.8.1 1.3.3 2.5.8 2.7 1.2.6.4 1.7-.8 2.5z"
            />
          </g>
          <g id="Group_12437">
            <g id="Group_12435">
              <path
                id="Path_10375"
                className="ava1"
                d="M947.5 483s-1.7-.4-2.4.8c-.6 2 .5 4.1 2.4 4.7.1 0 .3.1.4.1 3.1.7 1.4-5-.4-5.6z"
              />
            </g>
            <g id="Group_12436">
              <path
                id="Path_10376"
                className="ava2"
                d="M948.4 489.1h-.5c-1.3-.2-2.4-1.1-3-2.3-.5-1-.6-2.1-.2-3.1.8-1.5 2.7-1 2.8-1 1.4.5 2.7 3.6 2.3 5.3 0 .7-.6 1.2-1.4 1.1zm-1.5-5.7c-.6-.1-1.1.2-1.4.7-.3.8-.2 1.7.2 2.4.4 1 1.4 1.7 2.4 1.9.8.2 1-.2 1.1-.6.4-1.3-.7-4-1.8-4.4h-.5z"
              />
            </g>
          </g>
          <g id="Group_12440">
            <g id="Group_12438">
              <path
                id="Path_10377"
                className="ava2"
                d="M947.6 485.9c-.1 0-.3-.1-.3-.2-.3-.5-.8-.9-1.4-1.1-.2 0-.4-.2-.3-.4 0-.2.2-.3.4-.3.8.2 1.5.8 1.9 1.5.1.2.1.4-.1.5h-.2z"
              />
            </g>
            <g id="Group_12439">
              <path
                id="Path_10378"
                className="ava2"
                d="M946.2 486.1s-.1 0 0 0c-.3-.1-.4-.3-.4-.5.2-.5.5-.9.9-1.2.2-.1.4-.1.5.1.1.2.1.4-.1.5-.3.2-.5.5-.7.8.1.2 0 .3-.2.3z"
              />
            </g>
          </g>
          <g id="Group_12443">
            <g id="Group_12441">
              <path
                id="Path_10379"
                className="ava1"
                d="M966.1 483s1.7-.4 2.4.8c.6 2-.5 4.1-2.4 4.7-.1 0-.3.1-.4.1-3.1.7-1.4-5 .4-5.6z"
              />
            </g>
            <g id="Group_12442">
              <path
                id="Path_10380"
                className="ava2"
                d="M965.1 489.1c-.7 0-1.3-.5-1.5-1.2-.5-1.7.9-4.8 2.3-5.3.1 0 2-.4 2.8 1 .4 1 .3 2.2-.2 3.1-.6 1.2-1.7 2.1-3 2.3 0 .1-.2.1-.4.1zm1.1-5.7c-1 .4-2.1 3-1.8 4.4.1.3.3.7 1.1.6 1.1-.2 2-.9 2.4-1.9.4-.7.5-1.6.2-2.4-.5-1-1.8-.7-1.9-.7z"
              />
            </g>
          </g>
          <g id="Group_12446">
            <g id="Group_12444">
              <path
                id="Path_10381"
                className="ava2"
                d="M965.9 485.9c-.2 0-.4-.2-.4-.4 0-.1 0-.1.1-.2.4-.7 1.1-1.2 1.9-1.5.2 0 .4.1.4.3 0 .2-.1.4-.3.4-.6.2-1.1.6-1.4 1.1 0 .2-.1.3-.3.3z"
              />
            </g>
            <g id="Group_12445">
              <path
                id="Path_10382"
                className="ava2"
                d="M967.4 486.1c-.2 0-.3-.1-.4-.3-.1-.3-.4-.6-.7-.8-.2-.1-.2-.4-.1-.5s.4-.2.5-.1c.4.3.8.7.9 1.2.1.2-.1.4-.3.5h.1z"
              />
            </g>
          </g>
          <g id="Group_12447">
            <path
              id="Path_10383"
              className="ava3"
              d="M960.3 499.2c-1.4-1.5-6.3-1.2-7.1-1.2v-.5c0-.8-.1-1.6-.1-1.9h.1c2.2 1.4 5 1.4 7.1 0h.1c-.1 1.3-.1 2.4-.1 3.6z"
            />
          </g>
          <g id="Group_12450">
            <g id="Group_12448">
              <path
                id="Path_10384"
                className="ava1"
                d="M966 485.4c-.1 4-2.1 7.8-5.4 10.1-2.3 1.6-5.3 1.6-7.6 0-3.3-2.3-5.3-6.1-5.4-10.1v-2.6c.2-4.3 1.6-9.8 9.2-9.8 9.2 0 9 6.6 9.2 9.8v2.6z"
              />
            </g>
            <g id="Group_12449">
              <path
                id="Path_10385"
                className="ava2"
                d="M956.7 497.1c-1.4 0-2.8-.5-4-1.2-3.4-2.4-5.5-6.3-5.6-10.4 0-.9 0-1.7.1-2.6.1-2.5.6-10.1 9.5-10.1 9.1 0 9.4 6.3 9.5 9.7v3.1c-.1 4.2-2.2 8-5.6 10.4-1 .7-2.4 1.1-3.9 1.1zm0-23.7c-7.4 0-8.6 5.4-8.8 9.4v2.6c.1 3.9 2.1 7.5 5.2 9.8 2.2 1.5 5 1.5 7.2 0 3.2-2.3 5.1-5.9 5.2-9.8v-3c-.1-3.4-.4-9-8.8-9z"
              />
            </g>
          </g>
          <g id="Group_12451">
            <path
              id="Path_10386"
              className="ava2"
              d="M953.7 483.4c0 .4-.3.8-.8.8-.4 0-.8-.3-.8-.8 0-.4.3-.8.8-.8s.8.4.8.8z"
            />
          </g>
          <g id="Group_12452">
            <path
              id="Path_10387"
              className="ava2"
              d="M961.2 483.4c0 .4-.3.8-.8.8-.4 0-.8-.3-.8-.8 0-.4.3-.8.8-.8s.8.4.8.8z"
            />
          </g>
          <g id="Group_12453">
            <path
              id="Path_10388"
              className="ava2"
              d="M957.2 488.4c-.3 0-.6 0-.9-.1-.2 0-.4-.2-.3-.4 0-.2.2-.3.4-.3.4.1.8.1 1.2 0 0-.2-.1-.5-.1-.7-.1-.4-.2-1-.3-1.6-.1-1.3 0-2.7.2-4 0-.2.2-.4.4-.3.2 0 .4.2.3.4-.2 1.2-.3 2.5-.2 3.7.1.7.2 1.2.3 1.6.2.8.3 1.4-.3 1.6-.3.1-.5.1-.7.1z"
            />
          </g>
          <g id="Group_12454">
            <path
              id="Path_10389"
              className="ava2"
              d="M953.7 481s-2.2-.5-2.9.3c0 0-.2-1.1 1.1-1.1.7 0 1.4.3 1.8.8z"
            />
          </g>
          <g id="Group_12455">
            <path
              id="Path_10390"
              className="ava2"
              d="M959.8 481s2.2-.5 2.9.3c0 0 .2-1.1-1.1-1.1-.8 0-1.4.3-1.8.8z"
            />
          </g>
          <g id="Group_12456">
            <path
              id="Path_10391"
              className="ava2"
              d="M953.7 490.2s3.4-.9 5.7 0c-.6.9-1.7 1.5-2.8 1.5-2 .1-2.8-1.1-2.9-1.5z"
            />
          </g>
          <g id="Group_12457">
            <path
              id="Path_10392"
              className="ava3"
              d="M954.9 491.5c.3-.5 1-.7 1.6-.5.3-.2.7-.3 1-.1.5.2.7.5.7.5-1 .5-2.2.5-3.3.1z"
            />
          </g>
          <g id="Group_12458">
            <path
              id="Path_10393"
              className="ava2"
              d="M947.8 484.7s.1 5.1 2.4 5.1c.7 0 5.3-2.3 7-1.1 1-.6 2.3-.6 3.3 0 1.8.9 2.6 1.4 3.5 1.1 1.4-.5 1.9-3 2-7 0 0 1.6 14.6-9.2 14.6s-9.4-12.7-9.4-14 .4 1.3.4 1.3z"
            />
            <path
              id="Path_10394"
              className="ava2"
              d="M956.7 497.8c-2.5.1-4.9-.8-6.7-2.5-3.3-3.4-3.2-9.3-3.1-11.3v-.6c0-.3 0-.7.4-.8s.5.1.9 2v.1c0 1.2.5 4.8 2 4.8.4-.1.8-.2 1.2-.4 1.7-.6 4.3-1.5 5.8-.8 1.1-.5 2.4-.5 3.5.1l.1.1c1.6.8 2.4 1.2 3.1 1 1.4-.5 1.6-4 1.7-6.6 0-.2.2-.4.4-.4s.4.1.4.3c0 .3.8 8-3 12.3-1.8 1.9-4.2 2.8-6.7 2.7zm-8.9-10.3c.2 2.4.9 5.3 2.8 7.3 1.6 1.6 3.9 2.4 6.2 2.3 2.3.1 4.4-.8 6-2.5 1.3-1.5 2.1-3.3 2.4-5.3-.2.4-.6.7-1.1.9-1 .3-1.9-.1-3.7-1l-.1-.1c-.9-.5-2-.5-3 0-.1.1-.3.1-.4 0-1.1-.8-3.8.2-5.3.7-.5.2-.9.3-1.4.4-1.4 0-2.1-1.3-2.4-2.7z"
            />
          </g>
          <g id="Group_12459">
            <path
              id="Path_10395"
              className="ava1"
              d="M956.7 491.7c-.9 0-1.7-.2-2.5-.5-.2-.1-.3-.3-.2-.5.1-.2.3-.3.5-.2 0 0 2.3 1 3.8 0 .2-.1.4-.1.5.1.1.2.1.4-.1.5-.6.4-1.3.6-2 .6z"
            />
          </g>
          <g id="Group_12460">
            <path
              id="Path_10396"
              className="ava2"
              d="M947.3 483.4c.7-1.6 1.1-3.4 1.1-5.1 0 0 9.2.4 15.9-1.8.4 2.2.9 4.5 1.6 6.6 0 0 2.8-8.6 1.7-11.5-1.1-2.9-5.7-4.8-7.8-3.8s-9.2 3.7-10.9 4.3-4.9 3.6-1.6 11.3z"
            />
            <path
              id="Path_10397"
              className="ava2"
              d="M947.3 483.8c-.2 0-.3-.1-.4-.2-2-4.6-1.5-7.5-.8-9.2.5-1.3 1.4-2.3 2.7-2.8 1.6-.6 8.7-3.4 10.8-4.3 1.4-.4 3-.3 4.4.4 1.8.7 3.2 2 4 3.7 1.1 3.1-1.6 11.4-1.7 11.8 0 .2-.2.3-.3.3-.2 0-.3-.1-.4-.2-.7-2.1-1.2-4.1-1.5-6.3-5.9 1.8-13.5 1.8-15.3 1.7 0 1.7-.4 3.4-1.1 4.9-.1.1-.3.2-.4.2zm13.8-15.9c-.4 0-.8.1-1.2.2-2.1.9-9.3 3.7-10.9 4.3-1 .5-1.8 1.3-2.2 2.4-.6 1.4-1 3.8.5 7.7.5-1.3.7-2.7.7-4.1 0-.1 0-.2.1-.3.1-.1.2-.1.3-.1.1 0 9.2.4 15.8-1.8h.3c.1.1.2.2.2.3 0 0 .6 3.4 1.2 5.4.7-2.4 2.1-8 1.3-10.1-.7-1.5-2-2.7-3.5-3.2-.8-.5-1.7-.7-2.6-.7z"
            />
          </g>
          <g id="Group_12461">
            <path
              id="Path_10398"
              className="ava2"
              d="M956.7 506.5c-1.5-.1-2.8-.7-3.9-1.7-.4-.3-1.6-1.2-1.5-2.2.1-.4.4-.8.8-.9 0 0 .6-.3.5-4.2 0-1.1-.1-2-.1-2 0-.2.1-.4.4-.4h7.6c.2 0 .4.2.4.4-.1 1.3-.1 2.5-.1 3.8.1 2.2.5 2.4.5 2.4.4.1.7.5.8.9.1 1-1.1 1.9-1.5 2.2-1 1-2.4 1.6-3.9 1.7zm-3.4-10.6c0 .4.1 1 .1 1.6.1 4-.5 4.7-1 4.9-.3.1-.3.2-.3.3 0 .3.4.9 1.2 1.5 1.8 1.9 4.8 2 6.7.2.1-.1.2-.1.2-.2.8-.6 1.2-1.2 1.2-1.5 0 0 0-.2-.3-.3-.6-.2-.9-1.2-1-3.1v-3.5l-6.8.1zm7.1 8.6z"
            />
          </g>
        </g>
      </g>
    </svg>
  )

  export const AvatarBot3 =()=>(
    <svg
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 49 49"
      xmlSpace="preserve"
    >
      <style>
        {".av2{fill:#1c1c2f}.av3{fill:#fff}"}
        </style>
      <g id="bot_3" transform="translate(-1115.5 -502.5)">
        <g id="Group_12158" transform="translate(115.5 54.5)">
          <circle
            id="Ellipse_719"
            cx={1024.5}
            cy={472.5}
            r={24}
            fill="#ffd7c4"
            stroke="#cecece"
          />
        </g>
        <g id="Group_12490" transform="translate(27.383 40.836)">
          <g id="Group_12465">
            <g id="Group_12463">
              <path
                id="Path_10399"
                d="M1108.6 496.7s-2 .5-2.1-1.1c-1.2.1-2.2-.8-2.3-2v-.3s-3.8-.3-3-3.6c0 0-3.5-.4-1.8-5 0 0-2.3-1.8-1.5-5.6.3-1.4 1.2-2.7 2.5-3.4 0 0-.1-2.8 1.5-3.6 1-.6 2.2-1 3.5-1 .7-1.2 1.9-2.1 3.3-2.4 1.8-.3 3.6.2 5 1.3 1.8-1.2 4.1-1.3 6-.3 1.2.7 2.1 2 2.3 3.4 1.3-.1 2.6.6 3.2 1.7 1.2 2.7 0 3.6 0 3.6s3 1.4 2.4 4.3c-.3 1.6-1.2 3.1-2.5 4.2.8 1.5.1 3.4-1.4 4.1-.3.2-.7.3-1 .3-.1 1.1-1 2-2.1 2.1 0 0 .1 2.8-3.7 2.8 0 0-3.9 4-8.3.5z"
                fill="#f8b45f"
              />
            </g>
            <g id="Group_12464">
              <path
                id="Path_10400"
                className="av2"
                d="M1112.3 498.5c-1.4 0-2.8-.5-3.8-1.4-.6.1-1.2 0-1.8-.3-.3-.2-.5-.5-.6-.9-.6-.1-1.2-.3-1.7-.8-.4-.4-.6-1-.7-1.6-1-.1-2-.6-2.6-1.4-.4-.6-.6-1.4-.5-2.2-.7-.2-1.3-.7-1.7-1.3-.6-1.2-.6-2.6-.1-3.9-1.5-1.6-2-3.8-1.4-5.8.3-1.5 1.2-2.8 2.5-3.5 0-.7.2-2.9 1.8-3.8 1-.6 2.2-.9 3.4-1 .8-1.2 2-2.1 3.5-2.4 1.8-.3 3.6.1 5.1 1.2 1.9-1.2 4.2-1.2 6.2-.2 1.3.7 2.2 1.9 2.5 3.4 1.4 0 2.6.8 3.2 2 .9 2 .6 3.1.2 3.7 1.6.9 2.5 2.7 2.2 4.5-.3 1.6-1.2 3.1-2.4 4.2.3.9.3 2-.1 2.9-.5.9-1.4 1.5-2.4 1.7-.2 1.1-1 1.9-2.1 2.1-.1.7-.4 1.3-.8 1.7-.8.8-1.9 1.2-3.1 1.1-1.3 1.3-3 2-4.8 2zm-3.7-2.2c.1 0 .2 0 .2.1 4.1 3.2 7.6-.4 7.7-.5.1-.1.2-.1.3-.1 1 .1 1.9-.2 2.7-.9.4-.4.6-.9.6-1.5 0-.2.1-.4.3-.4.9 0 1.7-.8 1.7-1.7 0-.2.1-.3.3-.4.9-.1 1.7-.6 2.1-1.4.3-.8.3-1.7 0-2.5-.1-.2 0-.4.1-.5 1.2-1 2-2.4 2.3-3.9.5-2.5-2.1-3.8-2.2-3.8-.2-.1-.3-.3-.2-.5 0-.1.1-.1.1-.1s.9-.8-.1-3.1c-.6-1-1.6-1.6-2.8-1.5-.2 0-.4-.1-.4-.3-.2-1.3-1-2.4-2.1-3.1-1.8-.9-3.9-.8-5.6.3-.2.1-.4.1-.5 0-1.3-1-3-1.5-4.7-1.2-1.3.3-2.4 1.1-3 2.2-.1.1-.2.2-.4.2-1.1 0-2.3.4-3.2.9-1.4.7-1.3 3.2-1.3 3.3 0 .2-.1.3-.2.4-1.2.7-2 1.8-2.3 3.1-.8 3.5 1.2 5.2 1.3 5.3.1.1.2.3.1.5-.5 1.5-.6 2.6-.1 3.4.4.5.9.9 1.6 1 .1 0 .2.1.3.2.1.1.1.2.1.3-.2.6-.1 1.4.3 1.9.6.7 1.5 1.1 2.4 1.1.2 0 .4.2.4.4-.1.5.1 1 .4 1.4.4.4.9.6 1.5.6.2 0 .4.2.4.4s.1.5.3.6c.6-.1 1.1-.1 1.6-.2-.1 0 0 0 0 0z"
              />
            </g>
          </g>
          <g id="Group_12466">
            <path
              id="Path_10401"
              className="av3"
              d="M1116.1 505c-2 2-5.2 2.1-7.2.2l-.2-.2c-1.1-.8-2-2-.8-2.4.7-.3.8-2.7.8-4.6 0-1.1-.1-2-.1-2h7.6c-.1 1.3-.1 2.6-.1 3.8.1 1.3.3 2.5.8 2.7 1.2.5.3 1.7-.8 2.5z"
            />
          </g>
          <g id="Group_12467">
            <path
              id="Path_10402"
              d="M1116.2 496.2c-2.3 1.4-5.2 1.4-7.6 0 0 .3.1 1 .1 1.9 1.1 0 5.9.2 7.4 1.6 0-1.5.1-3.1.1-3.5z"
              fill="#f18185"
            />
          </g>
          <g id="Group_12468">
            <path
              id="Path_10403"
              className="av2"
              d="M1112.4 507c-1.5-.1-2.8-.7-3.9-1.7-.4-.3-1.6-1.2-1.5-2.2.1-.4.4-.8.8-.9.2-.1.6-.9.5-4.2 0-1.1-.1-2-.1-2v-.4h8.5v.4c-.1 1.3-.1 2.5-.1 3.8.1 2.2.5 2.4.5 2.4.4.1.7.5.8.9.1 1-1.1 1.9-1.5 2.2-1.2 1-2.5 1.6-4 1.7zm-3.4-10.6c0 .4.1.9.1 1.6.1 4-.5 4.7-1 4.9-.3.1-.3.2-.3.3 0 .3.4.9 1.2 1.5 1.8 1.9 4.8 2 6.7.2l.2-.2c.8-.6 1.2-1.2 1.2-1.5 0 0 0-.2-.3-.3-.6-.2-.9-1.2-1-3.1v-3.5l-6.8.1z"
            />
          </g>
          <g id="Group_12471">
            <g id="Group_12469">
              <path
                id="Path_10404"
                className="av3"
                d="M1103.7 489.2c-2-.4-3.4-2.4-3-4.4 0-.1.1-.3.1-.4.3-.6 1-.9 1.7-.9.3.9.6 1.9.7 2.9v-.1c0-.3.1-1.4.3-2.6 1.6 1 3 6.1.2 5.5z"
              />
            </g>
            <g id="Group_12470">
              <path
                id="Path_10405"
                className="av2"
                d="M1104.1 489.6h-.5c-1.3-.2-2.4-1.1-3-2.3-.5-1-.6-2.1-.2-3.1.4-.7 1.2-1.1 2-1.1.2 0 .3.1.4.3 0 0 .1.2.2.6v-.3c0-.2.2-.4.5-.3.1 0 .1 0 .2.1 1.3.8 2.5 3.8 1.8 5.4-.2.4-.8.8-1.4.7zm-1.9-5.7c-.4 0-.8.3-1 .7-.3.8-.2 1.7.2 2.4.4 1 1.3 1.7 2.4 1.9.7.1.9-.1 1-.4.4-.9-.2-2.9-1-3.9-.1.8-.2 1.5-.2 1.8v.1c0 .2-.2.4-.4.4s-.4-.2-.4-.4c-.1-1-.3-1.8-.6-2.6z"
              />
            </g>
          </g>
          <g id="Group_12474">
            <g id="Group_12472">
              <path
                id="Path_10406"
                className="av2"
                d="M1103.3 486.4c-.1 0-.3-.1-.3-.2-.3-.5-.8-.9-1.3-1.1-.2 0-.4-.2-.3-.5 0-.2.2-.4.5-.3.8.2 1.5.8 1.9 1.5.1.2.1.4-.1.5-.3.1-.3.1-.4.1z"
              />
            </g>
            <g id="Group_12473">
              <path
                id="Path_10407"
                className="av2"
                d="M1101.8 486.6c-.3-.1-.4-.3-.4-.5.2-.5.5-.9 1-1.2.2-.1.4-.1.6.1.1.2.1.4-.1.6-.3.2-.5.5-.7.8 0 .1-.2.2-.4.2z"
              />
            </g>
          </g>
          <g id="Group_12477">
            <g id="Group_12475">
              <path
                id="Path_10408"
                className="av3"
                d="M1121.2 489.2c-2.7.5-1.5-4.1.1-5.4.1.8.2 1.6.3 2.6l.3-2.9c.8-.2 1.7.2 2.1.9.6 2-.5 4.1-2.4 4.7-.1 0-.3.1-.4.1z"
              />
            </g>
            <g id="Group_12476">
              <path
                id="Path_10409"
                className="av2"
                d="M1120.8 489.6c-.6 0-1.1-.3-1.4-.9-.7-1.4.4-4.3 1.6-5.3.1-.1.3-.1.4-.1 0 0 .1 0 .1.1 0-.2.2-.3.3-.4 1-.2 2 .2 2.5 1.1.4 1 .3 2.2-.2 3.1-.6 1.2-1.7 2.1-3 2.3 0 .1-.1.1-.3.1zm.2-4.9c-.8 1.1-1.2 3-.9 3.8.1.2.3.5 1 .4 1.1-.2 2-.9 2.4-1.9.4-.7.5-1.6.2-2.4-.3-.5-.9-.7-1.4-.7l-.3 2.5c0 .2-.2.4-.4.4s-.4-.2-.4-.4c0-.6-.1-1.2-.2-1.7z"
              />
            </g>
          </g>
          <g id="Group_12480">
            <g id="Group_12478">
              <path
                id="Path_10410"
                className="av2"
                d="M1121.6 486.4c-.1 0-.1 0-.2-.1-.2-.1-.2-.4-.1-.5.4-.7 1.1-1.3 1.9-1.5.2 0 .4.1.5.3 0 .2-.1.4-.3.5-.6.2-1 .6-1.3 1.1-.2.1-.4.2-.5.2z"
              />
            </g>
            <g id="Group_12479">
              <path
                id="Path_10411"
                className="av2"
                d="M1123.1 486.6c-.2 0-.3-.1-.4-.3-.1-.3-.4-.6-.7-.8-.2-.1-.2-.4-.1-.6.1-.2.4-.2.6-.1.4.3.8.7 1 1.2.1.2-.1.4-.3.5l-.1.1z"
              />
            </g>
          </g>
          <g id="Group_12483">
            <g id="Group_12481">
              <path
                id="Path_10412"
                className="av3"
                d="M1121.6 486.3c-.3 3.9-2.2 7.4-5.4 9.7-2.3 1.6-5.3 1.6-7.6 0-3.2-2.3-5.2-5.9-5.4-9.8.1-.9.6-6.3 2.1-6.8 1.6-.6 3.3.9 5.3-.8 1.2-1 2.3-1.7 3-1.1.6.8 1.6 1.2 2.5 1 2.5-.5 4.7-.6 5.5 7.8z"
              />
            </g>
            <g id="Group_12482">
              <path
                id="Path_10413"
                className="av2"
                d="M1112.4 497.6c-1.4 0-2.8-.5-4-1.2-3.3-2.3-5.3-6.1-5.6-10.1v-.1c.5-6 1.9-7 2.4-7.2.7-.2 1.4-.2 2.2-.1 1.1.3 2.2 0 3-.6 1.3-1.1 2.6-1.9 3.5-1.1l.2.2c.5.6 1.2.9 2 .7 1.1-.4 2.4-.2 3.4.4 1.3 1 2.2 3.5 2.5 7.8-.2 4-2.3 7.7-5.6 10-1.2.8-2.6 1.3-4 1.3zm-8.8-11.3c.2 3.8 2.1 7.2 5.2 9.4 2.2 1.5 5 1.5 7.2 0 3-2.2 5-5.6 5.2-9.3-.4-4-1.1-6.3-2.2-7.2-.8-.5-1.9-.6-2.8-.3-1 .2-2-.1-2.7-.9l-.2-.2c-.5-.4-1.6.4-2.5 1.1-1 .8-2.4 1.1-3.6.8-.6-.1-1.2-.1-1.8 0-.9.4-1.6 3.7-1.8 6.6z"
              />
            </g>
          </g>
          <g id="Group_12484">
            <path
              id="Path_10414"
              className="av2"
              d="M1109.4 483.9c0 .4-.3.8-.8.8-.4 0-.8-.3-.8-.8 0-.4.3-.5.8-.5s.8.1.8.5z"
            />
          </g>
          <g id="Group_12485">
            <path
              id="Path_10415"
              className="av2"
              d="M1116.9 483.9c0 .4-.3.8-.8.8s-.8-.3-.8-.8c0-.4.3-.5.8-.5s.8.1.8.5z"
            />
          </g>
          <g id="Group_12486">
            <path
              id="Path_10416"
              className="av2"
              d="M1112.8 488.9c-.3 0-.6 0-.9-.1-.2 0-.4-.2-.3-.5s.2-.4.5-.3c.4.1.8.1 1.2 0 0-.2-.1-.5-.1-.7-.1-.4-.2-1-.3-1.6-.1-1.3 0-2.7.2-4 0-.2.2-.4.5-.3.2 0 .4.2.3.5-.2 1.2-.3 2.5-.2 3.7.1.7.2 1.2.3 1.6.2.7.3 1.4-.3 1.6-.4.1-.6.1-.9.1z"
            />
          </g>
          <g id="Group_12487">
            <path
              id="Path_10417"
              className="av2"
              d="M1109.4 481.5s-2.2-.5-2.9.3c0 0-.2-1.1 1.1-1.1.7-.1 1.4.2 1.8.8z"
            />
          </g>
          <g id="Group_12488">
            <path
              id="Path_10418"
              className="av2"
              d="M1115.4 481.5s2.2-.5 2.9.3c0 0 .2-1.1-1.1-1.1-.7-.1-1.4.3-1.8.8z"
            />
          </g>
          <g id="Group_12489">
            <path
              id="Path_10419"
              className="av2"
              d="M1112.1 491.9c-.7.1-1.3-.2-1.8-.7-.1-.2-.1-.4.1-.6.2-.1.4-.1.6.1.6.8 2.7.2 3.4-.1.2-.1.4 0 .5.2.1.2 0 .4-.2.5-.8.4-1.7.6-2.6.6z"
            />
          </g>
        </g>
      </g>
    </svg>
  )

  export const AvatarBot4 =()=>(
    <svg
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 49 49"
      xmlSpace="preserve"
    >
      <style>
        {".ab1{fill:#1c1c2f}.ab2{fill:#fff}.ab3{fill:#f18185}"}
        </style>
      <g id="bot_4" transform="translate(-1282.5 -418.5)">
        <g id="Group_12159" transform="translate(282.5 -29.5)">
          <circle
            id="Ellipse_719"
            cx={1024.5}
            cy={472.5}
            r={24}
            fill="#ffe1eb"
            stroke="#cecece"
          />
        </g>
        <g id="Group_12549" transform="translate(197.252 -193.171)">
          <g id="Group_12547">
            <g id="Group_12493">
              <g id="Group_12491">
                <path
                  id="Path_10420"
                  className="ab1"
                  d="M1119.1 638.8s-.4 5.8 3.2 8c0 0-15.5 6.5-19.9-1.2s6.3-27.2 13.9-24c4 1.3 2.8 17.2 2.8 17.2z"
                />
              </g>
              <g id="Group_12492">
                <path
                  id="Path_10421"
                  className="ab1"
                  d="M1110.6 649.7c-4.1 0-7-1.3-8.5-3.9-2.9-5.1.6-15.3 5.6-20.9 3.1-3.4 6.2-4.7 8.8-3.6 4.1 1.3 3.1 15.9 3 17.6 0 .1-.4 5.5 3 7.6.2.1.2.3.1.5 0 .1-.1.1-.2.2-2.7 1.1-5.5 1.8-8.4 2.3-1.1.1-2.2.2-3.4.2zm4-28c-2.6 0-5 2.2-6.3 3.7-5.9 6.6-7.8 16-5.5 20 3.7 6.4 15.8 2.4 18.7 1.3-3.2-2.5-2.8-7.7-2.8-7.9.2-2.7.2-5.4.1-8.1-.2-5.2-1.2-8.3-2.6-8.7-.5-.2-1.1-.4-1.6-.3zm4.5 17.1z"
                />
              </g>
            </g>
            <g id="Group_12495">
              <g id="Group_12494">
                <path
                  id="Path_10422"
                  className="ab2"
                  d="M1114.6 651.9c-.3-.8-.5-1.6-.5-2.5 0-1.3 0-2.6.1-3.8h-7.6s.1.9.1 2c0 1.6 0 3.6-.5 4.3"
                />
              </g>
            </g>
            <g id="Group_12497">
              <g id="Group_12496">
                <path
                  id="Path_10423"
                  className="ab3"
                  d="M1114 649.3c-1.4-1.5-6.3-1.7-7.1-1.7 0-.8-.1-1.6-.1-1.9h.1c2.2 1.4 5 1.4 7.1 0h.1c-.1.5-.2 2.1-.1 3.6z"
                />
              </g>
            </g>
            <g id="Group_12499">
              <g id="Group_12498">
                <path
                  id="Path_10424"
                  className="ab1"
                  d="M1106.2 652.3c-.1 0-.1 0-.2-.1-.2-.1-.2-.4-.1-.5.2-.2.5-1.1.4-4.1 0-1.1-.1-2-.1-2 0-.2.1-.4.3-.4h7.6c.2 0 .4.2.4.4-.1 1.3-.1 2.5-.1 3.8 0 .8.1 1.6.4 2.3.1.2.1.4-.1.5s-.4.1-.5-.1c-.4-.8-.6-1.8-.6-2.7v-3.5h-6.8c0 .4.1 1 .1 1.6 0 2.4-.1 3.9-.6 4.5.1.2 0 .3-.1.3z"
                />
              </g>
            </g>
            <g id="Group_12504">
              <g id="Group_12501">
                <g id="Group_12500">
                  <path
                    id="Path_10425"
                    className="ab2"
                    d="M1101.2 633.1s-1.7-.4-2.4.8c-.6 2 .5 4.1 2.4 4.7.1 0 .3.1.4.1 3.1.7 1.4-5-.4-5.6z"
                  />
                </g>
              </g>
              <g id="Group_12503">
                <g id="Group_12502">
                  <path
                    id="Path_10426"
                    className="ab1"
                    d="M1102.1 639.2h-.5c-1.3-.2-2.4-1.1-3-2.3-.5-1-.6-2.1-.2-3.1.8-1.5 2.7-1 2.8-1 1.4.5 2.7 3.6 2.3 5.3 0 .6-.7 1.1-1.4 1.1zm-1.5-5.8c-.6-.1-1.1.2-1.4.7-.3.8-.2 1.7.2 2.4.4 1 1.4 1.7 2.4 1.9.8.2 1-.2 1.1-.6.4-1.3-.7-4-1.8-4.4h-.5z"
                  />
                </g>
              </g>
            </g>
            <g id="Group_12509">
              <g id="Group_12506">
                <g id="Group_12505">
                  <path
                    id="Path_10427"
                    className="ab1"
                    d="M1101.3 635.9c-.1 0-.3-.1-.3-.2-.3-.5-.8-.9-1.4-1.1-.2 0-.4-.2-.3-.4 0-.2.2-.3.4-.3.8.2 1.5.8 1.9 1.5.1.2.1.4-.1.5h-.2z"
                  />
                </g>
              </g>
              <g id="Group_12508">
                <g id="Group_12507">
                  <path
                    id="Path_10428"
                    className="ab1"
                    d="M1099.9 636.2c-.1 0-.1 0 0 0-.3-.1-.4-.3-.4-.5.2-.5.5-.9.9-1.2.2-.1.4-.1.5.1.1.2.1.4-.1.5-.3.2-.5.5-.7.8.1.2-.1.3-.2.3z"
                  />
                </g>
              </g>
            </g>
            <g id="Group_12514">
              <g id="Group_12511">
                <g id="Group_12510">
                  <path
                    id="Path_10429"
                    className="ab2"
                    d="M1119.7 633.1s1.7-.4 2.4.8c.6 2-.5 4.1-2.4 4.7-.1 0-.3.1-.4.1-3 .7-1.3-5 .4-5.6z"
                  />
                </g>
              </g>
              <g id="Group_12513">
                <g id="Group_12512">
                  <path
                    id="Path_10430"
                    className="ab1"
                    d="M1118.8 639.2c-.7 0-1.3-.5-1.5-1.2-.5-1.7.9-4.8 2.3-5.3.1 0 2-.4 2.8 1 .4 1 .3 2.2-.2 3.1-.6 1.2-1.7 2.1-3 2.3-.1.1-.2.1-.4.1zm1.1-5.7c-1 .4-2.1 3-1.8 4.4.1.3.3.7 1.1.6 1.1-.2 2-.9 2.4-1.9.4-.8.5-1.6.2-2.4-.5-1-1.8-.8-1.9-.7z"
                  />
                </g>
              </g>
            </g>
            <g id="Group_12519">
              <g id="Group_12516">
                <g id="Group_12515">
                  <path
                    id="Path_10431"
                    className="ab1"
                    d="M1119.6 635.9c-.1 0-.1 0-.2-.1-.2-.1-.2-.3-.1-.5.4-.7 1.1-1.2 1.9-1.5.2 0 .4.1.4.3 0 .2-.1.4-.3.4-.6.2-1.1.6-1.4 1.1 0 .3-.1.3-.3.3z"
                  />
                </g>
              </g>
              <g id="Group_12518">
                <g id="Group_12517">
                  <path
                    id="Path_10432"
                    className="ab1"
                    d="M1121.1 636.2c-.2 0-.3-.1-.4-.3-.1-.3-.4-.6-.7-.8-.2-.1-.2-.4-.1-.5.1-.2.3-.2.5-.1.4.3.8.7.9 1.2.2.2.1.4-.2.5.1 0 0 0 0 0z"
                  />
                </g>
              </g>
            </g>
            <g id="Group_12524">
              <g id="Group_12521">
                <g id="Group_12520">
                  <path
                    id="Path_10433"
                    className="ab2"
                    d="M1119.6 632.9c-.2-3.2-.9-6.2-4.2-7.7-1.6-.6-3.3-.9-5-.9-7.6 0-8.9 4.2-9.2 8.5 0 .9-.1 1.7-.1 2.6.1 4 2.1 7.8 5.4 10.1 2.3 1.6 5.3 1.6 7.6 0 3.3-2.3 5.3-6.1 5.4-10.1.1-.8.1-1.6.1-2.5z"
                  />
                </g>
              </g>
              <g id="Group_12523">
                <g id="Group_12522">
                  <path
                    id="Path_10434"
                    className="ab1"
                    d="M1110.4 647.2c-1.4 0-2.8-.5-4-1.2-3.4-2.4-5.5-6.3-5.6-10.4 0-.9 0-1.7.1-2.6 0-2.2.6-4.3 1.9-6.1 1.5-1.9 4-2.8 7.6-2.8 1.8-.1 3.5.2 5.1.9 3.6 1.6 4.3 4.9 4.4 8v2.6c-.1 4.2-2.2 8-5.6 10.4-1.1.7-2.4 1.1-3.9 1.2zm0-22.4c-7.3 0-8.6 3.9-8.8 8.1 0 .8-.1 1.7-.1 2.6.1 3.9 2.1 7.5 5.2 9.8 2.2 1.5 5 1.5 7.2 0 3.2-2.3 5.1-5.9 5.2-9.8V633c-.1-2.8-.7-5.9-4-7.3-1.4-.7-3-1-4.7-.9zm3.8 20.8z"
                  />
                </g>
              </g>
            </g>
            <g id="Group_12526">
              <g id="Group_12525">
                <path
                  id="Path_10435"
                  className="ab1"
                  d="M1107.4 633.5c0 .4-.3.8-.8.8-.4 0-.8-.3-.8-.8 0-.4.3-.8.8-.8.4 0 .8.4.8.8z"
                />
              </g>
            </g>
            <g id="Group_12528">
              <g id="Group_12527">
                <path
                  id="Path_10436"
                  className="ab1"
                  d="M1114.9 633.5c0 .4-.3.8-.8.8-.4 0-.8-.3-.8-.8 0-.4.3-.8.8-.8s.8.4.8.8z"
                />
              </g>
            </g>
            <g id="Group_12530">
              <g id="Group_12529">
                <path
                  id="Path_10437"
                  className="ab1"
                  d="M1110.8 638.5c-.3 0-.6 0-.9-.1-.2 0-.4-.2-.3-.4 0-.2.2-.4.4-.3.4.1.8.1 1.2 0 0-.2-.1-.5-.1-.7-.1-.4-.2-1-.3-1.6-.1-1.3 0-2.7.2-4 0-.2.2-.3.4-.3s.3.2.3.4c-.2 1.2-.3 2.5-.2 3.7.1.7.2 1.2.3 1.6.2.8.3 1.4-.3 1.6-.2.1-.4.1-.7.1z"
                />
              </g>
            </g>
            <g id="Group_12532">
              <g id="Group_12531">
                <path
                  id="Path_10438"
                  className="ab1"
                  d="M1107.4 631.1s-2.2-.5-2.9.3c0 0-.2-1.1 1.1-1.1.7-.1 1.4.2 1.8.8z"
                />
              </g>
            </g>
            <g id="Group_12534">
              <g id="Group_12533">
                <path
                  id="Path_10439"
                  className="ab1"
                  d="M1113.5 631.1s2.2-.5 2.9.3c0 0 .2-1.1-1.1-1.1-.8-.1-1.5.2-1.8.8z"
                />
              </g>
            </g>
            <g id="Group_12537">
              <g id="Group_12535">
                <path
                  id="Path_10440"
                  className="ab1"
                  d="M1113.1 624.4c1.7 1.7 3.6 3.1 5.7 4.2.6 1.4.8 2.8.8 4.3 0 0 3.8-4.7 2.7-8.5-.7-2.3-4.7-8.7-12.4-5.3-1.4.7 3.6 3.5 3.2 5.3z"
                />
              </g>
              <g id="Group_12536">
                <path
                  id="Path_10441"
                  className="ab1"
                  d="M1119.6 633.3h-.1c-.2-.1-.3-.2-.3-.4 0-1.4-.2-2.7-.7-4-2.1-1.1-4-2.6-5.7-4.3-.1-.1-.1-.2-.1-.4.2-.7-1-1.9-1.9-2.7-.9-1-1.6-1.6-1.5-2.3.1-.3.2-.5.5-.6 2.4-1.3 5.3-1.4 7.8-.3 2.4 1.2 4.2 3.3 5.1 5.8 1.2 3.9-2.6 8.7-2.8 8.9-.1.2-.2.3-.3.3zm-6.1-9c1.6 1.6 3.5 3 5.5 4 .1 0 .1.1.2.2.4 1.1.7 2.2.8 3.3 1-1.5 2.8-4.7 2-7.3-.8-2.3-2.5-4.2-4.7-5.3-2.3-1-4.9-.9-7.1.3h-.1c0 .2.8 1 1.3 1.6 1 1 2.2 2.1 2.1 3.2z"
                />
              </g>
            </g>
            <g id="Group_12540">
              <g id="Group_12538">
                <path
                  id="Path_10442"
                  className="ab1"
                  d="M1113.1 624.4s-2.9 4-6.3 4.2c-4.9.3-5.5 9-4.6 14.8.7 4.6-1.5 4.9-1.5 4.9.1-2-.4-4-1.4-5.8-2-2.9-3-6.2-3.1-9.7-.8-16.1 16.9-18.3 16.9-8.4z"
                />
              </g>
              <g id="Group_12539">
                <path
                  id="Path_10443"
                  className="ab1"
                  d="M1100.7 648.7c-.2 0-.4-.2-.4-.4.1-1.9-.4-3.9-1.4-5.5-.1-.1-.2-.3-.3-.5-1.8-2.8-2.8-6-2.8-9.4-.3-5.9 1.9-10.7 6-13.3 2.9-1.8 6.3-2.1 8.7-.7 1.9 1.1 3.1 3.2 3 5.5 0 .1 0 .2-.1.2-.1.2-3 4.2-6.6 4.4-1 .1-2 .6-2.6 1.4-2.1 2.7-2.3 8.6-1.6 12.9.3 2 .1 3.5-.6 4.5-.3.5-.7.8-1.3.9zm6.3-29.9c-1.7 0-3.4.5-4.9 1.5-3.8 2.4-5.9 7-5.6 12.6 0 3.2 1 6.3 2.7 9 .1.2.2.4.3.5.9 1.6 1.5 3.5 1.5 5.3.5-.4 1.2-1.5.8-4.2-.8-4.7-.5-10.6 1.8-13.5.7-1 1.9-1.6 3.1-1.7 2.9-.2 5.5-3.4 5.9-4 .1-1.9-.9-3.7-2.6-4.7-.9-.5-1.9-.8-3-.8zm6.1 5.6z"
                />
              </g>
            </g>
            <g id="Group_12542">
              <g id="Group_12541">
                <path
                  id="Path_10444"
                  className="ab1"
                  d="M1109.9 641.5c-.7 0-1.5-.1-2.2-.1-.2 0-.4-.2-.3-.4s.2-.4.4-.3c0 0 3.6.5 5-.4.2-.1.4-.1.5.1s.1.4-.1.5c-1 .5-2.1.7-3.3.6z"
                />
              </g>
            </g>
            <g id="Group_12544">
              <g id="Group_12543">
                <path
                  id="Path_10445"
                  className="ab3"
                  d="M1105.9 638.5c-2.2 0-3.9-1.7-3.9-3.9s1.7-3.9 3.9-3.9 3.9 1.7 3.9 3.9c0 2.1-1.7 3.9-3.9 3.9zm0-7c-1.7 0-3.1 1.4-3.1 3.1 0 1.7 1.4 3.1 3.1 3.1 1.7 0 3.1-1.4 3.1-3.1 0-1.8-1.4-3.1-3.1-3.1z"
                />
              </g>
            </g>
            <g id="Group_12546">
              <g id="Group_12545">
                <path
                  id="Path_10446"
                  className="ab3"
                  d="M1115.5 638.5c-2.2 0-3.9-1.7-3.9-3.9s1.7-3.9 3.9-3.9 3.9 1.7 3.9 3.9c0 2.1-1.8 3.9-3.9 3.9zm0-7c-1.7 0-3.1 1.4-3.1 3.1s1.4 3.1 3.1 3.1 3.1-1.4 3.1-3.1c0-1.8-1.4-3.1-3.1-3.1z"
                />
              </g>
            </g>
          </g>
          <g id="Group_12548">
            <path
              id="Path_10447"
              className="ab1"
              d="M1110.6 656.6c-1.4-.1-2.8-.7-3.9-1.7-.4-.3-1.6-1.2-1.5-2.2.1-.4.4-.8.8-.9 0 0 .6-.3.5-4.2h.8c.1 4-.5 4.7-1 4.9-.3.1-.3.2-.3.3 0 .3.4.9 1.2 1.5 1.7 1.9 4.6 2 6.5.3l.3-.3c.8-.6 1.2-1.2 1.2-1.5 0 0 0-.2-.3-.3-.6-.2-.9-1.2-1-3.1h.8c.1 2.2.5 2.4.5 2.4.4.1.7.5.8.9.1 1-1.1 1.9-1.5 2.2-1.1 1-2.5 1.6-3.9 1.7z"
            />
          </g>
        </g>
      </g>
    </svg>
  )

  export const AvatarBot5 =()=>(
    <svg
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 49 49"
      xmlSpace="preserve"
    >
      <style>
        {".af1{fill:#fff}.af2{fill:#f18185}.af3{fill:#1c1c2f}"}
        </style>
      <g id="bot_5" transform="translate(-1231.5 -502.5)">
        <g id="Group_12560" transform="translate(123 84)">
          <g id="Group_12156" transform="translate(108.5 -29.5)">
            <circle
              id="Ellipse_719"
              cx={1024.5}
              cy={472.5}
              r={24}
              fill="#d9fff1"
              stroke="#cecece"
            />
          </g>
        </g>
        <g id="Group_12591" transform="translate(270.198 -196.065)">
          <g id="Group_12561">
            <path
              id="Path_10449"
              className="af1"
              d="M989.5 739.2c-.5-.2-.7-1.4-.8-2.7 0-1.3 0-2.6.1-3.8h-7.6s.1.9.1 2c0 1.8-.1 4.3-.8 4.6-1.2.5-.3 1.6.8 2.4.6.5 3.4 1.9 3.9 2.4 0 0 2.8-2 3.5-2.4 1.1-.9 1.9-2.1.8-2.5z"
            />
          </g>
          <g id="Group_12562">
            <path
              id="Path_10450"
              className="af2"
              d="M988.5 736.3c-1.4-1.5-6.3-1.7-7.1-1.7 0-.8-.1-1.6-.1-1.9h.1c2.2 1.4 5 1.4 7.1 0h.1c-.1 1.2-.1 2.4-.1 3.6z"
            />
          </g>
          <g id="Group_12563">
            <path
              id="Path_10451"
              className="af3"
              d="M985.2 744.4c-.1 0-.2 0-.2-.1-.3-.3-1.4-.9-2.3-1.4-.7-.4-1.3-.8-1.6-1-.4-.3-1.6-1.2-1.5-2.2.1-.4.4-.8.8-.9 0 0 .6-.3.5-4.2 0-1.1-.1-2-.1-2 0-.2.1-.4.3-.4h7.6c.2 0 .4.2.4.4-.1 1.3-.1 2.5-.1 3.8.1 2.2.5 2.4.5 2.4.4.1.7.5.8.9.1 1-1.1 1.9-1.5 2.2-.6.5-3.5 2.4-3.5 2.4.1.1 0 .1-.1.1zm-3.6-11.4c0 .4.1 1 .1 1.6.1 4-.5 4.7-1 4.9-.3.1-.3.2-.3.3 0 .3.4.9 1.2 1.5.3.2.9.6 1.6 1 .8.5 1.7 1 2.2 1.3.7-.5 2.7-1.9 3.2-2.3.8-.6 1.2-1.2 1.2-1.5 0 0 0-.2-.3-.3-.6-.2-.9-1.2-1-3.1v-3.5l-6.9.1z"
            />
          </g>
          <g id="Group_12566">
            <g id="Group_12564">
              <path
                id="Path_10452"
                d="M975.1 717s-1.5-8 4.3-10.5 18.5-1.1 15.7 9.6l-20 .9z"
                fill="#f8b45f"
              />
            </g>
            <g id="Group_12565">
              <path
                id="Path_10453"
                className="af3"
                d="M975.1 717.4c-.2 0-.3-.1-.4-.3 0-.1-1.5-8.3 4.5-10.9 4.1-1.7 10.7-1.5 14.2 1.5 1.6 1.4 3.2 4 2 8.5 0 .2-.2.3-.4.3l-19.9.9zm9.9-11.6c-1.9 0-3.8.3-5.5 1.1-2.3 1-3.7 2.9-4.1 5.8-.2 1.3-.2 2.6 0 3.9l19.3-.9c.8-3.2.2-5.7-1.8-7.5-1.7-1.4-4.7-2.4-7.9-2.4z"
              />
            </g>
          </g>
          <g id="Group_12567">
            <path
              id="Path_10454"
              className="af3"
              d="M975.1 717l.2 3.1 1.2.8 18.2-.3.2-3.5s.5-1.9-2.1-2.5-15.5-3.9-17.7 2.4z"
            />
            <path
              id="Path_10455"
              className="af3"
              d="M976.4 721.2c-.1 0-.1 0-.2-.1l-1.2-.8c-.1-.1-.2-.2-.2-.3l-.2-3.1v-.1c1.1-3 5-5.8 18-2.7h.1c.9.1 1.6.6 2.1 1.3.3.5.4 1 .3 1.6l-.2 3.5c0 .2-.2.4-.4.4l-18.1.3zm-.8-1.4l1 .6 17.8-.3.1-3.1v-.1c0-.2.3-1.5-1.8-2h-.1c-9.6-2.3-15.7-1.5-17.1 2.2l.1 2.7z"
            />
          </g>
          <g id="Group_12570">
            <g id="Group_12568">
              <path
                id="Path_10456"
                className="af1"
                d="M975.7 720.1s-1.7-.4-2.4.8c-.6 2 .5 4.1 2.4 4.7.1 0 .3.1.4.1 3.1.7 1.4-5-.4-5.6z"
              />
            </g>
            <g id="Group_12569">
              <path
                id="Path_10457"
                className="af3"
                d="M976.7 726.2h-.5c-1.3-.2-2.4-1.1-3-2.3-.5-1-.6-2.1-.2-3.1.8-1.5 2.7-1 2.8-1 1.4.5 2.7 3.6 2.3 5.3-.1.6-.7 1.1-1.4 1.1zm-1.6-5.8c-.6-.1-1.1.2-1.4.7-.3.8-.2 1.7.2 2.4.4 1 1.4 1.7 2.4 1.9.8.2 1-.2 1.1-.6.4-1.3-.7-4-1.8-4.4h-.5z"
              />
            </g>
          </g>
          <g id="Group_12573">
            <g id="Group_12571">
              <path
                id="Path_10458"
                className="af3"
                d="M975.9 722.9c-.1 0-.3-.1-.3-.2-.3-.5-.8-.9-1.4-1.1-.2 0-.3-.2-.3-.4s.2-.3.4-.3c.8.2 1.5.8 1.9 1.5.1.2.1.4-.1.5h-.2z"
              />
            </g>
            <g id="Group_12572">
              <path
                id="Path_10459"
                className="af3"
                d="M974.4 723.2s-.1 0 0 0c-.3-.1-.4-.3-.4-.5.2-.5.5-.9.9-1.2.2-.1.4-.1.5.1.1.2.1.4-.1.5-.3.2-.5.5-.7.8.1.2 0 .3-.2.3z"
              />
            </g>
          </g>
          <g id="Group_12576">
            <g id="Group_12574">
              <path
                id="Path_10460"
                className="af1"
                d="M994.3 720.1s1.7-.4 2.4.8c.6 2-.5 4.1-2.4 4.7-.1 0-.3.1-.4.1-3.1.7-1.4-5 .4-5.6z"
              />
            </g>
            <g id="Group_12575">
              <path
                id="Path_10461"
                className="af3"
                d="M993.4 726.2c-.7 0-1.3-.5-1.5-1.2-.5-1.7.9-4.8 2.3-5.3.1 0 2-.4 2.8 1 .4 1 .3 2.2-.2 3.1-.6 1.2-1.7 2.1-3 2.3-.1.1-.3.1-.4.1zm1-5.7c-1 .4-2.1 3-1.8 4.4.1.3.3.7 1.1.6 1.1-.2 2-.9 2.4-1.9.4-.7.5-1.6.2-2.4-.5-1-1.7-.8-1.9-.7z"
              />
            </g>
          </g>
          <g id="Group_12579">
            <g id="Group_12577">
              <path
                id="Path_10462"
                className="af3"
                d="M994.2 722.9c-.2 0-.4-.2-.4-.4 0-.1 0-.1.1-.2.4-.7 1.1-1.2 1.9-1.5.2 0 .4.1.5.3 0 .2-.1.4-.3.5-.6.2-1.1.6-1.4 1.1-.2.2-.3.2-.4.2z"
              />
            </g>
            <g id="Group_12578">
              <path
                id="Path_10463"
                className="af3"
                d="M995.6 723.2c-.2 0-.3-.1-.4-.3-.1-.3-.4-.6-.7-.8-.2-.1-.2-.4-.1-.5.1-.2.3-.2.5-.1.4.3.8.7.9 1.2.1.2-.1.4-.3.5h.1z"
              />
            </g>
          </g>
          <g id="Group_12582">
            <g id="Group_12580">
              <path
                id="Path_10464"
                className="af1"
                d="M994.1 719.9c-.2-3.2-.9-6.2-4.2-7.7-1.6-.6-3.3-.9-5-.9-7.6 0-8.9 4.2-9.2 8.5 0 .9-.1 1.7-.1 2.6.1 4 2.1 7.8 5.4 10.1 2.3 1.6 5.3 1.6 7.6 0 3.3-2.3 5.3-6.1 5.4-10.1.2-.8.2-1.6.1-2.5z"
              />
            </g>
            <g id="Group_12581">
              <path
                id="Path_10465"
                className="af3"
                d="M985 734.2c-1.4 0-2.8-.5-4-1.2-3.4-2.4-5.5-6.3-5.6-10.4 0-.9 0-1.7.1-2.6 0-2.2.6-4.3 1.9-6.1 1.5-1.9 4-2.8 7.6-2.8 1.8-.1 3.5.2 5.1.9 3.6 1.6 4.3 4.9 4.4 8v2.6c-.1 4.2-2.2 8-5.6 10.4-1.1.7-2.5 1.1-3.9 1.2zm0-22.4c-7.3 0-8.5 3.9-8.8 8.1v2.6c.1 3.9 2.1 7.5 5.2 9.8 2.2 1.5 5 1.5 7.2 0 3.2-2.3 5.1-5.9 5.2-9.8V720c-.1-2.8-.7-5.9-4-7.3-1.6-.7-3.2-1-4.8-.9zm3.8 20.8z"
              />
            </g>
          </g>
          <g id="Group_12583">
            <path
              id="Path_10466"
              className="af3"
              d="M981.9 720.5c0 .4-.3.8-.8.8s-.8-.3-.8-.8.3-.8.8-.8.8.4.8.8z"
            />
          </g>
          <g id="Group_12584">
            <path
              id="Path_10467"
              className="af3"
              d="M989.4 720.5c0 .4-.3.8-.8.8s-.8-.3-.8-.8.3-.8.8-.8.8.4.8.8z"
            />
          </g>
          <g id="Group_12585">
            <path
              id="Path_10468"
              className="af3"
              d="M985.4 725.5c-.3 0-.6 0-.9-.1-.2 0-.3-.2-.3-.4s.2-.3.4-.3c.4.1.8.1 1.2 0 0-.2-.1-.5-.1-.7-.1-.4-.2-1-.3-1.6-.1-1.3 0-2.7.2-4 .1-.2.3-.3.5-.3s.3.2.3.4c-.2 1.2-.3 2.5-.2 3.7.1.7.2 1.2.3 1.6.2.8.3 1.4-.3 1.6-.3.1-.6.1-.8.1z"
            />
          </g>
          <g id="Group_12586">
            <path
              id="Path_10469"
              className="af3"
              d="M981.9 718.1s-2.2-.5-2.9.3c0 0-.2-1.1 1.1-1.1.8-.1 1.4.2 1.8.8z"
            />
          </g>
          <g id="Group_12587">
            <path
              id="Path_10470"
              className="af3"
              d="M988 718.1s2.2-.5 2.9.3c0 0 .2-1.1-1.1-1.1-.7-.1-1.4.2-1.8.8z"
            />
          </g>
          <g id="Group_12588">
            <path
              id="Path_10471"
              className="af3"
              d="M981.9 727.3s3.4-.9 5.7 0c-.6.9-1.7 1.5-2.8 1.5-1.9 0-2.8-1.1-2.9-1.5z"
            />
          </g>
          <g id="Group_12589">
            <path
              id="Path_10472"
              className="af2"
              d="M983.2 728.5c.3-.5 1-.7 1.6-.5.3-.2.7-.3 1-.1.5.2.7.5.7.5-1.1.5-2.3.6-3.3.1z"
            />
          </g>
          <g id="Group_12590">
            <path
              id="Path_10473"
              className="af1"
              d="M975.1 717c.6-.9 1.4-1.6 2.5-1.9 1.5-.3 19.4-3 17.3 1.9 0 0 3.3-3.4 2.3-5.6-1.3-3-14-4.4-17.8-1-2 1.6-4 4-4.3 6.6z"
            />
            <path
              id="Path_10474"
              className="af3"
              d="M994.8 717.4c-.1 0-.2 0-.2-.1-.2-.1-.2-.3-.1-.5.2-.4.2-.8-.1-1.1-.5-.6-2.2-1.5-8.6-1.1-3.7.2-7.5.8-8.2.9-.9.3-1.7.9-2.2 1.7-.1.2-.4.2-.5.1-.1-.1-.2-.2-.2-.4.3-2.3 1.8-4.6 4.4-6.8 2.6-2.2 8.9-2.5 13.5-1.5 1.6.3 4.3 1.1 4.9 2.6 1.1 2.5-2.3 5.9-2.4 6-.1.2-.2.2-.3.2zm-6.3-3.7c3 0 5.7.4 6.6 1.5l.3.6c.9-1.2 2-3 1.5-4.2-.4-.8-2-1.7-4.4-2.2-4.4-1-10.5-.7-12.8 1.3-1.6 1.3-2.8 2.9-3.7 4.8.4-.4 1-.6 1.6-.7 3.5-.7 7.2-1 10.9-1.1z"
            />
          </g>
        </g>
      </g>
    </svg>
  )

  export const AvatarBot6 =()=>(
    <svg
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 49 49"
      xmlSpace="preserve"
    >
      <style>
        {".avatar1{fill:#1c1c2f}.avatar2{fill:#f18185}.avatar3{fill:#fff}"}
        </style>
      <g id="bot_6" transform="translate(-1166.5 -418.5)">
        <g id="Group_12157" transform="translate(166.5 -29.5)">
          <circle
            id="Ellipse_719"
            cx={1024.5}
            cy={472.5}
            r={24}
            fill="#f5f0c9"
            stroke="#cecece"
          />
        </g>
        <g id="Group_12625" transform="translate(384.722 -249.093)">
          <g id="Group_12592">
            <path
              id="Path_10475"
              className="avatar1"
              d="M796.5 691.6c.1 1.4-.1 2.9-.4 4.3-.5 1.8 1.1 2.9.9 4.1s-1.2 2.1-1.5 3.3c-.2 1.3-.6 2.5-1.1 3.8-.6 1.1 2.2 5.1 9.3 5.4 12.1.9 13.1-1.5 13.1-1.5s-.1-5.4-1.1-6.3-1.2-.7-.9-2.2c.2-1.2 0-2.5-.6-3.5-.4-.5-.3-.9.2-2s1.6-2.3 1.3-4.9-19.2-.5-19.2-.5z"
            />
            <path
              id="Path_10476"
              className="avatar1"
              d="M808.8 713.1c-1.4 0-3.1-.1-5-.2-5.3-.2-8.3-2.5-9.4-4.3-.4-.5-.5-1.2-.2-1.7.3-.7.6-1.5.7-2.3.1-.5.2-.9.3-1.4.2-.5.4-1.1.8-1.5.4-.5.6-1.1.7-1.7 0-.5-.2-.9-.4-1.3-.6-.8-.7-1.9-.5-2.8.3-1.3.5-2.7.4-4.1 0-.2.1-.4.3-.4 0 0 4.8-.6 9.5-.8 8.8-.4 10.1.6 10.2 1.5.2 1.6-.1 3.2-1 4.5l-.3.6c-.5 1.1-.5 1.3-.2 1.6.7 1.2.9 2.5.7 3.9-.2 1.1-.2 1.1.3 1.5.1.1.2.2.4.3 1.1 1 1.2 5.7 1.2 6.6v.2c-.1.1-1.1 1.8-8.5 1.8zM796.9 692c0 1.4-.1 2.7-.4 4-.2.8 0 1.6.5 2.3.4.5.5 1.2.5 1.8-.2.7-.4 1.4-.8 2-.3.4-.5.9-.7 1.4-.1.4-.2.9-.3 1.3-.1.9-.4 1.7-.8 2.5-.1.1 0 .5.2 1 .8 1.3 3.4 3.6 8.7 3.9 10.3.8 12.4-.9 12.7-1.2 0-2.2-.4-5.4-1-5.9-.1-.1-.3-.2-.4-.3-.8-.7-.9-.9-.6-2.2.2-1.1 0-2.2-.5-3.2-.6-.7-.3-1.3.2-2.4.1-.2.2-.5.4-.7.8-1.2 1.1-2.6.9-4-.2-1.3-7.3-1.6-18.6-.3z"
            />
          </g>
          <g id="Group_12593">
            <path
              id="Path_10477"
              className="avatar2"
              d="M806.1 709.4l4.5-4.2 1.5.4"
            />
            <path
              id="Path_10478"
              className="avatar1"
              d="M806.1 709.8c-.2 0-.4-.2-.4-.4 0-.1 0-.2.1-.3l4.5-4.2c.1-.1.2-.1.4-.1l1.5.4c.2.1.3.3.2.5-.1.2-.3.3-.5.2l-1.2-.4-4.3 4c-.1.3-.2.3-.3.3z"
            />
          </g>
          <g id="Group_12594">
            <path
              id="Path_10479"
              className="avatar3"
              d="M810 707.8c-2 2-5.2 2.1-7.2.2l-.2-.2c-1.1-.8-2-2-.8-2.4.7-.3.8-2.7.8-4.6 0-1.1-.1-2-.1-2h7.6c-.1 1.3-.1 2.6-.1 3.8.1 1.3.3 2.5.8 2.7 1.1.5.3 1.7-.8 2.5z"
            />
          </g>
          <g id="Group_12595">
            <path
              id="Path_10480"
              className="avatar2"
              d="M809.8 702.5c-1.4-1.5-6.3-1.7-7.1-1.7 0-.8-.1-1.6-.1-1.9h.1c2.2 1.4 5 1.4 7.1 0h.1c0 .6-.1 2.2-.1 3.6z"
            />
          </g>
          <g id="Group_12596">
            <path
              id="Path_10481"
              className="avatar1"
              d="M806.3 709.8c-1.5-.1-2.8-.7-3.9-1.7-.4-.3-1.6-1.2-1.5-2.2.1-.4.4-.8.8-.9 0 0 .6-.3.5-4.2 0-1.1-.1-2-.1-2 0-.2.1-.4.4-.4h7.6c.1 0 .2 0 .3.1.1.1.1.2.1.3-.1 1.3-.1 2.5-.1 3.8.1 2.2.5 2.4.5 2.4.4.1.7.5.8.9.1 1-1.1 1.9-1.5 2.2-1.1 1-2.5 1.6-3.9 1.7zm-3.4-10.6c0 .4.1 1 .1 1.6.1 4-.5 4.7-1 4.9-.3.1-.3.2-.3.3 0 .3.4.9 1.2 1.5 1.8 1.9 4.8 2 6.7.2l.2-.2c.8-.6 1.2-1.2 1.2-1.5 0 0 0-.2-.3-.3-.6-.2-.9-1.2-1-3.1v-3.5h-6.8z"
            />
          </g>
          <g id="Group_12597">
            <path
              id="Path_10482"
              className="avatar1"
              d="M815.5 689.4v-.7-2.6c-1.4-.1-.3-2.3-2-3.4s-2.2-4.2-2.2-4.2c-1.5 1-3.3 1.3-5 .7-3.1-.9-6.4 2.2-6.8 4.4-.2 1.2-1.1 2.2-2.4 2.6 0 .9-.1 1.7-.1 2.6v.8-.1s-3.5-10.3.1-14.4c5.9-6.5 18.3-3.4 19.9 2.1 1.6 5.2-1.5 12.2-1.5 12.2z"
            />
            <path
              id="Path_10483"
              className="avatar1"
              d="M797.1 689.9c-.1 0-.3-.1-.3-.2l-.1-.1c-.1-.4-3.6-10.6.2-14.7 3.5-3.9 9-4.3 13-3.4 3.9.9 6.9 3 7.6 5.6 1.6 5.3-1.5 12.2-1.6 12.5 0 .1-.1.2-.2.2h-.1c-.2.1-.4-.1-.5-.3v-.1-.7-2.2c-.7-.2-.8-1-.9-1.6 0-.7-.3-1.4-.9-1.9-1.4-.9-2-2.9-2.3-3.9-1.5.8-3.2.9-4.8.4-1.2-.3-2.6-.1-3.6.6-1.3.8-2.3 2-2.7 3.5-.2 1.3-1.1 2.4-2.4 2.8V689.5c0 .2-.1.3-.3.4h-.1zm14.1-11.8h.1c.1 0 .2.2.2.3 0 0 .5 2.9 2.1 4 .8.6 1.2 1.5 1.2 2.4.1.8.2.9.5 1 .2 0 .3.2.3.4v1.2c.8-2.4 1.9-6.7.9-10-.7-2.3-3.4-4.2-7-5.1-3.8-.9-9-.5-12.2 3.1-2.4 2.6-1.5 8.1-.8 11.4v-.6c0-.2.1-.3.3-.3 1.1-.3 1.9-1.2 2.1-2.3.5-1.7 1.6-3.1 3.1-4 1.2-.8 2.8-1.1 4.2-.7 1.5.6 3.3.3 4.6-.6.3-.2.4-.2.4-.2z"
            />
          </g>
          <g id="Group_12598">
            <path
              id="Path_10484"
              className="avatar2"
              d="M815.5 688.7v.8c-.8.2-15.6 4.3-18.4 0v-.8c0-.8 0-1.7.1-2.6 1.2-.3 2.1-1.3 2.4-2.6.4-2.2 3.7-5.3 6.8-4.4 1.7.6 3.5.3 5-.7 0 0 .5 3.1 2.2 4.2s.5 3.3 2 3.4c-.1 1-.1 1.9-.1 2.7z"
            />
            <path
              id="Path_10485"
              className="avatar1"
              d="M803 691.8c-3.3 0-5.4-.7-6.3-2.1 0-.1-.1-.1-.1-.2v-.8c0-.9 0-1.7.1-2.6 0-.2.1-.3.3-.3 1.1-.3 1.9-1.2 2.1-2.3.5-1.7 1.6-3.1 3.1-4 1.2-.8 2.8-1.1 4.2-.7 1.5.6 3.3.3 4.6-.6.2-.1.4-.1.5 0 0 .1.1.1.1.2 0 0 .5 2.9 2.1 4 .8.6 1.2 1.5 1.2 2.4.1.8.2.9.5 1 .2 0 .3.2.3.4V689.6c0 .2-.1.3-.3.3-2.8.8-5.6 1.3-8.5 1.7-1.2.1-2.5.2-3.9.2zm-5.5-2.4c2.2 3 12.3 1.2 17.6-.2v-.5-2.2c-.7-.2-.8-1-.9-1.6 0-.7-.3-1.4-.9-1.9-1.4-.9-2-2.9-2.3-3.9-1.5.8-3.2.9-4.8.4-1.2-.3-2.6-.1-3.6.6-1.3.8-2.3 2-2.7 3.5-.2 1.3-1.1 2.4-2.4 2.8v2.3c-.1.2-.1.4 0 .7zm18 .1z"
            />
          </g>
          <g id="Group_12601">
            <g id="Group_12599">
              <path
                id="Path_10486"
                className="avatar3"
                d="M797 686.3s-1.7-.4-2.4.8c-.6 2 .5 4.1 2.4 4.7.1 0 .3.1.4.1 3.1.7 1.4-5-.4-5.6z"
              />
            </g>
            <g id="Group_12600">
              <path
                id="Path_10487"
                className="avatar1"
                d="M798 692.4h-.5c-1.3-.2-2.4-1.1-3-2.3-.5-1-.6-2.1-.2-3.1.8-1.5 2.7-1 2.8-1 1.4.5 2.7 3.6 2.3 5.3-.1.7-.7 1.2-1.4 1.1zm-1.6-5.8c-.6-.1-1.1.2-1.4.7-.3.8-.2 1.7.2 2.4.4 1 1.4 1.7 2.4 1.9.8.2 1-.2 1.1-.6.4-1.3-.7-4-1.8-4.4-.1.1-.3 0-.5 0z"
              />
            </g>
          </g>
          <g id="Group_12604">
            <g id="Group_12602">
              <path
                id="Path_10488"
                className="avatar1"
                d="M797.2 689.2c-.1 0-.3-.1-.3-.2-.3-.5-.8-.9-1.4-1.1-.2 0-.3-.2-.3-.5 0-.2.2-.3.4-.3.8.2 1.5.8 1.9 1.5.1.2.1.4-.1.5-.1 0-.2.1-.2.1z"
              />
            </g>
            <g id="Group_12603">
              <path
                id="Path_10489"
                className="avatar1"
                d="M795.7 689.4s-.1 0 0 0c-.3-.1-.4-.3-.4-.5.2-.5.5-.9.9-1.2.2-.1.4-.1.5.1.1.2.1.4-.1.5-.3.2-.5.5-.7.8.1.2 0 .3-.2.3z"
              />
            </g>
          </g>
          <g id="Group_12607">
            <g id="Group_12605">
              <path
                id="Path_10490"
                className="avatar3"
                d="M815.6 686.3s1.7-.4 2.4.8c.6 2-.5 4.1-2.4 4.7-.1 0-.3.1-.4.1-3.1.7-1.4-5 .4-5.6z"
              />
            </g>
            <g id="Group_12606">
              <path
                id="Path_10491"
                className="avatar1"
                d="M814.7 692.4c-.7 0-1.3-.5-1.5-1.2-.5-1.7.9-4.8 2.3-5.3.1 0 2-.4 2.8 1 .4 1 .3 2.2-.2 3.1-.6 1.2-1.7 2.1-3 2.3-.1.1-.3.1-.4.1zm1-5.7c-1 .4-2.1 3-1.8 4.4.1.3.3.7 1.1.6 1.1-.2 2-.9 2.4-1.9.4-.7.5-1.6.2-2.4-.5-1-1.7-.7-1.9-.7z"
              />
            </g>
          </g>
          <g id="Group_12610">
            <g id="Group_12608">
              <path
                id="Path_10492"
                className="avatar1"
                d="M815.5 689.2c-.1 0-.1 0-.2-.1-.2-.1-.2-.3-.1-.5.4-.7 1.1-1.2 1.9-1.5.2 0 .4.1.5.3 0 .2-.1.4-.3.5-.6.2-1.1.6-1.4 1.1-.2.1-.3.2-.4.2z"
              />
            </g>
            <g id="Group_12609">
              <path
                id="Path_10493"
                className="avatar1"
                d="M816.9 689.4c-.2 0-.3-.1-.4-.3-.1-.3-.4-.6-.7-.8-.2-.1-.2-.4-.1-.5.1-.2.4-.2.5-.1.4.3.8.7.9 1.2.1.2-.1.4-.3.5h.1z"
              />
            </g>
          </g>
          <g id="Group_12613">
            <g id="Group_12611">
              <path
                id="Path_10494"
                className="avatar3"
                d="M815.5 688.7v.8c-.3 3.8-2.3 7.2-5.4 9.4-2.3 1.6-5.3 1.6-7.6 0-3.1-2.2-5-5.6-5.4-9.3v-.8c0-.8 0-1.7.1-2.6 1.2-.3 2.1-1.3 2.4-2.6.4-2.2 3.7-5.3 6.8-4.4 1.7.6 3.5.3 5-.7 0 0 .5 3.1 2.2 4.2s.5 3.3 2 3.4c-.1.9-.1 1.8-.1 2.6z"
              />
            </g>
            <g id="Group_12612">
              <path
                id="Path_10495"
                className="avatar1"
                d="M806.3 700.4c-1.4 0-2.8-.5-4-1.2-3.2-2.2-5.2-5.8-5.6-9.6v-.8c0-.9 0-1.7.1-2.6 0-.2.1-.3.3-.3 1.1-.3 1.9-1.2 2.1-2.3.5-1.7 1.6-3.1 3.1-4 1.2-.8 2.8-1.1 4.2-.7 1.5.6 3.3.3 4.6-.6.2-.1.4-.1.5 0 0 .1.1.1.1.2 0 0 .5 2.9 2.1 4 .8.6 1.2 1.5 1.2 2.4.1.8.2.9.5 1 .2 0 .3.2.3.4V689.7c-.3 3.9-2.4 7.4-5.6 9.7-1.1.5-2.5 1-3.9 1zm-8.8-14V689.5c.3 3.6 2.2 6.9 5.2 9 2.2 1.5 5 1.5 7.2 0 3-2.1 4.9-5.4 5.2-9.1v-.7-2.2c-.7-.2-.8-1-.9-1.6 0-.7-.3-1.4-.9-1.9-1.4-.9-2-2.9-2.3-3.9-1.5.8-3.2.9-4.8.4-1.2-.3-2.6-.1-3.6.6-1.3.8-2.3 2-2.7 3.5-.3 1.3-1.2 2.4-2.4 2.8z"
              />
            </g>
          </g>
          <g id="Group_12614">
            <path
              id="Path_10496"
              className="avatar1"
              d="M806.7 691.7c-.3 0-.6 0-.9-.1-.2 0-.4-.2-.3-.4s.2-.4.4-.3c.4.1.8.1 1.2 0 0-.2-.1-.5-.1-.7-.1-.4-.2-1-.3-1.6-.1-1.3 0-2.7.2-4 .1-.2.3-.3.5-.3s.3.2.3.4c-.2 1.2-.3 2.5-.2 3.7.1.7.2 1.2.3 1.6.2.8.3 1.4-.3 1.6-.3.1-.6.1-.8.1z"
            />
          </g>
          <g id="Group_12615">
            <path
              id="Path_10497"
              className="avatar1"
              d="M803.2 684.3s-2.2-.5-2.9.3c0 0-.2-1.1 1.1-1.1.8 0 1.4.3 1.8.8z"
            />
          </g>
          <g id="Group_12616">
            <path
              id="Path_10498"
              className="avatar1"
              d="M809.3 684.3s2.2-.5 2.9.3c0 0 .2-1.1-1.1-1.1-.7 0-1.4.3-1.8.8z"
            />
          </g>
          <g id="Group_12617">
            <path
              id="Path_10499"
              className="avatar1"
              d="M803.2 693.5s3.4-.9 5.7 0c-.6.9-1.7 1.5-2.8 1.5-1.9.1-2.8-1.1-2.9-1.5z"
            />
          </g>
          <g id="Group_12618">
            <path
              id="Path_10500"
              className="avatar2"
              d="M804.5 694.7c.3-.5 1-.7 1.6-.5.3-.2.7-.3 1-.1.5.2.7.5.7.5-1.1.6-2.3.6-3.3.1z"
            />
          </g>
          <g id="Group_12619">
            <path
              id="Path_10501"
              className="avatar2"
              d="M802.5 689.7c0 .5-.8.9-1.8.9s-1.8-.4-1.8-.9.8-.9 1.8-.9 1.8.4 1.8.9z"
            />
          </g>
          <g id="Group_12620">
            <path
              id="Path_10502"
              className="avatar2"
              d="M813.6 689.7c0 .5-.8.9-1.8.9s-1.8-.4-1.8-.9.8-.9 1.8-.9 1.8.4 1.8.9z"
            />
          </g>
          <g id="Group_12621">
            <path
              id="Path_10503"
              className="avatar1"
              d="M803.5 686.7c0 .4-.3.8-.8.8s-.8-.3-.8-.8.3-.8.8-.8c.4.1.8.4.8.8z"
            />
          </g>
          <g id="Group_12622">
            <path
              id="Path_10504"
              className="avatar1"
              d="M811 686.7c0 .4-.3.8-.8.8s-.8-.3-.8-.8.3-.8.8-.8.8.4.8.8z"
            />
          </g>
          <g id="Group_12623">
            <path
              id="Path_10505"
              className="avatar1"
              d="M802.1 686.6c-.4 0-.8-.1-1.2-.3-.2-.1-.2-.4-.1-.5s.4-.2.5-.1c.3.1.6.2.9.1.2 0 .4.1.4.3s-.1.4-.3.4c0 .1-.1.1-.2.1z"
            />
          </g>
          <g id="Group_12624">
            <path
              id="Path_10506"
              className="avatar1"
              d="M810.6 686.6h-.3c-.2 0-.4-.2-.3-.4s.2-.4.4-.3c.3 0 .6 0 .9-.1.2-.1.4-.1.5.1s.1.4-.1.5c-.3.1-.7.3-1.1.2z"
            />
          </g>
        </g>
      </g>
    </svg>
  )